webpackJsonp([3],{

/***/ "9JTz":
/***/ (function(module, exports) {

/*! jQuery UI - v1.12.1 - 2017-08-12
* http://jqueryui.com
* Includes: widget.js, position.js, data.js, keycode.js, scroll-parent.js, unique-id.js, widgets/sortable.js, widgets/autocomplete.js, widgets/menu.js, widgets/mouse.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function( factory ) {
	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define([ "jquery" ], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
}(function( $ ) {

$.ui = $.ui || {};

var version = $.ui.version = "1.12.1";


/*!
 * jQuery UI Widget 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Widget
//>>group: Core
//>>description: Provides a factory for creating stateful widgets with a common API.
//>>docs: http://api.jqueryui.com/jQuery.widget/
//>>demos: http://jqueryui.com/widget/



var widgetUuid = 0;
var widgetSlice = Array.prototype.slice;

$.cleanData = ( function( orig ) {
	return function( elems ) {
		var events, elem, i;
		for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
			try {

				// Only trigger remove when necessary to save time
				events = $._data( elem, "events" );
				if ( events && events.remove ) {
					$( elem ).triggerHandler( "remove" );
				}

			// Http://bugs.jquery.com/ticket/8235
			} catch ( e ) {}
		}
		orig( elems );
	};
} )( $.cleanData );

$.widget = function( name, base, prototype ) {
	var existingConstructor, constructor, basePrototype;

	// ProxiedPrototype allows the provided prototype to remain unmodified
	// so that it can be used as a mixin for multiple widgets (#8876)
	var proxiedPrototype = {};

	var namespace = name.split( "." )[ 0 ];
	name = name.split( "." )[ 1 ];
	var fullName = namespace + "-" + name;

	if ( !prototype ) {
		prototype = base;
		base = $.Widget;
	}

	if ( $.isArray( prototype ) ) {
		prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
	}

	// Create selector for plugin
	$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
		return !!$.data( elem, fullName );
	};

	$[ namespace ] = $[ namespace ] || {};
	existingConstructor = $[ namespace ][ name ];
	constructor = $[ namespace ][ name ] = function( options, element ) {

		// Allow instantiation without "new" keyword
		if ( !this._createWidget ) {
			return new constructor( options, element );
		}

		// Allow instantiation without initializing for simple inheritance
		// must use "new" keyword (the code above always passes args)
		if ( arguments.length ) {
			this._createWidget( options, element );
		}
	};

	// Extend with the existing constructor to carry over any static properties
	$.extend( constructor, existingConstructor, {
		version: prototype.version,

		// Copy the object used to create the prototype in case we need to
		// redefine the widget later
		_proto: $.extend( {}, prototype ),

		// Track widgets that inherit from this widget in case this widget is
		// redefined after a widget inherits from it
		_childConstructors: []
	} );

	basePrototype = new base();

	// We need to make the options hash a property directly on the new instance
	// otherwise we'll modify the options hash on the prototype that we're
	// inheriting from
	basePrototype.options = $.widget.extend( {}, basePrototype.options );
	$.each( prototype, function( prop, value ) {
		if ( !$.isFunction( value ) ) {
			proxiedPrototype[ prop ] = value;
			return;
		}
		proxiedPrototype[ prop ] = ( function() {
			function _super() {
				return base.prototype[ prop ].apply( this, arguments );
			}

			function _superApply( args ) {
				return base.prototype[ prop ].apply( this, args );
			}

			return function() {
				var __super = this._super;
				var __superApply = this._superApply;
				var returnValue;

				this._super = _super;
				this._superApply = _superApply;

				returnValue = value.apply( this, arguments );

				this._super = __super;
				this._superApply = __superApply;

				return returnValue;
			};
		} )();
	} );
	constructor.prototype = $.widget.extend( basePrototype, {

		// TODO: remove support for widgetEventPrefix
		// always use the name + a colon as the prefix, e.g., draggable:start
		// don't prefix for widgets that aren't DOM-based
		widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
	}, proxiedPrototype, {
		constructor: constructor,
		namespace: namespace,
		widgetName: name,
		widgetFullName: fullName
	} );

	// If this widget is being redefined then we need to find all widgets that
	// are inheriting from it and redefine all of them so that they inherit from
	// the new version of this widget. We're essentially trying to replace one
	// level in the prototype chain.
	if ( existingConstructor ) {
		$.each( existingConstructor._childConstructors, function( i, child ) {
			var childPrototype = child.prototype;

			// Redefine the child widget using the same prototype that was
			// originally used, but inherit from the new version of the base
			$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
				child._proto );
		} );

		// Remove the list of existing child constructors from the old constructor
		// so the old child constructors can be garbage collected
		delete existingConstructor._childConstructors;
	} else {
		base._childConstructors.push( constructor );
	}

	$.widget.bridge( name, constructor );

	return constructor;
};

$.widget.extend = function( target ) {
	var input = widgetSlice.call( arguments, 1 );
	var inputIndex = 0;
	var inputLength = input.length;
	var key;
	var value;

	for ( ; inputIndex < inputLength; inputIndex++ ) {
		for ( key in input[ inputIndex ] ) {
			value = input[ inputIndex ][ key ];
			if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {

				// Clone objects
				if ( $.isPlainObject( value ) ) {
					target[ key ] = $.isPlainObject( target[ key ] ) ?
						$.widget.extend( {}, target[ key ], value ) :

						// Don't extend strings, arrays, etc. with objects
						$.widget.extend( {}, value );

				// Copy everything else by reference
				} else {
					target[ key ] = value;
				}
			}
		}
	}
	return target;
};

$.widget.bridge = function( name, object ) {
	var fullName = object.prototype.widgetFullName || name;
	$.fn[ name ] = function( options ) {
		var isMethodCall = typeof options === "string";
		var args = widgetSlice.call( arguments, 1 );
		var returnValue = this;

		if ( isMethodCall ) {

			// If this is an empty collection, we need to have the instance method
			// return undefined instead of the jQuery instance
			if ( !this.length && options === "instance" ) {
				returnValue = undefined;
			} else {
				this.each( function() {
					var methodValue;
					var instance = $.data( this, fullName );

					if ( options === "instance" ) {
						returnValue = instance;
						return false;
					}

					if ( !instance ) {
						return $.error( "cannot call methods on " + name +
							" prior to initialization; " +
							"attempted to call method '" + options + "'" );
					}

					if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
						return $.error( "no such method '" + options + "' for " + name +
							" widget instance" );
					}

					methodValue = instance[ options ].apply( instance, args );

					if ( methodValue !== instance && methodValue !== undefined ) {
						returnValue = methodValue && methodValue.jquery ?
							returnValue.pushStack( methodValue.get() ) :
							methodValue;
						return false;
					}
				} );
			}
		} else {

			// Allow multiple hashes to be passed on init
			if ( args.length ) {
				options = $.widget.extend.apply( null, [ options ].concat( args ) );
			}

			this.each( function() {
				var instance = $.data( this, fullName );
				if ( instance ) {
					instance.option( options || {} );
					if ( instance._init ) {
						instance._init();
					}
				} else {
					$.data( this, fullName, new object( options, this ) );
				}
			} );
		}

		return returnValue;
	};
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
	widgetName: "widget",
	widgetEventPrefix: "",
	defaultElement: "<div>",

	options: {
		classes: {},
		disabled: false,

		// Callbacks
		create: null
	},

	_createWidget: function( options, element ) {
		element = $( element || this.defaultElement || this )[ 0 ];
		this.element = $( element );
		this.uuid = widgetUuid++;
		this.eventNamespace = "." + this.widgetName + this.uuid;

		this.bindings = $();
		this.hoverable = $();
		this.focusable = $();
		this.classesElementLookup = {};

		if ( element !== this ) {
			$.data( element, this.widgetFullName, this );
			this._on( true, this.element, {
				remove: function( event ) {
					if ( event.target === element ) {
						this.destroy();
					}
				}
			} );
			this.document = $( element.style ?

				// Element within the document
				element.ownerDocument :

				// Element is window or document
				element.document || element );
			this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
		}

		this.options = $.widget.extend( {},
			this.options,
			this._getCreateOptions(),
			options );

		this._create();

		if ( this.options.disabled ) {
			this._setOptionDisabled( this.options.disabled );
		}

		this._trigger( "create", null, this._getCreateEventData() );
		this._init();
	},

	_getCreateOptions: function() {
		return {};
	},

	_getCreateEventData: $.noop,

	_create: $.noop,

	_init: $.noop,

	destroy: function() {
		var that = this;

		this._destroy();
		$.each( this.classesElementLookup, function( key, value ) {
			that._removeClass( value, key );
		} );

		// We can probably remove the unbind calls in 2.0
		// all event bindings should go through this._on()
		this.element
			.off( this.eventNamespace )
			.removeData( this.widgetFullName );
		this.widget()
			.off( this.eventNamespace )
			.removeAttr( "aria-disabled" );

		// Clean up events and states
		this.bindings.off( this.eventNamespace );
	},

	_destroy: $.noop,

	widget: function() {
		return this.element;
	},

	option: function( key, value ) {
		var options = key;
		var parts;
		var curOption;
		var i;

		if ( arguments.length === 0 ) {

			// Don't return a reference to the internal hash
			return $.widget.extend( {}, this.options );
		}

		if ( typeof key === "string" ) {

			// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
			options = {};
			parts = key.split( "." );
			key = parts.shift();
			if ( parts.length ) {
				curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
				for ( i = 0; i < parts.length - 1; i++ ) {
					curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
					curOption = curOption[ parts[ i ] ];
				}
				key = parts.pop();
				if ( arguments.length === 1 ) {
					return curOption[ key ] === undefined ? null : curOption[ key ];
				}
				curOption[ key ] = value;
			} else {
				if ( arguments.length === 1 ) {
					return this.options[ key ] === undefined ? null : this.options[ key ];
				}
				options[ key ] = value;
			}
		}

		this._setOptions( options );

		return this;
	},

	_setOptions: function( options ) {
		var key;

		for ( key in options ) {
			this._setOption( key, options[ key ] );
		}

		return this;
	},

	_setOption: function( key, value ) {
		if ( key === "classes" ) {
			this._setOptionClasses( value );
		}

		this.options[ key ] = value;

		if ( key === "disabled" ) {
			this._setOptionDisabled( value );
		}

		return this;
	},

	_setOptionClasses: function( value ) {
		var classKey, elements, currentElements;

		for ( classKey in value ) {
			currentElements = this.classesElementLookup[ classKey ];
			if ( value[ classKey ] === this.options.classes[ classKey ] ||
					!currentElements ||
					!currentElements.length ) {
				continue;
			}

			// We are doing this to create a new jQuery object because the _removeClass() call
			// on the next line is going to destroy the reference to the current elements being
			// tracked. We need to save a copy of this collection so that we can add the new classes
			// below.
			elements = $( currentElements.get() );
			this._removeClass( currentElements, classKey );

			// We don't use _addClass() here, because that uses this.options.classes
			// for generating the string of classes. We want to use the value passed in from
			// _setOption(), this is the new value of the classes option which was passed to
			// _setOption(). We pass this value directly to _classes().
			elements.addClass( this._classes( {
				element: elements,
				keys: classKey,
				classes: value,
				add: true
			} ) );
		}
	},

	_setOptionDisabled: function( value ) {
		this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );

		// If the widget is becoming disabled, then nothing is interactive
		if ( value ) {
			this._removeClass( this.hoverable, null, "ui-state-hover" );
			this._removeClass( this.focusable, null, "ui-state-focus" );
		}
	},

	enable: function() {
		return this._setOptions( { disabled: false } );
	},

	disable: function() {
		return this._setOptions( { disabled: true } );
	},

	_classes: function( options ) {
		var full = [];
		var that = this;

		options = $.extend( {
			element: this.element,
			classes: this.options.classes || {}
		}, options );

		function processClassString( classes, checkOption ) {
			var current, i;
			for ( i = 0; i < classes.length; i++ ) {
				current = that.classesElementLookup[ classes[ i ] ] || $();
				if ( options.add ) {
					current = $( $.unique( current.get().concat( options.element.get() ) ) );
				} else {
					current = $( current.not( options.element ).get() );
				}
				that.classesElementLookup[ classes[ i ] ] = current;
				full.push( classes[ i ] );
				if ( checkOption && options.classes[ classes[ i ] ] ) {
					full.push( options.classes[ classes[ i ] ] );
				}
			}
		}

		this._on( options.element, {
			"remove": "_untrackClassesElement"
		} );

		if ( options.keys ) {
			processClassString( options.keys.match( /\S+/g ) || [], true );
		}
		if ( options.extra ) {
			processClassString( options.extra.match( /\S+/g ) || [] );
		}

		return full.join( " " );
	},

	_untrackClassesElement: function( event ) {
		var that = this;
		$.each( that.classesElementLookup, function( key, value ) {
			if ( $.inArray( event.target, value ) !== -1 ) {
				that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
			}
		} );
	},

	_removeClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, false );
	},

	_addClass: function( element, keys, extra ) {
		return this._toggleClass( element, keys, extra, true );
	},

	_toggleClass: function( element, keys, extra, add ) {
		add = ( typeof add === "boolean" ) ? add : extra;
		var shift = ( typeof element === "string" || element === null ),
			options = {
				extra: shift ? keys : extra,
				keys: shift ? element : keys,
				element: shift ? this.element : element,
				add: add
			};
		options.element.toggleClass( this._classes( options ), add );
		return this;
	},

	_on: function( suppressDisabledCheck, element, handlers ) {
		var delegateElement;
		var instance = this;

		// No suppressDisabledCheck flag, shuffle arguments
		if ( typeof suppressDisabledCheck !== "boolean" ) {
			handlers = element;
			element = suppressDisabledCheck;
			suppressDisabledCheck = false;
		}

		// No element argument, shuffle and use this.element
		if ( !handlers ) {
			handlers = element;
			element = this.element;
			delegateElement = this.widget();
		} else {
			element = delegateElement = $( element );
			this.bindings = this.bindings.add( element );
		}

		$.each( handlers, function( event, handler ) {
			function handlerProxy() {

				// Allow widgets to customize the disabled handling
				// - disabled as an array instead of boolean
				// - disabled class as method for disabling individual parts
				if ( !suppressDisabledCheck &&
						( instance.options.disabled === true ||
						$( this ).hasClass( "ui-state-disabled" ) ) ) {
					return;
				}
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}

			// Copy the guid so direct unbinding works
			if ( typeof handler !== "string" ) {
				handlerProxy.guid = handler.guid =
					handler.guid || handlerProxy.guid || $.guid++;
			}

			var match = event.match( /^([\w:-]*)\s*(.*)$/ );
			var eventName = match[ 1 ] + instance.eventNamespace;
			var selector = match[ 2 ];

			if ( selector ) {
				delegateElement.on( eventName, selector, handlerProxy );
			} else {
				element.on( eventName, handlerProxy );
			}
		} );
	},

	_off: function( element, eventName ) {
		eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
			this.eventNamespace;
		element.off( eventName ).off( eventName );

		// Clear the stack to avoid memory leaks (#10056)
		this.bindings = $( this.bindings.not( element ).get() );
		this.focusable = $( this.focusable.not( element ).get() );
		this.hoverable = $( this.hoverable.not( element ).get() );
	},

	_delay: function( handler, delay ) {
		function handlerProxy() {
			return ( typeof handler === "string" ? instance[ handler ] : handler )
				.apply( instance, arguments );
		}
		var instance = this;
		return setTimeout( handlerProxy, delay || 0 );
	},

	_hoverable: function( element ) {
		this.hoverable = this.hoverable.add( element );
		this._on( element, {
			mouseenter: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
			},
			mouseleave: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
			}
		} );
	},

	_focusable: function( element ) {
		this.focusable = this.focusable.add( element );
		this._on( element, {
			focusin: function( event ) {
				this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
			},
			focusout: function( event ) {
				this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
			}
		} );
	},

	_trigger: function( type, event, data ) {
		var prop, orig;
		var callback = this.options[ type ];

		data = data || {};
		event = $.Event( event );
		event.type = ( type === this.widgetEventPrefix ?
			type :
			this.widgetEventPrefix + type ).toLowerCase();

		// The original event may come from any element
		// so we need to reset the target on the new event
		event.target = this.element[ 0 ];

		// Copy original event properties over to the new event
		orig = event.originalEvent;
		if ( orig ) {
			for ( prop in orig ) {
				if ( !( prop in event ) ) {
					event[ prop ] = orig[ prop ];
				}
			}
		}

		this.element.trigger( event, data );
		return !( $.isFunction( callback ) &&
			callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
			event.isDefaultPrevented() );
	}
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
	$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
		if ( typeof options === "string" ) {
			options = { effect: options };
		}

		var hasOptions;
		var effectName = !options ?
			method :
			options === true || typeof options === "number" ?
				defaultEffect :
				options.effect || defaultEffect;

		options = options || {};
		if ( typeof options === "number" ) {
			options = { duration: options };
		}

		hasOptions = !$.isEmptyObject( options );
		options.complete = callback;

		if ( options.delay ) {
			element.delay( options.delay );
		}

		if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
			element[ method ]( options );
		} else if ( effectName !== method && element[ effectName ] ) {
			element[ effectName ]( options.duration, options.easing, callback );
		} else {
			element.queue( function( next ) {
				$( this )[ method ]();
				if ( callback ) {
					callback.call( element[ 0 ] );
				}
				next();
			} );
		}
	};
} );

var widget = $.widget;


/*!
 * jQuery UI Position 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */

//>>label: Position
//>>group: Core
//>>description: Positions elements relative to other elements.
//>>docs: http://api.jqueryui.com/position/
//>>demos: http://jqueryui.com/position/


( function() {
var cachedScrollbarWidth,
	max = Math.max,
	abs = Math.abs,
	rhorizontal = /left|center|right/,
	rvertical = /top|center|bottom/,
	roffset = /[\+\-]\d+(\.[\d]+)?%?/,
	rposition = /^\w+/,
	rpercent = /%$/,
	_position = $.fn.position;

function getOffsets( offsets, width, height ) {
	return [
		parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
		parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
	];
}

function parseCss( element, property ) {
	return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
	var raw = elem[ 0 ];
	if ( raw.nodeType === 9 ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: 0, left: 0 }
		};
	}
	if ( $.isWindow( raw ) ) {
		return {
			width: elem.width(),
			height: elem.height(),
			offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
		};
	}
	if ( raw.preventDefault ) {
		return {
			width: 0,
			height: 0,
			offset: { top: raw.pageY, left: raw.pageX }
		};
	}
	return {
		width: elem.outerWidth(),
		height: elem.outerHeight(),
		offset: elem.offset()
	};
}

$.position = {
	scrollbarWidth: function() {
		if ( cachedScrollbarWidth !== undefined ) {
			return cachedScrollbarWidth;
		}
		var w1, w2,
			div = $( "<div " +
				"style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'>" +
				"<div style='height:100px;width:auto;'></div></div>" ),
			innerDiv = div.children()[ 0 ];

		$( "body" ).append( div );
		w1 = innerDiv.offsetWidth;
		div.css( "overflow", "scroll" );

		w2 = innerDiv.offsetWidth;

		if ( w1 === w2 ) {
			w2 = div[ 0 ].clientWidth;
		}

		div.remove();

		return ( cachedScrollbarWidth = w1 - w2 );
	},
	getScrollInfo: function( within ) {
		var overflowX = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-x" ),
			overflowY = within.isWindow || within.isDocument ? "" :
				within.element.css( "overflow-y" ),
			hasOverflowX = overflowX === "scroll" ||
				( overflowX === "auto" && within.width < within.element[ 0 ].scrollWidth ),
			hasOverflowY = overflowY === "scroll" ||
				( overflowY === "auto" && within.height < within.element[ 0 ].scrollHeight );
		return {
			width: hasOverflowY ? $.position.scrollbarWidth() : 0,
			height: hasOverflowX ? $.position.scrollbarWidth() : 0
		};
	},
	getWithinInfo: function( element ) {
		var withinElement = $( element || window ),
			isWindow = $.isWindow( withinElement[ 0 ] ),
			isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9,
			hasOffset = !isWindow && !isDocument;
		return {
			element: withinElement,
			isWindow: isWindow,
			isDocument: isDocument,
			offset: hasOffset ? $( element ).offset() : { left: 0, top: 0 },
			scrollLeft: withinElement.scrollLeft(),
			scrollTop: withinElement.scrollTop(),
			width: withinElement.outerWidth(),
			height: withinElement.outerHeight()
		};
	}
};

$.fn.position = function( options ) {
	if ( !options || !options.of ) {
		return _position.apply( this, arguments );
	}

	// Make a copy, we don't want to modify arguments
	options = $.extend( {}, options );

	var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
		target = $( options.of ),
		within = $.position.getWithinInfo( options.within ),
		scrollInfo = $.position.getScrollInfo( within ),
		collision = ( options.collision || "flip" ).split( " " ),
		offsets = {};

	dimensions = getDimensions( target );
	if ( target[ 0 ].preventDefault ) {

		// Force left top to allow flipping
		options.at = "left top";
	}
	targetWidth = dimensions.width;
	targetHeight = dimensions.height;
	targetOffset = dimensions.offset;

	// Clone to reuse original targetOffset later
	basePosition = $.extend( {}, targetOffset );

	// Force my and at to have valid horizontal and vertical positions
	// if a value is missing or invalid, it will be converted to center
	$.each( [ "my", "at" ], function() {
		var pos = ( options[ this ] || "" ).split( " " ),
			horizontalOffset,
			verticalOffset;

		if ( pos.length === 1 ) {
			pos = rhorizontal.test( pos[ 0 ] ) ?
				pos.concat( [ "center" ] ) :
				rvertical.test( pos[ 0 ] ) ?
					[ "center" ].concat( pos ) :
					[ "center", "center" ];
		}
		pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
		pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

		// Calculate offsets
		horizontalOffset = roffset.exec( pos[ 0 ] );
		verticalOffset = roffset.exec( pos[ 1 ] );
		offsets[ this ] = [
			horizontalOffset ? horizontalOffset[ 0 ] : 0,
			verticalOffset ? verticalOffset[ 0 ] : 0
		];

		// Reduce to just the positions without the offsets
		options[ this ] = [
			rposition.exec( pos[ 0 ] )[ 0 ],
			rposition.exec( pos[ 1 ] )[ 0 ]
		];
	} );

	// Normalize collision option
	if ( collision.length === 1 ) {
		collision[ 1 ] = collision[ 0 ];
	}

	if ( options.at[ 0 ] === "right" ) {
		basePosition.left += targetWidth;
	} else if ( options.at[ 0 ] === "center" ) {
		basePosition.left += targetWidth / 2;
	}

	if ( options.at[ 1 ] === "bottom" ) {
		basePosition.top += targetHeight;
	} else if ( options.at[ 1 ] === "center" ) {
		basePosition.top += targetHeight / 2;
	}

	atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
	basePosition.left += atOffset[ 0 ];
	basePosition.top += atOffset[ 1 ];

	return this.each( function() {
		var collisionPosition, using,
			elem = $( this ),
			elemWidth = elem.outerWidth(),
			elemHeight = elem.outerHeight(),
			marginLeft = parseCss( this, "marginLeft" ),
			marginTop = parseCss( this, "marginTop" ),
			collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) +
				scrollInfo.width,
			collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) +
				scrollInfo.height,
			position = $.extend( {}, basePosition ),
			myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

		if ( options.my[ 0 ] === "right" ) {
			position.left -= elemWidth;
		} else if ( options.my[ 0 ] === "center" ) {
			position.left -= elemWidth / 2;
		}

		if ( options.my[ 1 ] === "bottom" ) {
			position.top -= elemHeight;
		} else if ( options.my[ 1 ] === "center" ) {
			position.top -= elemHeight / 2;
		}

		position.left += myOffset[ 0 ];
		position.top += myOffset[ 1 ];

		collisionPosition = {
			marginLeft: marginLeft,
			marginTop: marginTop
		};

		$.each( [ "left", "top" ], function( i, dir ) {
			if ( $.ui.position[ collision[ i ] ] ) {
				$.ui.position[ collision[ i ] ][ dir ]( position, {
					targetWidth: targetWidth,
					targetHeight: targetHeight,
					elemWidth: elemWidth,
					elemHeight: elemHeight,
					collisionPosition: collisionPosition,
					collisionWidth: collisionWidth,
					collisionHeight: collisionHeight,
					offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
					my: options.my,
					at: options.at,
					within: within,
					elem: elem
				} );
			}
		} );

		if ( options.using ) {

			// Adds feedback as second argument to using callback, if present
			using = function( props ) {
				var left = targetOffset.left - position.left,
					right = left + targetWidth - elemWidth,
					top = targetOffset.top - position.top,
					bottom = top + targetHeight - elemHeight,
					feedback = {
						target: {
							element: target,
							left: targetOffset.left,
							top: targetOffset.top,
							width: targetWidth,
							height: targetHeight
						},
						element: {
							element: elem,
							left: position.left,
							top: position.top,
							width: elemWidth,
							height: elemHeight
						},
						horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
						vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
					};
				if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
					feedback.horizontal = "center";
				}
				if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
					feedback.vertical = "middle";
				}
				if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
					feedback.important = "horizontal";
				} else {
					feedback.important = "vertical";
				}
				options.using.call( this, props, feedback );
			};
		}

		elem.offset( $.extend( position, { using: using } ) );
	} );
};

$.ui.position = {
	fit: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
				outerWidth = within.width,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = withinOffset - collisionPosLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
				newOverRight;

			// Element is wider than within
			if ( data.collisionWidth > outerWidth ) {

				// Element is initially over the left side of within
				if ( overLeft > 0 && overRight <= 0 ) {
					newOverRight = position.left + overLeft + data.collisionWidth - outerWidth -
						withinOffset;
					position.left += overLeft - newOverRight;

				// Element is initially over right side of within
				} else if ( overRight > 0 && overLeft <= 0 ) {
					position.left = withinOffset;

				// Element is initially over both left and right sides of within
				} else {
					if ( overLeft > overRight ) {
						position.left = withinOffset + outerWidth - data.collisionWidth;
					} else {
						position.left = withinOffset;
					}
				}

			// Too far left -> align with left edge
			} else if ( overLeft > 0 ) {
				position.left += overLeft;

			// Too far right -> align with right edge
			} else if ( overRight > 0 ) {
				position.left -= overRight;

			// Adjust based on position and margin
			} else {
				position.left = max( position.left - collisionPosLeft, position.left );
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
				outerHeight = data.within.height,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = withinOffset - collisionPosTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
				newOverBottom;

			// Element is taller than within
			if ( data.collisionHeight > outerHeight ) {

				// Element is initially over the top of within
				if ( overTop > 0 && overBottom <= 0 ) {
					newOverBottom = position.top + overTop + data.collisionHeight - outerHeight -
						withinOffset;
					position.top += overTop - newOverBottom;

				// Element is initially over bottom of within
				} else if ( overBottom > 0 && overTop <= 0 ) {
					position.top = withinOffset;

				// Element is initially over both top and bottom of within
				} else {
					if ( overTop > overBottom ) {
						position.top = withinOffset + outerHeight - data.collisionHeight;
					} else {
						position.top = withinOffset;
					}
				}

			// Too far up -> align with top
			} else if ( overTop > 0 ) {
				position.top += overTop;

			// Too far down -> align with bottom edge
			} else if ( overBottom > 0 ) {
				position.top -= overBottom;

			// Adjust based on position and margin
			} else {
				position.top = max( position.top - collisionPosTop, position.top );
			}
		}
	},
	flip: {
		left: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.left + within.scrollLeft,
				outerWidth = within.width,
				offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
				collisionPosLeft = position.left - data.collisionPosition.marginLeft,
				overLeft = collisionPosLeft - offsetLeft,
				overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
				myOffset = data.my[ 0 ] === "left" ?
					-data.elemWidth :
					data.my[ 0 ] === "right" ?
						data.elemWidth :
						0,
				atOffset = data.at[ 0 ] === "left" ?
					data.targetWidth :
					data.at[ 0 ] === "right" ?
						-data.targetWidth :
						0,
				offset = -2 * data.offset[ 0 ],
				newOverRight,
				newOverLeft;

			if ( overLeft < 0 ) {
				newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth -
					outerWidth - withinOffset;
				if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
					position.left += myOffset + atOffset + offset;
				}
			} else if ( overRight > 0 ) {
				newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset +
					atOffset + offset - offsetLeft;
				if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
					position.left += myOffset + atOffset + offset;
				}
			}
		},
		top: function( position, data ) {
			var within = data.within,
				withinOffset = within.offset.top + within.scrollTop,
				outerHeight = within.height,
				offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
				collisionPosTop = position.top - data.collisionPosition.marginTop,
				overTop = collisionPosTop - offsetTop,
				overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
				top = data.my[ 1 ] === "top",
				myOffset = top ?
					-data.elemHeight :
					data.my[ 1 ] === "bottom" ?
						data.elemHeight :
						0,
				atOffset = data.at[ 1 ] === "top" ?
					data.targetHeight :
					data.at[ 1 ] === "bottom" ?
						-data.targetHeight :
						0,
				offset = -2 * data.offset[ 1 ],
				newOverTop,
				newOverBottom;
			if ( overTop < 0 ) {
				newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight -
					outerHeight - withinOffset;
				if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
					position.top += myOffset + atOffset + offset;
				}
			} else if ( overBottom > 0 ) {
				newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset +
					offset - offsetTop;
				if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
					position.top += myOffset + atOffset + offset;
				}
			}
		}
	},
	flipfit: {
		left: function() {
			$.ui.position.flip.left.apply( this, arguments );
			$.ui.position.fit.left.apply( this, arguments );
		},
		top: function() {
			$.ui.position.flip.top.apply( this, arguments );
			$.ui.position.fit.top.apply( this, arguments );
		}
	}
};

} )();

var position = $.ui.position;


/*!
 * jQuery UI :data 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: :data Selector
//>>group: Core
//>>description: Selects elements which have data stored under the specified key.
//>>docs: http://api.jqueryui.com/data-selector/


var data = $.extend( $.expr[ ":" ], {
	data: $.expr.createPseudo ?
		$.expr.createPseudo( function( dataName ) {
			return function( elem ) {
				return !!$.data( elem, dataName );
			};
		} ) :

		// Support: jQuery <1.8
		function( elem, i, match ) {
			return !!$.data( elem, match[ 3 ] );
		}
} );

/*!
 * jQuery UI Keycode 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Keycode
//>>group: Core
//>>description: Provide keycodes as keynames
//>>docs: http://api.jqueryui.com/jQuery.ui.keyCode/


var keycode = $.ui.keyCode = {
	BACKSPACE: 8,
	COMMA: 188,
	DELETE: 46,
	DOWN: 40,
	END: 35,
	ENTER: 13,
	ESCAPE: 27,
	HOME: 36,
	LEFT: 37,
	PAGE_DOWN: 34,
	PAGE_UP: 33,
	PERIOD: 190,
	RIGHT: 39,
	SPACE: 32,
	TAB: 9,
	UP: 38
};


/*!
 * jQuery UI Scroll Parent 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: scrollParent
//>>group: Core
//>>description: Get the closest ancestor element that is scrollable.
//>>docs: http://api.jqueryui.com/scrollParent/



var scrollParent = $.fn.scrollParent = function( includeHidden ) {
	var position = this.css( "position" ),
		excludeStaticParent = position === "absolute",
		overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
		scrollParent = this.parents().filter( function() {
			var parent = $( this );
			if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
				return false;
			}
			return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) +
				parent.css( "overflow-x" ) );
		} ).eq( 0 );

	return position === "fixed" || !scrollParent.length ?
		$( this[ 0 ].ownerDocument || document ) :
		scrollParent;
};


/*!
 * jQuery UI Unique ID 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: uniqueId
//>>group: Core
//>>description: Functions to generate and remove uniqueId's
//>>docs: http://api.jqueryui.com/uniqueId/



var uniqueId = $.fn.extend( {
	uniqueId: ( function() {
		var uuid = 0;

		return function() {
			return this.each( function() {
				if ( !this.id ) {
					this.id = "ui-id-" + ( ++uuid );
				}
			} );
		};
	} )(),

	removeUniqueId: function() {
		return this.each( function() {
			if ( /^ui-id-\d+$/.test( this.id ) ) {
				$( this ).removeAttr( "id" );
			}
		} );
	}
} );




// This file is deprecated
var ie = $.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

/*!
 * jQuery UI Mouse 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Mouse
//>>group: Widgets
//>>description: Abstracts mouse-based interactions to assist in creating certain widgets.
//>>docs: http://api.jqueryui.com/mouse/



var mouseHandled = false;
$( document ).on( "mouseup", function() {
	mouseHandled = false;
} );

var widgetsMouse = $.widget( "ui.mouse", {
	version: "1.12.1",
	options: {
		cancel: "input, textarea, button, select, option",
		distance: 1,
		delay: 0
	},
	_mouseInit: function() {
		var that = this;

		this.element
			.on( "mousedown." + this.widgetName, function( event ) {
				return that._mouseDown( event );
			} )
			.on( "click." + this.widgetName, function( event ) {
				if ( true === $.data( event.target, that.widgetName + ".preventClickEvent" ) ) {
					$.removeData( event.target, that.widgetName + ".preventClickEvent" );
					event.stopImmediatePropagation();
					return false;
				}
			} );

		this.started = false;
	},

	// TODO: make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	_mouseDestroy: function() {
		this.element.off( "." + this.widgetName );
		if ( this._mouseMoveDelegate ) {
			this.document
				.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
				.off( "mouseup." + this.widgetName, this._mouseUpDelegate );
		}
	},

	_mouseDown: function( event ) {

		// don't let more than one widget handle mouseStart
		if ( mouseHandled ) {
			return;
		}

		this._mouseMoved = false;

		// We may have missed mouseup (out of window)
		( this._mouseStarted && this._mouseUp( event ) );

		this._mouseDownEvent = event;

		var that = this,
			btnIsLeft = ( event.which === 1 ),

			// event.target.nodeName works around a bug in IE 8 with
			// disabled inputs (#7620)
			elIsCancel = ( typeof this.options.cancel === "string" && event.target.nodeName ?
				$( event.target ).closest( this.options.cancel ).length : false );
		if ( !btnIsLeft || elIsCancel || !this._mouseCapture( event ) ) {
			return true;
		}

		this.mouseDelayMet = !this.options.delay;
		if ( !this.mouseDelayMet ) {
			this._mouseDelayTimer = setTimeout( function() {
				that.mouseDelayMet = true;
			}, this.options.delay );
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted = ( this._mouseStart( event ) !== false );
			if ( !this._mouseStarted ) {
				event.preventDefault();
				return true;
			}
		}

		// Click event may never have fired (Gecko & Opera)
		if ( true === $.data( event.target, this.widgetName + ".preventClickEvent" ) ) {
			$.removeData( event.target, this.widgetName + ".preventClickEvent" );
		}

		// These delegates are required to keep context
		this._mouseMoveDelegate = function( event ) {
			return that._mouseMove( event );
		};
		this._mouseUpDelegate = function( event ) {
			return that._mouseUp( event );
		};

		this.document
			.on( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.on( "mouseup." + this.widgetName, this._mouseUpDelegate );

		event.preventDefault();

		mouseHandled = true;
		return true;
	},

	_mouseMove: function( event ) {

		// Only check for mouseups outside the document if you've moved inside the document
		// at least once. This prevents the firing of mouseup in the case of IE<9, which will
		// fire a mousemove event if content is placed under the cursor. See #7778
		// Support: IE <9
		if ( this._mouseMoved ) {

			// IE mouseup check - mouseup happened when mouse was out of window
			if ( $.ui.ie && ( !document.documentMode || document.documentMode < 9 ) &&
					!event.button ) {
				return this._mouseUp( event );

			// Iframe mouseup check - mouseup occurred in another document
			} else if ( !event.which ) {

				// Support: Safari <=8 - 9
				// Safari sets which to 0 if you press any of the following keys
				// during a drag (#14461)
				if ( event.originalEvent.altKey || event.originalEvent.ctrlKey ||
						event.originalEvent.metaKey || event.originalEvent.shiftKey ) {
					this.ignoreMissingWhich = true;
				} else if ( !this.ignoreMissingWhich ) {
					return this._mouseUp( event );
				}
			}
		}

		if ( event.which || event.button ) {
			this._mouseMoved = true;
		}

		if ( this._mouseStarted ) {
			this._mouseDrag( event );
			return event.preventDefault();
		}

		if ( this._mouseDistanceMet( event ) && this._mouseDelayMet( event ) ) {
			this._mouseStarted =
				( this._mouseStart( this._mouseDownEvent, event ) !== false );
			( this._mouseStarted ? this._mouseDrag( event ) : this._mouseUp( event ) );
		}

		return !this._mouseStarted;
	},

	_mouseUp: function( event ) {
		this.document
			.off( "mousemove." + this.widgetName, this._mouseMoveDelegate )
			.off( "mouseup." + this.widgetName, this._mouseUpDelegate );

		if ( this._mouseStarted ) {
			this._mouseStarted = false;

			if ( event.target === this._mouseDownEvent.target ) {
				$.data( event.target, this.widgetName + ".preventClickEvent", true );
			}

			this._mouseStop( event );
		}

		if ( this._mouseDelayTimer ) {
			clearTimeout( this._mouseDelayTimer );
			delete this._mouseDelayTimer;
		}

		this.ignoreMissingWhich = false;
		mouseHandled = false;
		event.preventDefault();
	},

	_mouseDistanceMet: function( event ) {
		return ( Math.max(
				Math.abs( this._mouseDownEvent.pageX - event.pageX ),
				Math.abs( this._mouseDownEvent.pageY - event.pageY )
			) >= this.options.distance
		);
	},

	_mouseDelayMet: function( /* event */ ) {
		return this.mouseDelayMet;
	},

	// These are placeholder methods, to be overriden by extending plugin
	_mouseStart: function( /* event */ ) {},
	_mouseDrag: function( /* event */ ) {},
	_mouseStop: function( /* event */ ) {},
	_mouseCapture: function( /* event */ ) { return true; }
} );


/*!
 * jQuery UI Sortable 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Sortable
//>>group: Interactions
//>>description: Enables items in a list to be sorted using the mouse.
//>>docs: http://api.jqueryui.com/sortable/
//>>demos: http://jqueryui.com/sortable/
//>>css.structure: ../../themes/base/sortable.css



var widgetsSortable = $.widget( "ui.sortable", $.ui.mouse, {
	version: "1.12.1",
	widgetEventPrefix: "sort",
	ready: false,
	options: {
		appendTo: "parent",
		axis: false,
		connectWith: false,
		containment: false,
		cursor: "auto",
		cursorAt: false,
		dropOnEmpty: true,
		forcePlaceholderSize: false,
		forceHelperSize: false,
		grid: false,
		handle: false,
		helper: "original",
		items: "> *",
		opacity: false,
		placeholder: false,
		revert: false,
		scroll: true,
		scrollSensitivity: 20,
		scrollSpeed: 20,
		scope: "default",
		tolerance: "intersect",
		zIndex: 1000,

		// Callbacks
		activate: null,
		beforeStop: null,
		change: null,
		deactivate: null,
		out: null,
		over: null,
		receive: null,
		remove: null,
		sort: null,
		start: null,
		stop: null,
		update: null
	},

	_isOverAxis: function( x, reference, size ) {
		return ( x >= reference ) && ( x < ( reference + size ) );
	},

	_isFloating: function( item ) {
		return ( /left|right/ ).test( item.css( "float" ) ) ||
			( /inline|table-cell/ ).test( item.css( "display" ) );
	},

	_create: function() {
		this.containerCache = {};
		this._addClass( "ui-sortable" );

		//Get the items
		this.refresh();

		//Let's determine the parent's offset
		this.offset = this.element.offset();

		//Initialize mouse events for interaction
		this._mouseInit();

		this._setHandleClassName();

		//We're ready to go
		this.ready = true;

	},

	_setOption: function( key, value ) {
		this._super( key, value );

		if ( key === "handle" ) {
			this._setHandleClassName();
		}
	},

	_setHandleClassName: function() {
		var that = this;
		this._removeClass( this.element.find( ".ui-sortable-handle" ), "ui-sortable-handle" );
		$.each( this.items, function() {
			that._addClass(
				this.instance.options.handle ?
					this.item.find( this.instance.options.handle ) :
					this.item,
				"ui-sortable-handle"
			);
		} );
	},

	_destroy: function() {
		this._mouseDestroy();

		for ( var i = this.items.length - 1; i >= 0; i-- ) {
			this.items[ i ].item.removeData( this.widgetName + "-item" );
		}

		return this;
	},

	_mouseCapture: function( event, overrideHandle ) {
		var currentItem = null,
			validHandle = false,
			that = this;

		if ( this.reverting ) {
			return false;
		}

		if ( this.options.disabled || this.options.type === "static" ) {
			return false;
		}

		//We have to refresh the items data once first
		this._refreshItems( event );

		//Find out if the clicked node (or one of its parents) is a actual item in this.items
		$( event.target ).parents().each( function() {
			if ( $.data( this, that.widgetName + "-item" ) === that ) {
				currentItem = $( this );
				return false;
			}
		} );
		if ( $.data( event.target, that.widgetName + "-item" ) === that ) {
			currentItem = $( event.target );
		}

		if ( !currentItem ) {
			return false;
		}
		if ( this.options.handle && !overrideHandle ) {
			$( this.options.handle, currentItem ).find( "*" ).addBack().each( function() {
				if ( this === event.target ) {
					validHandle = true;
				}
			} );
			if ( !validHandle ) {
				return false;
			}
		}

		this.currentItem = currentItem;
		this._removeCurrentsFromItems();
		return true;

	},

	_mouseStart: function( event, overrideHandle, noActivation ) {

		var i, body,
			o = this.options;

		this.currentContainer = this;

		//We only need to call refreshPositions, because the refreshItems call has been moved to
		// mouseCapture
		this.refreshPositions();

		//Create and append the visible helper
		this.helper = this._createHelper( event );

		//Cache the helper size
		this._cacheHelperProportions();

		/*
		 * - Position generation -
		 * This block generates everything position related - it's the core of draggables.
		 */

		//Cache the margins of the original element
		this._cacheMargins();

		//Get the next scrolling parent
		this.scrollParent = this.helper.scrollParent();

		//The element's absolute position on the page minus margins
		this.offset = this.currentItem.offset();
		this.offset = {
			top: this.offset.top - this.margins.top,
			left: this.offset.left - this.margins.left
		};

		$.extend( this.offset, {
			click: { //Where the click happened, relative to the element
				left: event.pageX - this.offset.left,
				top: event.pageY - this.offset.top
			},
			parent: this._getParentOffset(),

			// This is a relative to absolute position minus the actual position calculation -
			// only used for relative positioned helper
			relative: this._getRelativeOffset()
		} );

		// Only after we got the offset, we can change the helper's position to absolute
		// TODO: Still need to figure out a way to make relative sorting possible
		this.helper.css( "position", "absolute" );
		this.cssPosition = this.helper.css( "position" );

		//Generate the original position
		this.originalPosition = this._generatePosition( event );
		this.originalPageX = event.pageX;
		this.originalPageY = event.pageY;

		//Adjust the mouse offset relative to the helper if "cursorAt" is supplied
		( o.cursorAt && this._adjustOffsetFromHelper( o.cursorAt ) );

		//Cache the former DOM position
		this.domPosition = {
			prev: this.currentItem.prev()[ 0 ],
			parent: this.currentItem.parent()[ 0 ]
		};

		// If the helper is not the original, hide the original so it's not playing any role during
		// the drag, won't cause anything bad this way
		if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
			this.currentItem.hide();
		}

		//Create the placeholder
		this._createPlaceholder();

		//Set a containment if given in the options
		if ( o.containment ) {
			this._setContainment();
		}

		if ( o.cursor && o.cursor !== "auto" ) { // cursor option
			body = this.document.find( "body" );

			// Support: IE
			this.storedCursor = body.css( "cursor" );
			body.css( "cursor", o.cursor );

			this.storedStylesheet =
				$( "<style>*{ cursor: " + o.cursor + " !important; }</style>" ).appendTo( body );
		}

		if ( o.opacity ) { // opacity option
			if ( this.helper.css( "opacity" ) ) {
				this._storedOpacity = this.helper.css( "opacity" );
			}
			this.helper.css( "opacity", o.opacity );
		}

		if ( o.zIndex ) { // zIndex option
			if ( this.helper.css( "zIndex" ) ) {
				this._storedZIndex = this.helper.css( "zIndex" );
			}
			this.helper.css( "zIndex", o.zIndex );
		}

		//Prepare scrolling
		if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ].tagName !== "HTML" ) {
			this.overflowOffset = this.scrollParent.offset();
		}

		//Call callbacks
		this._trigger( "start", event, this._uiHash() );

		//Recache the helper size
		if ( !this._preserveHelperProportions ) {
			this._cacheHelperProportions();
		}

		//Post "activate" events to possible containers
		if ( !noActivation ) {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "activate", event, this._uiHash( this ) );
			}
		}

		//Prepare possible droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.current = this;
		}

		if ( $.ui.ddmanager && !o.dropBehaviour ) {
			$.ui.ddmanager.prepareOffsets( this, event );
		}

		this.dragging = true;

		this._addClass( this.helper, "ui-sortable-helper" );

		// Execute the drag once - this causes the helper not to be visiblebefore getting its
		// correct position
		this._mouseDrag( event );
		return true;

	},

	_mouseDrag: function( event ) {
		var i, item, itemElement, intersection,
			o = this.options,
			scrolled = false;

		//Compute the helpers position
		this.position = this._generatePosition( event );
		this.positionAbs = this._convertPositionTo( "absolute" );

		if ( !this.lastPositionAbs ) {
			this.lastPositionAbs = this.positionAbs;
		}

		//Do scrolling
		if ( this.options.scroll ) {
			if ( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
					this.scrollParent[ 0 ].tagName !== "HTML" ) {

				if ( ( this.overflowOffset.top + this.scrollParent[ 0 ].offsetHeight ) -
						event.pageY < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop + o.scrollSpeed;
				} else if ( event.pageY - this.overflowOffset.top < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollTop =
						scrolled = this.scrollParent[ 0 ].scrollTop - o.scrollSpeed;
				}

				if ( ( this.overflowOffset.left + this.scrollParent[ 0 ].offsetWidth ) -
						event.pageX < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft + o.scrollSpeed;
				} else if ( event.pageX - this.overflowOffset.left < o.scrollSensitivity ) {
					this.scrollParent[ 0 ].scrollLeft = scrolled =
						this.scrollParent[ 0 ].scrollLeft - o.scrollSpeed;
				}

			} else {

				if ( event.pageY - this.document.scrollTop() < o.scrollSensitivity ) {
					scrolled = this.document.scrollTop( this.document.scrollTop() - o.scrollSpeed );
				} else if ( this.window.height() - ( event.pageY - this.document.scrollTop() ) <
						o.scrollSensitivity ) {
					scrolled = this.document.scrollTop( this.document.scrollTop() + o.scrollSpeed );
				}

				if ( event.pageX - this.document.scrollLeft() < o.scrollSensitivity ) {
					scrolled = this.document.scrollLeft(
						this.document.scrollLeft() - o.scrollSpeed
					);
				} else if ( this.window.width() - ( event.pageX - this.document.scrollLeft() ) <
						o.scrollSensitivity ) {
					scrolled = this.document.scrollLeft(
						this.document.scrollLeft() + o.scrollSpeed
					);
				}

			}

			if ( scrolled !== false && $.ui.ddmanager && !o.dropBehaviour ) {
				$.ui.ddmanager.prepareOffsets( this, event );
			}
		}

		//Regenerate the absolute position used for position checks
		this.positionAbs = this._convertPositionTo( "absolute" );

		//Set the helper position
		if ( !this.options.axis || this.options.axis !== "y" ) {
			this.helper[ 0 ].style.left = this.position.left + "px";
		}
		if ( !this.options.axis || this.options.axis !== "x" ) {
			this.helper[ 0 ].style.top = this.position.top + "px";
		}

		//Rearrange
		for ( i = this.items.length - 1; i >= 0; i-- ) {

			//Cache variables and intersection, continue if no intersection
			item = this.items[ i ];
			itemElement = item.item[ 0 ];
			intersection = this._intersectsWithPointer( item );
			if ( !intersection ) {
				continue;
			}

			// Only put the placeholder inside the current Container, skip all
			// items from other containers. This works because when moving
			// an item from one container to another the
			// currentContainer is switched before the placeholder is moved.
			//
			// Without this, moving items in "sub-sortables" can cause
			// the placeholder to jitter between the outer and inner container.
			if ( item.instance !== this.currentContainer ) {
				continue;
			}

			// Cannot intersect with itself
			// no useless actions that have been done before
			// no action if the item moved is the parent of the item checked
			if ( itemElement !== this.currentItem[ 0 ] &&
				this.placeholder[ intersection === 1 ? "next" : "prev" ]()[ 0 ] !== itemElement &&
				!$.contains( this.placeholder[ 0 ], itemElement ) &&
				( this.options.type === "semi-dynamic" ?
					!$.contains( this.element[ 0 ], itemElement ) :
					true
				)
			) {

				this.direction = intersection === 1 ? "down" : "up";

				if ( this.options.tolerance === "pointer" || this._intersectsWithSides( item ) ) {
					this._rearrange( event, item );
				} else {
					break;
				}

				this._trigger( "change", event, this._uiHash() );
				break;
			}
		}

		//Post events to containers
		this._contactContainers( event );

		//Interconnect with droppables
		if ( $.ui.ddmanager ) {
			$.ui.ddmanager.drag( this, event );
		}

		//Call callbacks
		this._trigger( "sort", event, this._uiHash() );

		this.lastPositionAbs = this.positionAbs;
		return false;

	},

	_mouseStop: function( event, noPropagation ) {

		if ( !event ) {
			return;
		}

		//If we are using droppables, inform the manager about the drop
		if ( $.ui.ddmanager && !this.options.dropBehaviour ) {
			$.ui.ddmanager.drop( this, event );
		}

		if ( this.options.revert ) {
			var that = this,
				cur = this.placeholder.offset(),
				axis = this.options.axis,
				animation = {};

			if ( !axis || axis === "x" ) {
				animation.left = cur.left - this.offset.parent.left - this.margins.left +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollLeft
					);
			}
			if ( !axis || axis === "y" ) {
				animation.top = cur.top - this.offset.parent.top - this.margins.top +
					( this.offsetParent[ 0 ] === this.document[ 0 ].body ?
						0 :
						this.offsetParent[ 0 ].scrollTop
					);
			}
			this.reverting = true;
			$( this.helper ).animate(
				animation,
				parseInt( this.options.revert, 10 ) || 500,
				function() {
					that._clear( event );
				}
			);
		} else {
			this._clear( event, noPropagation );
		}

		return false;

	},

	cancel: function() {

		if ( this.dragging ) {

			this._mouseUp( new $.Event( "mouseup", { target: null } ) );

			if ( this.options.helper === "original" ) {
				this.currentItem.css( this._storedCSS );
				this._removeClass( this.currentItem, "ui-sortable-helper" );
			} else {
				this.currentItem.show();
			}

			//Post deactivating events to containers
			for ( var i = this.containers.length - 1; i >= 0; i-- ) {
				this.containers[ i ]._trigger( "deactivate", null, this._uiHash( this ) );
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", null, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		if ( this.placeholder ) {

			//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
			// it unbinds ALL events from the original node!
			if ( this.placeholder[ 0 ].parentNode ) {
				this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );
			}
			if ( this.options.helper !== "original" && this.helper &&
					this.helper[ 0 ].parentNode ) {
				this.helper.remove();
			}

			$.extend( this, {
				helper: null,
				dragging: false,
				reverting: false,
				_noFinalSort: null
			} );

			if ( this.domPosition.prev ) {
				$( this.domPosition.prev ).after( this.currentItem );
			} else {
				$( this.domPosition.parent ).prepend( this.currentItem );
			}
		}

		return this;

	},

	serialize: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			str = [];
		o = o || {};

		$( items ).each( function() {
			var res = ( $( o.item || this ).attr( o.attribute || "id" ) || "" )
				.match( o.expression || ( /(.+)[\-=_](.+)/ ) );
			if ( res ) {
				str.push(
					( o.key || res[ 1 ] + "[]" ) +
					"=" + ( o.key && o.expression ? res[ 1 ] : res[ 2 ] ) );
			}
		} );

		if ( !str.length && o.key ) {
			str.push( o.key + "=" );
		}

		return str.join( "&" );

	},

	toArray: function( o ) {

		var items = this._getItemsAsjQuery( o && o.connected ),
			ret = [];

		o = o || {};

		items.each( function() {
			ret.push( $( o.item || this ).attr( o.attribute || "id" ) || "" );
		} );
		return ret;

	},

	/* Be careful with the following core functions */
	_intersectsWith: function( item ) {

		var x1 = this.positionAbs.left,
			x2 = x1 + this.helperProportions.width,
			y1 = this.positionAbs.top,
			y2 = y1 + this.helperProportions.height,
			l = item.left,
			r = l + item.width,
			t = item.top,
			b = t + item.height,
			dyClick = this.offset.click.top,
			dxClick = this.offset.click.left,
			isOverElementHeight = ( this.options.axis === "x" ) || ( ( y1 + dyClick ) > t &&
				( y1 + dyClick ) < b ),
			isOverElementWidth = ( this.options.axis === "y" ) || ( ( x1 + dxClick ) > l &&
				( x1 + dxClick ) < r ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( this.options.tolerance === "pointer" ||
			this.options.forcePointerForContainers ||
			( this.options.tolerance !== "pointer" &&
				this.helperProportions[ this.floating ? "width" : "height" ] >
				item[ this.floating ? "width" : "height" ] )
		) {
			return isOverElement;
		} else {

			return ( l < x1 + ( this.helperProportions.width / 2 ) && // Right Half
				x2 - ( this.helperProportions.width / 2 ) < r && // Left Half
				t < y1 + ( this.helperProportions.height / 2 ) && // Bottom Half
				y2 - ( this.helperProportions.height / 2 ) < b ); // Top Half

		}
	},

	_intersectsWithPointer: function( item ) {
		var verticalDirection, horizontalDirection,
			isOverElementHeight = ( this.options.axis === "x" ) ||
				this._isOverAxis(
					this.positionAbs.top + this.offset.click.top, item.top, item.height ),
			isOverElementWidth = ( this.options.axis === "y" ) ||
				this._isOverAxis(
					this.positionAbs.left + this.offset.click.left, item.left, item.width ),
			isOverElement = isOverElementHeight && isOverElementWidth;

		if ( !isOverElement ) {
			return false;
		}

		verticalDirection = this._getDragVerticalDirection();
		horizontalDirection = this._getDragHorizontalDirection();

		return this.floating ?
			( ( horizontalDirection === "right" || verticalDirection === "down" ) ? 2 : 1 )
			: ( verticalDirection && ( verticalDirection === "down" ? 2 : 1 ) );

	},

	_intersectsWithSides: function( item ) {

		var isOverBottomHalf = this._isOverAxis( this.positionAbs.top +
				this.offset.click.top, item.top + ( item.height / 2 ), item.height ),
			isOverRightHalf = this._isOverAxis( this.positionAbs.left +
				this.offset.click.left, item.left + ( item.width / 2 ), item.width ),
			verticalDirection = this._getDragVerticalDirection(),
			horizontalDirection = this._getDragHorizontalDirection();

		if ( this.floating && horizontalDirection ) {
			return ( ( horizontalDirection === "right" && isOverRightHalf ) ||
				( horizontalDirection === "left" && !isOverRightHalf ) );
		} else {
			return verticalDirection && ( ( verticalDirection === "down" && isOverBottomHalf ) ||
				( verticalDirection === "up" && !isOverBottomHalf ) );
		}

	},

	_getDragVerticalDirection: function() {
		var delta = this.positionAbs.top - this.lastPositionAbs.top;
		return delta !== 0 && ( delta > 0 ? "down" : "up" );
	},

	_getDragHorizontalDirection: function() {
		var delta = this.positionAbs.left - this.lastPositionAbs.left;
		return delta !== 0 && ( delta > 0 ? "right" : "left" );
	},

	refresh: function( event ) {
		this._refreshItems( event );
		this._setHandleClassName();
		this.refreshPositions();
		return this;
	},

	_connectWith: function() {
		var options = this.options;
		return options.connectWith.constructor === String ?
			[ options.connectWith ] :
			options.connectWith;
	},

	_getItemsAsjQuery: function( connected ) {

		var i, j, cur, inst,
			items = [],
			queries = [],
			connectWith = this._connectWith();

		if ( connectWith && connected ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ $.isFunction( inst.options.items ) ?
							inst.options.items.call( inst.element ) :
							$( inst.options.items, inst.element )
								.not( ".ui-sortable-helper" )
								.not( ".ui-sortable-placeholder" ), inst ] );
					}
				}
			}
		}

		queries.push( [ $.isFunction( this.options.items ) ?
			this.options.items
				.call( this.element, null, { options: this.options, item: this.currentItem } ) :
			$( this.options.items, this.element )
				.not( ".ui-sortable-helper" )
				.not( ".ui-sortable-placeholder" ), this ] );

		function addItems() {
			items.push( this );
		}
		for ( i = queries.length - 1; i >= 0; i-- ) {
			queries[ i ][ 0 ].each( addItems );
		}

		return $( items );

	},

	_removeCurrentsFromItems: function() {

		var list = this.currentItem.find( ":data(" + this.widgetName + "-item)" );

		this.items = $.grep( this.items, function( item ) {
			for ( var j = 0; j < list.length; j++ ) {
				if ( list[ j ] === item.item[ 0 ] ) {
					return false;
				}
			}
			return true;
		} );

	},

	_refreshItems: function( event ) {

		this.items = [];
		this.containers = [ this ];

		var i, j, cur, inst, targetData, _queries, item, queriesLength,
			items = this.items,
			queries = [ [ $.isFunction( this.options.items ) ?
				this.options.items.call( this.element[ 0 ], event, { item: this.currentItem } ) :
				$( this.options.items, this.element ), this ] ],
			connectWith = this._connectWith();

		//Shouldn't be run the first time through due to massive slow-down
		if ( connectWith && this.ready ) {
			for ( i = connectWith.length - 1; i >= 0; i-- ) {
				cur = $( connectWith[ i ], this.document[ 0 ] );
				for ( j = cur.length - 1; j >= 0; j-- ) {
					inst = $.data( cur[ j ], this.widgetFullName );
					if ( inst && inst !== this && !inst.options.disabled ) {
						queries.push( [ $.isFunction( inst.options.items ) ?
							inst.options.items
								.call( inst.element[ 0 ], event, { item: this.currentItem } ) :
							$( inst.options.items, inst.element ), inst ] );
						this.containers.push( inst );
					}
				}
			}
		}

		for ( i = queries.length - 1; i >= 0; i-- ) {
			targetData = queries[ i ][ 1 ];
			_queries = queries[ i ][ 0 ];

			for ( j = 0, queriesLength = _queries.length; j < queriesLength; j++ ) {
				item = $( _queries[ j ] );

				// Data for target checking (mouse manager)
				item.data( this.widgetName + "-item", targetData );

				items.push( {
					item: item,
					instance: targetData,
					width: 0, height: 0,
					left: 0, top: 0
				} );
			}
		}

	},

	refreshPositions: function( fast ) {

		// Determine whether items are being displayed horizontally
		this.floating = this.items.length ?
			this.options.axis === "x" || this._isFloating( this.items[ 0 ].item ) :
			false;

		//This has to be redone because due to the item being moved out/into the offsetParent,
		// the offsetParent's position will change
		if ( this.offsetParent && this.helper ) {
			this.offset.parent = this._getParentOffset();
		}

		var i, item, t, p;

		for ( i = this.items.length - 1; i >= 0; i-- ) {
			item = this.items[ i ];

			//We ignore calculating positions of all connected containers when we're not over them
			if ( item.instance !== this.currentContainer && this.currentContainer &&
					item.item[ 0 ] !== this.currentItem[ 0 ] ) {
				continue;
			}

			t = this.options.toleranceElement ?
				$( this.options.toleranceElement, item.item ) :
				item.item;

			if ( !fast ) {
				item.width = t.outerWidth();
				item.height = t.outerHeight();
			}

			p = t.offset();
			item.left = p.left;
			item.top = p.top;
		}

		if ( this.options.custom && this.options.custom.refreshContainers ) {
			this.options.custom.refreshContainers.call( this );
		} else {
			for ( i = this.containers.length - 1; i >= 0; i-- ) {
				p = this.containers[ i ].element.offset();
				this.containers[ i ].containerCache.left = p.left;
				this.containers[ i ].containerCache.top = p.top;
				this.containers[ i ].containerCache.width =
					this.containers[ i ].element.outerWidth();
				this.containers[ i ].containerCache.height =
					this.containers[ i ].element.outerHeight();
			}
		}

		return this;
	},

	_createPlaceholder: function( that ) {
		that = that || this;
		var className,
			o = that.options;

		if ( !o.placeholder || o.placeholder.constructor === String ) {
			className = o.placeholder;
			o.placeholder = {
				element: function() {

					var nodeName = that.currentItem[ 0 ].nodeName.toLowerCase(),
						element = $( "<" + nodeName + ">", that.document[ 0 ] );

						that._addClass( element, "ui-sortable-placeholder",
								className || that.currentItem[ 0 ].className )
							._removeClass( element, "ui-sortable-helper" );

					if ( nodeName === "tbody" ) {
						that._createTrPlaceholder(
							that.currentItem.find( "tr" ).eq( 0 ),
							$( "<tr>", that.document[ 0 ] ).appendTo( element )
						);
					} else if ( nodeName === "tr" ) {
						that._createTrPlaceholder( that.currentItem, element );
					} else if ( nodeName === "img" ) {
						element.attr( "src", that.currentItem.attr( "src" ) );
					}

					if ( !className ) {
						element.css( "visibility", "hidden" );
					}

					return element;
				},
				update: function( container, p ) {

					// 1. If a className is set as 'placeholder option, we don't force sizes -
					// the class is responsible for that
					// 2. The option 'forcePlaceholderSize can be enabled to force it even if a
					// class name is specified
					if ( className && !o.forcePlaceholderSize ) {
						return;
					}

					//If the element doesn't have a actual height by itself (without styles coming
					// from a stylesheet), it receives the inline height from the dragged item
					if ( !p.height() ) {
						p.height(
							that.currentItem.innerHeight() -
							parseInt( that.currentItem.css( "paddingTop" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingBottom" ) || 0, 10 ) );
					}
					if ( !p.width() ) {
						p.width(
							that.currentItem.innerWidth() -
							parseInt( that.currentItem.css( "paddingLeft" ) || 0, 10 ) -
							parseInt( that.currentItem.css( "paddingRight" ) || 0, 10 ) );
					}
				}
			};
		}

		//Create the placeholder
		that.placeholder = $( o.placeholder.element.call( that.element, that.currentItem ) );

		//Append it after the actual current item
		that.currentItem.after( that.placeholder );

		//Update the size of the placeholder (TODO: Logic to fuzzy, see line 316/317)
		o.placeholder.update( that, that.placeholder );

	},

	_createTrPlaceholder: function( sourceTr, targetTr ) {
		var that = this;

		sourceTr.children().each( function() {
			$( "<td>&#160;</td>", that.document[ 0 ] )
				.attr( "colspan", $( this ).attr( "colspan" ) || 1 )
				.appendTo( targetTr );
		} );
	},

	_contactContainers: function( event ) {
		var i, j, dist, itemWithLeastDistance, posProperty, sizeProperty, cur, nearBottom,
			floating, axis,
			innermostContainer = null,
			innermostIndex = null;

		// Get innermost container that intersects with item
		for ( i = this.containers.length - 1; i >= 0; i-- ) {

			// Never consider a container that's located within the item itself
			if ( $.contains( this.currentItem[ 0 ], this.containers[ i ].element[ 0 ] ) ) {
				continue;
			}

			if ( this._intersectsWith( this.containers[ i ].containerCache ) ) {

				// If we've already found a container and it's more "inner" than this, then continue
				if ( innermostContainer &&
						$.contains(
							this.containers[ i ].element[ 0 ],
							innermostContainer.element[ 0 ] ) ) {
					continue;
				}

				innermostContainer = this.containers[ i ];
				innermostIndex = i;

			} else {

				// container doesn't intersect. trigger "out" event if necessary
				if ( this.containers[ i ].containerCache.over ) {
					this.containers[ i ]._trigger( "out", event, this._uiHash( this ) );
					this.containers[ i ].containerCache.over = 0;
				}
			}

		}

		// If no intersecting containers found, return
		if ( !innermostContainer ) {
			return;
		}

		// Move the item into the container if it's not there already
		if ( this.containers.length === 1 ) {
			if ( !this.containers[ innermostIndex ].containerCache.over ) {
				this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
				this.containers[ innermostIndex ].containerCache.over = 1;
			}
		} else {

			// When entering a new container, we will find the item with the least distance and
			// append our item near it
			dist = 10000;
			itemWithLeastDistance = null;
			floating = innermostContainer.floating || this._isFloating( this.currentItem );
			posProperty = floating ? "left" : "top";
			sizeProperty = floating ? "width" : "height";
			axis = floating ? "pageX" : "pageY";

			for ( j = this.items.length - 1; j >= 0; j-- ) {
				if ( !$.contains(
						this.containers[ innermostIndex ].element[ 0 ], this.items[ j ].item[ 0 ] )
				) {
					continue;
				}
				if ( this.items[ j ].item[ 0 ] === this.currentItem[ 0 ] ) {
					continue;
				}

				cur = this.items[ j ].item.offset()[ posProperty ];
				nearBottom = false;
				if ( event[ axis ] - cur > this.items[ j ][ sizeProperty ] / 2 ) {
					nearBottom = true;
				}

				if ( Math.abs( event[ axis ] - cur ) < dist ) {
					dist = Math.abs( event[ axis ] - cur );
					itemWithLeastDistance = this.items[ j ];
					this.direction = nearBottom ? "up" : "down";
				}
			}

			//Check if dropOnEmpty is enabled
			if ( !itemWithLeastDistance && !this.options.dropOnEmpty ) {
				return;
			}

			if ( this.currentContainer === this.containers[ innermostIndex ] ) {
				if ( !this.currentContainer.containerCache.over ) {
					this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash() );
					this.currentContainer.containerCache.over = 1;
				}
				return;
			}

			itemWithLeastDistance ?
				this._rearrange( event, itemWithLeastDistance, null, true ) :
				this._rearrange( event, null, this.containers[ innermostIndex ].element, true );
			this._trigger( "change", event, this._uiHash() );
			this.containers[ innermostIndex ]._trigger( "change", event, this._uiHash( this ) );
			this.currentContainer = this.containers[ innermostIndex ];

			//Update the placeholder
			this.options.placeholder.update( this.currentContainer, this.placeholder );

			this.containers[ innermostIndex ]._trigger( "over", event, this._uiHash( this ) );
			this.containers[ innermostIndex ].containerCache.over = 1;
		}

	},

	_createHelper: function( event ) {

		var o = this.options,
			helper = $.isFunction( o.helper ) ?
				$( o.helper.apply( this.element[ 0 ], [ event, this.currentItem ] ) ) :
				( o.helper === "clone" ? this.currentItem.clone() : this.currentItem );

		//Add the helper to the DOM if that didn't happen already
		if ( !helper.parents( "body" ).length ) {
			$( o.appendTo !== "parent" ?
				o.appendTo :
				this.currentItem[ 0 ].parentNode )[ 0 ].appendChild( helper[ 0 ] );
		}

		if ( helper[ 0 ] === this.currentItem[ 0 ] ) {
			this._storedCSS = {
				width: this.currentItem[ 0 ].style.width,
				height: this.currentItem[ 0 ].style.height,
				position: this.currentItem.css( "position" ),
				top: this.currentItem.css( "top" ),
				left: this.currentItem.css( "left" )
			};
		}

		if ( !helper[ 0 ].style.width || o.forceHelperSize ) {
			helper.width( this.currentItem.width() );
		}
		if ( !helper[ 0 ].style.height || o.forceHelperSize ) {
			helper.height( this.currentItem.height() );
		}

		return helper;

	},

	_adjustOffsetFromHelper: function( obj ) {
		if ( typeof obj === "string" ) {
			obj = obj.split( " " );
		}
		if ( $.isArray( obj ) ) {
			obj = { left: +obj[ 0 ], top: +obj[ 1 ] || 0 };
		}
		if ( "left" in obj ) {
			this.offset.click.left = obj.left + this.margins.left;
		}
		if ( "right" in obj ) {
			this.offset.click.left = this.helperProportions.width - obj.right + this.margins.left;
		}
		if ( "top" in obj ) {
			this.offset.click.top = obj.top + this.margins.top;
		}
		if ( "bottom" in obj ) {
			this.offset.click.top = this.helperProportions.height - obj.bottom + this.margins.top;
		}
	},

	_getParentOffset: function() {

		//Get the offsetParent and cache its position
		this.offsetParent = this.helper.offsetParent();
		var po = this.offsetParent.offset();

		// This is a special case where we need to modify a offset calculated on start, since the
		// following happened:
		// 1. The position of the helper is absolute, so it's position is calculated based on the
		// next positioned parent
		// 2. The actual offset parent is a child of the scroll parent, and the scroll parent isn't
		// the document, which means that the scroll is included in the initial calculation of the
		// offset of the parent, and never recalculated upon drag
		if ( this.cssPosition === "absolute" && this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) {
			po.left += this.scrollParent.scrollLeft();
			po.top += this.scrollParent.scrollTop();
		}

		// This needs to be actually done for all browsers, since pageX/pageY includes this
		// information with an ugly IE fix
		if ( this.offsetParent[ 0 ] === this.document[ 0 ].body ||
				( this.offsetParent[ 0 ].tagName &&
				this.offsetParent[ 0 ].tagName.toLowerCase() === "html" && $.ui.ie ) ) {
			po = { top: 0, left: 0 };
		}

		return {
			top: po.top + ( parseInt( this.offsetParent.css( "borderTopWidth" ), 10 ) || 0 ),
			left: po.left + ( parseInt( this.offsetParent.css( "borderLeftWidth" ), 10 ) || 0 )
		};

	},

	_getRelativeOffset: function() {

		if ( this.cssPosition === "relative" ) {
			var p = this.currentItem.position();
			return {
				top: p.top - ( parseInt( this.helper.css( "top" ), 10 ) || 0 ) +
					this.scrollParent.scrollTop(),
				left: p.left - ( parseInt( this.helper.css( "left" ), 10 ) || 0 ) +
					this.scrollParent.scrollLeft()
			};
		} else {
			return { top: 0, left: 0 };
		}

	},

	_cacheMargins: function() {
		this.margins = {
			left: ( parseInt( this.currentItem.css( "marginLeft" ), 10 ) || 0 ),
			top: ( parseInt( this.currentItem.css( "marginTop" ), 10 ) || 0 )
		};
	},

	_cacheHelperProportions: function() {
		this.helperProportions = {
			width: this.helper.outerWidth(),
			height: this.helper.outerHeight()
		};
	},

	_setContainment: function() {

		var ce, co, over,
			o = this.options;
		if ( o.containment === "parent" ) {
			o.containment = this.helper[ 0 ].parentNode;
		}
		if ( o.containment === "document" || o.containment === "window" ) {
			this.containment = [
				0 - this.offset.relative.left - this.offset.parent.left,
				0 - this.offset.relative.top - this.offset.parent.top,
				o.containment === "document" ?
					this.document.width() :
					this.window.width() - this.helperProportions.width - this.margins.left,
				( o.containment === "document" ?
					( this.document.height() || document.body.parentNode.scrollHeight ) :
					this.window.height() || this.document[ 0 ].body.parentNode.scrollHeight
				) - this.helperProportions.height - this.margins.top
			];
		}

		if ( !( /^(document|window|parent)$/ ).test( o.containment ) ) {
			ce = $( o.containment )[ 0 ];
			co = $( o.containment ).offset();
			over = ( $( ce ).css( "overflow" ) !== "hidden" );

			this.containment = [
				co.left + ( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingLeft" ), 10 ) || 0 ) - this.margins.left,
				co.top + ( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) +
					( parseInt( $( ce ).css( "paddingTop" ), 10 ) || 0 ) - this.margins.top,
				co.left + ( over ? Math.max( ce.scrollWidth, ce.offsetWidth ) : ce.offsetWidth ) -
					( parseInt( $( ce ).css( "borderLeftWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingRight" ), 10 ) || 0 ) -
					this.helperProportions.width - this.margins.left,
				co.top + ( over ? Math.max( ce.scrollHeight, ce.offsetHeight ) : ce.offsetHeight ) -
					( parseInt( $( ce ).css( "borderTopWidth" ), 10 ) || 0 ) -
					( parseInt( $( ce ).css( "paddingBottom" ), 10 ) || 0 ) -
					this.helperProportions.height - this.margins.top
			];
		}

	},

	_convertPositionTo: function( d, pos ) {

		if ( !pos ) {
			pos = this.position;
		}
		var mod = d === "absolute" ? 1 : -1,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
			scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		return {
			top: (

				// The absolute mouse position
				pos.top	+

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top * mod -
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) * mod )
			),
			left: (

				// The absolute mouse position
				pos.left +

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left * mod +

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left * mod	-
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() : scrollIsRootNode ? 0 :
					scroll.scrollLeft() ) * mod )
			)
		};

	},

	_generatePosition: function( event ) {

		var top, left,
			o = this.options,
			pageX = event.pageX,
			pageY = event.pageY,
			scroll = this.cssPosition === "absolute" &&
				!( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				$.contains( this.scrollParent[ 0 ], this.offsetParent[ 0 ] ) ) ?
					this.offsetParent :
					this.scrollParent,
				scrollIsRootNode = ( /(html|body)/i ).test( scroll[ 0 ].tagName );

		// This is another very weird special case that only happens for relative elements:
		// 1. If the css position is relative
		// 2. and the scroll parent is the document or similar to the offset parent
		// we have to refresh the relative offset during the scroll so there are no jumps
		if ( this.cssPosition === "relative" && !( this.scrollParent[ 0 ] !== this.document[ 0 ] &&
				this.scrollParent[ 0 ] !== this.offsetParent[ 0 ] ) ) {
			this.offset.relative = this._getRelativeOffset();
		}

		/*
		 * - Position constraining -
		 * Constrain the position to a mix of grid, containment.
		 */

		if ( this.originalPosition ) { //If we are not dragging yet, we won't check for options

			if ( this.containment ) {
				if ( event.pageX - this.offset.click.left < this.containment[ 0 ] ) {
					pageX = this.containment[ 0 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top < this.containment[ 1 ] ) {
					pageY = this.containment[ 1 ] + this.offset.click.top;
				}
				if ( event.pageX - this.offset.click.left > this.containment[ 2 ] ) {
					pageX = this.containment[ 2 ] + this.offset.click.left;
				}
				if ( event.pageY - this.offset.click.top > this.containment[ 3 ] ) {
					pageY = this.containment[ 3 ] + this.offset.click.top;
				}
			}

			if ( o.grid ) {
				top = this.originalPageY + Math.round( ( pageY - this.originalPageY ) /
					o.grid[ 1 ] ) * o.grid[ 1 ];
				pageY = this.containment ?
					( ( top - this.offset.click.top >= this.containment[ 1 ] &&
						top - this.offset.click.top <= this.containment[ 3 ] ) ?
							top :
							( ( top - this.offset.click.top >= this.containment[ 1 ] ) ?
								top - o.grid[ 1 ] : top + o.grid[ 1 ] ) ) :
								top;

				left = this.originalPageX + Math.round( ( pageX - this.originalPageX ) /
					o.grid[ 0 ] ) * o.grid[ 0 ];
				pageX = this.containment ?
					( ( left - this.offset.click.left >= this.containment[ 0 ] &&
						left - this.offset.click.left <= this.containment[ 2 ] ) ?
							left :
							( ( left - this.offset.click.left >= this.containment[ 0 ] ) ?
								left - o.grid[ 0 ] : left + o.grid[ 0 ] ) ) :
								left;
			}

		}

		return {
			top: (

				// The absolute mouse position
				pageY -

				// Click offset (relative to the element)
				this.offset.click.top -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.top -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.top +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollTop() :
					( scrollIsRootNode ? 0 : scroll.scrollTop() ) ) )
			),
			left: (

				// The absolute mouse position
				pageX -

				// Click offset (relative to the element)
				this.offset.click.left -

				// Only for relative positioned nodes: Relative offset from element to offset parent
				this.offset.relative.left -

				// The offsetParent's offset without borders (offset + border)
				this.offset.parent.left +
				( ( this.cssPosition === "fixed" ?
					-this.scrollParent.scrollLeft() :
					scrollIsRootNode ? 0 : scroll.scrollLeft() ) )
			)
		};

	},

	_rearrange: function( event, i, a, hardRefresh ) {

		a ? a[ 0 ].appendChild( this.placeholder[ 0 ] ) :
			i.item[ 0 ].parentNode.insertBefore( this.placeholder[ 0 ],
				( this.direction === "down" ? i.item[ 0 ] : i.item[ 0 ].nextSibling ) );

		//Various things done here to improve the performance:
		// 1. we create a setTimeout, that calls refreshPositions
		// 2. on the instance, we have a counter variable, that get's higher after every append
		// 3. on the local scope, we copy the counter variable, and check in the timeout,
		// if it's still the same
		// 4. this lets only the last addition to the timeout stack through
		this.counter = this.counter ? ++this.counter : 1;
		var counter = this.counter;

		this._delay( function() {
			if ( counter === this.counter ) {

				//Precompute after each DOM insertion, NOT on mousemove
				this.refreshPositions( !hardRefresh );
			}
		} );

	},

	_clear: function( event, noPropagation ) {

		this.reverting = false;

		// We delay all events that have to be triggered to after the point where the placeholder
		// has been removed and everything else normalized again
		var i,
			delayedTriggers = [];

		// We first have to update the dom position of the actual currentItem
		// Note: don't do it if the current item is already removed (by a user), or it gets
		// reappended (see #4088)
		if ( !this._noFinalSort && this.currentItem.parent().length ) {
			this.placeholder.before( this.currentItem );
		}
		this._noFinalSort = null;

		if ( this.helper[ 0 ] === this.currentItem[ 0 ] ) {
			for ( i in this._storedCSS ) {
				if ( this._storedCSS[ i ] === "auto" || this._storedCSS[ i ] === "static" ) {
					this._storedCSS[ i ] = "";
				}
			}
			this.currentItem.css( this._storedCSS );
			this._removeClass( this.currentItem, "ui-sortable-helper" );
		} else {
			this.currentItem.show();
		}

		if ( this.fromOutside && !noPropagation ) {
			delayedTriggers.push( function( event ) {
				this._trigger( "receive", event, this._uiHash( this.fromOutside ) );
			} );
		}
		if ( ( this.fromOutside ||
				this.domPosition.prev !==
				this.currentItem.prev().not( ".ui-sortable-helper" )[ 0 ] ||
				this.domPosition.parent !== this.currentItem.parent()[ 0 ] ) && !noPropagation ) {

			// Trigger update callback if the DOM position has changed
			delayedTriggers.push( function( event ) {
				this._trigger( "update", event, this._uiHash() );
			} );
		}

		// Check if the items Container has Changed and trigger appropriate
		// events.
		if ( this !== this.currentContainer ) {
			if ( !noPropagation ) {
				delayedTriggers.push( function( event ) {
					this._trigger( "remove", event, this._uiHash() );
				} );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "receive", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
				delayedTriggers.push( ( function( c ) {
					return function( event ) {
						c._trigger( "update", event, this._uiHash( this ) );
					};
				} ).call( this, this.currentContainer ) );
			}
		}

		//Post events to containers
		function delayEvent( type, instance, container ) {
			return function( event ) {
				container._trigger( type, event, instance._uiHash( instance ) );
			};
		}
		for ( i = this.containers.length - 1; i >= 0; i-- ) {
			if ( !noPropagation ) {
				delayedTriggers.push( delayEvent( "deactivate", this, this.containers[ i ] ) );
			}
			if ( this.containers[ i ].containerCache.over ) {
				delayedTriggers.push( delayEvent( "out", this, this.containers[ i ] ) );
				this.containers[ i ].containerCache.over = 0;
			}
		}

		//Do what was originally in plugins
		if ( this.storedCursor ) {
			this.document.find( "body" ).css( "cursor", this.storedCursor );
			this.storedStylesheet.remove();
		}
		if ( this._storedOpacity ) {
			this.helper.css( "opacity", this._storedOpacity );
		}
		if ( this._storedZIndex ) {
			this.helper.css( "zIndex", this._storedZIndex === "auto" ? "" : this._storedZIndex );
		}

		this.dragging = false;

		if ( !noPropagation ) {
			this._trigger( "beforeStop", event, this._uiHash() );
		}

		//$(this.placeholder[0]).remove(); would have been the jQuery way - unfortunately,
		// it unbinds ALL events from the original node!
		this.placeholder[ 0 ].parentNode.removeChild( this.placeholder[ 0 ] );

		if ( !this.cancelHelperRemoval ) {
			if ( this.helper[ 0 ] !== this.currentItem[ 0 ] ) {
				this.helper.remove();
			}
			this.helper = null;
		}

		if ( !noPropagation ) {
			for ( i = 0; i < delayedTriggers.length; i++ ) {

				// Trigger all delayed events
				delayedTriggers[ i ].call( this, event );
			}
			this._trigger( "stop", event, this._uiHash() );
		}

		this.fromOutside = false;
		return !this.cancelHelperRemoval;

	},

	_trigger: function() {
		if ( $.Widget.prototype._trigger.apply( this, arguments ) === false ) {
			this.cancel();
		}
	},

	_uiHash: function( _inst ) {
		var inst = _inst || this;
		return {
			helper: inst.helper,
			placeholder: inst.placeholder || $( [] ),
			position: inst.position,
			originalPosition: inst.originalPosition,
			offset: inst.positionAbs,
			item: inst.currentItem,
			sender: _inst ? _inst.element : null
		};
	}

} );



var safeActiveElement = $.ui.safeActiveElement = function( document ) {
	var activeElement;

	// Support: IE 9 only
	// IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
	try {
		activeElement = document.activeElement;
	} catch ( error ) {
		activeElement = document.body;
	}

	// Support: IE 9 - 11 only
	// IE may return null instead of an element
	// Interestingly, this only seems to occur when NOT in an iframe
	if ( !activeElement ) {
		activeElement = document.body;
	}

	// Support: IE 11 only
	// IE11 returns a seemingly empty object in some cases when accessing
	// document.activeElement from an <iframe>
	if ( !activeElement.nodeName ) {
		activeElement = document.body;
	}

	return activeElement;
};


/*!
 * jQuery UI Menu 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Menu
//>>group: Widgets
//>>description: Creates nestable menus.
//>>docs: http://api.jqueryui.com/menu/
//>>demos: http://jqueryui.com/menu/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/menu.css
//>>css.theme: ../../themes/base/theme.css



var widgetsMenu = $.widget( "ui.menu", {
	version: "1.12.1",
	defaultElement: "<ul>",
	delay: 300,
	options: {
		icons: {
			submenu: "ui-icon-caret-1-e"
		},
		items: "> *",
		menus: "ul",
		position: {
			my: "left top",
			at: "right top"
		},
		role: "menu",

		// Callbacks
		blur: null,
		focus: null,
		select: null
	},

	_create: function() {
		this.activeMenu = this.element;

		// Flag used to prevent firing of the click handler
		// as the event bubbles up through nested menus
		this.mouseHandled = false;
		this.element
			.uniqueId()
			.attr( {
				role: this.options.role,
				tabIndex: 0
			} );

		this._addClass( "ui-menu", "ui-widget ui-widget-content" );
		this._on( {

			// Prevent focus from sticking to links inside menu after clicking
			// them (focus should always stay on UL during navigation).
			"mousedown .ui-menu-item": function( event ) {
				event.preventDefault();
			},
			"click .ui-menu-item": function( event ) {
				var target = $( event.target );
				var active = $( $.ui.safeActiveElement( this.document[ 0 ] ) );
				if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
					this.select( event );

					// Only set the mouseHandled flag if the event will bubble, see #9469.
					if ( !event.isPropagationStopped() ) {
						this.mouseHandled = true;
					}

					// Open submenu on click
					if ( target.has( ".ui-menu" ).length ) {
						this.expand( event );
					} else if ( !this.element.is( ":focus" ) &&
							active.closest( ".ui-menu" ).length ) {

						// Redirect focus to the menu
						this.element.trigger( "focus", [ true ] );

						// If the active item is on the top level, let it stay active.
						// Otherwise, blur the active item since it is no longer visible.
						if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
							clearTimeout( this.timer );
						}
					}
				}
			},
			"mouseenter .ui-menu-item": function( event ) {

				// Ignore mouse events while typeahead is active, see #10458.
				// Prevents focusing the wrong item when typeahead causes a scroll while the mouse
				// is over an item in the menu
				if ( this.previousFilter ) {
					return;
				}

				var actualTarget = $( event.target ).closest( ".ui-menu-item" ),
					target = $( event.currentTarget );

				// Ignore bubbled events on parent items, see #11641
				if ( actualTarget[ 0 ] !== target[ 0 ] ) {
					return;
				}

				// Remove ui-state-active class from siblings of the newly focused menu item
				// to avoid a jump caused by adjacent elements both having a class with a border
				this._removeClass( target.siblings().children( ".ui-state-active" ),
					null, "ui-state-active" );
				this.focus( event, target );
			},
			mouseleave: "collapseAll",
			"mouseleave .ui-menu": "collapseAll",
			focus: function( event, keepActiveItem ) {

				// If there's already an active item, keep it active
				// If not, activate the first item
				var item = this.active || this.element.find( this.options.items ).eq( 0 );

				if ( !keepActiveItem ) {
					this.focus( event, item );
				}
			},
			blur: function( event ) {
				this._delay( function() {
					var notContained = !$.contains(
						this.element[ 0 ],
						$.ui.safeActiveElement( this.document[ 0 ] )
					);
					if ( notContained ) {
						this.collapseAll( event );
					}
				} );
			},
			keydown: "_keydown"
		} );

		this.refresh();

		// Clicks outside of a menu collapse any open menus
		this._on( this.document, {
			click: function( event ) {
				if ( this._closeOnDocumentClick( event ) ) {
					this.collapseAll( event );
				}

				// Reset the mouseHandled flag
				this.mouseHandled = false;
			}
		} );
	},

	_destroy: function() {
		var items = this.element.find( ".ui-menu-item" )
				.removeAttr( "role aria-disabled" ),
			submenus = items.children( ".ui-menu-item-wrapper" )
				.removeUniqueId()
				.removeAttr( "tabIndex role aria-haspopup" );

		// Destroy (sub)menus
		this.element
			.removeAttr( "aria-activedescendant" )
			.find( ".ui-menu" ).addBack()
				.removeAttr( "role aria-labelledby aria-expanded aria-hidden aria-disabled " +
					"tabIndex" )
				.removeUniqueId()
				.show();

		submenus.children().each( function() {
			var elem = $( this );
			if ( elem.data( "ui-menu-submenu-caret" ) ) {
				elem.remove();
			}
		} );
	},

	_keydown: function( event ) {
		var match, prev, character, skip,
			preventDefault = true;

		switch ( event.keyCode ) {
		case $.ui.keyCode.PAGE_UP:
			this.previousPage( event );
			break;
		case $.ui.keyCode.PAGE_DOWN:
			this.nextPage( event );
			break;
		case $.ui.keyCode.HOME:
			this._move( "first", "first", event );
			break;
		case $.ui.keyCode.END:
			this._move( "last", "last", event );
			break;
		case $.ui.keyCode.UP:
			this.previous( event );
			break;
		case $.ui.keyCode.DOWN:
			this.next( event );
			break;
		case $.ui.keyCode.LEFT:
			this.collapse( event );
			break;
		case $.ui.keyCode.RIGHT:
			if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
				this.expand( event );
			}
			break;
		case $.ui.keyCode.ENTER:
		case $.ui.keyCode.SPACE:
			this._activate( event );
			break;
		case $.ui.keyCode.ESCAPE:
			this.collapse( event );
			break;
		default:
			preventDefault = false;
			prev = this.previousFilter || "";
			skip = false;

			// Support number pad values
			character = event.keyCode >= 96 && event.keyCode <= 105 ?
				( event.keyCode - 96 ).toString() : String.fromCharCode( event.keyCode );

			clearTimeout( this.filterTimer );

			if ( character === prev ) {
				skip = true;
			} else {
				character = prev + character;
			}

			match = this._filterMenuItems( character );
			match = skip && match.index( this.active.next() ) !== -1 ?
				this.active.nextAll( ".ui-menu-item" ) :
				match;

			// If no matches on the current filter, reset to the last character pressed
			// to move down the menu to the first item that starts with that character
			if ( !match.length ) {
				character = String.fromCharCode( event.keyCode );
				match = this._filterMenuItems( character );
			}

			if ( match.length ) {
				this.focus( event, match );
				this.previousFilter = character;
				this.filterTimer = this._delay( function() {
					delete this.previousFilter;
				}, 1000 );
			} else {
				delete this.previousFilter;
			}
		}

		if ( preventDefault ) {
			event.preventDefault();
		}
	},

	_activate: function( event ) {
		if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
			if ( this.active.children( "[aria-haspopup='true']" ).length ) {
				this.expand( event );
			} else {
				this.select( event );
			}
		}
	},

	refresh: function() {
		var menus, items, newSubmenus, newItems, newWrappers,
			that = this,
			icon = this.options.icons.submenu,
			submenus = this.element.find( this.options.menus );

		this._toggleClass( "ui-menu-icons", null, !!this.element.find( ".ui-icon" ).length );

		// Initialize nested menus
		newSubmenus = submenus.filter( ":not(.ui-menu)" )
			.hide()
			.attr( {
				role: this.options.role,
				"aria-hidden": "true",
				"aria-expanded": "false"
			} )
			.each( function() {
				var menu = $( this ),
					item = menu.prev(),
					submenuCaret = $( "<span>" ).data( "ui-menu-submenu-caret", true );

				that._addClass( submenuCaret, "ui-menu-icon", "ui-icon " + icon );
				item
					.attr( "aria-haspopup", "true" )
					.prepend( submenuCaret );
				menu.attr( "aria-labelledby", item.attr( "id" ) );
			} );

		this._addClass( newSubmenus, "ui-menu", "ui-widget ui-widget-content ui-front" );

		menus = submenus.add( this.element );
		items = menus.find( this.options.items );

		// Initialize menu-items containing spaces and/or dashes only as dividers
		items.not( ".ui-menu-item" ).each( function() {
			var item = $( this );
			if ( that._isDivider( item ) ) {
				that._addClass( item, "ui-menu-divider", "ui-widget-content" );
			}
		} );

		// Don't refresh list items that are already adapted
		newItems = items.not( ".ui-menu-item, .ui-menu-divider" );
		newWrappers = newItems.children()
			.not( ".ui-menu" )
				.uniqueId()
				.attr( {
					tabIndex: -1,
					role: this._itemRole()
				} );
		this._addClass( newItems, "ui-menu-item" )
			._addClass( newWrappers, "ui-menu-item-wrapper" );

		// Add aria-disabled attribute to any disabled menu item
		items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

		// If the active item has been removed, blur the menu
		if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
			this.blur();
		}
	},

	_itemRole: function() {
		return {
			menu: "menuitem",
			listbox: "option"
		}[ this.options.role ];
	},

	_setOption: function( key, value ) {
		if ( key === "icons" ) {
			var icons = this.element.find( ".ui-menu-icon" );
			this._removeClass( icons, null, this.options.icons.submenu )
				._addClass( icons, null, value.submenu );
		}
		this._super( key, value );
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", String( value ) );
		this._toggleClass( null, "ui-state-disabled", !!value );
	},

	focus: function( event, item ) {
		var nested, focused, activeParent;
		this.blur( event, event && event.type === "focus" );

		this._scrollIntoView( item );

		this.active = item.first();

		focused = this.active.children( ".ui-menu-item-wrapper" );
		this._addClass( focused, null, "ui-state-active" );

		// Only update aria-activedescendant if there's a role
		// otherwise we assume focus is managed elsewhere
		if ( this.options.role ) {
			this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
		}

		// Highlight active parent menu item, if any
		activeParent = this.active
			.parent()
				.closest( ".ui-menu-item" )
					.children( ".ui-menu-item-wrapper" );
		this._addClass( activeParent, null, "ui-state-active" );

		if ( event && event.type === "keydown" ) {
			this._close();
		} else {
			this.timer = this._delay( function() {
				this._close();
			}, this.delay );
		}

		nested = item.children( ".ui-menu" );
		if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
			this._startOpening( nested );
		}
		this.activeMenu = item.parent();

		this._trigger( "focus", event, { item: item } );
	},

	_scrollIntoView: function( item ) {
		var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
		if ( this._hasScroll() ) {
			borderTop = parseFloat( $.css( this.activeMenu[ 0 ], "borderTopWidth" ) ) || 0;
			paddingTop = parseFloat( $.css( this.activeMenu[ 0 ], "paddingTop" ) ) || 0;
			offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
			scroll = this.activeMenu.scrollTop();
			elementHeight = this.activeMenu.height();
			itemHeight = item.outerHeight();

			if ( offset < 0 ) {
				this.activeMenu.scrollTop( scroll + offset );
			} else if ( offset + itemHeight > elementHeight ) {
				this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
			}
		}
	},

	blur: function( event, fromFocus ) {
		if ( !fromFocus ) {
			clearTimeout( this.timer );
		}

		if ( !this.active ) {
			return;
		}

		this._removeClass( this.active.children( ".ui-menu-item-wrapper" ),
			null, "ui-state-active" );

		this._trigger( "blur", event, { item: this.active } );
		this.active = null;
	},

	_startOpening: function( submenu ) {
		clearTimeout( this.timer );

		// Don't open if already open fixes a Firefox bug that caused a .5 pixel
		// shift in the submenu position when mousing over the caret icon
		if ( submenu.attr( "aria-hidden" ) !== "true" ) {
			return;
		}

		this.timer = this._delay( function() {
			this._close();
			this._open( submenu );
		}, this.delay );
	},

	_open: function( submenu ) {
		var position = $.extend( {
			of: this.active
		}, this.options.position );

		clearTimeout( this.timer );
		this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
			.hide()
			.attr( "aria-hidden", "true" );

		submenu
			.show()
			.removeAttr( "aria-hidden" )
			.attr( "aria-expanded", "true" )
			.position( position );
	},

	collapseAll: function( event, all ) {
		clearTimeout( this.timer );
		this.timer = this._delay( function() {

			// If we were passed an event, look for the submenu that contains the event
			var currentMenu = all ? this.element :
				$( event && event.target ).closest( this.element.find( ".ui-menu" ) );

			// If we found no valid submenu ancestor, use the main menu to close all
			// sub menus anyway
			if ( !currentMenu.length ) {
				currentMenu = this.element;
			}

			this._close( currentMenu );

			this.blur( event );

			// Work around active item staying active after menu is blurred
			this._removeClass( currentMenu.find( ".ui-state-active" ), null, "ui-state-active" );

			this.activeMenu = currentMenu;
		}, this.delay );
	},

	// With no arguments, closes the currently active menu - if nothing is active
	// it closes all menus.  If passed an argument, it will search for menus BELOW
	_close: function( startMenu ) {
		if ( !startMenu ) {
			startMenu = this.active ? this.active.parent() : this.element;
		}

		startMenu.find( ".ui-menu" )
			.hide()
			.attr( "aria-hidden", "true" )
			.attr( "aria-expanded", "false" );
	},

	_closeOnDocumentClick: function( event ) {
		return !$( event.target ).closest( ".ui-menu" ).length;
	},

	_isDivider: function( item ) {

		// Match hyphen, em dash, en dash
		return !/[^\-\u2014\u2013\s]/.test( item.text() );
	},

	collapse: function( event ) {
		var newItem = this.active &&
			this.active.parent().closest( ".ui-menu-item", this.element );
		if ( newItem && newItem.length ) {
			this._close();
			this.focus( event, newItem );
		}
	},

	expand: function( event ) {
		var newItem = this.active &&
			this.active
				.children( ".ui-menu " )
					.find( this.options.items )
						.first();

		if ( newItem && newItem.length ) {
			this._open( newItem.parent() );

			// Delay so Firefox will not hide activedescendant change in expanding submenu from AT
			this._delay( function() {
				this.focus( event, newItem );
			} );
		}
	},

	next: function( event ) {
		this._move( "next", "first", event );
	},

	previous: function( event ) {
		this._move( "prev", "last", event );
	},

	isFirstItem: function() {
		return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
	},

	isLastItem: function() {
		return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
	},

	_move: function( direction, filter, event ) {
		var next;
		if ( this.active ) {
			if ( direction === "first" || direction === "last" ) {
				next = this.active
					[ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
					.eq( -1 );
			} else {
				next = this.active
					[ direction + "All" ]( ".ui-menu-item" )
					.eq( 0 );
			}
		}
		if ( !next || !next.length || !this.active ) {
			next = this.activeMenu.find( this.options.items )[ filter ]();
		}

		this.focus( event, next );
	},

	nextPage: function( event ) {
		var item, base, height;

		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isLastItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.nextAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base - height < 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items )
				[ !this.active ? "first" : "last" ]() );
		}
	},

	previousPage: function( event ) {
		var item, base, height;
		if ( !this.active ) {
			this.next( event );
			return;
		}
		if ( this.isFirstItem() ) {
			return;
		}
		if ( this._hasScroll() ) {
			base = this.active.offset().top;
			height = this.element.height();
			this.active.prevAll( ".ui-menu-item" ).each( function() {
				item = $( this );
				return item.offset().top - base + height > 0;
			} );

			this.focus( event, item );
		} else {
			this.focus( event, this.activeMenu.find( this.options.items ).first() );
		}
	},

	_hasScroll: function() {
		return this.element.outerHeight() < this.element.prop( "scrollHeight" );
	},

	select: function( event ) {

		// TODO: It should never be possible to not have an active item at this
		// point, but the tests don't trigger mouseenter before click.
		this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
		var ui = { item: this.active };
		if ( !this.active.has( ".ui-menu" ).length ) {
			this.collapseAll( event, true );
		}
		this._trigger( "select", event, ui );
	},

	_filterMenuItems: function( character ) {
		var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
			regex = new RegExp( "^" + escapedCharacter, "i" );

		return this.activeMenu
			.find( this.options.items )

				// Only match on items, not dividers or other content (#10571)
				.filter( ".ui-menu-item" )
					.filter( function() {
						return regex.test(
							$.trim( $( this ).children( ".ui-menu-item-wrapper" ).text() ) );
					} );
	}
} );


/*!
 * jQuery UI Autocomplete 1.12.1
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Autocomplete
//>>group: Widgets
//>>description: Lists suggested words as the user is typing.
//>>docs: http://api.jqueryui.com/autocomplete/
//>>demos: http://jqueryui.com/autocomplete/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/autocomplete.css
//>>css.theme: ../../themes/base/theme.css



$.widget( "ui.autocomplete", {
	version: "1.12.1",
	defaultElement: "<input>",
	options: {
		appendTo: null,
		autoFocus: false,
		delay: 300,
		minLength: 1,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "none"
		},
		source: null,

		// Callbacks
		change: null,
		close: null,
		focus: null,
		open: null,
		response: null,
		search: null,
		select: null
	},

	requestIndex: 0,
	pending: 0,

	_create: function() {

		// Some browsers only repeat keydown events, not keypress events,
		// so we use the suppressKeyPress flag to determine if we've already
		// handled the keydown event. #7269
		// Unfortunately the code for & in keypress is the same as the up arrow,
		// so we use the suppressKeyPressRepeat flag to avoid handling keypress
		// events when we know the keydown event was used to modify the
		// search term. #7799
		var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
			nodeName = this.element[ 0 ].nodeName.toLowerCase(),
			isTextarea = nodeName === "textarea",
			isInput = nodeName === "input";

		// Textareas are always multi-line
		// Inputs are always single-line, even if inside a contentEditable element
		// IE also treats inputs as contentEditable
		// All other element types are determined by whether or not they're contentEditable
		this.isMultiLine = isTextarea || !isInput && this._isContentEditable( this.element );

		this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
		this.isNewMenu = true;

		this._addClass( "ui-autocomplete-input" );
		this.element.attr( "autocomplete", "off" );

		this._on( this.element, {
			keydown: function( event ) {
				if ( this.element.prop( "readOnly" ) ) {
					suppressKeyPress = true;
					suppressInput = true;
					suppressKeyPressRepeat = true;
					return;
				}

				suppressKeyPress = false;
				suppressInput = false;
				suppressKeyPressRepeat = false;
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					suppressKeyPress = true;
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					suppressKeyPress = true;
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					suppressKeyPress = true;
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					suppressKeyPress = true;
					this._keyEvent( "next", event );
					break;
				case keyCode.ENTER:

					// when menu is open and has focus
					if ( this.menu.active ) {

						// #6055 - Opera still allows the keypress to occur
						// which causes forms to submit
						suppressKeyPress = true;
						event.preventDefault();
						this.menu.select( event );
					}
					break;
				case keyCode.TAB:
					if ( this.menu.active ) {
						this.menu.select( event );
					}
					break;
				case keyCode.ESCAPE:
					if ( this.menu.element.is( ":visible" ) ) {
						if ( !this.isMultiLine ) {
							this._value( this.term );
						}
						this.close( event );

						// Different browsers have different default behavior for escape
						// Single press can mean undo or clear
						// Double press in IE means clear the whole form
						event.preventDefault();
					}
					break;
				default:
					suppressKeyPressRepeat = true;

					// search timeout should be triggered before the input value is changed
					this._searchTimeout( event );
					break;
				}
			},
			keypress: function( event ) {
				if ( suppressKeyPress ) {
					suppressKeyPress = false;
					if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
						event.preventDefault();
					}
					return;
				}
				if ( suppressKeyPressRepeat ) {
					return;
				}

				// Replicate some key handlers to allow them to repeat in Firefox and Opera
				var keyCode = $.ui.keyCode;
				switch ( event.keyCode ) {
				case keyCode.PAGE_UP:
					this._move( "previousPage", event );
					break;
				case keyCode.PAGE_DOWN:
					this._move( "nextPage", event );
					break;
				case keyCode.UP:
					this._keyEvent( "previous", event );
					break;
				case keyCode.DOWN:
					this._keyEvent( "next", event );
					break;
				}
			},
			input: function( event ) {
				if ( suppressInput ) {
					suppressInput = false;
					event.preventDefault();
					return;
				}
				this._searchTimeout( event );
			},
			focus: function() {
				this.selectedItem = null;
				this.previous = this._value();
			},
			blur: function( event ) {
				if ( this.cancelBlur ) {
					delete this.cancelBlur;
					return;
				}

				clearTimeout( this.searching );
				this.close( event );
				this._change( event );
			}
		} );

		this._initSource();
		this.menu = $( "<ul>" )
			.appendTo( this._appendTo() )
			.menu( {

				// disable ARIA support, the live region takes care of that
				role: null
			} )
			.hide()
			.menu( "instance" );

		this._addClass( this.menu.element, "ui-autocomplete", "ui-front" );
		this._on( this.menu.element, {
			mousedown: function( event ) {

				// prevent moving focus out of the text field
				event.preventDefault();

				// IE doesn't prevent moving focus even with event.preventDefault()
				// so we set a flag to know when we should ignore the blur event
				this.cancelBlur = true;
				this._delay( function() {
					delete this.cancelBlur;

					// Support: IE 8 only
					// Right clicking a menu item or selecting text from the menu items will
					// result in focus moving out of the input. However, we've already received
					// and ignored the blur event because of the cancelBlur flag set above. So
					// we restore focus to ensure that the menu closes properly based on the user's
					// next actions.
					if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
						this.element.trigger( "focus" );
					}
				} );
			},
			menufocus: function( event, ui ) {
				var label, item;

				// support: Firefox
				// Prevent accidental activation of menu items in Firefox (#7024 #9118)
				if ( this.isNewMenu ) {
					this.isNewMenu = false;
					if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
						this.menu.blur();

						this.document.one( "mousemove", function() {
							$( event.target ).trigger( event.originalEvent );
						} );

						return;
					}
				}

				item = ui.item.data( "ui-autocomplete-item" );
				if ( false !== this._trigger( "focus", event, { item: item } ) ) {

					// use value to match what will end up in the input, if it was a key event
					if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
						this._value( item.value );
					}
				}

				// Announce the value in the liveRegion
				label = ui.item.attr( "aria-label" ) || item.value;
				if ( label && $.trim( label ).length ) {
					this.liveRegion.children().hide();
					$( "<div>" ).text( label ).appendTo( this.liveRegion );
				}
			},
			menuselect: function( event, ui ) {
				var item = ui.item.data( "ui-autocomplete-item" ),
					previous = this.previous;

				// Only trigger when focus was lost (click on menu)
				if ( this.element[ 0 ] !== $.ui.safeActiveElement( this.document[ 0 ] ) ) {
					this.element.trigger( "focus" );
					this.previous = previous;

					// #6109 - IE triggers two focus events and the second
					// is asynchronous, so we need to reset the previous
					// term synchronously and asynchronously :-(
					this._delay( function() {
						this.previous = previous;
						this.selectedItem = item;
					} );
				}

				if ( false !== this._trigger( "select", event, { item: item } ) ) {
					this._value( item.value );
				}

				// reset the term after the select event
				// this allows custom select handling to work properly
				this.term = this._value();

				this.close( event );
				this.selectedItem = item;
			}
		} );

		this.liveRegion = $( "<div>", {
			role: "status",
			"aria-live": "assertive",
			"aria-relevant": "additions"
		} )
			.appendTo( this.document[ 0 ].body );

		this._addClass( this.liveRegion, null, "ui-helper-hidden-accessible" );

		// Turning off autocomplete prevents the browser from remembering the
		// value when navigating through history, so we re-enable autocomplete
		// if the page is unloaded before the widget is destroyed. #7790
		this._on( this.window, {
			beforeunload: function() {
				this.element.removeAttr( "autocomplete" );
			}
		} );
	},

	_destroy: function() {
		clearTimeout( this.searching );
		this.element.removeAttr( "autocomplete" );
		this.menu.element.remove();
		this.liveRegion.remove();
	},

	_setOption: function( key, value ) {
		this._super( key, value );
		if ( key === "source" ) {
			this._initSource();
		}
		if ( key === "appendTo" ) {
			this.menu.element.appendTo( this._appendTo() );
		}
		if ( key === "disabled" && value && this.xhr ) {
			this.xhr.abort();
		}
	},

	_isEventTargetInWidget: function( event ) {
		var menuElement = this.menu.element[ 0 ];

		return event.target === this.element[ 0 ] ||
			event.target === menuElement ||
			$.contains( menuElement, event.target );
	},

	_closeOnClickOutside: function( event ) {
		if ( !this._isEventTargetInWidget( event ) ) {
			this.close();
		}
	},

	_appendTo: function() {
		var element = this.options.appendTo;

		if ( element ) {
			element = element.jquery || element.nodeType ?
				$( element ) :
				this.document.find( element ).eq( 0 );
		}

		if ( !element || !element[ 0 ] ) {
			element = this.element.closest( ".ui-front, dialog" );
		}

		if ( !element.length ) {
			element = this.document[ 0 ].body;
		}

		return element;
	},

	_initSource: function() {
		var array, url,
			that = this;
		if ( $.isArray( this.options.source ) ) {
			array = this.options.source;
			this.source = function( request, response ) {
				response( $.ui.autocomplete.filter( array, request.term ) );
			};
		} else if ( typeof this.options.source === "string" ) {
			url = this.options.source;
			this.source = function( request, response ) {
				if ( that.xhr ) {
					that.xhr.abort();
				}
				that.xhr = $.ajax( {
					url: url,
					data: request,
					dataType: "json",
					success: function( data ) {
						response( data );
					},
					error: function() {
						response( [] );
					}
				} );
			};
		} else {
			this.source = this.options.source;
		}
	},

	_searchTimeout: function( event ) {
		clearTimeout( this.searching );
		this.searching = this._delay( function() {

			// Search if the value has changed, or if the user retypes the same value (see #7434)
			var equalValues = this.term === this._value(),
				menuVisible = this.menu.element.is( ":visible" ),
				modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

			if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
				this.selectedItem = null;
				this.search( null, event );
			}
		}, this.options.delay );
	},

	search: function( value, event ) {
		value = value != null ? value : this._value();

		// Always save the actual value, not the one passed as an argument
		this.term = this._value();

		if ( value.length < this.options.minLength ) {
			return this.close( event );
		}

		if ( this._trigger( "search", event ) === false ) {
			return;
		}

		return this._search( value );
	},

	_search: function( value ) {
		this.pending++;
		this._addClass( "ui-autocomplete-loading" );
		this.cancelSearch = false;

		this.source( { term: value }, this._response() );
	},

	_response: function() {
		var index = ++this.requestIndex;

		return $.proxy( function( content ) {
			if ( index === this.requestIndex ) {
				this.__response( content );
			}

			this.pending--;
			if ( !this.pending ) {
				this._removeClass( "ui-autocomplete-loading" );
			}
		}, this );
	},

	__response: function( content ) {
		if ( content ) {
			content = this._normalize( content );
		}
		this._trigger( "response", null, { content: content } );
		if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
			this._suggest( content );
			this._trigger( "open" );
		} else {

			// use ._close() instead of .close() so we don't cancel future searches
			this._close();
		}
	},

	close: function( event ) {
		this.cancelSearch = true;
		this._close( event );
	},

	_close: function( event ) {

		// Remove the handler that closes the menu on outside clicks
		this._off( this.document, "mousedown" );

		if ( this.menu.element.is( ":visible" ) ) {
			this.menu.element.hide();
			this.menu.blur();
			this.isNewMenu = true;
			this._trigger( "close", event );
		}
	},

	_change: function( event ) {
		if ( this.previous !== this._value() ) {
			this._trigger( "change", event, { item: this.selectedItem } );
		}
	},

	_normalize: function( items ) {

		// assume all items have the right format when the first item is complete
		if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
			return items;
		}
		return $.map( items, function( item ) {
			if ( typeof item === "string" ) {
				return {
					label: item,
					value: item
				};
			}
			return $.extend( {}, item, {
				label: item.label || item.value,
				value: item.value || item.label
			} );
		} );
	},

	_suggest: function( items ) {
		var ul = this.menu.element.empty();
		this._renderMenu( ul, items );
		this.isNewMenu = true;
		this.menu.refresh();

		// Size and position menu
		ul.show();
		this._resizeMenu();
		ul.position( $.extend( {
			of: this.element
		}, this.options.position ) );

		if ( this.options.autoFocus ) {
			this.menu.next();
		}

		// Listen for interactions outside of the widget (#6642)
		this._on( this.document, {
			mousedown: "_closeOnClickOutside"
		} );
	},

	_resizeMenu: function() {
		var ul = this.menu.element;
		ul.outerWidth( Math.max(

			// Firefox wraps long text (possibly a rounding bug)
			// so we add 1px to avoid the wrapping (#7513)
			ul.width( "" ).outerWidth() + 1,
			this.element.outerWidth()
		) );
	},

	_renderMenu: function( ul, items ) {
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( ul, item );
		} );
	},

	_renderItemData: function( ul, item ) {
		return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
	},

	_renderItem: function( ul, item ) {
		return $( "<li>" )
			.append( $( "<div>" ).text( item.label ) )
			.appendTo( ul );
	},

	_move: function( direction, event ) {
		if ( !this.menu.element.is( ":visible" ) ) {
			this.search( null, event );
			return;
		}
		if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
				this.menu.isLastItem() && /^next/.test( direction ) ) {

			if ( !this.isMultiLine ) {
				this._value( this.term );
			}

			this.menu.blur();
			return;
		}
		this.menu[ direction ]( event );
	},

	widget: function() {
		return this.menu.element;
	},

	_value: function() {
		return this.valueMethod.apply( this.element, arguments );
	},

	_keyEvent: function( keyEvent, event ) {
		if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
			this._move( keyEvent, event );

			// Prevents moving cursor to beginning/end of the text field in some browsers
			event.preventDefault();
		}
	},

	// Support: Chrome <=50
	// We should be able to just use this.element.prop( "isContentEditable" )
	// but hidden elements always report false in Chrome.
	// https://code.google.com/p/chromium/issues/detail?id=313082
	_isContentEditable: function( element ) {
		if ( !element.length ) {
			return false;
		}

		var editable = element.prop( "contentEditable" );

		if ( editable === "inherit" ) {
		  return this._isContentEditable( element.parent() );
		}

		return editable === "true";
	}
} );

$.extend( $.ui.autocomplete, {
	escapeRegex: function( value ) {
		return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
	},
	filter: function( array, term ) {
		var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
		return $.grep( array, function( value ) {
			return matcher.test( value.label || value.value || value );
		} );
	}
} );

// Live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
	options: {
		messages: {
			noResults: "No search results.",
			results: function( amount ) {
				return amount + ( amount > 1 ? " results are" : " result is" ) +
					" available, use up and down arrow keys to navigate.";
			}
		}
	},

	__response: function( content ) {
		var message;
		this._superApply( arguments );
		if ( this.options.disabled || this.cancelSearch ) {
			return;
		}
		if ( content && content.length ) {
			message = this.options.messages.results( content.length );
		} else {
			message = this.options.messages.noResults;
		}
		this.liveRegion.children().hide();
		$( "<div>" ).text( message ).appendTo( this.liveRegion );
	}
} );

var widgetsAutocomplete = $.ui.autocomplete;




}));

/***/ }),

/***/ "FbJA":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("9NYw");
__webpack_require__("iARY");
__webpack_require__("WnPD");
__webpack_require__("oFEn");
__webpack_require__("Wgr5");
__webpack_require__("CT8B");
__webpack_require__("SRZf");
__webpack_require__("Nnw9");
__webpack_require__("Bd6y");

__webpack_require__("9JTz");
__webpack_require__("rO4t");
__webpack_require__("qXSf");
__webpack_require__("nEsx");
__webpack_require__("LWeo");


/***/ }),

/***/ "LWeo":
/***/ (function(module, exports) {

// https://github.com/jwheare/js-emoji/tree/irccloud
// Update .emoji background-size in CSS when sheet_size changes
window.emoji.sheet_size = 62;
window.emoji.data = {
    "0023-fe0f-20e3":[["\u0023\uFE0F\u20E3"],"Symbols",1549,["hash"],0,0,"0.6","keycap"],
    "002a-fe0f-20e3":[["\u002A\uFE0F\u20E3"],"Symbols",1550,["keycap_star"],0,1,"2.0","keycap"],
    "0030-fe0f-20e3":[["\u0030\uFE0F\u20E3"],"Symbols",1551,["zero"],0,2,"0.6","keycap"],
    "0031-fe0f-20e3":[["\u0031\uFE0F\u20E3"],"Symbols",1552,["one"],0,3,"0.6","keycap"],
    "0032-fe0f-20e3":[["\u0032\uFE0F\u20E3"],"Symbols",1553,["two"],0,4,"0.6","keycap"],
    "0033-fe0f-20e3":[["\u0033\uFE0F\u20E3"],"Symbols",1554,["three"],0,5,"0.6","keycap"],
    "0034-fe0f-20e3":[["\u0034\uFE0F\u20E3"],"Symbols",1555,["four"],0,6,"0.6","keycap"],
    "0035-fe0f-20e3":[["\u0035\uFE0F\u20E3"],"Symbols",1556,["five"],0,7,"0.6","keycap"],
    "0036-fe0f-20e3":[["\u0036\uFE0F\u20E3"],"Symbols",1557,["six"],0,8,"0.6","keycap"],
    "0037-fe0f-20e3":[["\u0037\uFE0F\u20E3"],"Symbols",1558,["seven"],0,9,"0.6","keycap"],
    "0038-fe0f-20e3":[["\u0038\uFE0F\u20E3"],"Symbols",1559,["eight"],0,10,"0.6","keycap"],
    "0039-fe0f-20e3":[["\u0039\uFE0F\u20E3"],"Symbols",1560,["nine"],0,11,"0.6","keycap"],
    "00a9-fe0f":[["\u00A9\uFE0F"],"Symbols",1546,["copyright"],0,12,"0.6","other-symbol"],
    "00ae-fe0f":[["\u00AE\uFE0F"],"Symbols",1547,["registered"],0,13,"0.6","other-symbol"],
    "1f004":[["\uD83C\uDC04"],"Activities",1141,["mahjong"],0,14,"0.6","game"],
    "1f0cf":[["\uD83C\uDCCF"],"Activities",1140,["black_joker"],0,15,"0.6","game"],
    "1f170-fe0f":[["\uD83C\uDD70\uFE0F"],"Symbols",1567,["a"],0,16,"0.6","alphanum"],
    "1f171-fe0f":[["\uD83C\uDD71\uFE0F"],"Symbols",1569,["b"],0,17,"0.6","alphanum"],
    "1f17e-fe0f":[["\uD83C\uDD7E\uFE0F"],"Symbols",1578,["o2"],0,18,"0.6","alphanum"],
    "1f17f-fe0f":[["\uD83C\uDD7F\uFE0F"],"Symbols",1580,["parking"],0,19,"0.6","alphanum"],
    "1f18e":[["\uD83C\uDD8E"],"Symbols",1568,["ab"],0,20,"0.6","alphanum"],
    "1f191":[["\uD83C\uDD91"],"Symbols",1570,["cl"],0,21,"0.6","alphanum"],
    "1f192":[["\uD83C\uDD92"],"Symbols",1571,["cool"],0,22,"0.6","alphanum"],
    "1f193":[["\uD83C\uDD93"],"Symbols",1572,["free"],0,23,"0.6","alphanum"],
    "1f194":[["\uD83C\uDD94"],"Symbols",1574,["id"],0,24,"0.6","alphanum"],
    "1f195":[["\uD83C\uDD95"],"Symbols",1576,["new"],0,25,"0.6","alphanum"],
    "1f196":[["\uD83C\uDD96"],"Symbols",1577,["ng"],0,26,"0.6","alphanum"],
    "1f197":[["\uD83C\uDD97"],"Symbols",1579,["ok"],0,27,"0.6","alphanum"],
    "1f198":[["\uD83C\uDD98"],"Symbols",1581,["sos"],0,28,"0.6","alphanum"],
    "1f199":[["\uD83C\uDD99"],"Symbols",1582,["up"],0,29,"0.6","alphanum"],
    "1f19a":[["\uD83C\uDD9A"],"Symbols",1583,["vs"],0,30,"0.6","alphanum"],
    "1f1e6-1f1e8":[["\uD83C\uDDE6\uD83C\uDDE8"],"Flags",1643,["flag-ac"],0,31,"2.0","country-flag"],
    "1f1e6-1f1e9":[["\uD83C\uDDE6\uD83C\uDDE9"],"Flags",1644,["flag-ad"],0,32,"2.0","country-flag"],
    "1f1e6-1f1ea":[["\uD83C\uDDE6\uD83C\uDDEA"],"Flags",1645,["flag-ae"],0,33,"2.0","country-flag"],
    "1f1e6-1f1eb":[["\uD83C\uDDE6\uD83C\uDDEB"],"Flags",1646,["flag-af"],0,34,"2.0","country-flag"],
    "1f1e6-1f1ec":[["\uD83C\uDDE6\uD83C\uDDEC"],"Flags",1647,["flag-ag"],0,35,"2.0","country-flag"],
    "1f1e6-1f1ee":[["\uD83C\uDDE6\uD83C\uDDEE"],"Flags",1648,["flag-ai"],0,36,"2.0","country-flag"],
    "1f1e6-1f1f1":[["\uD83C\uDDE6\uD83C\uDDF1"],"Flags",1649,["flag-al"],0,37,"2.0","country-flag"],
    "1f1e6-1f1f2":[["\uD83C\uDDE6\uD83C\uDDF2"],"Flags",1650,["flag-am"],0,38,"2.0","country-flag"],
    "1f1e6-1f1f4":[["\uD83C\uDDE6\uD83C\uDDF4"],"Flags",1651,["flag-ao"],0,39,"2.0","country-flag"],
    "1f1e6-1f1f6":[["\uD83C\uDDE6\uD83C\uDDF6"],"Flags",1652,["flag-aq"],0,40,"2.0","country-flag"],
    "1f1e6-1f1f7":[["\uD83C\uDDE6\uD83C\uDDF7"],"Flags",1653,["flag-ar"],0,41,"2.0","country-flag"],
    "1f1e6-1f1f8":[["\uD83C\uDDE6\uD83C\uDDF8"],"Flags",1654,["flag-as"],0,42,"2.0","country-flag"],
    "1f1e6-1f1f9":[["\uD83C\uDDE6\uD83C\uDDF9"],"Flags",1655,["flag-at"],0,43,"2.0","country-flag"],
    "1f1e6-1f1fa":[["\uD83C\uDDE6\uD83C\uDDFA"],"Flags",1656,["flag-au"],0,44,"2.0","country-flag"],
    "1f1e6-1f1fc":[["\uD83C\uDDE6\uD83C\uDDFC"],"Flags",1657,["flag-aw"],0,45,"2.0","country-flag"],
    "1f1e6-1f1fd":[["\uD83C\uDDE6\uD83C\uDDFD"],"Flags",1658,["flag-ax"],0,46,"2.0","country-flag"],
    "1f1e6-1f1ff":[["\uD83C\uDDE6\uD83C\uDDFF"],"Flags",1659,["flag-az"],0,47,"2.0","country-flag"],
    "1f1e7-1f1e6":[["\uD83C\uDDE7\uD83C\uDDE6"],"Flags",1660,["flag-ba"],0,48,"2.0","country-flag"],
    "1f1e7-1f1e7":[["\uD83C\uDDE7\uD83C\uDDE7"],"Flags",1661,["flag-bb"],0,49,"2.0","country-flag"],
    "1f1e7-1f1e9":[["\uD83C\uDDE7\uD83C\uDDE9"],"Flags",1662,["flag-bd"],0,50,"2.0","country-flag"],
    "1f1e7-1f1ea":[["\uD83C\uDDE7\uD83C\uDDEA"],"Flags",1663,["flag-be"],0,51,"2.0","country-flag"],
    "1f1e7-1f1eb":[["\uD83C\uDDE7\uD83C\uDDEB"],"Flags",1664,["flag-bf"],0,52,"2.0","country-flag"],
    "1f1e7-1f1ec":[["\uD83C\uDDE7\uD83C\uDDEC"],"Flags",1665,["flag-bg"],0,53,"2.0","country-flag"],
    "1f1e7-1f1ed":[["\uD83C\uDDE7\uD83C\uDDED"],"Flags",1666,["flag-bh"],0,54,"2.0","country-flag"],
    "1f1e7-1f1ee":[["\uD83C\uDDE7\uD83C\uDDEE"],"Flags",1667,["flag-bi"],0,55,"2.0","country-flag"],
    "1f1e7-1f1ef":[["\uD83C\uDDE7\uD83C\uDDEF"],"Flags",1668,["flag-bj"],0,56,"2.0","country-flag"],
    "1f1e7-1f1f1":[["\uD83C\uDDE7\uD83C\uDDF1"],"Flags",1669,["flag-bl"],0,57,"2.0","country-flag"],
    "1f1e7-1f1f2":[["\uD83C\uDDE7\uD83C\uDDF2"],"Flags",1670,["flag-bm"],0,58,"2.0","country-flag"],
    "1f1e7-1f1f3":[["\uD83C\uDDE7\uD83C\uDDF3"],"Flags",1671,["flag-bn"],0,59,"2.0","country-flag"],
    "1f1e7-1f1f4":[["\uD83C\uDDE7\uD83C\uDDF4"],"Flags",1672,["flag-bo"],0,60,"2.0","country-flag"],
    "1f1e7-1f1f6":[["\uD83C\uDDE7\uD83C\uDDF6"],"Flags",1673,["flag-bq"],0,61,"2.0","country-flag"],
    "1f1e7-1f1f7":[["\uD83C\uDDE7\uD83C\uDDF7"],"Flags",1674,["flag-br"],1,0,"2.0","country-flag"],
    "1f1e7-1f1f8":[["\uD83C\uDDE7\uD83C\uDDF8"],"Flags",1675,["flag-bs"],1,1,"2.0","country-flag"],
    "1f1e7-1f1f9":[["\uD83C\uDDE7\uD83C\uDDF9"],"Flags",1676,["flag-bt"],1,2,"2.0","country-flag"],
    "1f1e7-1f1fb":[["\uD83C\uDDE7\uD83C\uDDFB"],"Flags",1677,["flag-bv"],1,3,"2.0","country-flag"],
    "1f1e7-1f1fc":[["\uD83C\uDDE7\uD83C\uDDFC"],"Flags",1678,["flag-bw"],1,4,"2.0","country-flag"],
    "1f1e7-1f1fe":[["\uD83C\uDDE7\uD83C\uDDFE"],"Flags",1679,["flag-by"],1,5,"2.0","country-flag"],
    "1f1e7-1f1ff":[["\uD83C\uDDE7\uD83C\uDDFF"],"Flags",1680,["flag-bz"],1,6,"2.0","country-flag"],
    "1f1e8-1f1e6":[["\uD83C\uDDE8\uD83C\uDDE6"],"Flags",1681,["flag-ca"],1,7,"2.0","country-flag"],
    "1f1e8-1f1e8":[["\uD83C\uDDE8\uD83C\uDDE8"],"Flags",1682,["flag-cc"],1,8,"2.0","country-flag"],
    "1f1e8-1f1e9":[["\uD83C\uDDE8\uD83C\uDDE9"],"Flags",1683,["flag-cd"],1,9,"2.0","country-flag"],
    "1f1e8-1f1eb":[["\uD83C\uDDE8\uD83C\uDDEB"],"Flags",1684,["flag-cf"],1,10,"2.0","country-flag"],
    "1f1e8-1f1ec":[["\uD83C\uDDE8\uD83C\uDDEC"],"Flags",1685,["flag-cg"],1,11,"2.0","country-flag"],
    "1f1e8-1f1ed":[["\uD83C\uDDE8\uD83C\uDDED"],"Flags",1686,["flag-ch"],1,12,"2.0","country-flag"],
    "1f1e8-1f1ee":[["\uD83C\uDDE8\uD83C\uDDEE"],"Flags",1687,["flag-ci"],1,13,"2.0","country-flag"],
    "1f1e8-1f1f0":[["\uD83C\uDDE8\uD83C\uDDF0"],"Flags",1688,["flag-ck"],1,14,"2.0","country-flag"],
    "1f1e8-1f1f1":[["\uD83C\uDDE8\uD83C\uDDF1"],"Flags",1689,["flag-cl"],1,15,"2.0","country-flag"],
    "1f1e8-1f1f2":[["\uD83C\uDDE8\uD83C\uDDF2"],"Flags",1690,["flag-cm"],1,16,"2.0","country-flag"],
    "1f1e8-1f1f3":[["\uD83C\uDDE8\uD83C\uDDF3"],"Flags",1691,["cn","flag-cn"],1,17,"0.6","country-flag"],
    "1f1e8-1f1f4":[["\uD83C\uDDE8\uD83C\uDDF4"],"Flags",1692,["flag-co"],1,18,"2.0","country-flag"],
    "1f1e8-1f1f5":[["\uD83C\uDDE8\uD83C\uDDF5"],"Flags",1693,["flag-cp"],1,19,"2.0","country-flag"],
    "1f1e8-1f1f7":[["\uD83C\uDDE8\uD83C\uDDF7"],"Flags",1694,["flag-cr"],1,20,"2.0","country-flag"],
    "1f1e8-1f1fa":[["\uD83C\uDDE8\uD83C\uDDFA"],"Flags",1695,["flag-cu"],1,21,"2.0","country-flag"],
    "1f1e8-1f1fb":[["\uD83C\uDDE8\uD83C\uDDFB"],"Flags",1696,["flag-cv"],1,22,"2.0","country-flag"],
    "1f1e8-1f1fc":[["\uD83C\uDDE8\uD83C\uDDFC"],"Flags",1697,["flag-cw"],1,23,"2.0","country-flag"],
    "1f1e8-1f1fd":[["\uD83C\uDDE8\uD83C\uDDFD"],"Flags",1698,["flag-cx"],1,24,"2.0","country-flag"],
    "1f1e8-1f1fe":[["\uD83C\uDDE8\uD83C\uDDFE"],"Flags",1699,["flag-cy"],1,25,"2.0","country-flag"],
    "1f1e8-1f1ff":[["\uD83C\uDDE8\uD83C\uDDFF"],"Flags",1700,["flag-cz"],1,26,"2.0","country-flag"],
    "1f1e9-1f1ea":[["\uD83C\uDDE9\uD83C\uDDEA"],"Flags",1701,["de","flag-de"],1,27,"0.6","country-flag"],
    "1f1e9-1f1ec":[["\uD83C\uDDE9\uD83C\uDDEC"],"Flags",1702,["flag-dg"],1,28,"2.0","country-flag"],
    "1f1e9-1f1ef":[["\uD83C\uDDE9\uD83C\uDDEF"],"Flags",1703,["flag-dj"],1,29,"2.0","country-flag"],
    "1f1e9-1f1f0":[["\uD83C\uDDE9\uD83C\uDDF0"],"Flags",1704,["flag-dk"],1,30,"2.0","country-flag"],
    "1f1e9-1f1f2":[["\uD83C\uDDE9\uD83C\uDDF2"],"Flags",1705,["flag-dm"],1,31,"2.0","country-flag"],
    "1f1e9-1f1f4":[["\uD83C\uDDE9\uD83C\uDDF4"],"Flags",1706,["flag-do"],1,32,"2.0","country-flag"],
    "1f1e9-1f1ff":[["\uD83C\uDDE9\uD83C\uDDFF"],"Flags",1707,["flag-dz"],1,33,"2.0","country-flag"],
    "1f1ea-1f1e6":[["\uD83C\uDDEA\uD83C\uDDE6"],"Flags",1708,["flag-ea"],1,34,"2.0","country-flag"],
    "1f1ea-1f1e8":[["\uD83C\uDDEA\uD83C\uDDE8"],"Flags",1709,["flag-ec"],1,35,"2.0","country-flag"],
    "1f1ea-1f1ea":[["\uD83C\uDDEA\uD83C\uDDEA"],"Flags",1710,["flag-ee"],1,36,"2.0","country-flag"],
    "1f1ea-1f1ec":[["\uD83C\uDDEA\uD83C\uDDEC"],"Flags",1711,["flag-eg"],1,37,"2.0","country-flag"],
    "1f1ea-1f1ed":[["\uD83C\uDDEA\uD83C\uDDED"],"Flags",1712,["flag-eh"],1,38,"2.0","country-flag"],
    "1f1ea-1f1f7":[["\uD83C\uDDEA\uD83C\uDDF7"],"Flags",1713,["flag-er"],1,39,"2.0","country-flag"],
    "1f1ea-1f1f8":[["\uD83C\uDDEA\uD83C\uDDF8"],"Flags",1714,["es","flag-es"],1,40,"0.6","country-flag"],
    "1f1ea-1f1f9":[["\uD83C\uDDEA\uD83C\uDDF9"],"Flags",1715,["flag-et"],1,41,"2.0","country-flag"],
    "1f1ea-1f1fa":[["\uD83C\uDDEA\uD83C\uDDFA"],"Flags",1716,["flag-eu"],1,42,"2.0","country-flag"],
    "1f1eb-1f1ee":[["\uD83C\uDDEB\uD83C\uDDEE"],"Flags",1717,["flag-fi"],1,43,"2.0","country-flag"],
    "1f1eb-1f1ef":[["\uD83C\uDDEB\uD83C\uDDEF"],"Flags",1718,["flag-fj"],1,44,"2.0","country-flag"],
    "1f1eb-1f1f0":[["\uD83C\uDDEB\uD83C\uDDF0"],"Flags",1719,["flag-fk"],1,45,"2.0","country-flag"],
    "1f1eb-1f1f2":[["\uD83C\uDDEB\uD83C\uDDF2"],"Flags",1720,["flag-fm"],1,46,"2.0","country-flag"],
    "1f1eb-1f1f4":[["\uD83C\uDDEB\uD83C\uDDF4"],"Flags",1721,["flag-fo"],1,47,"2.0","country-flag"],
    "1f1eb-1f1f7":[["\uD83C\uDDEB\uD83C\uDDF7"],"Flags",1722,["fr","flag-fr"],1,48,"0.6","country-flag"],
    "1f1ec-1f1e6":[["\uD83C\uDDEC\uD83C\uDDE6"],"Flags",1723,["flag-ga"],1,49,"2.0","country-flag"],
    "1f1ec-1f1e7":[["\uD83C\uDDEC\uD83C\uDDE7"],"Flags",1724,["gb","uk","flag-gb"],1,50,"0.6","country-flag"],
    "1f1ec-1f1e9":[["\uD83C\uDDEC\uD83C\uDDE9"],"Flags",1725,["flag-gd"],1,51,"2.0","country-flag"],
    "1f1ec-1f1ea":[["\uD83C\uDDEC\uD83C\uDDEA"],"Flags",1726,["flag-ge"],1,52,"2.0","country-flag"],
    "1f1ec-1f1eb":[["\uD83C\uDDEC\uD83C\uDDEB"],"Flags",1727,["flag-gf"],1,53,"2.0","country-flag"],
    "1f1ec-1f1ec":[["\uD83C\uDDEC\uD83C\uDDEC"],"Flags",1728,["flag-gg"],1,54,"2.0","country-flag"],
    "1f1ec-1f1ed":[["\uD83C\uDDEC\uD83C\uDDED"],"Flags",1729,["flag-gh"],1,55,"2.0","country-flag"],
    "1f1ec-1f1ee":[["\uD83C\uDDEC\uD83C\uDDEE"],"Flags",1730,["flag-gi"],1,56,"2.0","country-flag"],
    "1f1ec-1f1f1":[["\uD83C\uDDEC\uD83C\uDDF1"],"Flags",1731,["flag-gl"],1,57,"2.0","country-flag"],
    "1f1ec-1f1f2":[["\uD83C\uDDEC\uD83C\uDDF2"],"Flags",1732,["flag-gm"],1,58,"2.0","country-flag"],
    "1f1ec-1f1f3":[["\uD83C\uDDEC\uD83C\uDDF3"],"Flags",1733,["flag-gn"],1,59,"2.0","country-flag"],
    "1f1ec-1f1f5":[["\uD83C\uDDEC\uD83C\uDDF5"],"Flags",1734,["flag-gp"],1,60,"2.0","country-flag"],
    "1f1ec-1f1f6":[["\uD83C\uDDEC\uD83C\uDDF6"],"Flags",1735,["flag-gq"],1,61,"2.0","country-flag"],
    "1f1ec-1f1f7":[["\uD83C\uDDEC\uD83C\uDDF7"],"Flags",1736,["flag-gr"],2,0,"2.0","country-flag"],
    "1f1ec-1f1f8":[["\uD83C\uDDEC\uD83C\uDDF8"],"Flags",1737,["flag-gs"],2,1,"2.0","country-flag"],
    "1f1ec-1f1f9":[["\uD83C\uDDEC\uD83C\uDDF9"],"Flags",1738,["flag-gt"],2,2,"2.0","country-flag"],
    "1f1ec-1f1fa":[["\uD83C\uDDEC\uD83C\uDDFA"],"Flags",1739,["flag-gu"],2,3,"2.0","country-flag"],
    "1f1ec-1f1fc":[["\uD83C\uDDEC\uD83C\uDDFC"],"Flags",1740,["flag-gw"],2,4,"2.0","country-flag"],
    "1f1ec-1f1fe":[["\uD83C\uDDEC\uD83C\uDDFE"],"Flags",1741,["flag-gy"],2,5,"2.0","country-flag"],
    "1f1ed-1f1f0":[["\uD83C\uDDED\uD83C\uDDF0"],"Flags",1742,["flag-hk"],2,6,"2.0","country-flag"],
    "1f1ed-1f1f2":[["\uD83C\uDDED\uD83C\uDDF2"],"Flags",1743,["flag-hm"],2,7,"2.0","country-flag"],
    "1f1ed-1f1f3":[["\uD83C\uDDED\uD83C\uDDF3"],"Flags",1744,["flag-hn"],2,8,"2.0","country-flag"],
    "1f1ed-1f1f7":[["\uD83C\uDDED\uD83C\uDDF7"],"Flags",1745,["flag-hr"],2,9,"2.0","country-flag"],
    "1f1ed-1f1f9":[["\uD83C\uDDED\uD83C\uDDF9"],"Flags",1746,["flag-ht"],2,10,"2.0","country-flag"],
    "1f1ed-1f1fa":[["\uD83C\uDDED\uD83C\uDDFA"],"Flags",1747,["flag-hu"],2,11,"2.0","country-flag"],
    "1f1ee-1f1e8":[["\uD83C\uDDEE\uD83C\uDDE8"],"Flags",1748,["flag-ic"],2,12,"2.0","country-flag"],
    "1f1ee-1f1e9":[["\uD83C\uDDEE\uD83C\uDDE9"],"Flags",1749,["flag-id"],2,13,"2.0","country-flag"],
    "1f1ee-1f1ea":[["\uD83C\uDDEE\uD83C\uDDEA"],"Flags",1750,["flag-ie"],2,14,"2.0","country-flag"],
    "1f1ee-1f1f1":[["\uD83C\uDDEE\uD83C\uDDF1"],"Flags",1751,["flag-il"],2,15,"2.0","country-flag"],
    "1f1ee-1f1f2":[["\uD83C\uDDEE\uD83C\uDDF2"],"Flags",1752,["flag-im"],2,16,"2.0","country-flag"],
    "1f1ee-1f1f3":[["\uD83C\uDDEE\uD83C\uDDF3"],"Flags",1753,["flag-in"],2,17,"2.0","country-flag"],
    "1f1ee-1f1f4":[["\uD83C\uDDEE\uD83C\uDDF4"],"Flags",1754,["flag-io"],2,18,"2.0","country-flag"],
    "1f1ee-1f1f6":[["\uD83C\uDDEE\uD83C\uDDF6"],"Flags",1755,["flag-iq"],2,19,"2.0","country-flag"],
    "1f1ee-1f1f7":[["\uD83C\uDDEE\uD83C\uDDF7"],"Flags",1756,["flag-ir"],2,20,"2.0","country-flag"],
    "1f1ee-1f1f8":[["\uD83C\uDDEE\uD83C\uDDF8"],"Flags",1757,["flag-is"],2,21,"2.0","country-flag"],
    "1f1ee-1f1f9":[["\uD83C\uDDEE\uD83C\uDDF9"],"Flags",1758,["it","flag-it"],2,22,"0.6","country-flag"],
    "1f1ef-1f1ea":[["\uD83C\uDDEF\uD83C\uDDEA"],"Flags",1759,["flag-je"],2,23,"2.0","country-flag"],
    "1f1ef-1f1f2":[["\uD83C\uDDEF\uD83C\uDDF2"],"Flags",1760,["flag-jm"],2,24,"2.0","country-flag"],
    "1f1ef-1f1f4":[["\uD83C\uDDEF\uD83C\uDDF4"],"Flags",1761,["flag-jo"],2,25,"2.0","country-flag"],
    "1f1ef-1f1f5":[["\uD83C\uDDEF\uD83C\uDDF5"],"Flags",1762,["jp","flag-jp"],2,26,"0.6","country-flag"],
    "1f1f0-1f1ea":[["\uD83C\uDDF0\uD83C\uDDEA"],"Flags",1763,["flag-ke"],2,27,"2.0","country-flag"],
    "1f1f0-1f1ec":[["\uD83C\uDDF0\uD83C\uDDEC"],"Flags",1764,["flag-kg"],2,28,"2.0","country-flag"],
    "1f1f0-1f1ed":[["\uD83C\uDDF0\uD83C\uDDED"],"Flags",1765,["flag-kh"],2,29,"2.0","country-flag"],
    "1f1f0-1f1ee":[["\uD83C\uDDF0\uD83C\uDDEE"],"Flags",1766,["flag-ki"],2,30,"2.0","country-flag"],
    "1f1f0-1f1f2":[["\uD83C\uDDF0\uD83C\uDDF2"],"Flags",1767,["flag-km"],2,31,"2.0","country-flag"],
    "1f1f0-1f1f3":[["\uD83C\uDDF0\uD83C\uDDF3"],"Flags",1768,["flag-kn"],2,32,"2.0","country-flag"],
    "1f1f0-1f1f5":[["\uD83C\uDDF0\uD83C\uDDF5"],"Flags",1769,["flag-kp"],2,33,"2.0","country-flag"],
    "1f1f0-1f1f7":[["\uD83C\uDDF0\uD83C\uDDF7"],"Flags",1770,["kr","flag-kr"],2,34,"0.6","country-flag"],
    "1f1f0-1f1fc":[["\uD83C\uDDF0\uD83C\uDDFC"],"Flags",1771,["flag-kw"],2,35,"2.0","country-flag"],
    "1f1f0-1f1fe":[["\uD83C\uDDF0\uD83C\uDDFE"],"Flags",1772,["flag-ky"],2,36,"2.0","country-flag"],
    "1f1f0-1f1ff":[["\uD83C\uDDF0\uD83C\uDDFF"],"Flags",1773,["flag-kz"],2,37,"2.0","country-flag"],
    "1f1f1-1f1e6":[["\uD83C\uDDF1\uD83C\uDDE6"],"Flags",1774,["flag-la"],2,38,"2.0","country-flag"],
    "1f1f1-1f1e7":[["\uD83C\uDDF1\uD83C\uDDE7"],"Flags",1775,["flag-lb"],2,39,"2.0","country-flag"],
    "1f1f1-1f1e8":[["\uD83C\uDDF1\uD83C\uDDE8"],"Flags",1776,["flag-lc"],2,40,"2.0","country-flag"],
    "1f1f1-1f1ee":[["\uD83C\uDDF1\uD83C\uDDEE"],"Flags",1777,["flag-li"],2,41,"2.0","country-flag"],
    "1f1f1-1f1f0":[["\uD83C\uDDF1\uD83C\uDDF0"],"Flags",1778,["flag-lk"],2,42,"2.0","country-flag"],
    "1f1f1-1f1f7":[["\uD83C\uDDF1\uD83C\uDDF7"],"Flags",1779,["flag-lr"],2,43,"2.0","country-flag"],
    "1f1f1-1f1f8":[["\uD83C\uDDF1\uD83C\uDDF8"],"Flags",1780,["flag-ls"],2,44,"2.0","country-flag"],
    "1f1f1-1f1f9":[["\uD83C\uDDF1\uD83C\uDDF9"],"Flags",1781,["flag-lt"],2,45,"2.0","country-flag"],
    "1f1f1-1f1fa":[["\uD83C\uDDF1\uD83C\uDDFA"],"Flags",1782,["flag-lu"],2,46,"2.0","country-flag"],
    "1f1f1-1f1fb":[["\uD83C\uDDF1\uD83C\uDDFB"],"Flags",1783,["flag-lv"],2,47,"2.0","country-flag"],
    "1f1f1-1f1fe":[["\uD83C\uDDF1\uD83C\uDDFE"],"Flags",1784,["flag-ly"],2,48,"2.0","country-flag"],
    "1f1f2-1f1e6":[["\uD83C\uDDF2\uD83C\uDDE6"],"Flags",1785,["flag-ma"],2,49,"2.0","country-flag"],
    "1f1f2-1f1e8":[["\uD83C\uDDF2\uD83C\uDDE8"],"Flags",1786,["flag-mc"],2,50,"2.0","country-flag"],
    "1f1f2-1f1e9":[["\uD83C\uDDF2\uD83C\uDDE9"],"Flags",1787,["flag-md"],2,51,"2.0","country-flag"],
    "1f1f2-1f1ea":[["\uD83C\uDDF2\uD83C\uDDEA"],"Flags",1788,["flag-me"],2,52,"2.0","country-flag"],
    "1f1f2-1f1eb":[["\uD83C\uDDF2\uD83C\uDDEB"],"Flags",1789,["flag-mf"],2,53,"2.0","country-flag"],
    "1f1f2-1f1ec":[["\uD83C\uDDF2\uD83C\uDDEC"],"Flags",1790,["flag-mg"],2,54,"2.0","country-flag"],
    "1f1f2-1f1ed":[["\uD83C\uDDF2\uD83C\uDDED"],"Flags",1791,["flag-mh"],2,55,"2.0","country-flag"],
    "1f1f2-1f1f0":[["\uD83C\uDDF2\uD83C\uDDF0"],"Flags",1792,["flag-mk"],2,56,"2.0","country-flag"],
    "1f1f2-1f1f1":[["\uD83C\uDDF2\uD83C\uDDF1"],"Flags",1793,["flag-ml"],2,57,"2.0","country-flag"],
    "1f1f2-1f1f2":[["\uD83C\uDDF2\uD83C\uDDF2"],"Flags",1794,["flag-mm"],2,58,"2.0","country-flag"],
    "1f1f2-1f1f3":[["\uD83C\uDDF2\uD83C\uDDF3"],"Flags",1795,["flag-mn"],2,59,"2.0","country-flag"],
    "1f1f2-1f1f4":[["\uD83C\uDDF2\uD83C\uDDF4"],"Flags",1796,["flag-mo"],2,60,"2.0","country-flag"],
    "1f1f2-1f1f5":[["\uD83C\uDDF2\uD83C\uDDF5"],"Flags",1797,["flag-mp"],2,61,"2.0","country-flag"],
    "1f1f2-1f1f6":[["\uD83C\uDDF2\uD83C\uDDF6"],"Flags",1798,["flag-mq"],3,0,"2.0","country-flag"],
    "1f1f2-1f1f7":[["\uD83C\uDDF2\uD83C\uDDF7"],"Flags",1799,["flag-mr"],3,1,"2.0","country-flag"],
    "1f1f2-1f1f8":[["\uD83C\uDDF2\uD83C\uDDF8"],"Flags",1800,["flag-ms"],3,2,"2.0","country-flag"],
    "1f1f2-1f1f9":[["\uD83C\uDDF2\uD83C\uDDF9"],"Flags",1801,["flag-mt"],3,3,"2.0","country-flag"],
    "1f1f2-1f1fa":[["\uD83C\uDDF2\uD83C\uDDFA"],"Flags",1802,["flag-mu"],3,4,"2.0","country-flag"],
    "1f1f2-1f1fb":[["\uD83C\uDDF2\uD83C\uDDFB"],"Flags",1803,["flag-mv"],3,5,"2.0","country-flag"],
    "1f1f2-1f1fc":[["\uD83C\uDDF2\uD83C\uDDFC"],"Flags",1804,["flag-mw"],3,6,"2.0","country-flag"],
    "1f1f2-1f1fd":[["\uD83C\uDDF2\uD83C\uDDFD"],"Flags",1805,["flag-mx"],3,7,"2.0","country-flag"],
    "1f1f2-1f1fe":[["\uD83C\uDDF2\uD83C\uDDFE"],"Flags",1806,["flag-my"],3,8,"2.0","country-flag"],
    "1f1f2-1f1ff":[["\uD83C\uDDF2\uD83C\uDDFF"],"Flags",1807,["flag-mz"],3,9,"2.0","country-flag"],
    "1f1f3-1f1e6":[["\uD83C\uDDF3\uD83C\uDDE6"],"Flags",1808,["flag-na"],3,10,"2.0","country-flag"],
    "1f1f3-1f1e8":[["\uD83C\uDDF3\uD83C\uDDE8"],"Flags",1809,["flag-nc"],3,11,"2.0","country-flag"],
    "1f1f3-1f1ea":[["\uD83C\uDDF3\uD83C\uDDEA"],"Flags",1810,["flag-ne"],3,12,"2.0","country-flag"],
    "1f1f3-1f1eb":[["\uD83C\uDDF3\uD83C\uDDEB"],"Flags",1811,["flag-nf"],3,13,"2.0","country-flag"],
    "1f1f3-1f1ec":[["\uD83C\uDDF3\uD83C\uDDEC"],"Flags",1812,["flag-ng"],3,14,"2.0","country-flag"],
    "1f1f3-1f1ee":[["\uD83C\uDDF3\uD83C\uDDEE"],"Flags",1813,["flag-ni"],3,15,"2.0","country-flag"],
    "1f1f3-1f1f1":[["\uD83C\uDDF3\uD83C\uDDF1"],"Flags",1814,["flag-nl"],3,16,"2.0","country-flag"],
    "1f1f3-1f1f4":[["\uD83C\uDDF3\uD83C\uDDF4"],"Flags",1815,["flag-no"],3,17,"2.0","country-flag"],
    "1f1f3-1f1f5":[["\uD83C\uDDF3\uD83C\uDDF5"],"Flags",1816,["flag-np"],3,18,"2.0","country-flag"],
    "1f1f3-1f1f7":[["\uD83C\uDDF3\uD83C\uDDF7"],"Flags",1817,["flag-nr"],3,19,"2.0","country-flag"],
    "1f1f3-1f1fa":[["\uD83C\uDDF3\uD83C\uDDFA"],"Flags",1818,["flag-nu"],3,20,"2.0","country-flag"],
    "1f1f3-1f1ff":[["\uD83C\uDDF3\uD83C\uDDFF"],"Flags",1819,["flag-nz"],3,21,"2.0","country-flag"],
    "1f1f4-1f1f2":[["\uD83C\uDDF4\uD83C\uDDF2"],"Flags",1820,["flag-om"],3,22,"2.0","country-flag"],
    "1f1f5-1f1e6":[["\uD83C\uDDF5\uD83C\uDDE6"],"Flags",1821,["flag-pa"],3,23,"2.0","country-flag"],
    "1f1f5-1f1ea":[["\uD83C\uDDF5\uD83C\uDDEA"],"Flags",1822,["flag-pe"],3,24,"2.0","country-flag"],
    "1f1f5-1f1eb":[["\uD83C\uDDF5\uD83C\uDDEB"],"Flags",1823,["flag-pf"],3,25,"2.0","country-flag"],
    "1f1f5-1f1ec":[["\uD83C\uDDF5\uD83C\uDDEC"],"Flags",1824,["flag-pg"],3,26,"2.0","country-flag"],
    "1f1f5-1f1ed":[["\uD83C\uDDF5\uD83C\uDDED"],"Flags",1825,["flag-ph"],3,27,"2.0","country-flag"],
    "1f1f5-1f1f0":[["\uD83C\uDDF5\uD83C\uDDF0"],"Flags",1826,["flag-pk"],3,28,"2.0","country-flag"],
    "1f1f5-1f1f1":[["\uD83C\uDDF5\uD83C\uDDF1"],"Flags",1827,["flag-pl"],3,29,"2.0","country-flag"],
    "1f1f5-1f1f2":[["\uD83C\uDDF5\uD83C\uDDF2"],"Flags",1828,["flag-pm"],3,30,"2.0","country-flag"],
    "1f1f5-1f1f3":[["\uD83C\uDDF5\uD83C\uDDF3"],"Flags",1829,["flag-pn"],3,31,"2.0","country-flag"],
    "1f1f5-1f1f7":[["\uD83C\uDDF5\uD83C\uDDF7"],"Flags",1830,["flag-pr"],3,32,"2.0","country-flag"],
    "1f1f5-1f1f8":[["\uD83C\uDDF5\uD83C\uDDF8"],"Flags",1831,["flag-ps"],3,33,"2.0","country-flag"],
    "1f1f5-1f1f9":[["\uD83C\uDDF5\uD83C\uDDF9"],"Flags",1832,["flag-pt"],3,34,"2.0","country-flag"],
    "1f1f5-1f1fc":[["\uD83C\uDDF5\uD83C\uDDFC"],"Flags",1833,["flag-pw"],3,35,"2.0","country-flag"],
    "1f1f5-1f1fe":[["\uD83C\uDDF5\uD83C\uDDFE"],"Flags",1834,["flag-py"],3,36,"2.0","country-flag"],
    "1f1f6-1f1e6":[["\uD83C\uDDF6\uD83C\uDDE6"],"Flags",1835,["flag-qa"],3,37,"2.0","country-flag"],
    "1f1f7-1f1ea":[["\uD83C\uDDF7\uD83C\uDDEA"],"Flags",1836,["flag-re"],3,38,"2.0","country-flag"],
    "1f1f7-1f1f4":[["\uD83C\uDDF7\uD83C\uDDF4"],"Flags",1837,["flag-ro"],3,39,"2.0","country-flag"],
    "1f1f7-1f1f8":[["\uD83C\uDDF7\uD83C\uDDF8"],"Flags",1838,["flag-rs"],3,40,"2.0","country-flag"],
    "1f1f7-1f1fa":[["\uD83C\uDDF7\uD83C\uDDFA"],"Flags",1839,["ru","flag-ru"],3,41,"0.6","country-flag"],
    "1f1f7-1f1fc":[["\uD83C\uDDF7\uD83C\uDDFC"],"Flags",1840,["flag-rw"],3,42,"2.0","country-flag"],
    "1f1f8-1f1e6":[["\uD83C\uDDF8\uD83C\uDDE6"],"Flags",1841,["flag-sa"],3,43,"2.0","country-flag"],
    "1f1f8-1f1e7":[["\uD83C\uDDF8\uD83C\uDDE7"],"Flags",1842,["flag-sb"],3,44,"2.0","country-flag"],
    "1f1f8-1f1e8":[["\uD83C\uDDF8\uD83C\uDDE8"],"Flags",1843,["flag-sc"],3,45,"2.0","country-flag"],
    "1f1f8-1f1e9":[["\uD83C\uDDF8\uD83C\uDDE9"],"Flags",1844,["flag-sd"],3,46,"2.0","country-flag"],
    "1f1f8-1f1ea":[["\uD83C\uDDF8\uD83C\uDDEA"],"Flags",1845,["flag-se"],3,47,"2.0","country-flag"],
    "1f1f8-1f1ec":[["\uD83C\uDDF8\uD83C\uDDEC"],"Flags",1846,["flag-sg"],3,48,"2.0","country-flag"],
    "1f1f8-1f1ed":[["\uD83C\uDDF8\uD83C\uDDED"],"Flags",1847,["flag-sh"],3,49,"2.0","country-flag"],
    "1f1f8-1f1ee":[["\uD83C\uDDF8\uD83C\uDDEE"],"Flags",1848,["flag-si"],3,50,"2.0","country-flag"],
    "1f1f8-1f1ef":[["\uD83C\uDDF8\uD83C\uDDEF"],"Flags",1849,["flag-sj"],3,51,"2.0","country-flag"],
    "1f1f8-1f1f0":[["\uD83C\uDDF8\uD83C\uDDF0"],"Flags",1850,["flag-sk"],3,52,"2.0","country-flag"],
    "1f1f8-1f1f1":[["\uD83C\uDDF8\uD83C\uDDF1"],"Flags",1851,["flag-sl"],3,53,"2.0","country-flag"],
    "1f1f8-1f1f2":[["\uD83C\uDDF8\uD83C\uDDF2"],"Flags",1852,["flag-sm"],3,54,"2.0","country-flag"],
    "1f1f8-1f1f3":[["\uD83C\uDDF8\uD83C\uDDF3"],"Flags",1853,["flag-sn"],3,55,"2.0","country-flag"],
    "1f1f8-1f1f4":[["\uD83C\uDDF8\uD83C\uDDF4"],"Flags",1854,["flag-so"],3,56,"2.0","country-flag"],
    "1f1f8-1f1f7":[["\uD83C\uDDF8\uD83C\uDDF7"],"Flags",1855,["flag-sr"],3,57,"2.0","country-flag"],
    "1f1f8-1f1f8":[["\uD83C\uDDF8\uD83C\uDDF8"],"Flags",1856,["flag-ss"],3,58,"2.0","country-flag"],
    "1f1f8-1f1f9":[["\uD83C\uDDF8\uD83C\uDDF9"],"Flags",1857,["flag-st"],3,59,"2.0","country-flag"],
    "1f1f8-1f1fb":[["\uD83C\uDDF8\uD83C\uDDFB"],"Flags",1858,["flag-sv"],3,60,"2.0","country-flag"],
    "1f1f8-1f1fd":[["\uD83C\uDDF8\uD83C\uDDFD"],"Flags",1859,["flag-sx"],3,61,"2.0","country-flag"],
    "1f1f8-1f1fe":[["\uD83C\uDDF8\uD83C\uDDFE"],"Flags",1860,["flag-sy"],4,0,"2.0","country-flag"],
    "1f1f8-1f1ff":[["\uD83C\uDDF8\uD83C\uDDFF"],"Flags",1861,["flag-sz"],4,1,"2.0","country-flag"],
    "1f1f9-1f1e6":[["\uD83C\uDDF9\uD83C\uDDE6"],"Flags",1862,["flag-ta"],4,2,"2.0","country-flag"],
    "1f1f9-1f1e8":[["\uD83C\uDDF9\uD83C\uDDE8"],"Flags",1863,["flag-tc"],4,3,"2.0","country-flag"],
    "1f1f9-1f1e9":[["\uD83C\uDDF9\uD83C\uDDE9"],"Flags",1864,["flag-td"],4,4,"2.0","country-flag"],
    "1f1f9-1f1eb":[["\uD83C\uDDF9\uD83C\uDDEB"],"Flags",1865,["flag-tf"],4,5,"2.0","country-flag"],
    "1f1f9-1f1ec":[["\uD83C\uDDF9\uD83C\uDDEC"],"Flags",1866,["flag-tg"],4,6,"2.0","country-flag"],
    "1f1f9-1f1ed":[["\uD83C\uDDF9\uD83C\uDDED"],"Flags",1867,["flag-th"],4,7,"2.0","country-flag"],
    "1f1f9-1f1ef":[["\uD83C\uDDF9\uD83C\uDDEF"],"Flags",1868,["flag-tj"],4,8,"2.0","country-flag"],
    "1f1f9-1f1f0":[["\uD83C\uDDF9\uD83C\uDDF0"],"Flags",1869,["flag-tk"],4,9,"2.0","country-flag"],
    "1f1f9-1f1f1":[["\uD83C\uDDF9\uD83C\uDDF1"],"Flags",1870,["flag-tl"],4,10,"2.0","country-flag"],
    "1f1f9-1f1f2":[["\uD83C\uDDF9\uD83C\uDDF2"],"Flags",1871,["flag-tm"],4,11,"2.0","country-flag"],
    "1f1f9-1f1f3":[["\uD83C\uDDF9\uD83C\uDDF3"],"Flags",1872,["flag-tn"],4,12,"2.0","country-flag"],
    "1f1f9-1f1f4":[["\uD83C\uDDF9\uD83C\uDDF4"],"Flags",1873,["flag-to"],4,13,"2.0","country-flag"],
    "1f1f9-1f1f7":[["\uD83C\uDDF9\uD83C\uDDF7"],"Flags",1874,["flag-tr"],4,14,"2.0","country-flag"],
    "1f1f9-1f1f9":[["\uD83C\uDDF9\uD83C\uDDF9"],"Flags",1875,["flag-tt"],4,15,"2.0","country-flag"],
    "1f1f9-1f1fb":[["\uD83C\uDDF9\uD83C\uDDFB"],"Flags",1876,["flag-tv"],4,16,"2.0","country-flag"],
    "1f1f9-1f1fc":[["\uD83C\uDDF9\uD83C\uDDFC"],"Flags",1877,["flag-tw"],4,17,"2.0","country-flag"],
    "1f1f9-1f1ff":[["\uD83C\uDDF9\uD83C\uDDFF"],"Flags",1878,["flag-tz"],4,18,"2.0","country-flag"],
    "1f1fa-1f1e6":[["\uD83C\uDDFA\uD83C\uDDE6"],"Flags",1879,["flag-ua"],4,19,"2.0","country-flag"],
    "1f1fa-1f1ec":[["\uD83C\uDDFA\uD83C\uDDEC"],"Flags",1880,["flag-ug"],4,20,"2.0","country-flag"],
    "1f1fa-1f1f2":[["\uD83C\uDDFA\uD83C\uDDF2"],"Flags",1881,["flag-um"],4,21,"2.0","country-flag"],
    "1f1fa-1f1f3":[["\uD83C\uDDFA\uD83C\uDDF3"],"Flags",1882,["flag-un"],4,22,"4.0","country-flag"],
    "1f1fa-1f1f8":[["\uD83C\uDDFA\uD83C\uDDF8"],"Flags",1883,["us","flag-us"],4,23,"0.6","country-flag"],
    "1f1fa-1f1fe":[["\uD83C\uDDFA\uD83C\uDDFE"],"Flags",1884,["flag-uy"],4,24,"2.0","country-flag"],
    "1f1fa-1f1ff":[["\uD83C\uDDFA\uD83C\uDDFF"],"Flags",1885,["flag-uz"],4,25,"2.0","country-flag"],
    "1f1fb-1f1e6":[["\uD83C\uDDFB\uD83C\uDDE6"],"Flags",1886,["flag-va"],4,26,"2.0","country-flag"],
    "1f1fb-1f1e8":[["\uD83C\uDDFB\uD83C\uDDE8"],"Flags",1887,["flag-vc"],4,27,"2.0","country-flag"],
    "1f1fb-1f1ea":[["\uD83C\uDDFB\uD83C\uDDEA"],"Flags",1888,["flag-ve"],4,28,"2.0","country-flag"],
    "1f1fb-1f1ec":[["\uD83C\uDDFB\uD83C\uDDEC"],"Flags",1889,["flag-vg"],4,29,"2.0","country-flag"],
    "1f1fb-1f1ee":[["\uD83C\uDDFB\uD83C\uDDEE"],"Flags",1890,["flag-vi"],4,30,"2.0","country-flag"],
    "1f1fb-1f1f3":[["\uD83C\uDDFB\uD83C\uDDF3"],"Flags",1891,["flag-vn"],4,31,"2.0","country-flag"],
    "1f1fb-1f1fa":[["\uD83C\uDDFB\uD83C\uDDFA"],"Flags",1892,["flag-vu"],4,32,"2.0","country-flag"],
    "1f1fc-1f1eb":[["\uD83C\uDDFC\uD83C\uDDEB"],"Flags",1893,["flag-wf"],4,33,"2.0","country-flag"],
    "1f1fc-1f1f8":[["\uD83C\uDDFC\uD83C\uDDF8"],"Flags",1894,["flag-ws"],4,34,"2.0","country-flag"],
    "1f1fd-1f1f0":[["\uD83C\uDDFD\uD83C\uDDF0"],"Flags",1895,["flag-xk"],4,35,"2.0","country-flag"],
    "1f1fe-1f1ea":[["\uD83C\uDDFE\uD83C\uDDEA"],"Flags",1896,["flag-ye"],4,36,"2.0","country-flag"],
    "1f1fe-1f1f9":[["\uD83C\uDDFE\uD83C\uDDF9"],"Flags",1897,["flag-yt"],4,37,"2.0","country-flag"],
    "1f1ff-1f1e6":[["\uD83C\uDDFF\uD83C\uDDE6"],"Flags",1898,["flag-za"],4,38,"2.0","country-flag"],
    "1f1ff-1f1f2":[["\uD83C\uDDFF\uD83C\uDDF2"],"Flags",1899,["flag-zm"],4,39,"2.0","country-flag"],
    "1f1ff-1f1fc":[["\uD83C\uDDFF\uD83C\uDDFC"],"Flags",1900,["flag-zw"],4,40,"2.0","country-flag"],
    "1f201":[["\uD83C\uDE01"],"Symbols",1584,["koko"],4,41,"0.6","alphanum"],
    "1f202-fe0f":[["\uD83C\uDE02\uFE0F"],"Symbols",1585,["sa"],4,42,"0.6","alphanum"],
    "1f21a":[["\uD83C\uDE1A"],"Symbols",1591,["u7121"],4,43,"0.6","alphanum"],
    "1f22f":[["\uD83C\uDE2F"],"Symbols",1588,["u6307"],4,44,"0.6","alphanum"],
    "1f232":[["\uD83C\uDE32"],"Symbols",1592,["u7981"],4,45,"0.6","alphanum"],
    "1f233":[["\uD83C\uDE33"],"Symbols",1596,["u7a7a"],4,46,"0.6","alphanum"],
    "1f234":[["\uD83C\uDE34"],"Symbols",1595,["u5408"],4,47,"0.6","alphanum"],
    "1f235":[["\uD83C\uDE35"],"Symbols",1600,["u6e80"],4,48,"0.6","alphanum"],
    "1f236":[["\uD83C\uDE36"],"Symbols",1587,["u6709"],4,49,"0.6","alphanum"],
    "1f237-fe0f":[["\uD83C\uDE37\uFE0F"],"Symbols",1586,["u6708"],4,50,"0.6","alphanum"],
    "1f238":[["\uD83C\uDE38"],"Symbols",1594,["u7533"],4,51,"0.6","alphanum"],
    "1f239":[["\uD83C\uDE39"],"Symbols",1590,["u5272"],4,52,"0.6","alphanum"],
    "1f23a":[["\uD83C\uDE3A"],"Symbols",1599,["u55b6"],4,53,"0.6","alphanum"],
    "1f250":[["\uD83C\uDE50"],"Symbols",1589,["ideograph_advantage"],4,54,"0.6","alphanum"],
    "1f251":[["\uD83C\uDE51"],"Symbols",1593,["accept"],4,55,"0.6","alphanum"],
    "1f300":[["\uD83C\uDF00"],"Travel & Places",1051,["cyclone"],4,56,"0.6","sky & weather"],
    "1f301":[["\uD83C\uDF01"],"Travel & Places",898,["foggy"],4,57,"0.6","place-other"],
    "1f302":[["\uD83C\uDF02"],"Travel & Places",1053,["closed_umbrella"],4,58,"0.6","sky & weather"],
    "1f303":[["\uD83C\uDF03"],"Travel & Places",899,["night_with_stars"],4,59,"0.6","place-other"],
    "1f304":[["\uD83C\uDF04"],"Travel & Places",901,["sunrise_over_mountains"],4,60,"0.6","place-other"],
    "1f305":[["\uD83C\uDF05"],"Travel & Places",902,["sunrise"],4,61,"0.6","place-other"],
    "1f306":[["\uD83C\uDF06"],"Travel & Places",903,["city_sunset"],5,0,"0.6","place-other"],
    "1f307":[["\uD83C\uDF07"],"Travel & Places",904,["city_sunrise"],5,1,"0.6","place-other"],
    "1f308":[["\uD83C\uDF08"],"Travel & Places",1052,["rainbow"],5,2,"0.6","sky & weather"],
    "1f309":[["\uD83C\uDF09"],"Travel & Places",905,["bridge_at_night"],5,3,"0.6","place-other"],
    "1f30a":[["\uD83C\uDF0A"],"Travel & Places",1064,["ocean"],5,4,"0.6","sky & weather"],
    "1f30b":[["\uD83C\uDF0B"],"Travel & Places",856,["volcano"],5,5,"0.6","place-geographic"],
    "1f30c":[["\uD83C\uDF0C"],"Travel & Places",1038,["milky_way"],5,6,"0.6","sky & weather"],
    "1f30d":[["\uD83C\uDF0D"],"Travel & Places",847,["earth_africa"],5,7,"0.7","place-map"],
    "1f30e":[["\uD83C\uDF0E"],"Travel & Places",848,["earth_americas"],5,8,"0.7","place-map"],
    "1f30f":[["\uD83C\uDF0F"],"Travel & Places",849,["earth_asia"],5,9,"0.6","place-map"],
    "1f310":[["\uD83C\uDF10"],"Travel & Places",850,["globe_with_meridians"],5,10,"1.0","place-map"],
    "1f311":[["\uD83C\uDF11"],"Travel & Places",1018,["new_moon"],5,11,"0.6","sky & weather"],
    "1f312":[["\uD83C\uDF12"],"Travel & Places",1019,["waxing_crescent_moon"],5,12,"1.0","sky & weather"],
    "1f313":[["\uD83C\uDF13"],"Travel & Places",1020,["first_quarter_moon"],5,13,"0.6","sky & weather"],
    "1f314":[["\uD83C\uDF14"],"Travel & Places",1021,["moon","waxing_gibbous_moon"],5,14,"0.6","sky & weather"],
    "1f315":[["\uD83C\uDF15"],"Travel & Places",1022,["full_moon"],5,15,"0.6","sky & weather"],
    "1f316":[["\uD83C\uDF16"],"Travel & Places",1023,["waning_gibbous_moon"],5,16,"1.0","sky & weather"],
    "1f317":[["\uD83C\uDF17"],"Travel & Places",1024,["last_quarter_moon"],5,17,"1.0","sky & weather"],
    "1f318":[["\uD83C\uDF18"],"Travel & Places",1025,["waning_crescent_moon"],5,18,"1.0","sky & weather"],
    "1f319":[["\uD83C\uDF19"],"Travel & Places",1026,["crescent_moon"],5,19,"0.6","sky & weather"],
    "1f31a":[["\uD83C\uDF1A"],"Travel & Places",1027,["new_moon_with_face"],5,20,"1.0","sky & weather"],
    "1f31b":[["\uD83C\uDF1B"],"Travel & Places",1028,["first_quarter_moon_with_face"],5,21,"0.6","sky & weather"],
    "1f31c":[["\uD83C\uDF1C"],"Travel & Places",1029,["last_quarter_moon_with_face"],5,22,"0.7","sky & weather"],
    "1f31d":[["\uD83C\uDF1D"],"Travel & Places",1032,["full_moon_with_face"],5,23,"1.0","sky & weather"],
    "1f31e":[["\uD83C\uDF1E"],"Travel & Places",1033,["sun_with_face"],5,24,"1.0","sky & weather"],
    "1f31f":[["\uD83C\uDF1F"],"Travel & Places",1036,["star2"],5,25,"0.6","sky & weather"],
    "1f320":[["\uD83C\uDF20"],"Travel & Places",1037,["stars"],5,26,"0.6","sky & weather"],
    "1f321-fe0f":[["\uD83C\uDF21\uFE0F"],"Travel & Places",1030,["thermometer"],5,27,"0.7","sky & weather"],
    "1f324-fe0f":[["\uD83C\uDF24\uFE0F"],"Travel & Places",1042,["mostly_sunny","sun_small_cloud"],5,28,"0.7","sky & weather"],
    "1f325-fe0f":[["\uD83C\uDF25\uFE0F"],"Travel & Places",1043,["barely_sunny","sun_behind_cloud"],5,29,"0.7","sky & weather"],
    "1f326-fe0f":[["\uD83C\uDF26\uFE0F"],"Travel & Places",1044,["partly_sunny_rain","sun_behind_rain_cloud"],5,30,"0.7","sky & weather"],
    "1f327-fe0f":[["\uD83C\uDF27\uFE0F"],"Travel & Places",1045,["rain_cloud"],5,31,"0.7","sky & weather"],
    "1f328-fe0f":[["\uD83C\uDF28\uFE0F"],"Travel & Places",1046,["snow_cloud"],5,32,"0.7","sky & weather"],
    "1f329-fe0f":[["\uD83C\uDF29\uFE0F"],"Travel & Places",1047,["lightning","lightning_cloud"],5,33,"0.7","sky & weather"],
    "1f32a-fe0f":[["\uD83C\uDF2A\uFE0F"],"Travel & Places",1048,["tornado","tornado_cloud"],5,34,"0.7","sky & weather"],
    "1f32b-fe0f":[["\uD83C\uDF2B\uFE0F"],"Travel & Places",1049,["fog"],5,35,"0.7","sky & weather"],
    "1f32c-fe0f":[["\uD83C\uDF2C\uFE0F"],"Travel & Places",1050,["wind_blowing_face"],5,36,"0.7","sky & weather"],
    "1f32d":[["\uD83C\uDF2D"],"Food & Drink",766,["hotdog"],5,37,"1.0","food-prepared"],
    "1f32e":[["\uD83C\uDF2E"],"Food & Drink",768,["taco"],5,38,"1.0","food-prepared"],
    "1f32f":[["\uD83C\uDF2F"],"Food & Drink",769,["burrito"],5,39,"1.0","food-prepared"],
    "1f330":[["\uD83C\uDF30"],"Food & Drink",746,["chestnut"],5,40,"0.6","food-vegetable"],
    "1f331":[["\uD83C\uDF31"],"Animals & Nature",696,["seedling"],5,41,"0.6","plant-other"],
    "1f332":[["\uD83C\uDF32"],"Animals & Nature",698,["evergreen_tree"],5,42,"1.0","plant-other"],
    "1f333":[["\uD83C\uDF33"],"Animals & Nature",699,["deciduous_tree"],5,43,"1.0","plant-other"],
    "1f334":[["\uD83C\uDF34"],"Animals & Nature",700,["palm_tree"],5,44,"0.6","plant-other"],
    "1f335":[["\uD83C\uDF35"],"Animals & Nature",701,["cactus"],5,45,"0.6","plant-other"],
    "1f336-fe0f":[["\uD83C\uDF36\uFE0F"],"Food & Drink",737,["hot_pepper"],5,46,"0.7","food-vegetable"],
    "1f337":[["\uD83C\uDF37"],"Animals & Nature",694,["tulip"],5,47,"0.6","plant-flower"],
    "1f338":[["\uD83C\uDF38"],"Animals & Nature",685,["cherry_blossom"],5,48,"0.6","plant-flower"],
    "1f339":[["\uD83C\uDF39"],"Animals & Nature",689,["rose"],5,49,"0.6","plant-flower"],
    "1f33a":[["\uD83C\uDF3A"],"Animals & Nature",691,["hibiscus"],5,50,"0.6","plant-flower"],
    "1f33b":[["\uD83C\uDF3B"],"Animals & Nature",692,["sunflower"],5,51,"0.6","plant-flower"],
    "1f33c":[["\uD83C\uDF3C"],"Animals & Nature",693,["blossom"],5,52,"0.6","plant-flower"],
    "1f33d":[["\uD83C\uDF3D"],"Food & Drink",736,["corn"],5,53,"0.6","food-vegetable"],
    "1f33e":[["\uD83C\uDF3E"],"Animals & Nature",702,["ear_of_rice"],5,54,"0.6","plant-other"],
    "1f33f":[["\uD83C\uDF3F"],"Animals & Nature",703,["herb"],5,55,"0.6","plant-other"],
    "1f340":[["\uD83C\uDF40"],"Animals & Nature",705,["four_leaf_clover"],5,56,"0.6","plant-other"],
    "1f341":[["\uD83C\uDF41"],"Animals & Nature",706,["maple_leaf"],5,57,"0.6","plant-other"],
    "1f342":[["\uD83C\uDF42"],"Animals & Nature",707,["fallen_leaf"],5,58,"0.6","plant-other"],
    "1f343":[["\uD83C\uDF43"],"Animals & Nature",708,["leaves"],5,59,"0.6","plant-other"],
    "1f344-200d-1f7eb":[["\uD83C\uDF44\u200D\uD83D\uDFEB"],"Food & Drink",749,["brown_mushroom"],5,60,"15.1","food-vegetable"],
    "1f344":[["\uD83C\uDF44"],"Animals & Nature",711,["mushroom"],5,61,"0.6","plant-other"],
    "1f345":[["\uD83C\uDF45"],"Food & Drink",729,["tomato"],6,0,"0.6","food-fruit"],
    "1f346":[["\uD83C\uDF46"],"Food & Drink",733,["eggplant"],6,1,"0.6","food-vegetable"],
    "1f347":[["\uD83C\uDF47"],"Food & Drink",712,["grapes"],6,2,"0.6","food-fruit"],
    "1f348":[["\uD83C\uDF48"],"Food & Drink",713,["melon"],6,3,"0.6","food-fruit"],
    "1f349":[["\uD83C\uDF49"],"Food & Drink",714,["watermelon"],6,4,"0.6","food-fruit"],
    "1f34a":[["\uD83C\uDF4A"],"Food & Drink",715,["tangerine"],6,5,"0.6","food-fruit"],
    "1f34b-200d-1f7e9":[["\uD83C\uDF4B\u200D\uD83D\uDFE9"],"Food & Drink",717,["lime"],6,6,"15.1","food-fruit"],
    "1f34b":[["\uD83C\uDF4B"],"Food & Drink",716,["lemon"],6,7,"1.0","food-fruit"],
    "1f34c":[["\uD83C\uDF4C"],"Food & Drink",718,["banana"],6,8,"0.6","food-fruit"],
    "1f34d":[["\uD83C\uDF4D"],"Food & Drink",719,["pineapple"],6,9,"0.6","food-fruit"],
    "1f34e":[["\uD83C\uDF4E"],"Food & Drink",721,["apple"],6,10,"0.6","food-fruit"],
    "1f34f":[["\uD83C\uDF4F"],"Food & Drink",722,["green_apple"],6,11,"0.6","food-fruit"],
    "1f350":[["\uD83C\uDF50"],"Food & Drink",723,["pear"],6,12,"1.0","food-fruit"],
    "1f351":[["\uD83C\uDF51"],"Food & Drink",724,["peach"],6,13,"0.6","food-fruit"],
    "1f352":[["\uD83C\uDF52"],"Food & Drink",725,["cherries"],6,14,"0.6","food-fruit"],
    "1f353":[["\uD83C\uDF53"],"Food & Drink",726,["strawberry"],6,15,"0.6","food-fruit"],
    "1f354":[["\uD83C\uDF54"],"Food & Drink",763,["hamburger"],6,16,"0.6","food-prepared"],
    "1f355":[["\uD83C\uDF55"],"Food & Drink",765,["pizza"],6,17,"0.6","food-prepared"],
    "1f356":[["\uD83C\uDF56"],"Food & Drink",759,["meat_on_bone"],6,18,"0.6","food-prepared"],
    "1f357":[["\uD83C\uDF57"],"Food & Drink",760,["poultry_leg"],6,19,"0.6","food-prepared"],
    "1f358":[["\uD83C\uDF58"],"Food & Drink",785,["rice_cracker"],6,20,"0.6","food-asian"],
    "1f359":[["\uD83C\uDF59"],"Food & Drink",786,["rice_ball"],6,21,"0.6","food-asian"],
    "1f35a":[["\uD83C\uDF5A"],"Food & Drink",787,["rice"],6,22,"0.6","food-asian"],
    "1f35b":[["\uD83C\uDF5B"],"Food & Drink",788,["curry"],6,23,"0.6","food-asian"],
    "1f35c":[["\uD83C\uDF5C"],"Food & Drink",789,["ramen"],6,24,"0.6","food-asian"],
    "1f35d":[["\uD83C\uDF5D"],"Food & Drink",790,["spaghetti"],6,25,"0.6","food-asian"],
    "1f35e":[["\uD83C\uDF5E"],"Food & Drink",750,["bread"],6,26,"0.6","food-prepared"],
    "1f35f":[["\uD83C\uDF5F"],"Food & Drink",764,["fries"],6,27,"0.6","food-prepared"],
    "1f360":[["\uD83C\uDF60"],"Food & Drink",791,["sweet_potato"],6,28,"0.6","food-asian"],
    "1f361":[["\uD83C\uDF61"],"Food & Drink",797,["dango"],6,29,"0.6","food-asian"],
    "1f362":[["\uD83C\uDF62"],"Food & Drink",792,["oden"],6,30,"0.6","food-asian"],
    "1f363":[["\uD83C\uDF63"],"Food & Drink",793,["sushi"],6,31,"0.6","food-asian"],
    "1f364":[["\uD83C\uDF64"],"Food & Drink",794,["fried_shrimp"],6,32,"0.6","food-asian"],
    "1f365":[["\uD83C\uDF65"],"Food & Drink",795,["fish_cake"],6,33,"0.6","food-asian"],
    "1f366":[["\uD83C\uDF66"],"Food & Drink",806,["icecream"],6,34,"0.6","food-sweet"],
    "1f367":[["\uD83C\uDF67"],"Food & Drink",807,["shaved_ice"],6,35,"0.6","food-sweet"],
    "1f368":[["\uD83C\uDF68"],"Food & Drink",808,["ice_cream"],6,36,"0.6","food-sweet"],
    "1f369":[["\uD83C\uDF69"],"Food & Drink",809,["doughnut"],6,37,"0.6","food-sweet"],
    "1f36a":[["\uD83C\uDF6A"],"Food & Drink",810,["cookie"],6,38,"0.6","food-sweet"],
    "1f36b":[["\uD83C\uDF6B"],"Food & Drink",815,["chocolate_bar"],6,39,"0.6","food-sweet"],
    "1f36c":[["\uD83C\uDF6C"],"Food & Drink",816,["candy"],6,40,"0.6","food-sweet"],
    "1f36d":[["\uD83C\uDF6D"],"Food & Drink",817,["lollipop"],6,41,"0.6","food-sweet"],
    "1f36e":[["\uD83C\uDF6E"],"Food & Drink",818,["custard"],6,42,"0.6","food-sweet"],
    "1f36f":[["\uD83C\uDF6F"],"Food & Drink",819,["honey_pot"],6,43,"0.6","food-sweet"],
    "1f370":[["\uD83C\uDF70"],"Food & Drink",812,["cake"],6,44,"0.6","food-sweet"],
    "1f371":[["\uD83C\uDF71"],"Food & Drink",784,["bento"],6,45,"0.6","food-asian"],
    "1f372":[["\uD83C\uDF72"],"Food & Drink",776,["stew"],6,46,"0.6","food-prepared"],
    "1f373":[["\uD83C\uDF73"],"Food & Drink",774,["fried_egg","cooking"],6,47,"0.6","food-prepared"],
    "1f374":[["\uD83C\uDF74"],"Food & Drink",842,["fork_and_knife"],6,48,"0.6","dishware"],
    "1f375":[["\uD83C\uDF75"],"Food & Drink",824,["tea"],6,49,"0.6","drink"],
    "1f376":[["\uD83C\uDF76"],"Food & Drink",825,["sake"],6,50,"0.6","drink"],
    "1f377":[["\uD83C\uDF77"],"Food & Drink",827,["wine_glass"],6,51,"0.6","drink"],
    "1f378":[["\uD83C\uDF78"],"Food & Drink",828,["cocktail"],6,52,"0.6","drink"],
    "1f379":[["\uD83C\uDF79"],"Food & Drink",829,["tropical_drink"],6,53,"0.6","drink"],
    "1f37a":[["\uD83C\uDF7A"],"Food & Drink",830,["beer"],6,54,"0.6","drink"],
    "1f37b":[["\uD83C\uDF7B"],"Food & Drink",831,["beers"],6,55,"0.6","drink"],
    "1f37c":[["\uD83C\uDF7C"],"Food & Drink",820,["baby_bottle"],6,56,"1.0","drink"],
    "1f37d-fe0f":[["\uD83C\uDF7D\uFE0F"],"Food & Drink",841,["knife_fork_plate"],6,57,"0.7","dishware"],
    "1f37e":[["\uD83C\uDF7E"],"Food & Drink",826,["champagne"],6,58,"1.0","drink"],
    "1f37f":[["\uD83C\uDF7F"],"Food & Drink",780,["popcorn"],6,59,"1.0","food-prepared"],
    "1f380":[["\uD83C\uDF80"],"Activities",1081,["ribbon"],6,60,"0.6","event"],
    "1f381":[["\uD83C\uDF81"],"Activities",1082,["gift"],6,61,"0.6","event"],
    "1f382":[["\uD83C\uDF82"],"Food & Drink",811,["birthday"],7,0,"0.6","food-sweet"],
    "1f383":[["\uD83C\uDF83"],"Activities",1065,["jack_o_lantern"],7,1,"0.6","event"],
    "1f384":[["\uD83C\uDF84"],"Activities",1066,["christmas_tree"],7,2,"0.6","event"],
    "1f385":[["\uD83C\uDF85"],"People & Body",371,["santa"],7,3,"0.6","person-fantasy"],
    "1f386":[["\uD83C\uDF86"],"Activities",1067,["fireworks"],7,9,"0.6","event"],
    "1f387":[["\uD83C\uDF87"],"Activities",1068,["sparkler"],7,10,"0.6","event"],
    "1f388":[["\uD83C\uDF88"],"Activities",1071,["balloon"],7,11,"0.6","event"],
    "1f389":[["\uD83C\uDF89"],"Activities",1072,["tada"],7,12,"0.6","event"],
    "1f38a":[["\uD83C\uDF8A"],"Activities",1073,["confetti_ball"],7,13,"0.6","event"],
    "1f38b":[["\uD83C\uDF8B"],"Activities",1074,["tanabata_tree"],7,14,"0.6","event"],
    "1f38c":[["\uD83C\uDF8C"],"Flags",1637,["crossed_flags"],7,15,"0.6","flag"],
    "1f38d":[["\uD83C\uDF8D"],"Activities",1075,["bamboo"],7,16,"0.6","event"],
    "1f38e":[["\uD83C\uDF8E"],"Activities",1076,["dolls"],7,17,"0.6","event"],
    "1f38f":[["\uD83C\uDF8F"],"Activities",1077,["flags"],7,18,"0.6","event"],
    "1f390":[["\uD83C\uDF90"],"Activities",1078,["wind_chime"],7,19,"0.6","event"],
    "1f391":[["\uD83C\uDF91"],"Activities",1079,["rice_scene"],7,20,"0.6","event"],
    "1f392":[["\uD83C\uDF92"],"Objects",1175,["school_satchel"],7,21,"0.6","clothing"],
    "1f393":[["\uD83C\uDF93"],"Objects",1189,["mortar_board"],7,22,"0.6","clothing"],
    "1f396-fe0f":[["\uD83C\uDF96\uFE0F"],"Activities",1086,["medal"],7,23,"0.7","award-medal"],
    "1f397-fe0f":[["\uD83C\uDF97\uFE0F"],"Activities",1083,["reminder_ribbon"],7,24,"0.7","event"],
    "1f399-fe0f":[["\uD83C\uDF99\uFE0F"],"Objects",1209,["studio_microphone"],7,25,"0.7","music"],
    "1f39a-fe0f":[["\uD83C\uDF9A\uFE0F"],"Objects",1210,["level_slider"],7,26,"0.7","music"],
    "1f39b-fe0f":[["\uD83C\uDF9B\uFE0F"],"Objects",1211,["control_knobs"],7,27,"0.7","music"],
    "1f39e-fe0f":[["\uD83C\uDF9E\uFE0F"],"Objects",1247,["film_frames"],7,28,"0.7","light & video"],
    "1f39f-fe0f":[["\uD83C\uDF9F\uFE0F"],"Activities",1084,["admission_tickets"],7,29,"0.7","event"],
    "1f3a0":[["\uD83C\uDFA0"],"Travel & Places",907,["carousel_horse"],7,30,"0.6","place-other"],
    "1f3a1":[["\uD83C\uDFA1"],"Travel & Places",909,["ferris_wheel"],7,31,"0.6","place-other"],
    "1f3a2":[["\uD83C\uDFA2"],"Travel & Places",910,["roller_coaster"],7,32,"0.6","place-other"],
    "1f3a3":[["\uD83C\uDFA3"],"Activities",1113,["fishing_pole_and_fish"],7,33,"0.6","sport"],
    "1f3a4":[["\uD83C\uDFA4"],"Objects",1212,["microphone"],7,34,"0.6","music"],
    "1f3a5":[["\uD83C\uDFA5"],"Objects",1246,["movie_camera"],7,35,"0.6","light & video"],
    "1f3a6":[["\uD83C\uDFA6"],"Symbols",1503,["cinema"],7,36,"0.6","av-symbol"],
    "1f3a7":[["\uD83C\uDFA7"],"Objects",1213,["headphones"],7,37,"0.6","music"],
    "1f3a8":[["\uD83C\uDFA8"],"Activities",1145,["art"],7,38,"0.6","arts & crafts"],
    "1f3a9":[["\uD83C\uDFA9"],"Objects",1188,["tophat"],7,39,"0.6","clothing"],
    "1f3aa":[["\uD83C\uDFAA"],"Travel & Places",912,["circus_tent"],7,40,"0.6","place-other"],
    "1f3ab":[["\uD83C\uDFAB"],"Activities",1085,["ticket"],7,41,"0.6","event"],
    "1f3ac":[["\uD83C\uDFAC"],"Objects",1249,["clapper"],7,42,"0.6","light & video"],
    "1f3ad":[["\uD83C\uDFAD"],"Activities",1143,["performing_arts"],7,43,"0.6","arts & crafts"],
    "1f3ae":[["\uD83C\uDFAE"],"Activities",1126,["video_game"],7,44,"0.6","game"],
    "1f3af":[["\uD83C\uDFAF"],"Activities",1119,["dart"],7,45,"0.6","game"],
    "1f3b0":[["\uD83C\uDFB0"],"Activities",1128,["slot_machine"],7,46,"0.6","game"],
    "1f3b1":[["\uD83C\uDFB1"],"Activities",1123,["8ball"],7,47,"0.6","game"],
    "1f3b2":[["\uD83C\uDFB2"],"Activities",1129,["game_die"],7,48,"0.6","game"],
    "1f3b3":[["\uD83C\uDFB3"],"Activities",1101,["bowling"],7,49,"0.6","sport"],
    "1f3b4":[["\uD83C\uDFB4"],"Activities",1142,["flower_playing_cards"],7,50,"0.6","game"],
    "1f3b5":[["\uD83C\uDFB5"],"Objects",1207,["musical_note"],7,51,"0.6","music"],
    "1f3b6":[["\uD83C\uDFB6"],"Objects",1208,["notes"],7,52,"0.6","music"],
    "1f3b7":[["\uD83C\uDFB7"],"Objects",1215,["saxophone"],7,53,"0.6","musical-instrument"],
    "1f3b8":[["\uD83C\uDFB8"],"Objects",1217,["guitar"],7,54,"0.6","musical-instrument"],
    "1f3b9":[["\uD83C\uDFB9"],"Objects",1218,["musical_keyboard"],7,55,"0.6","musical-instrument"],
    "1f3ba":[["\uD83C\uDFBA"],"Objects",1219,["trumpet"],7,56,"0.6","musical-instrument"],
    "1f3bb":[["\uD83C\uDFBB"],"Objects",1220,["violin"],7,57,"0.6","musical-instrument"],
    "1f3bc":[["\uD83C\uDFBC"],"Objects",1206,["musical_score"],7,58,"0.6","music"],
    "1f3bd":[["\uD83C\uDFBD"],"Activities",1115,["running_shirt_with_sash"],7,59,"0.6","sport"],
    "1f3be":[["\uD83C\uDFBE"],"Activities",1099,["tennis"],7,60,"0.6","sport"],
    "1f3bf":[["\uD83C\uDFBF"],"Activities",1116,["ski"],7,61,"0.6","sport"],
    "1f3c0":[["\uD83C\uDFC0"],"Activities",1095,["basketball"],8,0,"0.6","sport"],
    "1f3c1":[["\uD83C\uDFC1"],"Flags",1635,["checkered_flag"],8,1,"0.6","flag"],
    "1f3c2":[["\uD83C\uDFC2"],"People & Body",462,["snowboarder"],8,2,"0.6","person-sport"],
    "1f3c3-200d-2640-fe0f":[["\uD83C\uDFC3\u200D\u2640\uFE0F"],"People & Body",443,["woman-running"],8,8,"4.0","person-activity"],
    "1f3c3-200d-2640-fe0f-200d-27a1-fe0f":[["\uD83C\uDFC3\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"People & Body",445,["woman_running_facing_right"],8,14,"15.1","person-activity"],
    "1f3c3-200d-2642-fe0f":[["\uD83C\uDFC3\u200D\u2642\uFE0F","\uD83C\uDFC3"],"People & Body",442,["man-running","runner","running"],8,20,"4.0","person-activity"],
    "1f3c3-200d-2642-fe0f-200d-27a1-fe0f":[["\uD83C\uDFC3\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"People & Body",446,["man_running_facing_right"],8,26,"15.1","person-activity"],
    "1f3c3-200d-27a1-fe0f":[["\uD83C\uDFC3\u200D\u27A1\uFE0F"],"People & Body",444,["person_running_facing_right"],8,32,"15.1","person-activity"],
    "1f3c4-200d-2640-fe0f":[["\uD83C\uDFC4\u200D\u2640\uFE0F"],"People & Body",468,["woman-surfing"],8,44,"4.0","person-sport"],
    "1f3c4-200d-2642-fe0f":[["\uD83C\uDFC4\u200D\u2642\uFE0F","\uD83C\uDFC4"],"People & Body",467,["man-surfing","surfer"],8,50,"4.0","person-sport"],
    "1f3c5":[["\uD83C\uDFC5"],"Activities",1088,["sports_medal"],9,0,"1.0","award-medal"],
    "1f3c6":[["\uD83C\uDFC6"],"Activities",1087,["trophy"],9,1,"0.6","award-medal"],
    "1f3c7":[["\uD83C\uDFC7"],"People & Body",460,["horse_racing"],9,2,"1.0","person-sport"],
    "1f3c8":[["\uD83C\uDFC8"],"Activities",1097,["football"],9,8,"0.6","sport"],
    "1f3c9":[["\uD83C\uDFC9"],"Activities",1098,["rugby_football"],9,9,"1.0","sport"],
    "1f3ca-200d-2640-fe0f":[["\uD83C\uDFCA\u200D\u2640\uFE0F"],"People & Body",474,["woman-swimming"],9,10,"4.0","person-sport"],
    "1f3ca-200d-2642-fe0f":[["\uD83C\uDFCA\u200D\u2642\uFE0F","\uD83C\uDFCA"],"People & Body",473,["man-swimming","swimmer"],9,16,"4.0","person-sport"],
    "1f3cb-fe0f-200d-2640-fe0f":[["\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F"],"People & Body",480,["woman-lifting-weights"],9,28,"4.0","person-sport"],
    "1f3cb-fe0f-200d-2642-fe0f":[["\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F","\uD83C\uDFCB\uFE0F"],"People & Body",479,["man-lifting-weights","weight_lifter"],9,34,"4.0","person-sport"],
    "1f3cc-fe0f-200d-2640-fe0f":[["\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F"],"People & Body",465,["woman-golfing"],9,46,"4.0","person-sport"],
    "1f3cc-fe0f-200d-2642-fe0f":[["\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F","\uD83C\uDFCC\uFE0F"],"People & Body",464,["man-golfing","golfer"],9,52,"4.0","person-sport"],
    "1f3cd-fe0f":[["\uD83C\uDFCD\uFE0F"],"Travel & Places",943,["racing_motorcycle"],10,2,"0.7","transport-ground"],
    "1f3ce-fe0f":[["\uD83C\uDFCE\uFE0F"],"Travel & Places",942,["racing_car"],10,3,"0.7","transport-ground"],
    "1f3cf":[["\uD83C\uDFCF"],"Activities",1102,["cricket_bat_and_ball"],10,4,"1.0","sport"],
    "1f3d0":[["\uD83C\uDFD0"],"Activities",1096,["volleyball"],10,5,"1.0","sport"],
    "1f3d1":[["\uD83C\uDFD1"],"Activities",1103,["field_hockey_stick_and_ball"],10,6,"1.0","sport"],
    "1f3d2":[["\uD83C\uDFD2"],"Activities",1104,["ice_hockey_stick_and_puck"],10,7,"1.0","sport"],
    "1f3d3":[["\uD83C\uDFD3"],"Activities",1106,["table_tennis_paddle_and_ball"],10,8,"1.0","sport"],
    "1f3d4-fe0f":[["\uD83C\uDFD4\uFE0F"],"Travel & Places",854,["snow_capped_mountain"],10,9,"0.7","place-geographic"],
    "1f3d5-fe0f":[["\uD83C\uDFD5\uFE0F"],"Travel & Places",858,["camping"],10,10,"0.7","place-geographic"],
    "1f3d6-fe0f":[["\uD83C\uDFD6\uFE0F"],"Travel & Places",859,["beach_with_umbrella"],10,11,"0.7","place-geographic"],
    "1f3d7-fe0f":[["\uD83C\uDFD7\uFE0F"],"Travel & Places",865,["building_construction"],10,12,"0.7","place-building"],
    "1f3d8-fe0f":[["\uD83C\uDFD8\uFE0F"],"Travel & Places",870,["house_buildings"],10,13,"0.7","place-building"],
    "1f3d9-fe0f":[["\uD83C\uDFD9\uFE0F"],"Travel & Places",900,["cityscape"],10,14,"0.7","place-other"],
    "1f3da-fe0f":[["\uD83C\uDFDA\uFE0F"],"Travel & Places",871,["derelict_house_building"],10,15,"0.7","place-building"],
    "1f3db-fe0f":[["\uD83C\uDFDB\uFE0F"],"Travel & Places",864,["classical_building"],10,16,"0.7","place-building"],
    "1f3dc-fe0f":[["\uD83C\uDFDC\uFE0F"],"Travel & Places",860,["desert"],10,17,"0.7","place-geographic"],
    "1f3dd-fe0f":[["\uD83C\uDFDD\uFE0F"],"Travel & Places",861,["desert_island"],10,18,"0.7","place-geographic"],
    "1f3de-fe0f":[["\uD83C\uDFDE\uFE0F"],"Travel & Places",862,["national_park"],10,19,"0.7","place-geographic"],
    "1f3df-fe0f":[["\uD83C\uDFDF\uFE0F"],"Travel & Places",863,["stadium"],10,20,"0.7","place-building"],
    "1f3e0":[["\uD83C\uDFE0"],"Travel & Places",872,["house"],10,21,"0.6","place-building"],
    "1f3e1":[["\uD83C\uDFE1"],"Travel & Places",873,["house_with_garden"],10,22,"0.6","place-building"],
    "1f3e2":[["\uD83C\uDFE2"],"Travel & Places",874,["office"],10,23,"0.6","place-building"],
    "1f3e3":[["\uD83C\uDFE3"],"Travel & Places",875,["post_office"],10,24,"0.6","place-building"],
    "1f3e4":[["\uD83C\uDFE4"],"Travel & Places",876,["european_post_office"],10,25,"1.0","place-building"],
    "1f3e5":[["\uD83C\uDFE5"],"Travel & Places",877,["hospital"],10,26,"0.6","place-building"],
    "1f3e6":[["\uD83C\uDFE6"],"Travel & Places",878,["bank"],10,27,"0.6","place-building"],
    "1f3e7":[["\uD83C\uDFE7"],"Symbols",1412,["atm"],10,28,"0.6","transport-sign"],
    "1f3e8":[["\uD83C\uDFE8"],"Travel & Places",879,["hotel"],10,29,"0.6","place-building"],
    "1f3e9":[["\uD83C\uDFE9"],"Travel & Places",880,["love_hotel"],10,30,"0.6","place-building"],
    "1f3ea":[["\uD83C\uDFEA"],"Travel & Places",881,["convenience_store"],10,31,"0.6","place-building"],
    "1f3eb":[["\uD83C\uDFEB"],"Travel & Places",882,["school"],10,32,"0.6","place-building"],
    "1f3ec":[["\uD83C\uDFEC"],"Travel & Places",883,["department_store"],10,33,"0.6","place-building"],
    "1f3ed":[["\uD83C\uDFED"],"Travel & Places",884,["factory"],10,34,"0.6","place-building"],
    "1f3ee":[["\uD83C\uDFEE"],"Objects",1260,["izakaya_lantern","lantern"],10,35,"0.6","light & video"],
    "1f3ef":[["\uD83C\uDFEF"],"Travel & Places",885,["japanese_castle"],10,36,"0.6","place-building"],
    "1f3f0":[["\uD83C\uDFF0"],"Travel & Places",886,["european_castle"],10,37,"0.6","place-building"],
    "1f3f3-fe0f-200d-1f308":[["\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08"],"Flags",1640,["rainbow-flag"],10,38,"4.0","flag"],
    "1f3f3-fe0f-200d-26a7-fe0f":[["\uD83C\uDFF3\uFE0F\u200D\u26A7\uFE0F"],"Flags",1641,["transgender_flag"],10,39,"13.0","flag"],
    "1f3f3-fe0f":[["\uD83C\uDFF3\uFE0F"],"Flags",1639,["waving_white_flag"],10,40,"0.7","flag"],
    "1f3f4-200d-2620-fe0f":[["\uD83C\uDFF4\u200D\u2620\uFE0F"],"Flags",1642,["pirate_flag"],10,41,"11.0","flag"],
    "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f":[["\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F"],"Flags",1901,["flag-england"],10,42,"5.0","subdivision-flag"],
    "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f":[["\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F"],"Flags",1902,["flag-scotland"],10,43,"5.0","subdivision-flag"],
    "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f":[["\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F"],"Flags",1903,["flag-wales"],10,44,"5.0","subdivision-flag"],
    "1f3f4":[["\uD83C\uDFF4"],"Flags",1638,["waving_black_flag"],10,45,"1.0","flag"],
    "1f3f5-fe0f":[["\uD83C\uDFF5\uFE0F"],"Animals & Nature",688,["rosette"],10,46,"0.7","plant-flower"],
    "1f3f7-fe0f":[["\uD83C\uDFF7\uFE0F"],"Objects",1278,["label"],10,47,"0.7","book-paper"],
    "1f3f8":[["\uD83C\uDFF8"],"Activities",1107,["badminton_racquet_and_shuttlecock"],10,48,"1.0","sport"],
    "1f3f9":[["\uD83C\uDFF9"],"Objects",1347,["bow_and_arrow"],10,49,"1.0","tool"],
    "1f3fa":[["\uD83C\uDFFA"],"Food & Drink",846,["amphora"],10,50,"1.0","dishware"],
    "1f3fb":[["\uD83C\uDFFB"],"Component",554,["skin-tone-2"],10,51,"1.0","skin-tone"],
    "1f3fc":[["\uD83C\uDFFC"],"Component",555,["skin-tone-3"],10,52,"1.0","skin-tone"],
    "1f3fd":[["\uD83C\uDFFD"],"Component",556,["skin-tone-4"],10,53,"1.0","skin-tone"],
    "1f3fe":[["\uD83C\uDFFE"],"Component",557,["skin-tone-5"],10,54,"1.0","skin-tone"],
    "1f3ff":[["\uD83C\uDFFF"],"Component",558,["skin-tone-6"],10,55,"1.0","skin-tone"],
    "1f400":[["\uD83D\uDC00"],"Animals & Nature",607,["rat"],10,56,"1.0","animal-mammal"],
    "1f401":[["\uD83D\uDC01"],"Animals & Nature",606,["mouse2"],10,57,"1.0","animal-mammal"],
    "1f402":[["\uD83D\uDC02"],"Animals & Nature",587,["ox"],10,58,"1.0","animal-mammal"],
    "1f403":[["\uD83D\uDC03"],"Animals & Nature",588,["water_buffalo"],10,59,"1.0","animal-mammal"],
    "1f404":[["\uD83D\uDC04"],"Animals & Nature",589,["cow2"],10,60,"1.0","animal-mammal"],
    "1f405":[["\uD83D\uDC05"],"Animals & Nature",576,["tiger2"],10,61,"1.0","animal-mammal"],
    "1f406":[["\uD83D\uDC06"],"Animals & Nature",577,["leopard"],11,0,"1.0","animal-mammal"],
    "1f407":[["\uD83D\uDC07"],"Animals & Nature",610,["rabbit2"],11,1,"1.0","animal-mammal"],
    "1f408-200d-2b1b":[["\uD83D\uDC08\u200D\u2B1B"],"Animals & Nature",573,["black_cat"],11,2,"13.0","animal-mammal"],
    "1f408":[["\uD83D\uDC08"],"Animals & Nature",572,["cat2"],11,3,"0.7","animal-mammal"],
    "1f409":[["\uD83D\uDC09"],"Animals & Nature",653,["dragon"],11,4,"1.0","animal-reptile"],
    "1f40a":[["\uD83D\uDC0A"],"Animals & Nature",648,["crocodile"],11,5,"1.0","animal-reptile"],
    "1f40b":[["\uD83D\uDC0B"],"Animals & Nature",657,["whale2"],11,6,"1.0","animal-marine"],
    "1f40c":[["\uD83D\uDC0C"],"Animals & Nature",668,["snail"],11,7,"0.6","animal-bug"],
    "1f40d":[["\uD83D\uDC0D"],"Animals & Nature",651,["snake"],11,8,"0.6","animal-reptile"],
    "1f40e":[["\uD83D\uDC0E"],"Animals & Nature",581,["racehorse"],11,9,"0.6","animal-mammal"],
    "1f40f":[["\uD83D\uDC0F"],"Animals & Nature",594,["ram"],11,10,"1.0","animal-mammal"],
    "1f410":[["\uD83D\uDC10"],"Animals & Nature",596,["goat"],11,11,"1.0","animal-mammal"],
    "1f411":[["\uD83D\uDC11"],"Animals & Nature",595,["sheep"],11,12,"0.6","animal-mammal"],
    "1f412":[["\uD83D\uDC12"],"Animals & Nature",560,["monkey"],11,13,"0.6","animal-mammal"],
    "1f413":[["\uD83D\uDC13"],"Animals & Nature",627,["rooster"],11,14,"1.0","animal-bird"],
    "1f414":[["\uD83D\uDC14"],"Animals & Nature",626,["chicken"],11,15,"0.6","animal-bird"],
    "1f415-200d-1f9ba":[["\uD83D\uDC15\u200D\uD83E\uDDBA"],"Animals & Nature",566,["service_dog"],11,16,"12.0","animal-mammal"],
    "1f415":[["\uD83D\uDC15"],"Animals & Nature",564,["dog2"],11,17,"0.7","animal-mammal"],
    "1f416":[["\uD83D\uDC16"],"Animals & Nature",591,["pig2"],11,18,"1.0","animal-mammal"],
    "1f417":[["\uD83D\uDC17"],"Animals & Nature",592,["boar"],11,19,"0.6","animal-mammal"],
    "1f418":[["\uD83D\uDC18"],"Animals & Nature",601,["elephant"],11,20,"0.6","animal-mammal"],
    "1f419":[["\uD83D\uDC19"],"Animals & Nature",664,["octopus"],11,21,"0.6","animal-marine"],
    "1f41a":[["\uD83D\uDC1A"],"Animals & Nature",665,["shell"],11,22,"0.6","animal-marine"],
    "1f41b":[["\uD83D\uDC1B"],"Animals & Nature",670,["bug"],11,23,"0.6","animal-bug"],
    "1f41c":[["\uD83D\uDC1C"],"Animals & Nature",671,["ant"],11,24,"0.6","animal-bug"],
    "1f41d":[["\uD83D\uDC1D"],"Animals & Nature",672,["bee","honeybee"],11,25,"0.6","animal-bug"],
    "1f41e":[["\uD83D\uDC1E"],"Animals & Nature",674,["ladybug","lady_beetle"],11,26,"0.6","animal-bug"],
    "1f41f":[["\uD83D\uDC1F"],"Animals & Nature",660,["fish"],11,27,"0.6","animal-marine"],
    "1f420":[["\uD83D\uDC20"],"Animals & Nature",661,["tropical_fish"],11,28,"0.6","animal-marine"],
    "1f421":[["\uD83D\uDC21"],"Animals & Nature",662,["blowfish"],11,29,"0.6","animal-marine"],
    "1f422":[["\uD83D\uDC22"],"Animals & Nature",649,["turtle"],11,30,"0.6","animal-reptile"],
    "1f423":[["\uD83D\uDC23"],"Animals & Nature",628,["hatching_chick"],11,31,"0.6","animal-bird"],
    "1f424":[["\uD83D\uDC24"],"Animals & Nature",629,["baby_chick"],11,32,"0.6","animal-bird"],
    "1f425":[["\uD83D\uDC25"],"Animals & Nature",630,["hatched_chick"],11,33,"0.6","animal-bird"],
    "1f426-200d-1f525":[["\uD83D\uDC26\u200D\uD83D\uDD25"],"Animals & Nature",646,["phoenix"],11,34,"15.1","animal-bird"],
    "1f426-200d-2b1b":[["\uD83D\uDC26\u200D\u2B1B"],"Animals & Nature",644,["black_bird"],11,35,"15.0","animal-bird"],
    "1f426":[["\uD83D\uDC26"],"Animals & Nature",631,["bird"],11,36,"0.6","animal-bird"],
    "1f427":[["\uD83D\uDC27"],"Animals & Nature",632,["penguin"],11,37,"0.6","animal-bird"],
    "1f428":[["\uD83D\uDC28"],"Animals & Nature",617,["koala"],11,38,"0.6","animal-mammal"],
    "1f429":[["\uD83D\uDC29"],"Animals & Nature",567,["poodle"],11,39,"0.6","animal-mammal"],
    "1f42a":[["\uD83D\uDC2A"],"Animals & Nature",597,["dromedary_camel"],11,40,"1.0","animal-mammal"],
    "1f42b":[["\uD83D\uDC2B"],"Animals & Nature",598,["camel"],11,41,"0.6","animal-mammal"],
    "1f42c":[["\uD83D\uDC2C"],"Animals & Nature",658,["dolphin","flipper"],11,42,"0.6","animal-marine"],
    "1f42d":[["\uD83D\uDC2D"],"Animals & Nature",605,["mouse"],11,43,"0.6","animal-mammal"],
    "1f42e":[["\uD83D\uDC2E"],"Animals & Nature",586,["cow"],11,44,"0.6","animal-mammal"],
    "1f42f":[["\uD83D\uDC2F"],"Animals & Nature",575,["tiger"],11,45,"0.6","animal-mammal"],
    "1f430":[["\uD83D\uDC30"],"Animals & Nature",609,["rabbit"],11,46,"0.6","animal-mammal"],
    "1f431":[["\uD83D\uDC31"],"Animals & Nature",571,["cat"],11,47,"0.6","animal-mammal"],
    "1f432":[["\uD83D\uDC32"],"Animals & Nature",652,["dragon_face"],11,48,"0.6","animal-reptile"],
    "1f433":[["\uD83D\uDC33"],"Animals & Nature",656,["whale"],11,49,"0.6","animal-marine"],
    "1f434":[["\uD83D\uDC34"],"Animals & Nature",578,["horse"],11,50,"0.6","animal-mammal"],
    "1f435":[["\uD83D\uDC35"],"Animals & Nature",559,["monkey_face"],11,51,"0.6","animal-mammal"],
    "1f436":[["\uD83D\uDC36"],"Animals & Nature",563,["dog"],11,52,"0.6","animal-mammal"],
    "1f437":[["\uD83D\uDC37"],"Animals & Nature",590,["pig"],11,53,"0.6","animal-mammal"],
    "1f438":[["\uD83D\uDC38"],"Animals & Nature",647,["frog"],11,54,"0.6","animal-amphibian"],
    "1f439":[["\uD83D\uDC39"],"Animals & Nature",608,["hamster"],11,55,"0.6","animal-mammal"],
    "1f43a":[["\uD83D\uDC3A"],"Animals & Nature",568,["wolf"],11,56,"0.6","animal-mammal"],
    "1f43b-200d-2744-fe0f":[["\uD83D\uDC3B\u200D\u2744\uFE0F"],"Animals & Nature",616,["polar_bear"],11,57,"13.0","animal-mammal"],
    "1f43b":[["\uD83D\uDC3B"],"Animals & Nature",615,["bear"],11,58,"0.6","animal-mammal"],
    "1f43c":[["\uD83D\uDC3C"],"Animals & Nature",618,["panda_face"],11,59,"0.6","animal-mammal"],
    "1f43d":[["\uD83D\uDC3D"],"Animals & Nature",593,["pig_nose"],11,60,"0.6","animal-mammal"],
    "1f43e":[["\uD83D\uDC3E"],"Animals & Nature",624,["feet","paw_prints"],11,61,"0.6","animal-mammal"],
    "1f43f-fe0f":[["\uD83D\uDC3F\uFE0F"],"Animals & Nature",611,["chipmunk"],12,0,"0.7","animal-mammal"],
    "1f440":[["\uD83D\uDC40"],"People & Body",225,["eyes"],12,1,"0.6","body-parts"],
    "1f441-fe0f-200d-1f5e8-fe0f":[["\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F"],"Smileys & Emotion",164,["eye-in-speech-bubble"],12,2,"2.0","emotion"],
    "1f441-fe0f":[["\uD83D\uDC41\uFE0F"],"People & Body",226,["eye"],12,3,"0.7","body-parts"],
    "1f442":[["\uD83D\uDC42"],"People & Body",217,["ear"],12,4,"0.6","body-parts"],
    "1f443":[["\uD83D\uDC43"],"People & Body",219,["nose"],12,10,"0.6","body-parts"],
    "1f444":[["\uD83D\uDC44"],"People & Body",228,["lips"],12,16,"0.6","body-parts"],
    "1f445":[["\uD83D\uDC45"],"People & Body",227,["tongue"],12,17,"0.6","body-parts"],
    "1f446":[["\uD83D\uDC46"],"People & Body",191,["point_up_2"],12,18,"0.6","hand-single-finger"],
    "1f447":[["\uD83D\uDC47"],"People & Body",193,["point_down"],12,24,"0.6","hand-single-finger"],
    "1f448":[["\uD83D\uDC48"],"People & Body",189,["point_left"],12,30,"0.6","hand-single-finger"],
    "1f449":[["\uD83D\uDC49"],"People & Body",190,["point_right"],12,36,"0.6","hand-single-finger"],
    "1f44a":[["\uD83D\uDC4A"],"People & Body",199,["facepunch","punch"],12,42,"0.6","hand-fingers-closed"],
    "1f44b":[["\uD83D\uDC4B"],"People & Body",169,["wave"],12,48,"0.6","hand-fingers-open"],
    "1f44c":[["\uD83D\uDC4C"],"People & Body",180,["ok_hand"],12,54,"0.6","hand-fingers-partial"],
    "1f44d":[["\uD83D\uDC4D"],"People & Body",196,["+1","thumbsup"],12,60,"0.6","hand-fingers-closed"],
    "1f44e":[["\uD83D\uDC4E"],"People & Body",197,["-1","thumbsdown"],13,4,"0.6","hand-fingers-closed"],
    "1f44f":[["\uD83D\uDC4F"],"People & Body",202,["clap"],13,10,"0.6","hands"],
    "1f450":[["\uD83D\uDC50"],"People & Body",205,["open_hands"],13,16,"0.6","hands"],
    "1f451":[["\uD83D\uDC51"],"Objects",1186,["crown"],13,22,"0.6","clothing"],
    "1f452":[["\uD83D\uDC52"],"Objects",1187,["womans_hat"],13,23,"0.6","clothing"],
    "1f453":[["\uD83D\uDC53"],"Objects",1150,["eyeglasses"],13,24,"0.6","clothing"],
    "1f454":[["\uD83D\uDC54"],"Objects",1155,["necktie"],13,25,"0.6","clothing"],
    "1f455":[["\uD83D\uDC55"],"Objects",1156,["shirt","tshirt"],13,26,"0.6","clothing"],
    "1f456":[["\uD83D\uDC56"],"Objects",1157,["jeans"],13,27,"0.6","clothing"],
    "1f457":[["\uD83D\uDC57"],"Objects",1162,["dress"],13,28,"0.6","clothing"],
    "1f458":[["\uD83D\uDC58"],"Objects",1163,["kimono"],13,29,"0.6","clothing"],
    "1f459":[["\uD83D\uDC59"],"Objects",1168,["bikini"],13,30,"0.6","clothing"],
    "1f45a":[["\uD83D\uDC5A"],"Objects",1169,["womans_clothes"],13,31,"0.6","clothing"],
    "1f45b":[["\uD83D\uDC5B"],"Objects",1171,["purse"],13,32,"0.6","clothing"],
    "1f45c":[["\uD83D\uDC5C"],"Objects",1172,["handbag"],13,33,"0.6","clothing"],
    "1f45d":[["\uD83D\uDC5D"],"Objects",1173,["pouch"],13,34,"0.6","clothing"],
    "1f45e":[["\uD83D\uDC5E"],"Objects",1177,["mans_shoe","shoe"],13,35,"0.6","clothing"],
    "1f45f":[["\uD83D\uDC5F"],"Objects",1178,["athletic_shoe"],13,36,"0.6","clothing"],
    "1f460":[["\uD83D\uDC60"],"Objects",1181,["high_heel"],13,37,"0.6","clothing"],
    "1f461":[["\uD83D\uDC61"],"Objects",1182,["sandal"],13,38,"0.6","clothing"],
    "1f462":[["\uD83D\uDC62"],"Objects",1184,["boot"],13,39,"0.6","clothing"],
    "1f463":[["\uD83D\uDC63"],"People & Body",553,["footprints"],13,40,"0.6","person-symbol"],
    "1f464":[["\uD83D\uDC64"],"People & Body",545,["bust_in_silhouette"],13,41,"0.6","person-symbol"],
    "1f465":[["\uD83D\uDC65"],"People & Body",546,["busts_in_silhouette"],13,42,"1.0","person-symbol"],
    "1f466":[["\uD83D\uDC66"],"People & Body",232,["boy"],13,43,"0.6","person"],
    "1f467":[["\uD83D\uDC67"],"People & Body",233,["girl"],13,49,"0.6","person"],
    "1f468-200d-1f33e":[["\uD83D\uDC68\u200D\uD83C\uDF3E"],"People & Body",301,["male-farmer"],13,55,"4.0","person-role"],
    "1f468-200d-1f373":[["\uD83D\uDC68\u200D\uD83C\uDF73"],"People & Body",304,["male-cook"],13,61,"4.0","person-role"],
    "1f468-200d-1f37c":[["\uD83D\uDC68\u200D\uD83C\uDF7C"],"People & Body",368,["man_feeding_baby"],14,5,"13.0","person-role"],
    "1f468-200d-1f393":[["\uD83D\uDC68\u200D\uD83C\uDF93"],"People & Body",292,["male-student"],14,11,"4.0","person-role"],
    "1f468-200d-1f3a4":[["\uD83D\uDC68\u200D\uD83C\uDFA4"],"People & Body",322,["male-singer"],14,17,"4.0","person-role"],
    "1f468-200d-1f3a8":[["\uD83D\uDC68\u200D\uD83C\uDFA8"],"People & Body",325,["male-artist"],14,23,"4.0","person-role"],
    "1f468-200d-1f3eb":[["\uD83D\uDC68\u200D\uD83C\uDFEB"],"People & Body",295,["male-teacher"],14,29,"4.0","person-role"],
    "1f468-200d-1f3ed":[["\uD83D\uDC68\u200D\uD83C\uDFED"],"People & Body",310,["male-factory-worker"],14,35,"4.0","person-role"],
    "1f468-200d-1f466-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66"],"People & Body",535,["man-boy-boy"],14,41,"4.0","family"],
    "1f468-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC66"],"People & Body",534,["man-boy"],14,42,"4.0","family"],
    "1f468-200d-1f467-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66"],"People & Body",537,["man-girl-boy"],14,43,"4.0","family"],
    "1f468-200d-1f467-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67"],"People & Body",538,["man-girl-girl"],14,44,"4.0","family"],
    "1f468-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC67"],"People & Body",536,["man-girl"],14,45,"4.0","family"],
    "1f468-200d-1f468-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66"],"People & Body",524,["man-man-boy"],14,46,"2.0","family"],
    "1f468-200d-1f468-200d-1f466-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66"],"People & Body",527,["man-man-boy-boy"],14,47,"2.0","family"],
    "1f468-200d-1f468-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67"],"People & Body",525,["man-man-girl"],14,48,"2.0","family"],
    "1f468-200d-1f468-200d-1f467-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66"],"People & Body",526,["man-man-girl-boy"],14,49,"2.0","family"],
    "1f468-200d-1f468-200d-1f467-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67"],"People & Body",528,["man-man-girl-girl"],14,50,"2.0","family"],
    "1f468-200d-1f469-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66","\uD83D\uDC6A"],"People & Body",519,["man-woman-boy","family"],14,51,"2.0","family"],
    "1f468-200d-1f469-200d-1f466-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"],"People & Body",522,["man-woman-boy-boy"],14,52,"2.0","family"],
    "1f468-200d-1f469-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67"],"People & Body",520,["man-woman-girl"],14,53,"2.0","family"],
    "1f468-200d-1f469-200d-1f467-200d-1f466":[["\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"],"People & Body",521,["man-woman-girl-boy"],14,54,"2.0","family"],
    "1f468-200d-1f469-200d-1f467-200d-1f467":[["\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"],"People & Body",523,["man-woman-girl-girl"],14,55,"2.0","family"],
    "1f468-200d-1f4bb":[["\uD83D\uDC68\u200D\uD83D\uDCBB"],"People & Body",319,["male-technologist"],14,56,"4.0","person-role"],
    "1f468-200d-1f4bc":[["\uD83D\uDC68\u200D\uD83D\uDCBC"],"People & Body",313,["male-office-worker"],15,0,"4.0","person-role"],
    "1f468-200d-1f527":[["\uD83D\uDC68\u200D\uD83D\uDD27"],"People & Body",307,["male-mechanic"],15,6,"4.0","person-role"],
    "1f468-200d-1f52c":[["\uD83D\uDC68\u200D\uD83D\uDD2C"],"People & Body",316,["male-scientist"],15,12,"4.0","person-role"],
    "1f468-200d-1f680":[["\uD83D\uDC68\u200D\uD83D\uDE80"],"People & Body",331,["male-astronaut"],15,18,"4.0","person-role"],
    "1f468-200d-1f692":[["\uD83D\uDC68\u200D\uD83D\uDE92"],"People & Body",334,["male-firefighter"],15,24,"4.0","person-role"],
    "1f468-200d-1f9af-200d-27a1-fe0f":[["\uD83D\uDC68\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"People & Body",426,["man_with_white_cane_facing_right"],15,30,"15.1","person-activity"],
    "1f468-200d-1f9af":[["\uD83D\uDC68\u200D\uD83E\uDDAF"],"People & Body",425,["man_with_probing_cane"],15,36,"12.0","person-activity"],
    "1f468-200d-1f9b0":[["\uD83D\uDC68\u200D\uD83E\uDDB0"],"People & Body",240,["red_haired_man"],15,42,"11.0","person"],
    "1f468-200d-1f9b1":[["\uD83D\uDC68\u200D\uD83E\uDDB1"],"People & Body",241,["curly_haired_man"],15,48,"11.0","person"],
    "1f468-200d-1f9b2":[["\uD83D\uDC68\u200D\uD83E\uDDB2"],"People & Body",243,["bald_man"],15,54,"11.0","person"],
    "1f468-200d-1f9b3":[["\uD83D\uDC68\u200D\uD83E\uDDB3"],"People & Body",242,["white_haired_man"],15,60,"11.0","person"],
    "1f468-200d-1f9bc-200d-27a1-fe0f":[["\uD83D\uDC68\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"People & Body",432,["man_in_motorized_wheelchair_facing_right"],16,4,"15.1","person-activity"],
    "1f468-200d-1f9bc":[["\uD83D\uDC68\u200D\uD83E\uDDBC"],"People & Body",431,["man_in_motorized_wheelchair"],16,10,"12.0","person-activity"],
    "1f468-200d-1f9bd-200d-27a1-fe0f":[["\uD83D\uDC68\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"People & Body",438,["man_in_manual_wheelchair_facing_right"],16,16,"15.1","person-activity"],
    "1f468-200d-1f9bd":[["\uD83D\uDC68\u200D\uD83E\uDDBD"],"People & Body",437,["man_in_manual_wheelchair"],16,22,"12.0","person-activity"],
    "1f468-200d-2695-fe0f":[["\uD83D\uDC68\u200D\u2695\uFE0F"],"People & Body",289,["male-doctor"],16,28,"4.0","person-role"],
    "1f468-200d-2696-fe0f":[["\uD83D\uDC68\u200D\u2696\uFE0F"],"People & Body",298,["male-judge"],16,34,"4.0","person-role"],
    "1f468-200d-2708-fe0f":[["\uD83D\uDC68\u200D\u2708\uFE0F"],"People & Body",328,["male-pilot"],16,40,"4.0","person-role"],
    "1f468-200d-2764-fe0f-200d-1f468":[["\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68"],"People & Body",517,["man-heart-man"],16,46,"2.0","family"],
    "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468":[["\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68"],"People & Body",513,["man-kiss-man"],17,10,"2.0","family"],
    "1f468":[["\uD83D\uDC68"],"People & Body",236,["man"],17,36,"0.6","person"],
    "1f469-200d-1f33e":[["\uD83D\uDC69\u200D\uD83C\uDF3E"],"People & Body",302,["female-farmer"],17,42,"4.0","person-role"],
    "1f469-200d-1f373":[["\uD83D\uDC69\u200D\uD83C\uDF73"],"People & Body",305,["female-cook"],17,48,"4.0","person-role"],
    "1f469-200d-1f37c":[["\uD83D\uDC69\u200D\uD83C\uDF7C"],"People & Body",367,["woman_feeding_baby"],17,54,"13.0","person-role"],
    "1f469-200d-1f393":[["\uD83D\uDC69\u200D\uD83C\uDF93"],"People & Body",293,["female-student"],17,60,"4.0","person-role"],
    "1f469-200d-1f3a4":[["\uD83D\uDC69\u200D\uD83C\uDFA4"],"People & Body",323,["female-singer"],18,4,"4.0","person-role"],
    "1f469-200d-1f3a8":[["\uD83D\uDC69\u200D\uD83C\uDFA8"],"People & Body",326,["female-artist"],18,10,"4.0","person-role"],
    "1f469-200d-1f3eb":[["\uD83D\uDC69\u200D\uD83C\uDFEB"],"People & Body",296,["female-teacher"],18,16,"4.0","person-role"],
    "1f469-200d-1f3ed":[["\uD83D\uDC69\u200D\uD83C\uDFED"],"People & Body",311,["female-factory-worker"],18,22,"4.0","person-role"],
    "1f469-200d-1f466-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"],"People & Body",540,["woman-boy-boy"],18,28,"4.0","family"],
    "1f469-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC66"],"People & Body",539,["woman-boy"],18,29,"4.0","family"],
    "1f469-200d-1f467-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"],"People & Body",542,["woman-girl-boy"],18,30,"4.0","family"],
    "1f469-200d-1f467-200d-1f467":[["\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"],"People & Body",543,["woman-girl-girl"],18,31,"4.0","family"],
    "1f469-200d-1f467":[["\uD83D\uDC69\u200D\uD83D\uDC67"],"People & Body",541,["woman-girl"],18,32,"4.0","family"],
    "1f469-200d-1f469-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66"],"People & Body",529,["woman-woman-boy"],18,33,"2.0","family"],
    "1f469-200d-1f469-200d-1f466-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66"],"People & Body",532,["woman-woman-boy-boy"],18,34,"2.0","family"],
    "1f469-200d-1f469-200d-1f467":[["\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67"],"People & Body",530,["woman-woman-girl"],18,35,"2.0","family"],
    "1f469-200d-1f469-200d-1f467-200d-1f466":[["\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66"],"People & Body",531,["woman-woman-girl-boy"],18,36,"2.0","family"],
    "1f469-200d-1f469-200d-1f467-200d-1f467":[["\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67"],"People & Body",533,["woman-woman-girl-girl"],18,37,"2.0","family"],
    "1f469-200d-1f4bb":[["\uD83D\uDC69\u200D\uD83D\uDCBB"],"People & Body",320,["female-technologist"],18,38,"4.0","person-role"],
    "1f469-200d-1f4bc":[["\uD83D\uDC69\u200D\uD83D\uDCBC"],"People & Body",314,["female-office-worker"],18,44,"4.0","person-role"],
    "1f469-200d-1f527":[["\uD83D\uDC69\u200D\uD83D\uDD27"],"People & Body",308,["female-mechanic"],18,50,"4.0","person-role"],
    "1f469-200d-1f52c":[["\uD83D\uDC69\u200D\uD83D\uDD2C"],"People & Body",317,["female-scientist"],18,56,"4.0","person-role"],
    "1f469-200d-1f680":[["\uD83D\uDC69\u200D\uD83D\uDE80"],"People & Body",332,["female-astronaut"],19,0,"4.0","person-role"],
    "1f469-200d-1f692":[["\uD83D\uDC69\u200D\uD83D\uDE92"],"People & Body",335,["female-firefighter"],19,6,"4.0","person-role"],
    "1f469-200d-1f9af-200d-27a1-fe0f":[["\uD83D\uDC69\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"People & Body",428,["woman_with_white_cane_facing_right"],19,12,"15.1","person-activity"],
    "1f469-200d-1f9af":[["\uD83D\uDC69\u200D\uD83E\uDDAF"],"People & Body",427,["woman_with_probing_cane"],19,18,"12.0","person-activity"],
    "1f469-200d-1f9b0":[["\uD83D\uDC69\u200D\uD83E\uDDB0"],"People & Body",245,["red_haired_woman"],19,24,"11.0","person"],
    "1f469-200d-1f9b1":[["\uD83D\uDC69\u200D\uD83E\uDDB1"],"People & Body",247,["curly_haired_woman"],19,30,"11.0","person"],
    "1f469-200d-1f9b2":[["\uD83D\uDC69\u200D\uD83E\uDDB2"],"People & Body",251,["bald_woman"],19,36,"11.0","person"],
    "1f469-200d-1f9b3":[["\uD83D\uDC69\u200D\uD83E\uDDB3"],"People & Body",249,["white_haired_woman"],19,42,"11.0","person"],
    "1f469-200d-1f9bc-200d-27a1-fe0f":[["\uD83D\uDC69\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"People & Body",434,["woman_in_motorized_wheelchair_facing_right"],19,48,"15.1","person-activity"],
    "1f469-200d-1f9bc":[["\uD83D\uDC69\u200D\uD83E\uDDBC"],"People & Body",433,["woman_in_motorized_wheelchair"],19,54,"12.0","person-activity"],
    "1f469-200d-1f9bd-200d-27a1-fe0f":[["\uD83D\uDC69\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"People & Body",440,["woman_in_manual_wheelchair_facing_right"],19,60,"15.1","person-activity"],
    "1f469-200d-1f9bd":[["\uD83D\uDC69\u200D\uD83E\uDDBD"],"People & Body",439,["woman_in_manual_wheelchair"],20,4,"12.0","person-activity"],
    "1f469-200d-2695-fe0f":[["\uD83D\uDC69\u200D\u2695\uFE0F"],"People & Body",290,["female-doctor"],20,10,"4.0","person-role"],
    "1f469-200d-2696-fe0f":[["\uD83D\uDC69\u200D\u2696\uFE0F"],"People & Body",299,["female-judge"],20,16,"4.0","person-role"],
    "1f469-200d-2708-fe0f":[["\uD83D\uDC69\u200D\u2708\uFE0F"],"People & Body",329,["female-pilot"],20,22,"4.0","person-role"],
    "1f469-200d-2764-fe0f-200d-1f468":[["\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68"],"People & Body",516,["woman-heart-man"],20,28,"2.0","family"],
    "1f469-200d-2764-fe0f-200d-1f469":[["\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69"],"People & Body",518,["woman-heart-woman"],20,54,"2.0","family"],
    "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468":[["\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68"],"People & Body",512,["woman-kiss-man"],21,18,"2.0","family"],
    "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469":[["\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69"],"People & Body",514,["woman-kiss-woman"],21,44,"2.0","family"],
    "1f469":[["\uD83D\uDC69"],"People & Body",244,["woman"],22,8,"0.6","person"],
    "1f46b":[["\uD83D\uDC6B"],"People & Body",509,["man_and_woman_holding_hands","woman_and_man_holding_hands","couple"],22,15,"0.6","family"],
    "1f46c":[["\uD83D\uDC6C"],"People & Body",510,["two_men_holding_hands","men_holding_hands"],22,41,"1.0","family"],
    "1f46d":[["\uD83D\uDC6D"],"People & Body",508,["two_women_holding_hands","women_holding_hands"],23,5,"1.0","family"],
    "1f46e-200d-2640-fe0f":[["\uD83D\uDC6E\u200D\u2640\uFE0F"],"People & Body",338,["female-police-officer"],23,31,"4.0","person-role"],
    "1f46e-200d-2642-fe0f":[["\uD83D\uDC6E\u200D\u2642\uFE0F","\uD83D\uDC6E"],"People & Body",337,["male-police-officer","cop"],23,37,"4.0","person-role"],
    "1f46f-200d-2640-fe0f":[["\uD83D\uDC6F\u200D\u2640\uFE0F","\uD83D\uDC6F"],"People & Body",452,["women-with-bunny-ears-partying","woman-with-bunny-ears-partying","dancers"],23,49,"4.0","person-activity"],
    "1f46f-200d-2642-fe0f":[["\uD83D\uDC6F\u200D\u2642\uFE0F"],"People & Body",451,["men-with-bunny-ears-partying","man-with-bunny-ears-partying"],23,50,"4.0","person-activity"],
    "1f470-200d-2640-fe0f":[["\uD83D\uDC70\u200D\u2640\uFE0F"],"People & Body",362,["woman_with_veil"],23,52,"13.0","person-role"],
    "1f470-200d-2642-fe0f":[["\uD83D\uDC70\u200D\u2642\uFE0F"],"People & Body",361,["man_with_veil"],23,58,"13.0","person-role"],
    "1f470":[["\uD83D\uDC70"],"People & Body",360,["bride_with_veil"],24,2,"0.6","person-role"],
    "1f471-200d-2640-fe0f":[["\uD83D\uDC71\u200D\u2640\uFE0F"],"People & Body",253,["blond-haired-woman"],24,8,"4.0","person"],
    "1f471-200d-2642-fe0f":[["\uD83D\uDC71\u200D\u2642\uFE0F","\uD83D\uDC71"],"People & Body",254,["blond-haired-man","person_with_blond_hair"],24,14,"4.0","person"],
    "1f472":[["\uD83D\uDC72"],"People & Body",355,["man_with_gua_pi_mao"],24,26,"0.6","person-role"],
    "1f473-200d-2640-fe0f":[["\uD83D\uDC73\u200D\u2640\uFE0F"],"People & Body",354,["woman-wearing-turban"],24,32,"4.0","person-role"],
    "1f473-200d-2642-fe0f":[["\uD83D\uDC73\u200D\u2642\uFE0F","\uD83D\uDC73"],"People & Body",353,["man-wearing-turban","man_with_turban"],24,38,"4.0","person-role"],
    "1f474":[["\uD83D\uDC74"],"People & Body",256,["older_man"],24,50,"0.6","person"],
    "1f475":[["\uD83D\uDC75"],"People & Body",257,["older_woman"],24,56,"0.6","person"],
    "1f476":[["\uD83D\uDC76"],"People & Body",230,["baby"],25,0,"0.6","person"],
    "1f477-200d-2640-fe0f":[["\uD83D\uDC77\u200D\u2640\uFE0F"],"People & Body",348,["female-construction-worker"],25,6,"4.0","person-role"],
    "1f477-200d-2642-fe0f":[["\uD83D\uDC77\u200D\u2642\uFE0F","\uD83D\uDC77"],"People & Body",347,["male-construction-worker","construction_worker"],25,12,"4.0","person-role"],
    "1f478":[["\uD83D\uDC78"],"People & Body",351,["princess"],25,24,"0.6","person-role"],
    "1f479":[["\uD83D\uDC79"],"Smileys & Emotion",112,["japanese_ogre"],25,30,"0.6","face-costume"],
    "1f47a":[["\uD83D\uDC7A"],"Smileys & Emotion",113,["japanese_goblin"],25,31,"0.6","face-costume"],
    "1f47b":[["\uD83D\uDC7B"],"Smileys & Emotion",114,["ghost"],25,32,"0.6","face-costume"],
    "1f47c":[["\uD83D\uDC7C"],"People & Body",370,["angel"],25,33,"0.6","person-fantasy"],
    "1f47d":[["\uD83D\uDC7D"],"Smileys & Emotion",115,["alien"],25,39,"0.6","face-costume"],
    "1f47e":[["\uD83D\uDC7E"],"Smileys & Emotion",116,["space_invader"],25,40,"0.6","face-costume"],
    "1f47f":[["\uD83D\uDC7F"],"Smileys & Emotion",107,["imp"],25,41,"0.6","face-negative"],
    "1f480":[["\uD83D\uDC80"],"Smileys & Emotion",108,["skull"],25,42,"0.6","face-negative"],
    "1f481-200d-2640-fe0f":[["\uD83D\uDC81\u200D\u2640\uFE0F","\uD83D\uDC81"],"People & Body",272,["woman-tipping-hand","information_desk_person"],25,43,"4.0","person-gesture"],
    "1f481-200d-2642-fe0f":[["\uD83D\uDC81\u200D\u2642\uFE0F"],"People & Body",271,["man-tipping-hand"],25,49,"4.0","person-gesture"],
    "1f482-200d-2640-fe0f":[["\uD83D\uDC82\u200D\u2640\uFE0F"],"People & Body",344,["female-guard"],25,61,"4.0","person-role"],
    "1f482-200d-2642-fe0f":[["\uD83D\uDC82\u200D\u2642\uFE0F","\uD83D\uDC82"],"People & Body",343,["male-guard","guardsman"],26,5,"4.0","person-role"],
    "1f483":[["\uD83D\uDC83"],"People & Body",447,["dancer"],26,17,"0.6","person-activity"],
    "1f484":[["\uD83D\uDC84"],"Objects",1194,["lipstick"],26,23,"0.6","clothing"],
    "1f485":[["\uD83D\uDC85"],"People & Body",210,["nail_care"],26,24,"0.6","hand-prop"],
    "1f486-200d-2640-fe0f":[["\uD83D\uDC86\u200D\u2640\uFE0F","\uD83D\uDC86"],"People & Body",404,["woman-getting-massage","massage"],26,30,"4.0","person-activity"],
    "1f486-200d-2642-fe0f":[["\uD83D\uDC86\u200D\u2642\uFE0F"],"People & Body",403,["man-getting-massage"],26,36,"4.0","person-activity"],
    "1f487-200d-2640-fe0f":[["\uD83D\uDC87\u200D\u2640\uFE0F","\uD83D\uDC87"],"People & Body",407,["woman-getting-haircut","haircut"],26,48,"4.0","person-activity"],
    "1f487-200d-2642-fe0f":[["\uD83D\uDC87\u200D\u2642\uFE0F"],"People & Body",406,["man-getting-haircut"],26,54,"4.0","person-activity"],
    "1f488":[["\uD83D\uDC88"],"Travel & Places",911,["barber"],27,4,"0.6","place-other"],
    "1f489":[["\uD83D\uDC89"],"Objects",1371,["syringe"],27,5,"0.6","medical"],
    "1f48a":[["\uD83D\uDC8A"],"Objects",1373,["pill"],27,6,"0.6","medical"],
    "1f48b":[["\uD83D\uDC8B"],"Smileys & Emotion",155,["kiss"],27,7,"0.6","emotion"],
    "1f48c":[["\uD83D\uDC8C"],"Smileys & Emotion",130,["love_letter"],27,8,"0.6","heart"],
    "1f48d":[["\uD83D\uDC8D"],"Objects",1195,["ring"],27,9,"0.6","clothing"],
    "1f48e":[["\uD83D\uDC8E"],"Objects",1196,["gem"],27,10,"0.6","clothing"],
    "1f48f":[["\uD83D\uDC8F"],"People & Body",511,["couplekiss"],27,11,"0.6","family"],
    "1f490":[["\uD83D\uDC90"],"Animals & Nature",684,["bouquet"],27,37,"0.6","plant-flower"],
    "1f491":[["\uD83D\uDC91"],"People & Body",515,["couple_with_heart"],27,38,"0.6","family"],
    "1f492":[["\uD83D\uDC92"],"Travel & Places",887,["wedding"],28,2,"0.6","place-building"],
    "1f493":[["\uD83D\uDC93"],"Smileys & Emotion",135,["heartbeat"],28,3,"0.6","heart"],
    "1f494":[["\uD83D\uDC94"],"Smileys & Emotion",140,["broken_heart"],28,4,"0.6","heart","<\/3"],
    "1f495":[["\uD83D\uDC95"],"Smileys & Emotion",137,["two_hearts"],28,5,"0.6","heart"],
    "1f496":[["\uD83D\uDC96"],"Smileys & Emotion",133,["sparkling_heart"],28,6,"0.6","heart"],
    "1f497":[["\uD83D\uDC97"],"Smileys & Emotion",134,["heartpulse"],28,7,"0.6","heart"],
    "1f498":[["\uD83D\uDC98"],"Smileys & Emotion",131,["cupid"],28,8,"0.6","heart"],
    "1f499":[["\uD83D\uDC99"],"Smileys & Emotion",148,["blue_heart"],28,9,"0.6","heart","<3"],
    "1f49a":[["\uD83D\uDC9A"],"Smileys & Emotion",147,["green_heart"],28,10,"0.6","heart","<3"],
    "1f49b":[["\uD83D\uDC9B"],"Smileys & Emotion",146,["yellow_heart"],28,11,"0.6","heart","<3"],
    "1f49c":[["\uD83D\uDC9C"],"Smileys & Emotion",150,["purple_heart"],28,12,"0.6","heart","<3"],
    "1f49d":[["\uD83D\uDC9D"],"Smileys & Emotion",132,["gift_heart"],28,13,"0.6","heart"],
    "1f49e":[["\uD83D\uDC9E"],"Smileys & Emotion",136,["revolving_hearts"],28,14,"0.6","heart"],
    "1f49f":[["\uD83D\uDC9F"],"Smileys & Emotion",138,["heart_decoration"],28,15,"0.6","heart"],
    "1f4a0":[["\uD83D\uDCA0"],"Symbols",1631,["diamond_shape_with_a_dot_inside"],28,16,"0.6","geometric"],
    "1f4a1":[["\uD83D\uDCA1"],"Objects",1258,["bulb"],28,17,"0.6","light & video"],
    "1f4a2":[["\uD83D\uDCA2"],"Smileys & Emotion",157,["anger"],28,18,"0.6","emotion"],
    "1f4a3":[["\uD83D\uDCA3"],"Objects",1345,["bomb"],28,19,"0.6","tool"],
    "1f4a4":[["\uD83D\uDCA4"],"Smileys & Emotion",168,["zzz"],28,20,"0.6","emotion"],
    "1f4a5":[["\uD83D\uDCA5"],"Smileys & Emotion",158,["boom","collision"],28,21,"0.6","emotion"],
    "1f4a6":[["\uD83D\uDCA6"],"Smileys & Emotion",160,["sweat_drops"],28,22,"0.6","emotion"],
    "1f4a7":[["\uD83D\uDCA7"],"Travel & Places",1063,["droplet"],28,23,"0.6","sky & weather"],
    "1f4a8":[["\uD83D\uDCA8"],"Smileys & Emotion",161,["dash"],28,24,"0.6","emotion"],
    "1f4a9":[["\uD83D\uDCA9"],"Smileys & Emotion",110,["pile_of_poo", "hankey","poop","shit"],28,25,"0.6","face-costume"],
    "1f4aa":[["\uD83D\uDCAA"],"People & Body",212,["muscle"],28,26,"0.6","body-parts"],
    "1f4ab":[["\uD83D\uDCAB"],"Smileys & Emotion",159,["dizzy"],28,32,"0.6","emotion"],
    "1f4ac":[["\uD83D\uDCAC"],"Smileys & Emotion",163,["speech_balloon"],28,33,"0.6","emotion"],
    "1f4ad":[["\uD83D\uDCAD"],"Smileys & Emotion",167,["thought_balloon"],28,34,"1.0","emotion"],
    "1f4ae":[["\uD83D\uDCAE"],"Animals & Nature",686,["white_flower"],28,35,"0.6","plant-flower"],
    "1f4af":[["\uD83D\uDCAF"],"Smileys & Emotion",156,["100"],28,36,"0.6","emotion"],
    "1f4b0":[["\uD83D\uDCB0"],"Objects",1279,["moneybag"],28,37,"0.6","money"],
    "1f4b1":[["\uD83D\uDCB1"],"Symbols",1526,["currency_exchange"],28,38,"0.6","currency"],
    "1f4b2":[["\uD83D\uDCB2"],"Symbols",1527,["heavy_dollar_sign"],28,39,"0.6","currency"],
    "1f4b3":[["\uD83D\uDCB3"],"Objects",1286,["credit_card"],28,40,"0.6","money"],
    "1f4b4":[["\uD83D\uDCB4"],"Objects",1281,["yen"],28,41,"0.6","money"],
    "1f4b5":[["\uD83D\uDCB5"],"Objects",1282,["dollar"],28,42,"0.6","money"],
    "1f4b6":[["\uD83D\uDCB6"],"Objects",1283,["euro"],28,43,"1.0","money"],
    "1f4b7":[["\uD83D\uDCB7"],"Objects",1284,["pound"],28,44,"1.0","money"],
    "1f4b8":[["\uD83D\uDCB8"],"Objects",1285,["money_with_wings"],28,45,"0.6","money"],
    "1f4b9":[["\uD83D\uDCB9"],"Objects",1288,["chart"],28,46,"0.6","money"],
    "1f4ba":[["\uD83D\uDCBA"],"Travel & Places",977,["seat"],28,47,"0.6","transport-air"],
    "1f4bb":[["\uD83D\uDCBB"],"Objects",1235,["computer"],28,48,"0.6","computer"],
    "1f4bc":[["\uD83D\uDCBC"],"Objects",1309,["briefcase"],28,49,"0.6","office"],
    "1f4bd":[["\uD83D\uDCBD"],"Objects",1241,["minidisc"],28,50,"0.6","computer"],
    "1f4be":[["\uD83D\uDCBE"],"Objects",1242,["floppy_disk"],28,51,"0.6","computer"],
    "1f4bf":[["\uD83D\uDCBF"],"Objects",1243,["cd"],28,52,"0.6","computer"],
    "1f4c0":[["\uD83D\uDCC0"],"Objects",1244,["dvd"],28,53,"0.6","computer"],
    "1f4c1":[["\uD83D\uDCC1"],"Objects",1310,["file_folder"],28,54,"0.6","office"],
    "1f4c2":[["\uD83D\uDCC2"],"Objects",1311,["open_file_folder"],28,55,"0.6","office"],
    "1f4c3":[["\uD83D\uDCC3"],"Objects",1271,["page_with_curl"],28,56,"0.6","book-paper"],
    "1f4c4":[["\uD83D\uDCC4"],"Objects",1273,["page_facing_up"],28,57,"0.6","book-paper"],
    "1f4c5":[["\uD83D\uDCC5"],"Objects",1313,["date"],28,58,"0.6","office"],
    "1f4c6":[["\uD83D\uDCC6"],"Objects",1314,["calendar"],28,59,"0.6","office"],
    "1f4c7":[["\uD83D\uDCC7"],"Objects",1317,["card_index"],28,60,"0.6","office"],
    "1f4c8":[["\uD83D\uDCC8"],"Objects",1318,["chart_with_upwards_trend"],28,61,"0.6","office"],
    "1f4c9":[["\uD83D\uDCC9"],"Objects",1319,["chart_with_downwards_trend"],29,0,"0.6","office"],
    "1f4ca":[["\uD83D\uDCCA"],"Objects",1320,["bar_chart"],29,1,"0.6","office"],
    "1f4cb":[["\uD83D\uDCCB"],"Objects",1321,["clipboard"],29,2,"0.6","office"],
    "1f4cc":[["\uD83D\uDCCC"],"Objects",1322,["pushpin"],29,3,"0.6","office"],
    "1f4cd":[["\uD83D\uDCCD"],"Objects",1323,["round_pushpin"],29,4,"0.6","office"],
    "1f4ce":[["\uD83D\uDCCE"],"Objects",1324,["paperclip"],29,5,"0.6","office"],
    "1f4cf":[["\uD83D\uDCCF"],"Objects",1326,["straight_ruler"],29,6,"0.6","office"],
    "1f4d0":[["\uD83D\uDCD0"],"Objects",1327,["triangular_ruler"],29,7,"0.6","office"],
    "1f4d1":[["\uD83D\uDCD1"],"Objects",1276,["bookmark_tabs"],29,8,"0.6","book-paper"],
    "1f4d2":[["\uD83D\uDCD2"],"Objects",1270,["ledger"],29,9,"0.6","book-paper"],
    "1f4d3":[["\uD83D\uDCD3"],"Objects",1269,["notebook"],29,10,"0.6","book-paper"],
    "1f4d4":[["\uD83D\uDCD4"],"Objects",1262,["notebook_with_decorative_cover"],29,11,"0.6","book-paper"],
    "1f4d5":[["\uD83D\uDCD5"],"Objects",1263,["closed_book"],29,12,"0.6","book-paper"],
    "1f4d6":[["\uD83D\uDCD6"],"Objects",1264,["book","open_book"],29,13,"0.6","book-paper"],
    "1f4d7":[["\uD83D\uDCD7"],"Objects",1265,["green_book"],29,14,"0.6","book-paper"],
    "1f4d8":[["\uD83D\uDCD8"],"Objects",1266,["blue_book"],29,15,"0.6","book-paper"],
    "1f4d9":[["\uD83D\uDCD9"],"Objects",1267,["orange_book"],29,16,"0.6","book-paper"],
    "1f4da":[["\uD83D\uDCDA"],"Objects",1268,["books"],29,17,"0.6","book-paper"],
    "1f4db":[["\uD83D\uDCDB"],"Symbols",1532,["name_badge"],29,18,"0.6","other-symbol"],
    "1f4dc":[["\uD83D\uDCDC"],"Objects",1272,["scroll"],29,19,"0.6","book-paper"],
    "1f4dd":[["\uD83D\uDCDD"],"Objects",1308,["memo","pencil"],29,20,"0.6","writing"],
    "1f4de":[["\uD83D\uDCDE"],"Objects",1229,["telephone_receiver"],29,21,"0.6","phone"],
    "1f4df":[["\uD83D\uDCDF"],"Objects",1230,["pager"],29,22,"0.6","phone"],
    "1f4e0":[["\uD83D\uDCE0"],"Objects",1231,["fax"],29,23,"0.6","phone"],
    "1f4e1":[["\uD83D\uDCE1"],"Objects",1370,["satellite_antenna"],29,24,"0.6","science"],
    "1f4e2":[["\uD83D\uDCE2"],"Objects",1201,["loudspeaker"],29,25,"0.6","sound"],
    "1f4e3":[["\uD83D\uDCE3"],"Objects",1202,["mega"],29,26,"0.6","sound"],
    "1f4e4":[["\uD83D\uDCE4"],"Objects",1293,["outbox_tray"],29,27,"0.6","mail"],
    "1f4e5":[["\uD83D\uDCE5"],"Objects",1294,["inbox_tray"],29,28,"0.6","mail"],
    "1f4e6":[["\uD83D\uDCE6"],"Objects",1295,["package"],29,29,"0.6","mail"],
    "1f4e7":[["\uD83D\uDCE7"],"Objects",1290,["e-mail"],29,30,"0.6","mail"],
    "1f4e8":[["\uD83D\uDCE8"],"Objects",1291,["incoming_envelope"],29,31,"0.6","mail"],
    "1f4e9":[["\uD83D\uDCE9"],"Objects",1292,["envelope_with_arrow"],29,32,"0.6","mail"],
    "1f4ea":[["\uD83D\uDCEA"],"Objects",1297,["mailbox_closed"],29,33,"0.6","mail"],
    "1f4eb":[["\uD83D\uDCEB"],"Objects",1296,["mailbox"],29,34,"0.6","mail"],
    "1f4ec":[["\uD83D\uDCEC"],"Objects",1298,["mailbox_with_mail"],29,35,"0.7","mail"],
    "1f4ed":[["\uD83D\uDCED"],"Objects",1299,["mailbox_with_no_mail"],29,36,"0.7","mail"],
    "1f4ee":[["\uD83D\uDCEE"],"Objects",1300,["postbox"],29,37,"0.6","mail"],
    "1f4ef":[["\uD83D\uDCEF"],"Objects",1203,["postal_horn"],29,38,"1.0","sound"],
    "1f4f0":[["\uD83D\uDCF0"],"Objects",1274,["newspaper"],29,39,"0.6","book-paper"],
    "1f4f1":[["\uD83D\uDCF1"],"Objects",1226,["iphone"],29,40,"0.6","phone"],
    "1f4f2":[["\uD83D\uDCF2"],"Objects",1227,["calling"],29,41,"0.6","phone"],
    "1f4f3":[["\uD83D\uDCF3"],"Symbols",1508,["vibration_mode"],29,42,"0.6","av-symbol"],
    "1f4f4":[["\uD83D\uDCF4"],"Symbols",1509,["mobile_phone_off"],29,43,"0.6","av-symbol"],
    "1f4f5":[["\uD83D\uDCF5"],"Symbols",1434,["no_mobile_phones"],29,44,"1.0","warning"],
    "1f4f6":[["\uD83D\uDCF6"],"Symbols",1506,["signal_strength"],29,45,"0.6","av-symbol"],
    "1f4f7":[["\uD83D\uDCF7"],"Objects",1251,["camera"],29,46,"0.6","light & video"],
    "1f4f8":[["\uD83D\uDCF8"],"Objects",1252,["camera_with_flash"],29,47,"1.0","light & video"],
    "1f4f9":[["\uD83D\uDCF9"],"Objects",1253,["video_camera"],29,48,"0.6","light & video"],
    "1f4fa":[["\uD83D\uDCFA"],"Objects",1250,["tv"],29,49,"0.6","light & video"],
    "1f4fb":[["\uD83D\uDCFB"],"Objects",1214,["radio"],29,50,"0.6","music"],
    "1f4fc":[["\uD83D\uDCFC"],"Objects",1254,["vhs"],29,51,"0.6","light & video"],
    "1f4fd-fe0f":[["\uD83D\uDCFD\uFE0F"],"Objects",1248,["film_projector"],29,52,"0.7","light & video"],
    "1f4ff":[["\uD83D\uDCFF"],"Objects",1193,["prayer_beads"],29,53,"1.0","clothing"],
    "1f500":[["\uD83D\uDD00"],"Symbols",1485,["twisted_rightwards_arrows"],29,54,"1.0","av-symbol"],
    "1f501":[["\uD83D\uDD01"],"Symbols",1486,["repeat"],29,55,"1.0","av-symbol"],
    "1f502":[["\uD83D\uDD02"],"Symbols",1487,["repeat_one"],29,56,"1.0","av-symbol"],
    "1f503":[["\uD83D\uDD03"],"Symbols",1452,["arrows_clockwise"],29,57,"0.6","arrow"],
    "1f504":[["\uD83D\uDD04"],"Symbols",1453,["arrows_counterclockwise"],29,58,"1.0","arrow"],
    "1f505":[["\uD83D\uDD05"],"Symbols",1504,["low_brightness"],29,59,"1.0","av-symbol"],
    "1f506":[["\uD83D\uDD06"],"Symbols",1505,["high_brightness"],29,60,"1.0","av-symbol"],
    "1f507":[["\uD83D\uDD07"],"Objects",1197,["mute"],29,61,"1.0","sound"],
    "1f508":[["\uD83D\uDD08"],"Objects",1198,["speaker"],30,0,"0.7","sound"],
    "1f509":[["\uD83D\uDD09"],"Objects",1199,["sound"],30,1,"1.0","sound"],
    "1f50a":[["\uD83D\uDD0A"],"Objects",1200,["loud_sound"],30,2,"0.6","sound"],
    "1f50b":[["\uD83D\uDD0B"],"Objects",1232,["battery"],30,3,"0.6","computer"],
    "1f50c":[["\uD83D\uDD0C"],"Objects",1234,["electric_plug"],30,4,"0.6","computer"],
    "1f50d":[["\uD83D\uDD0D"],"Objects",1255,["mag"],30,5,"0.6","light & video"],
    "1f50e":[["\uD83D\uDD0E"],"Objects",1256,["mag_right"],30,6,"0.6","light & video"],
    "1f50f":[["\uD83D\uDD0F"],"Objects",1334,["lock_with_ink_pen"],30,7,"0.6","lock"],
    "1f510":[["\uD83D\uDD10"],"Objects",1335,["closed_lock_with_key"],30,8,"0.6","lock"],
    "1f511":[["\uD83D\uDD11"],"Objects",1336,["key"],30,9,"0.6","lock"],
    "1f512":[["\uD83D\uDD12"],"Objects",1332,["lock"],30,10,"0.6","lock"],
    "1f513":[["\uD83D\uDD13"],"Objects",1333,["unlock"],30,11,"0.6","lock"],
    "1f514":[["\uD83D\uDD14"],"Objects",1204,["bell"],30,12,"0.6","sound"],
    "1f515":[["\uD83D\uDD15"],"Objects",1205,["no_bell"],30,13,"1.0","sound"],
    "1f516":[["\uD83D\uDD16"],"Objects",1277,["bookmark"],30,14,"0.6","book-paper"],
    "1f517":[["\uD83D\uDD17"],"Objects",1357,["link"],30,15,"0.6","tool"],
    "1f518":[["\uD83D\uDD18"],"Symbols",1632,["radio_button"],30,16,"0.6","geometric"],
    "1f519":[["\uD83D\uDD19"],"Symbols",1454,["back"],30,17,"0.6","arrow"],
    "1f51a":[["\uD83D\uDD1A"],"Symbols",1455,["end"],30,18,"0.6","arrow"],
    "1f51b":[["\uD83D\uDD1B"],"Symbols",1456,["on"],30,19,"0.6","arrow"],
    "1f51c":[["\uD83D\uDD1C"],"Symbols",1457,["soon"],30,20,"0.6","arrow"],
    "1f51d":[["\uD83D\uDD1D"],"Symbols",1458,["top"],30,21,"0.6","arrow"],
    "1f51e":[["\uD83D\uDD1E"],"Symbols",1435,["underage"],30,22,"0.6","warning"],
    "1f51f":[["\uD83D\uDD1F"],"Symbols",1561,["keycap_ten"],30,23,"0.6","keycap"],
    "1f520":[["\uD83D\uDD20"],"Symbols",1562,["capital_abcd"],30,24,"0.6","alphanum"],
    "1f521":[["\uD83D\uDD21"],"Symbols",1563,["abcd"],30,25,"0.6","alphanum"],
    "1f522":[["\uD83D\uDD22"],"Symbols",1564,["1234"],30,26,"0.6","alphanum"],
    "1f523":[["\uD83D\uDD23"],"Symbols",1565,["symbols"],30,27,"0.6","alphanum"],
    "1f524":[["\uD83D\uDD24"],"Symbols",1566,["abc"],30,28,"0.6","alphanum"],
    "1f525":[["\uD83D\uDD25"],"Travel & Places",1062,["fire"],30,29,"0.6","sky & weather"],
    "1f526":[["\uD83D\uDD26"],"Objects",1259,["flashlight"],30,30,"0.6","light & video"],
    "1f527":[["\uD83D\uDD27"],"Objects",1350,["wrench"],30,31,"0.6","tool"],
    "1f528":[["\uD83D\uDD28"],"Objects",1338,["hammer"],30,32,"0.6","tool"],
    "1f529":[["\uD83D\uDD29"],"Objects",1352,["nut_and_bolt"],30,33,"0.6","tool"],
    "1f52a":[["\uD83D\uDD2A"],"Food & Drink",844,["hocho","knife"],30,34,"0.6","dishware"],
    "1f52b":[["\uD83D\uDD2B"],"Activities",1122,["gun"],30,35,"0.6","game"],
    "1f52c":[["\uD83D\uDD2C"],"Objects",1368,["microscope"],30,36,"1.0","science"],
    "1f52d":[["\uD83D\uDD2D"],"Objects",1369,["telescope"],30,37,"1.0","science"],
    "1f52e":[["\uD83D\uDD2E"],"Activities",1124,["crystal_ball"],30,38,"0.6","game"],
    "1f52f":[["\uD83D\uDD2F"],"Symbols",1470,["six_pointed_star"],30,39,"0.6","religion"],
    "1f530":[["\uD83D\uDD30"],"Symbols",1533,["beginner"],30,40,"0.6","other-symbol"],
    "1f531":[["\uD83D\uDD31"],"Symbols",1531,["trident"],30,41,"0.6","other-symbol"],
    "1f532":[["\uD83D\uDD32"],"Symbols",1634,["black_square_button"],30,42,"0.6","geometric"],
    "1f533":[["\uD83D\uDD33"],"Symbols",1633,["white_square_button"],30,43,"0.6","geometric"],
    "1f534":[["\uD83D\uDD34"],"Symbols",1601,["red_circle"],30,44,"0.6","geometric"],
    "1f535":[["\uD83D\uDD35"],"Symbols",1605,["large_blue_circle"],30,45,"0.6","geometric"],
    "1f536":[["\uD83D\uDD36"],"Symbols",1625,["large_orange_diamond"],30,46,"0.6","geometric"],
    "1f537":[["\uD83D\uDD37"],"Symbols",1626,["large_blue_diamond"],30,47,"0.6","geometric"],
    "1f538":[["\uD83D\uDD38"],"Symbols",1627,["small_orange_diamond"],30,48,"0.6","geometric"],
    "1f539":[["\uD83D\uDD39"],"Symbols",1628,["small_blue_diamond"],30,49,"0.6","geometric"],
    "1f53a":[["\uD83D\uDD3A"],"Symbols",1629,["small_red_triangle"],30,50,"0.6","geometric"],
    "1f53b":[["\uD83D\uDD3B"],"Symbols",1630,["small_red_triangle_down"],30,51,"0.6","geometric"],
    "1f53c":[["\uD83D\uDD3C"],"Symbols",1495,["arrow_up_small"],30,52,"0.6","av-symbol"],
    "1f53d":[["\uD83D\uDD3D"],"Symbols",1497,["arrow_down_small"],30,53,"0.6","av-symbol"],
    "1f549-fe0f":[["\uD83D\uDD49\uFE0F"],"Symbols",1461,["om_symbol"],30,54,"0.7","religion"],
    "1f54a-fe0f":[["\uD83D\uDD4A\uFE0F"],"Animals & Nature",633,["dove_of_peace"],30,55,"0.7","animal-bird"],
    "1f54b":[["\uD83D\uDD4B"],"Travel & Places",895,["kaaba"],30,56,"1.0","place-religious"],
    "1f54c":[["\uD83D\uDD4C"],"Travel & Places",891,["mosque"],30,57,"1.0","place-religious"],
    "1f54d":[["\uD83D\uDD4D"],"Travel & Places",893,["synagogue"],30,58,"1.0","place-religious"],
    "1f54e":[["\uD83D\uDD4E"],"Symbols",1469,["menorah_with_nine_branches"],30,59,"1.0","religion"],
    "1f550":[["\uD83D\uDD50"],"Travel & Places",996,["clock1"],30,60,"0.6","time"],
    "1f551":[["\uD83D\uDD51"],"Travel & Places",998,["clock2"],30,61,"0.6","time"],
    "1f552":[["\uD83D\uDD52"],"Travel & Places",1000,["clock3"],31,0,"0.6","time"],
    "1f553":[["\uD83D\uDD53"],"Travel & Places",1002,["clock4"],31,1,"0.6","time"],
    "1f554":[["\uD83D\uDD54"],"Travel & Places",1004,["clock5"],31,2,"0.6","time"],
    "1f555":[["\uD83D\uDD55"],"Travel & Places",1006,["clock6"],31,3,"0.6","time"],
    "1f556":[["\uD83D\uDD56"],"Travel & Places",1008,["clock7"],31,4,"0.6","time"],
    "1f557":[["\uD83D\uDD57"],"Travel & Places",1010,["clock8"],31,5,"0.6","time"],
    "1f558":[["\uD83D\uDD58"],"Travel & Places",1012,["clock9"],31,6,"0.6","time"],
    "1f559":[["\uD83D\uDD59"],"Travel & Places",1014,["clock10"],31,7,"0.6","time"],
    "1f55a":[["\uD83D\uDD5A"],"Travel & Places",1016,["clock11"],31,8,"0.6","time"],
    "1f55b":[["\uD83D\uDD5B"],"Travel & Places",994,["clock12"],31,9,"0.6","time"],
    "1f55c":[["\uD83D\uDD5C"],"Travel & Places",997,["clock130"],31,10,"0.7","time"],
    "1f55d":[["\uD83D\uDD5D"],"Travel & Places",999,["clock230"],31,11,"0.7","time"],
    "1f55e":[["\uD83D\uDD5E"],"Travel & Places",1001,["clock330"],31,12,"0.7","time"],
    "1f55f":[["\uD83D\uDD5F"],"Travel & Places",1003,["clock430"],31,13,"0.7","time"],
    "1f560":[["\uD83D\uDD60"],"Travel & Places",1005,["clock530"],31,14,"0.7","time"],
    "1f561":[["\uD83D\uDD61"],"Travel & Places",1007,["clock630"],31,15,"0.7","time"],
    "1f562":[["\uD83D\uDD62"],"Travel & Places",1009,["clock730"],31,16,"0.7","time"],
    "1f563":[["\uD83D\uDD63"],"Travel & Places",1011,["clock830"],31,17,"0.7","time"],
    "1f564":[["\uD83D\uDD64"],"Travel & Places",1013,["clock930"],31,18,"0.7","time"],
    "1f565":[["\uD83D\uDD65"],"Travel & Places",1015,["clock1030"],31,19,"0.7","time"],
    "1f566":[["\uD83D\uDD66"],"Travel & Places",1017,["clock1130"],31,20,"0.7","time"],
    "1f567":[["\uD83D\uDD67"],"Travel & Places",995,["clock1230"],31,21,"0.7","time"],
    "1f56f-fe0f":[["\uD83D\uDD6F\uFE0F"],"Objects",1257,["candle"],31,22,"0.7","light & video"],
    "1f570-fe0f":[["\uD83D\uDD70\uFE0F"],"Travel & Places",993,["mantelpiece_clock"],31,23,"0.7","time"],
    "1f573-fe0f":[["\uD83D\uDD73\uFE0F"],"Smileys & Emotion",162,["hole"],31,24,"0.7","emotion"],
    "1f574-fe0f":[["\uD83D\uDD74\uFE0F"],"People & Body",449,["man_in_business_suit_levitating"],31,25,"0.7","person-activity"],
    "1f575-fe0f-200d-2640-fe0f":[["\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F"],"People & Body",341,["female-detective"],31,31,"4.0","person-role"],
    "1f575-fe0f-200d-2642-fe0f":[["\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F","\uD83D\uDD75\uFE0F"],"People & Body",340,["male-detective","sleuth_or_spy"],31,37,"4.0","person-role"],
    "1f576-fe0f":[["\uD83D\uDD76\uFE0F"],"Objects",1151,["dark_sunglasses"],31,49,"0.7","clothing"],
    "1f577-fe0f":[["\uD83D\uDD77\uFE0F"],"Animals & Nature",677,["spider"],31,50,"0.7","animal-bug"],
    "1f578-fe0f":[["\uD83D\uDD78\uFE0F"],"Animals & Nature",678,["spider_web"],31,51,"0.7","animal-bug"],
    "1f579-fe0f":[["\uD83D\uDD79\uFE0F"],"Activities",1127,["joystick"],31,52,"0.7","game"],
    "1f57a":[["\uD83D\uDD7A"],"People & Body",448,["man_dancing"],31,53,"3.0","person-activity"],
    "1f587-fe0f":[["\uD83D\uDD87\uFE0F"],"Objects",1325,["linked_paperclips"],31,59,"0.7","office"],
    "1f58a-fe0f":[["\uD83D\uDD8A\uFE0F"],"Objects",1305,["lower_left_ballpoint_pen"],31,60,"0.7","writing"],
    "1f58b-fe0f":[["\uD83D\uDD8B\uFE0F"],"Objects",1304,["lower_left_fountain_pen"],31,61,"0.7","writing"],
    "1f58c-fe0f":[["\uD83D\uDD8C\uFE0F"],"Objects",1306,["lower_left_paintbrush"],32,0,"0.7","writing"],
    "1f58d-fe0f":[["\uD83D\uDD8D\uFE0F"],"Objects",1307,["lower_left_crayon"],32,1,"0.7","writing"],
    "1f590-fe0f":[["\uD83D\uDD90\uFE0F"],"People & Body",171,["raised_hand_with_fingers_splayed"],32,2,"0.7","hand-fingers-open"],
    "1f595":[["\uD83D\uDD95"],"People & Body",192,["middle_finger","reversed_hand_with_middle_finger_extended"],32,8,"1.0","hand-single-finger"],
    "1f596":[["\uD83D\uDD96"],"People & Body",173,["spock-hand"],32,14,"1.0","hand-fingers-open"],
    "1f5a4":[["\uD83D\uDDA4"],"Smileys & Emotion",152,["black_heart"],32,20,"3.0","heart"],
    "1f5a5-fe0f":[["\uD83D\uDDA5\uFE0F"],"Objects",1236,["desktop_computer"],32,21,"0.7","computer"],
    "1f5a8-fe0f":[["\uD83D\uDDA8\uFE0F"],"Objects",1237,["printer"],32,22,"0.7","computer"],
    "1f5b1-fe0f":[["\uD83D\uDDB1\uFE0F"],"Objects",1239,["three_button_mouse"],32,23,"0.7","computer"],
    "1f5b2-fe0f":[["\uD83D\uDDB2\uFE0F"],"Objects",1240,["trackball"],32,24,"0.7","computer"],
    "1f5bc-fe0f":[["\uD83D\uDDBC\uFE0F"],"Activities",1144,["frame_with_picture"],32,25,"0.7","arts & crafts"],
    "1f5c2-fe0f":[["\uD83D\uDDC2\uFE0F"],"Objects",1312,["card_index_dividers"],32,26,"0.7","office"],
    "1f5c3-fe0f":[["\uD83D\uDDC3\uFE0F"],"Objects",1329,["card_file_box"],32,27,"0.7","office"],
    "1f5c4-fe0f":[["\uD83D\uDDC4\uFE0F"],"Objects",1330,["file_cabinet"],32,28,"0.7","office"],
    "1f5d1-fe0f":[["\uD83D\uDDD1\uFE0F"],"Objects",1331,["wastebasket"],32,29,"0.7","office"],
    "1f5d2-fe0f":[["\uD83D\uDDD2\uFE0F"],"Objects",1315,["spiral_note_pad"],32,30,"0.7","office"],
    "1f5d3-fe0f":[["\uD83D\uDDD3\uFE0F"],"Objects",1316,["spiral_calendar_pad"],32,31,"0.7","office"],
    "1f5dc-fe0f":[["\uD83D\uDDDC\uFE0F"],"Objects",1354,["compression"],32,32,"0.7","tool"],
    "1f5dd-fe0f":[["\uD83D\uDDDD\uFE0F"],"Objects",1337,["old_key"],32,33,"0.7","lock"],
    "1f5de-fe0f":[["\uD83D\uDDDE\uFE0F"],"Objects",1275,["rolled_up_newspaper"],32,34,"0.7","book-paper"],
    "1f5e1-fe0f":[["\uD83D\uDDE1\uFE0F"],"Objects",1343,["dagger_knife"],32,35,"0.7","tool"],
    "1f5e3-fe0f":[["\uD83D\uDDE3\uFE0F"],"People & Body",544,["speaking_head_in_silhouette"],32,36,"0.7","person-symbol"],
    "1f5e8-fe0f":[["\uD83D\uDDE8\uFE0F"],"Smileys & Emotion",165,["left_speech_bubble"],32,37,"2.0","emotion"],
    "1f5ef-fe0f":[["\uD83D\uDDEF\uFE0F"],"Smileys & Emotion",166,["right_anger_bubble"],32,38,"0.7","emotion"],
    "1f5f3-fe0f":[["\uD83D\uDDF3\uFE0F"],"Objects",1301,["ballot_box_with_ballot"],32,39,"0.7","mail"],
    "1f5fa-fe0f":[["\uD83D\uDDFA\uFE0F"],"Travel & Places",851,["world_map"],32,40,"0.7","place-map"],
    "1f5fb":[["\uD83D\uDDFB"],"Travel & Places",857,["mount_fuji"],32,41,"0.6","place-geographic"],
    "1f5fc":[["\uD83D\uDDFC"],"Travel & Places",888,["tokyo_tower"],32,42,"0.6","place-building"],
    "1f5fd":[["\uD83D\uDDFD"],"Travel & Places",889,["statue_of_liberty"],32,43,"0.6","place-building"],
    "1f5fe":[["\uD83D\uDDFE"],"Travel & Places",852,["japan"],32,44,"0.6","place-map"],
    "1f5ff":[["\uD83D\uDDFF"],"Objects",1409,["moyai"],32,45,"0.6","other-object"],
    "1f600":[["\uD83D\uDE00"],"Smileys & Emotion",1,["grinning"],32,46,"1.0","face-smiling",":D"],
    "1f601":[["\uD83D\uDE01"],"Smileys & Emotion",4,["grin"],32,47,"0.6","face-smiling"],
    "1f602":[["\uD83D\uDE02"],"Smileys & Emotion",8,["joy"],32,48,"0.6","face-smiling"],
    "1f603":[["\uD83D\uDE03"],"Smileys & Emotion",2,["smiley"],32,49,"0.6","face-smiling",":)"],
    "1f604":[["\uD83D\uDE04"],"Smileys & Emotion",3,["smile"],32,50,"0.6","face-smiling",":)"],
    "1f605":[["\uD83D\uDE05"],"Smileys & Emotion",6,["sweat_smile"],32,51,"0.6","face-smiling"],
    "1f606":[["\uD83D\uDE06"],"Smileys & Emotion",5,["laughing","satisfied"],32,52,"0.6","face-smiling"],
    "1f607":[["\uD83D\uDE07"],"Smileys & Emotion",14,["innocent"],32,53,"1.0","face-smiling"],
    "1f608":[["\uD83D\uDE08"],"Smileys & Emotion",106,["smiling_imp"],32,54,"1.0","face-negative"],
    "1f609":[["\uD83D\uDE09"],"Smileys & Emotion",12,["wink"],32,55,"0.6","face-smiling",";)"],
    "1f60a":[["\uD83D\uDE0A"],"Smileys & Emotion",13,["blush"],32,56,"0.6","face-smiling",":)"],
    "1f60b":[["\uD83D\uDE0B"],"Smileys & Emotion",24,["yum"],32,57,"0.6","face-tongue"],
    "1f60c":[["\uD83D\uDE0C"],"Smileys & Emotion",53,["relieved"],32,58,"0.6","face-sleepy"],
    "1f60d":[["\uD83D\uDE0D"],"Smileys & Emotion",16,["heart_eyes"],32,59,"0.6","face-affection"],
    "1f60e":[["\uD83D\uDE0E"],"Smileys & Emotion",73,["sunglasses"],32,60,"1.0","face-glasses"],
    "1f60f":[["\uD83D\uDE0F"],"Smileys & Emotion",44,["smirk"],32,61,"0.6","face-neutral-skeptical"],
    "1f610":[["\uD83D\uDE10"],"Smileys & Emotion",39,["neutral_face"],33,0,"0.7","face-neutral-skeptical"],
    "1f611":[["\uD83D\uDE11"],"Smileys & Emotion",40,["expressionless"],33,1,"1.0","face-neutral-skeptical"],
    "1f612":[["\uD83D\uDE12"],"Smileys & Emotion",45,["unamused"],33,2,"0.6","face-neutral-skeptical",":("],
    "1f613":[["\uD83D\uDE13"],"Smileys & Emotion",98,["sweat"],33,3,"0.6","face-concerned"],
    "1f614":[["\uD83D\uDE14"],"Smileys & Emotion",54,["pensive"],33,4,"0.6","face-sleepy"],
    "1f615":[["\uD83D\uDE15"],"Smileys & Emotion",76,["confused"],33,5,"1.0","face-concerned"],
    "1f616":[["\uD83D\uDE16"],"Smileys & Emotion",95,["confounded"],33,6,"0.6","face-concerned"],
    "1f617":[["\uD83D\uDE17"],"Smileys & Emotion",19,["kissing"],33,7,"1.0","face-affection"],
    "1f618":[["\uD83D\uDE18"],"Smileys & Emotion",18,["kissing_heart"],33,8,"0.6","face-affection"],
    "1f619":[["\uD83D\uDE19"],"Smileys & Emotion",22,["kissing_smiling_eyes"],33,9,"1.0","face-affection"],
    "1f61a":[["\uD83D\uDE1A"],"Smileys & Emotion",21,["kissing_closed_eyes"],33,10,"0.6","face-affection"],
    "1f61b":[["\uD83D\uDE1B"],"Smileys & Emotion",25,["stuck_out_tongue"],33,11,"1.0","face-tongue",":p"],
    "1f61c":[["\uD83D\uDE1C"],"Smileys & Emotion",26,["stuck_out_tongue_winking_eye"],33,12,"0.6","face-tongue",";p"],
    "1f61d":[["\uD83D\uDE1D"],"Smileys & Emotion",28,["stuck_out_tongue_closed_eyes"],33,13,"0.6","face-tongue"],
    "1f61e":[["\uD83D\uDE1E"],"Smileys & Emotion",97,["disappointed"],33,14,"0.6","face-concerned",":("],
    "1f61f":[["\uD83D\uDE1F"],"Smileys & Emotion",78,["worried"],33,15,"1.0","face-concerned"],
    "1f620":[["\uD83D\uDE20"],"Smileys & Emotion",104,["angry"],33,16,"0.6","face-negative"],
    "1f621":[["\uD83D\uDE21"],"Smileys & Emotion",103,["rage"],33,17,"0.6","face-negative"],
    "1f622":[["\uD83D\uDE22"],"Smileys & Emotion",92,["cry"],33,18,"0.6","face-concerned",":'("],
    "1f623":[["\uD83D\uDE23"],"Smileys & Emotion",96,["persevere"],33,19,"0.6","face-concerned"],
    "1f624":[["\uD83D\uDE24"],"Smileys & Emotion",102,["triumph"],33,20,"0.6","face-negative"],
    "1f625":[["\uD83D\uDE25"],"Smileys & Emotion",91,["disappointed_relieved"],33,21,"0.6","face-concerned"],
    "1f626":[["\uD83D\uDE26"],"Smileys & Emotion",87,["frowning"],33,22,"1.0","face-concerned"],
    "1f627":[["\uD83D\uDE27"],"Smileys & Emotion",88,["anguished"],33,23,"1.0","face-concerned"],
    "1f628":[["\uD83D\uDE28"],"Smileys & Emotion",89,["fearful"],33,24,"0.6","face-concerned"],
    "1f629":[["\uD83D\uDE29"],"Smileys & Emotion",99,["weary"],33,25,"0.6","face-concerned"],
    "1f62a":[["\uD83D\uDE2A"],"Smileys & Emotion",55,["sleepy"],33,26,"0.6","face-sleepy"],
    "1f62b":[["\uD83D\uDE2B"],"Smileys & Emotion",100,["tired_face"],33,27,"0.6","face-concerned"],
    "1f62c":[["\uD83D\uDE2C"],"Smileys & Emotion",47,["grimacing"],33,28,"1.0","face-neutral-skeptical"],
    "1f62d":[["\uD83D\uDE2D"],"Smileys & Emotion",93,["sob"],33,29,"0.6","face-concerned",":'("],
    "1f62e-200d-1f4a8":[["\uD83D\uDE2E\u200D\uD83D\uDCA8"],"Smileys & Emotion",48,["face_exhaling"],33,30,"13.1","face-neutral-skeptical"],
    "1f62e":[["\uD83D\uDE2E"],"Smileys & Emotion",81,["open_mouth"],33,31,"1.0","face-concerned"],
    "1f62f":[["\uD83D\uDE2F"],"Smileys & Emotion",82,["hushed"],33,32,"1.0","face-concerned"],
    "1f630":[["\uD83D\uDE30"],"Smileys & Emotion",90,["cold_sweat"],33,33,"0.6","face-concerned"],
    "1f631":[["\uD83D\uDE31"],"Smileys & Emotion",94,["scream"],33,34,"0.6","face-concerned"],
    "1f632":[["\uD83D\uDE32"],"Smileys & Emotion",83,["astonished"],33,35,"0.6","face-concerned"],
    "1f633":[["\uD83D\uDE33"],"Smileys & Emotion",84,["flushed"],33,36,"0.6","face-concerned"],
    "1f634":[["\uD83D\uDE34"],"Smileys & Emotion",57,["sleeping"],33,37,"1.0","face-sleepy"],
    "1f635-200d-1f4ab":[["\uD83D\uDE35\u200D\uD83D\uDCAB"],"Smileys & Emotion",68,["face_with_spiral_eyes"],33,38,"13.1","face-unwell"],
    "1f635":[["\uD83D\uDE35"],"Smileys & Emotion",67,["dizzy_face"],33,39,"0.6","face-unwell"],
    "1f636-200d-1f32b-fe0f":[["\uD83D\uDE36\u200D\uD83C\uDF2B\uFE0F"],"Smileys & Emotion",43,["face_in_clouds"],33,40,"13.1","face-neutral-skeptical"],
    "1f636":[["\uD83D\uDE36"],"Smileys & Emotion",41,["no_mouth"],33,41,"1.0","face-neutral-skeptical"],
    "1f637":[["\uD83D\uDE37"],"Smileys & Emotion",58,["mask"],33,42,"0.6","face-unwell"],
    "1f638":[["\uD83D\uDE38"],"Smileys & Emotion",119,["smile_cat"],33,43,"0.6","cat-face"],
    "1f639":[["\uD83D\uDE39"],"Smileys & Emotion",120,["joy_cat"],33,44,"0.6","cat-face"],
    "1f63a":[["\uD83D\uDE3A"],"Smileys & Emotion",118,["smiley_cat"],33,45,"0.6","cat-face"],
    "1f63b":[["\uD83D\uDE3B"],"Smileys & Emotion",121,["heart_eyes_cat"],33,46,"0.6","cat-face"],
    "1f63c":[["\uD83D\uDE3C"],"Smileys & Emotion",122,["smirk_cat"],33,47,"0.6","cat-face"],
    "1f63d":[["\uD83D\uDE3D"],"Smileys & Emotion",123,["kissing_cat"],33,48,"0.6","cat-face"],
    "1f63e":[["\uD83D\uDE3E"],"Smileys & Emotion",126,["pouting_cat"],33,49,"0.6","cat-face"],
    "1f63f":[["\uD83D\uDE3F"],"Smileys & Emotion",125,["crying_cat_face"],33,50,"0.6","cat-face"],
    "1f640":[["\uD83D\uDE40"],"Smileys & Emotion",124,["scream_cat"],33,51,"0.6","cat-face"],
    "1f641":[["\uD83D\uDE41"],"Smileys & Emotion",79,["slightly_frowning_face"],33,52,"1.0","face-concerned"],
    "1f642-200d-2194-fe0f":[["\uD83D\uDE42\u200D\u2194\uFE0F"],"Smileys & Emotion",51,["head_shaking_horizontally"],33,53,"15.1","face-neutral-skeptical"],
    "1f642-200d-2195-fe0f":[["\uD83D\uDE42\u200D\u2195\uFE0F"],"Smileys & Emotion",52,["head_shaking_vertically"],33,54,"15.1","face-neutral-skeptical"],
    "1f642":[["\uD83D\uDE42"],"Smileys & Emotion",9,["slightly_smiling_face"],33,55,"1.0","face-smiling"],
    "1f643":[["\uD83D\uDE43"],"Smileys & Emotion",10,["upside_down_face"],33,56,"1.0","face-smiling"],
    "1f644":[["\uD83D\uDE44"],"Smileys & Emotion",46,["face_with_rolling_eyes"],33,57,"1.0","face-neutral-skeptical"],
    "1f645-200d-2640-fe0f":[["\uD83D\uDE45\u200D\u2640\uFE0F","\uD83D\uDE45"],"People & Body",266,["woman-gesturing-no","no_good"],33,58,"4.0","person-gesture"],
    "1f645-200d-2642-fe0f":[["\uD83D\uDE45\u200D\u2642\uFE0F"],"People & Body",265,["man-gesturing-no"],34,2,"4.0","person-gesture"],
    "1f646-200d-2640-fe0f":[["\uD83D\uDE46\u200D\u2640\uFE0F","\uD83D\uDE46"],"People & Body",269,["woman-gesturing-ok","ok_woman"],34,14,"4.0","person-gesture"],
    "1f646-200d-2642-fe0f":[["\uD83D\uDE46\u200D\u2642\uFE0F"],"People & Body",268,["man-gesturing-ok"],34,20,"4.0","person-gesture"],
    "1f647-200d-2640-fe0f":[["\uD83D\uDE47\u200D\u2640\uFE0F"],"People & Body",281,["woman-bowing"],34,32,"4.0","person-gesture"],
    "1f647-200d-2642-fe0f":[["\uD83D\uDE47\u200D\u2642\uFE0F"],"People & Body",280,["man-bowing"],34,38,"4.0","person-gesture"],
    "1f647":[["\uD83D\uDE47"],"People & Body",279,["bow"],34,44,"0.6","person-gesture"],
    "1f648":[["\uD83D\uDE48"],"Smileys & Emotion",127,["see_no_evil"],34,50,"0.6","monkey-face"],
    "1f649":[["\uD83D\uDE49"],"Smileys & Emotion",128,["hear_no_evil"],34,51,"0.6","monkey-face"],
    "1f64a":[["\uD83D\uDE4A"],"Smileys & Emotion",129,["speak_no_evil"],34,52,"0.6","monkey-face"],
    "1f64b-200d-2640-fe0f":[["\uD83D\uDE4B\u200D\u2640\uFE0F","\uD83D\uDE4B"],"People & Body",275,["woman-raising-hand","raising_hand"],34,53,"4.0","person-gesture"],
    "1f64b-200d-2642-fe0f":[["\uD83D\uDE4B\u200D\u2642\uFE0F"],"People & Body",274,["man-raising-hand"],34,59,"4.0","person-gesture"],
    "1f64c":[["\uD83D\uDE4C"],"People & Body",203,["raised_hands"],35,9,"0.6","hands"],
    "1f64d-200d-2640-fe0f":[["\uD83D\uDE4D\u200D\u2640\uFE0F","\uD83D\uDE4D"],"People & Body",260,["woman-frowning","person_frowning"],35,15,"4.0","person-gesture"],
    "1f64d-200d-2642-fe0f":[["\uD83D\uDE4D\u200D\u2642\uFE0F"],"People & Body",259,["man-frowning"],35,21,"4.0","person-gesture"],
    "1f64e-200d-2640-fe0f":[["\uD83D\uDE4E\u200D\u2640\uFE0F","\uD83D\uDE4E"],"People & Body",263,["woman-pouting","person_with_pouting_face"],35,33,"4.0","person-gesture"],
    "1f64e-200d-2642-fe0f":[["\uD83D\uDE4E\u200D\u2642\uFE0F"],"People & Body",262,["man-pouting"],35,39,"4.0","person-gesture"],
    "1f64f":[["\uD83D\uDE4F"],"People & Body",208,["pray"],35,51,"0.6","hands"],
    "1f680":[["\uD83D\uDE80"],"Travel & Places",983,["rocket"],35,57,"0.6","transport-air"],
    "1f681":[["\uD83D\uDE81"],"Travel & Places",978,["helicopter"],35,58,"1.0","transport-air"],
    "1f682":[["\uD83D\uDE82"],"Travel & Places",913,["steam_locomotive"],35,59,"1.0","transport-ground"],
    "1f683":[["\uD83D\uDE83"],"Travel & Places",914,["railway_car"],35,60,"0.6","transport-ground"],
    "1f684":[["\uD83D\uDE84"],"Travel & Places",915,["bullettrain_side"],35,61,"0.6","transport-ground"],
    "1f685":[["\uD83D\uDE85"],"Travel & Places",916,["bullettrain_front"],36,0,"0.6","transport-ground"],
    "1f686":[["\uD83D\uDE86"],"Travel & Places",917,["train2"],36,1,"1.0","transport-ground"],
    "1f687":[["\uD83D\uDE87"],"Travel & Places",918,["metro"],36,2,"0.6","transport-ground"],
    "1f688":[["\uD83D\uDE88"],"Travel & Places",919,["light_rail"],36,3,"1.0","transport-ground"],
    "1f689":[["\uD83D\uDE89"],"Travel & Places",920,["station"],36,4,"0.6","transport-ground"],
    "1f68a":[["\uD83D\uDE8A"],"Travel & Places",921,["tram"],36,5,"1.0","transport-ground"],
    "1f68b":[["\uD83D\uDE8B"],"Travel & Places",924,["train"],36,6,"1.0","transport-ground"],
    "1f68c":[["\uD83D\uDE8C"],"Travel & Places",925,["bus"],36,7,"0.6","transport-ground"],
    "1f68d":[["\uD83D\uDE8D"],"Travel & Places",926,["oncoming_bus"],36,8,"0.7","transport-ground"],
    "1f68e":[["\uD83D\uDE8E"],"Travel & Places",927,["trolleybus"],36,9,"1.0","transport-ground"],
    "1f68f":[["\uD83D\uDE8F"],"Travel & Places",952,["busstop"],36,10,"0.6","transport-ground"],
    "1f690":[["\uD83D\uDE90"],"Travel & Places",928,["minibus"],36,11,"1.0","transport-ground"],
    "1f691":[["\uD83D\uDE91"],"Travel & Places",929,["ambulance"],36,12,"0.6","transport-ground"],
    "1f692":[["\uD83D\uDE92"],"Travel & Places",930,["fire_engine"],36,13,"0.6","transport-ground"],
    "1f693":[["\uD83D\uDE93"],"Travel & Places",931,["police_car"],36,14,"0.6","transport-ground"],
    "1f694":[["\uD83D\uDE94"],"Travel & Places",932,["oncoming_police_car"],36,15,"0.7","transport-ground"],
    "1f695":[["\uD83D\uDE95"],"Travel & Places",933,["taxi"],36,16,"0.6","transport-ground"],
    "1f696":[["\uD83D\uDE96"],"Travel & Places",934,["oncoming_taxi"],36,17,"1.0","transport-ground"],
    "1f697":[["\uD83D\uDE97"],"Travel & Places",935,["car","red_car"],36,18,"0.6","transport-ground"],
    "1f698":[["\uD83D\uDE98"],"Travel & Places",936,["oncoming_automobile"],36,19,"0.7","transport-ground"],
    "1f699":[["\uD83D\uDE99"],"Travel & Places",937,["blue_car"],36,20,"0.6","transport-ground"],
    "1f69a":[["\uD83D\uDE9A"],"Travel & Places",939,["truck"],36,21,"0.6","transport-ground"],
    "1f69b":[["\uD83D\uDE9B"],"Travel & Places",940,["articulated_lorry"],36,22,"1.0","transport-ground"],
    "1f69c":[["\uD83D\uDE9C"],"Travel & Places",941,["tractor"],36,23,"1.0","transport-ground"],
    "1f69d":[["\uD83D\uDE9D"],"Travel & Places",922,["monorail"],36,24,"1.0","transport-ground"],
    "1f69e":[["\uD83D\uDE9E"],"Travel & Places",923,["mountain_railway"],36,25,"1.0","transport-ground"],
    "1f69f":[["\uD83D\uDE9F"],"Travel & Places",979,["suspension_railway"],36,26,"1.0","transport-air"],
    "1f6a0":[["\uD83D\uDEA0"],"Travel & Places",980,["mountain_cableway"],36,27,"1.0","transport-air"],
    "1f6a1":[["\uD83D\uDEA1"],"Travel & Places",981,["aerial_tramway"],36,28,"1.0","transport-air"],
    "1f6a2":[["\uD83D\uDEA2"],"Travel & Places",971,["ship"],36,29,"0.6","transport-water"],
    "1f6a3-200d-2640-fe0f":[["\uD83D\uDEA3\u200D\u2640\uFE0F"],"People & Body",471,["woman-rowing-boat"],36,30,"4.0","person-sport"],
    "1f6a3-200d-2642-fe0f":[["\uD83D\uDEA3\u200D\u2642\uFE0F","\uD83D\uDEA3"],"People & Body",470,["man-rowing-boat","rowboat"],36,36,"4.0","person-sport"],
    "1f6a4":[["\uD83D\uDEA4"],"Travel & Places",967,["speedboat"],36,48,"0.6","transport-water"],
    "1f6a5":[["\uD83D\uDEA5"],"Travel & Places",959,["traffic_light"],36,49,"0.6","transport-ground"],
    "1f6a6":[["\uD83D\uDEA6"],"Travel & Places",960,["vertical_traffic_light"],36,50,"1.0","transport-ground"],
    "1f6a7":[["\uD83D\uDEA7"],"Travel & Places",962,["construction"],36,51,"0.6","transport-ground"],
    "1f6a8":[["\uD83D\uDEA8"],"Travel & Places",958,["rotating_light"],36,52,"0.6","transport-ground"],
    "1f6a9":[["\uD83D\uDEA9"],"Flags",1636,["triangular_flag_on_post"],36,53,"0.6","flag"],
    "1f6aa":[["\uD83D\uDEAA"],"Objects",1378,["door"],36,54,"0.6","household"],
    "1f6ab":[["\uD83D\uDEAB"],"Symbols",1428,["no_entry_sign"],36,55,"0.6","warning"],
    "1f6ac":[["\uD83D\uDEAC"],"Objects",1403,["smoking"],36,56,"0.6","other-object"],
    "1f6ad":[["\uD83D\uDEAD"],"Symbols",1430,["no_smoking"],36,57,"0.6","warning"],
    "1f6ae":[["\uD83D\uDEAE"],"Symbols",1413,["put_litter_in_its_place"],36,58,"1.0","transport-sign"],
    "1f6af":[["\uD83D\uDEAF"],"Symbols",1431,["do_not_litter"],36,59,"1.0","warning"],
    "1f6b0":[["\uD83D\uDEB0"],"Symbols",1414,["potable_water"],36,60,"1.0","transport-sign"],
    "1f6b1":[["\uD83D\uDEB1"],"Symbols",1432,["non-potable_water"],36,61,"1.0","warning"],
    "1f6b2":[["\uD83D\uDEB2"],"Travel & Places",948,["bike"],37,0,"0.6","transport-ground"],
    "1f6b3":[["\uD83D\uDEB3"],"Symbols",1429,["no_bicycles"],37,1,"1.0","warning"],
    "1f6b4-200d-2640-fe0f":[["\uD83D\uDEB4\u200D\u2640\uFE0F"],"People & Body",483,["woman-biking"],37,2,"4.0","person-sport"],
    "1f6b4-200d-2642-fe0f":[["\uD83D\uDEB4\u200D\u2642\uFE0F","\uD83D\uDEB4"],"People & Body",482,["man-biking","bicyclist"],37,8,"4.0","person-sport"],
    "1f6b5-200d-2640-fe0f":[["\uD83D\uDEB5\u200D\u2640\uFE0F"],"People & Body",486,["woman-mountain-biking"],37,20,"4.0","person-sport"],
    "1f6b5-200d-2642-fe0f":[["\uD83D\uDEB5\u200D\u2642\uFE0F","\uD83D\uDEB5"],"People & Body",485,["man-mountain-biking","mountain_bicyclist"],37,26,"4.0","person-sport"],
    "1f6b6-200d-2640-fe0f":[["\uD83D\uDEB6\u200D\u2640\uFE0F"],"People & Body",410,["woman-walking"],37,38,"4.0","person-activity"],
    "1f6b6-200d-2640-fe0f-200d-27a1-fe0f":[["\uD83D\uDEB6\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"People & Body",412,["woman_walking_facing_right"],37,44,"15.1","person-activity"],
    "1f6b6-200d-2642-fe0f":[["\uD83D\uDEB6\u200D\u2642\uFE0F","\uD83D\uDEB6"],"People & Body",409,["man-walking","walking"],37,50,"4.0","person-activity"],
    "1f6b6-200d-2642-fe0f-200d-27a1-fe0f":[["\uD83D\uDEB6\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"People & Body",413,["man_walking_facing_right"],37,56,"15.1","person-activity"],
    "1f6b6-200d-27a1-fe0f":[["\uD83D\uDEB6\u200D\u27A1\uFE0F"],"People & Body",411,["person_walking_facing_right"],38,0,"15.1","person-activity"],
    "1f6b7":[["\uD83D\uDEB7"],"Symbols",1433,["no_pedestrians"],38,12,"1.0","warning"],
    "1f6b8":[["\uD83D\uDEB8"],"Symbols",1426,["children_crossing"],38,13,"1.0","warning"],
    "1f6b9":[["\uD83D\uDEB9"],"Symbols",1416,["mens"],38,14,"0.6","transport-sign"],
    "1f6ba":[["\uD83D\uDEBA"],"Symbols",1417,["womens"],38,15,"0.6","transport-sign"],
    "1f6bb":[["\uD83D\uDEBB"],"Symbols",1418,["restroom"],38,16,"0.6","transport-sign"],
    "1f6bc":[["\uD83D\uDEBC"],"Symbols",1419,["baby_symbol"],38,17,"0.6","transport-sign"],
    "1f6bd":[["\uD83D\uDEBD"],"Objects",1385,["toilet"],38,18,"0.6","household"],
    "1f6be":[["\uD83D\uDEBE"],"Symbols",1420,["wc"],38,19,"0.6","transport-sign"],
    "1f6bf":[["\uD83D\uDEBF"],"Objects",1387,["shower"],38,20,"1.0","household"],
    "1f6c0":[["\uD83D\uDEC0"],"People & Body",505,["bath"],38,21,"0.6","person-resting"],
    "1f6c1":[["\uD83D\uDEC1"],"Objects",1388,["bathtub"],38,27,"1.0","household"],
    "1f6c2":[["\uD83D\uDEC2"],"Symbols",1421,["passport_control"],38,28,"1.0","transport-sign"],
    "1f6c3":[["\uD83D\uDEC3"],"Symbols",1422,["customs"],38,29,"1.0","transport-sign"],
    "1f6c4":[["\uD83D\uDEC4"],"Symbols",1423,["baggage_claim"],38,30,"1.0","transport-sign"],
    "1f6c5":[["\uD83D\uDEC5"],"Symbols",1424,["left_luggage"],38,31,"1.0","transport-sign"],
    "1f6cb-fe0f":[["\uD83D\uDECB\uFE0F"],"Objects",1383,["couch_and_lamp"],38,32,"0.7","household"],
    "1f6cc":[["\uD83D\uDECC"],"People & Body",506,["sleeping_accommodation"],38,33,"1.0","person-resting"],
    "1f6cd-fe0f":[["\uD83D\uDECD\uFE0F"],"Objects",1174,["shopping_bags"],38,39,"0.7","clothing"],
    "1f6ce-fe0f":[["\uD83D\uDECE\uFE0F"],"Travel & Places",985,["bellhop_bell"],38,40,"0.7","hotel"],
    "1f6cf-fe0f":[["\uD83D\uDECF\uFE0F"],"Objects",1382,["bed"],38,41,"0.7","household"],
    "1f6d0":[["\uD83D\uDED0"],"Symbols",1459,["place_of_worship"],38,42,"1.0","religion"],
    "1f6d1":[["\uD83D\uDED1"],"Travel & Places",961,["octagonal_sign"],38,43,"3.0","transport-ground"],
    "1f6d2":[["\uD83D\uDED2"],"Objects",1402,["shopping_trolley"],38,44,"3.0","household"],
    "1f6d5":[["\uD83D\uDED5"],"Travel & Places",892,["hindu_temple"],38,45,"12.0","place-religious"],
    "1f6d6":[["\uD83D\uDED6"],"Travel & Places",869,["hut"],38,46,"13.0","place-building"],
    "1f6d7":[["\uD83D\uDED7"],"Objects",1379,["elevator"],38,47,"13.0","household"],
    "1f6dc":[["\uD83D\uDEDC"],"Symbols",1507,["wireless"],38,48,"15.0","av-symbol"],
    "1f6dd":[["\uD83D\uDEDD"],"Travel & Places",908,["playground_slide"],38,49,"14.0","place-other"],
    "1f6de":[["\uD83D\uDEDE"],"Travel & Places",957,["wheel"],38,50,"14.0","transport-ground"],
    "1f6df":[["\uD83D\uDEDF"],"Travel & Places",964,["ring_buoy"],38,51,"14.0","transport-water"],
    "1f6e0-fe0f":[["\uD83D\uDEE0\uFE0F"],"Objects",1342,["hammer_and_wrench"],38,52,"0.7","tool"],
    "1f6e1-fe0f":[["\uD83D\uDEE1\uFE0F"],"Objects",1348,["shield"],38,53,"0.7","tool"],
    "1f6e2-fe0f":[["\uD83D\uDEE2\uFE0F"],"Travel & Places",955,["oil_drum"],38,54,"0.7","transport-ground"],
    "1f6e3-fe0f":[["\uD83D\uDEE3\uFE0F"],"Travel & Places",953,["motorway"],38,55,"0.7","transport-ground"],
    "1f6e4-fe0f":[["\uD83D\uDEE4\uFE0F"],"Travel & Places",954,["railway_track"],38,56,"0.7","transport-ground"],
    "1f6e5-fe0f":[["\uD83D\uDEE5\uFE0F"],"Travel & Places",970,["motor_boat"],38,57,"0.7","transport-water"],
    "1f6e9-fe0f":[["\uD83D\uDEE9\uFE0F"],"Travel & Places",973,["small_airplane"],38,58,"0.7","transport-air"],
    "1f6eb":[["\uD83D\uDEEB"],"Travel & Places",974,["airplane_departure"],38,59,"1.0","transport-air"],
    "1f6ec":[["\uD83D\uDEEC"],"Travel & Places",975,["airplane_arriving"],38,60,"1.0","transport-air"],
    "1f6f0-fe0f":[["\uD83D\uDEF0\uFE0F"],"Travel & Places",982,["satellite"],38,61,"0.7","transport-air"],
    "1f6f3-fe0f":[["\uD83D\uDEF3\uFE0F"],"Travel & Places",968,["passenger_ship"],39,0,"0.7","transport-water"],
    "1f6f4":[["\uD83D\uDEF4"],"Travel & Places",949,["scooter"],39,1,"3.0","transport-ground"],
    "1f6f5":[["\uD83D\uDEF5"],"Travel & Places",944,["motor_scooter"],39,2,"3.0","transport-ground"],
    "1f6f6":[["\uD83D\uDEF6"],"Travel & Places",966,["canoe"],39,3,"3.0","transport-water"],
    "1f6f7":[["\uD83D\uDEF7"],"Activities",1117,["sled"],39,4,"5.0","sport"],
    "1f6f8":[["\uD83D\uDEF8"],"Travel & Places",984,["flying_saucer"],39,5,"5.0","transport-air"],
    "1f6f9":[["\uD83D\uDEF9"],"Travel & Places",950,["skateboard"],39,6,"11.0","transport-ground"],
    "1f6fa":[["\uD83D\uDEFA"],"Travel & Places",947,["auto_rickshaw"],39,7,"12.0","transport-ground"],
    "1f6fb":[["\uD83D\uDEFB"],"Travel & Places",938,["pickup_truck"],39,8,"13.0","transport-ground"],
    "1f6fc":[["\uD83D\uDEFC"],"Travel & Places",951,["roller_skate"],39,9,"13.0","transport-ground"],
    "1f7e0":[["\uD83D\uDFE0"],"Symbols",1602,["large_orange_circle"],39,10,"12.0","geometric"],
    "1f7e1":[["\uD83D\uDFE1"],"Symbols",1603,["large_yellow_circle"],39,11,"12.0","geometric"],
    "1f7e2":[["\uD83D\uDFE2"],"Symbols",1604,["large_green_circle"],39,12,"12.0","geometric"],
    "1f7e3":[["\uD83D\uDFE3"],"Symbols",1606,["large_purple_circle"],39,13,"12.0","geometric"],
    "1f7e4":[["\uD83D\uDFE4"],"Symbols",1607,["large_brown_circle"],39,14,"12.0","geometric"],
    "1f7e5":[["\uD83D\uDFE5"],"Symbols",1610,["large_red_square"],39,15,"12.0","geometric"],
    "1f7e6":[["\uD83D\uDFE6"],"Symbols",1614,["large_blue_square"],39,16,"12.0","geometric"],
    "1f7e7":[["\uD83D\uDFE7"],"Symbols",1611,["large_orange_square"],39,17,"12.0","geometric"],
    "1f7e8":[["\uD83D\uDFE8"],"Symbols",1612,["large_yellow_square"],39,18,"12.0","geometric"],
    "1f7e9":[["\uD83D\uDFE9"],"Symbols",1613,["large_green_square"],39,19,"12.0","geometric"],
    "1f7ea":[["\uD83D\uDFEA"],"Symbols",1615,["large_purple_square"],39,20,"12.0","geometric"],
    "1f7eb":[["\uD83D\uDFEB"],"Symbols",1616,["large_brown_square"],39,21,"12.0","geometric"],
    "1f7f0":[["\uD83D\uDFF0"],"Symbols",1517,["heavy_equals_sign"],39,22,"14.0","math"],
    "1f90c":[["\uD83E\uDD0C"],"People & Body",181,["pinched_fingers"],39,23,"13.0","hand-fingers-partial"],
    "1f90d":[["\uD83E\uDD0D"],"Smileys & Emotion",154,["white_heart"],39,29,"12.0","heart"],
    "1f90e":[["\uD83E\uDD0E"],"Smileys & Emotion",151,["brown_heart"],39,30,"12.0","heart"],
    "1f90f":[["\uD83E\uDD0F"],"People & Body",182,["pinching_hand"],39,31,"12.0","hand-fingers-partial"],
    "1f910":[["\uD83E\uDD10"],"Smileys & Emotion",37,["zipper_mouth_face"],39,37,"1.0","face-neutral-skeptical"],
    "1f911":[["\uD83E\uDD11"],"Smileys & Emotion",29,["money_mouth_face"],39,38,"1.0","face-tongue"],
    "1f912":[["\uD83E\uDD12"],"Smileys & Emotion",59,["face_with_thermometer"],39,39,"1.0","face-unwell"],
    "1f913":[["\uD83E\uDD13"],"Smileys & Emotion",74,["nerd_face"],39,40,"1.0","face-glasses"],
    "1f914":[["\uD83E\uDD14"],"Smileys & Emotion",35,["thinking_face"],39,41,"1.0","face-hand"],
    "1f915":[["\uD83E\uDD15"],"Smileys & Emotion",60,["face_with_head_bandage"],39,42,"1.0","face-unwell"],
    "1f916":[["\uD83E\uDD16"],"Smileys & Emotion",117,["robot_face"],39,43,"1.0","face-costume"],
    "1f917":[["\uD83E\uDD17"],"Smileys & Emotion",30,["hugging_face"],39,44,"1.0","face-hand"],
    "1f918":[["\uD83E\uDD18"],"People & Body",187,["the_horns","sign_of_the_horns"],39,45,"1.0","hand-fingers-partial"],
    "1f919":[["\uD83E\uDD19"],"People & Body",188,["call_me_hand"],39,51,"3.0","hand-fingers-partial"],
    "1f91a":[["\uD83E\uDD1A"],"People & Body",170,["raised_back_of_hand"],39,57,"3.0","hand-fingers-open"],
    "1f91b":[["\uD83E\uDD1B"],"People & Body",200,["left-facing_fist"],40,1,"3.0","hand-fingers-closed"],
    "1f91c":[["\uD83E\uDD1C"],"People & Body",201,["right-facing_fist"],40,7,"3.0","hand-fingers-closed"],
    "1f91d":[["\uD83E\uDD1D"],"People & Body",207,["handshake"],40,13,"3.0","hands"],
    "1f91e":[["\uD83E\uDD1E"],"People & Body",184,["crossed_fingers","hand_with_index_and_middle_fingers_crossed"],40,39,"3.0","hand-fingers-partial"],
    "1f91f":[["\uD83E\uDD1F"],"People & Body",186,["i_love_you_hand_sign"],40,45,"5.0","hand-fingers-partial"],
    "1f920":[["\uD83E\uDD20"],"Smileys & Emotion",70,["face_with_cowboy_hat"],40,51,"3.0","face-hat"],
    "1f921":[["\uD83E\uDD21"],"Smileys & Emotion",111,["clown_face"],40,52,"3.0","face-costume"],
    "1f922":[["\uD83E\uDD22"],"Smileys & Emotion",61,["nauseated_face"],40,53,"3.0","face-unwell"],
    "1f923":[["\uD83E\uDD23"],"Smileys & Emotion",7,["rolling_on_the_floor_laughing"],40,54,"3.0","face-smiling"],
    "1f924":[["\uD83E\uDD24"],"Smileys & Emotion",56,["drooling_face"],40,55,"3.0","face-sleepy"],
    "1f925":[["\uD83E\uDD25"],"Smileys & Emotion",49,["lying_face"],40,56,"3.0","face-neutral-skeptical"],
    "1f926-200d-2640-fe0f":[["\uD83E\uDD26\u200D\u2640\uFE0F"],"People & Body",284,["woman-facepalming"],40,57,"4.0","person-gesture"],
    "1f926-200d-2642-fe0f":[["\uD83E\uDD26\u200D\u2642\uFE0F"],"People & Body",283,["man-facepalming"],41,1,"4.0","person-gesture"],
    "1f926":[["\uD83E\uDD26"],"People & Body",282,["face_palm"],41,7,"3.0","person-gesture"],
    "1f927":[["\uD83E\uDD27"],"Smileys & Emotion",63,["sneezing_face"],41,13,"3.0","face-unwell"],
    "1f928":[["\uD83E\uDD28"],"Smileys & Emotion",38,["face_with_raised_eyebrow","face_with_one_eyebrow_raised"],41,14,"5.0","face-neutral-skeptical"],
    "1f929":[["\uD83E\uDD29"],"Smileys & Emotion",17,["star-struck","grinning_face_with_star_eyes"],41,15,"5.0","face-affection"],
    "1f92a":[["\uD83E\uDD2A"],"Smileys & Emotion",27,["zany_face","grinning_face_with_one_large_and_one_small_eye"],41,16,"5.0","face-tongue"],
    "1f92b":[["\uD83E\uDD2B"],"Smileys & Emotion",34,["shushing_face","face_with_finger_covering_closed_lips"],41,17,"5.0","face-hand"],
    "1f92c":[["\uD83E\uDD2C"],"Smileys & Emotion",105,["face_with_symbols_on_mouth","serious_face_with_symbols_covering_mouth"],41,18,"5.0","face-negative"],
    "1f92d":[["\uD83E\uDD2D"],"Smileys & Emotion",31,["face_with_hand_over_mouth","smiling_face_with_smiling_eyes_and_hand_covering_mouth"],41,19,"5.0","face-hand"],
    "1f92e":[["\uD83E\uDD2E"],"Smileys & Emotion",62,["face_vomiting","face_with_open_mouth_vomiting"],41,20,"5.0","face-unwell"],
    "1f92f":[["\uD83E\uDD2F"],"Smileys & Emotion",69,["exploding_head","shocked_face_with_exploding_head"],41,21,"5.0","face-unwell"],
    "1f930":[["\uD83E\uDD30"],"People & Body",363,["pregnant_woman"],41,22,"3.0","person-role"],
    "1f931":[["\uD83E\uDD31"],"People & Body",366,["breast-feeding"],41,28,"5.0","person-role"],
    "1f932":[["\uD83E\uDD32"],"People & Body",206,["palms_up_together"],41,34,"5.0","hands"],
    "1f933":[["\uD83E\uDD33"],"People & Body",211,["selfie"],41,40,"3.0","hand-prop"],
    "1f934":[["\uD83E\uDD34"],"People & Body",350,["prince"],41,46,"3.0","person-role"],
    "1f935-200d-2640-fe0f":[["\uD83E\uDD35\u200D\u2640\uFE0F"],"People & Body",359,["woman_in_tuxedo"],41,52,"13.0","person-role"],
    "1f935-200d-2642-fe0f":[["\uD83E\uDD35\u200D\u2642\uFE0F"],"People & Body",358,["man_in_tuxedo"],41,58,"13.0","person-role"],
    "1f935":[["\uD83E\uDD35"],"People & Body",357,["person_in_tuxedo"],42,2,"3.0","person-role"],
    "1f936":[["\uD83E\uDD36"],"People & Body",372,["mrs_claus","mother_christmas"],42,8,"3.0","person-fantasy"],
    "1f937-200d-2640-fe0f":[["\uD83E\uDD37\u200D\u2640\uFE0F"],"People & Body",287,["woman-shrugging"],42,14,"4.0","person-gesture"],
    "1f937-200d-2642-fe0f":[["\uD83E\uDD37\u200D\u2642\uFE0F"],"People & Body",286,["man-shrugging"],42,20,"4.0","person-gesture"],
    "1f937":[["\uD83E\uDD37"],"People & Body",285,["shrug"],42,26,"3.0","person-gesture"],
    "1f938-200d-2640-fe0f":[["\uD83E\uDD38\u200D\u2640\uFE0F"],"People & Body",489,["woman-cartwheeling"],42,32,"4.0","person-sport"],
    "1f938-200d-2642-fe0f":[["\uD83E\uDD38\u200D\u2642\uFE0F"],"People & Body",488,["man-cartwheeling"],42,38,"4.0","person-sport"],
    "1f938":[["\uD83E\uDD38"],"People & Body",487,["person_doing_cartwheel"],42,44,"3.0","person-sport"],
    "1f939-200d-2640-fe0f":[["\uD83E\uDD39\u200D\u2640\uFE0F"],"People & Body",501,["woman-juggling"],42,50,"4.0","person-sport"],
    "1f939-200d-2642-fe0f":[["\uD83E\uDD39\u200D\u2642\uFE0F"],"People & Body",500,["man-juggling"],42,56,"4.0","person-sport"],
    "1f939":[["\uD83E\uDD39"],"People & Body",499,["juggling"],43,0,"3.0","person-sport"],
    "1f93a":[["\uD83E\uDD3A"],"People & Body",459,["fencer"],43,6,"3.0","person-sport"],
    "1f93c-200d-2640-fe0f":[["\uD83E\uDD3C\u200D\u2640\uFE0F"],"People & Body",492,["woman-wrestling"],43,7,"4.0","person-sport"],
    "1f93c-200d-2642-fe0f":[["\uD83E\uDD3C\u200D\u2642\uFE0F"],"People & Body",491,["man-wrestling"],43,8,"4.0","person-sport"],
    "1f93c":[["\uD83E\uDD3C"],"People & Body",490,["wrestlers"],43,9,"3.0","person-sport"],
    "1f93d-200d-2640-fe0f":[["\uD83E\uDD3D\u200D\u2640\uFE0F"],"People & Body",495,["woman-playing-water-polo"],43,10,"4.0","person-sport"],
    "1f93d-200d-2642-fe0f":[["\uD83E\uDD3D\u200D\u2642\uFE0F"],"People & Body",494,["man-playing-water-polo"],43,16,"4.0","person-sport"],
    "1f93d":[["\uD83E\uDD3D"],"People & Body",493,["water_polo"],43,22,"3.0","person-sport"],
    "1f93e-200d-2640-fe0f":[["\uD83E\uDD3E\u200D\u2640\uFE0F"],"People & Body",498,["woman-playing-handball"],43,28,"4.0","person-sport"],
    "1f93e-200d-2642-fe0f":[["\uD83E\uDD3E\u200D\u2642\uFE0F"],"People & Body",497,["man-playing-handball"],43,34,"4.0","person-sport"],
    "1f93e":[["\uD83E\uDD3E"],"People & Body",496,["handball"],43,40,"3.0","person-sport"],
    "1f93f":[["\uD83E\uDD3F"],"Activities",1114,["diving_mask"],43,46,"12.0","sport"],
    "1f940":[["\uD83E\uDD40"],"Animals & Nature",690,["wilted_flower"],43,47,"3.0","plant-flower"],
    "1f941":[["\uD83E\uDD41"],"Objects",1222,["drum_with_drumsticks"],43,48,"3.0","musical-instrument"],
    "1f942":[["\uD83E\uDD42"],"Food & Drink",832,["clinking_glasses"],43,49,"3.0","drink"],
    "1f943":[["\uD83E\uDD43"],"Food & Drink",833,["tumbler_glass"],43,50,"3.0","drink"],
    "1f944":[["\uD83E\uDD44"],"Food & Drink",843,["spoon"],43,51,"3.0","dishware"],
    "1f945":[["\uD83E\uDD45"],"Activities",1110,["goal_net"],43,52,"3.0","sport"],
    "1f947":[["\uD83E\uDD47"],"Activities",1089,["first_place_medal"],43,53,"3.0","award-medal"],
    "1f948":[["\uD83E\uDD48"],"Activities",1090,["second_place_medal"],43,54,"3.0","award-medal"],
    "1f949":[["\uD83E\uDD49"],"Activities",1091,["third_place_medal"],43,55,"3.0","award-medal"],
    "1f94a":[["\uD83E\uDD4A"],"Activities",1108,["boxing_glove"],43,56,"3.0","sport"],
    "1f94b":[["\uD83E\uDD4B"],"Activities",1109,["martial_arts_uniform"],43,57,"3.0","sport"],
    "1f94c":[["\uD83E\uDD4C"],"Activities",1118,["curling_stone"],43,58,"5.0","sport"],
    "1f94d":[["\uD83E\uDD4D"],"Activities",1105,["lacrosse"],43,59,"11.0","sport"],
    "1f94e":[["\uD83E\uDD4E"],"Activities",1094,["softball"],43,60,"11.0","sport"],
    "1f94f":[["\uD83E\uDD4F"],"Activities",1100,["flying_disc"],43,61,"11.0","sport"],
    "1f950":[["\uD83E\uDD50"],"Food & Drink",751,["croissant"],44,0,"3.0","food-prepared"],
    "1f951":[["\uD83E\uDD51"],"Food & Drink",732,["avocado"],44,1,"3.0","food-vegetable"],
    "1f952":[["\uD83E\uDD52"],"Food & Drink",739,["cucumber"],44,2,"3.0","food-vegetable"],
    "1f953":[["\uD83E\uDD53"],"Food & Drink",762,["bacon"],44,3,"3.0","food-prepared"],
    "1f954":[["\uD83E\uDD54"],"Food & Drink",734,["potato"],44,4,"3.0","food-vegetable"],
    "1f955":[["\uD83E\uDD55"],"Food & Drink",735,["carrot"],44,5,"3.0","food-vegetable"],
    "1f956":[["\uD83E\uDD56"],"Food & Drink",752,["baguette_bread"],44,6,"3.0","food-prepared"],
    "1f957":[["\uD83E\uDD57"],"Food & Drink",779,["green_salad"],44,7,"3.0","food-prepared"],
    "1f958":[["\uD83E\uDD58"],"Food & Drink",775,["shallow_pan_of_food"],44,8,"3.0","food-prepared"],
    "1f959":[["\uD83E\uDD59"],"Food & Drink",771,["stuffed_flatbread"],44,9,"3.0","food-prepared"],
    "1f95a":[["\uD83E\uDD5A"],"Food & Drink",773,["egg"],44,10,"3.0","food-prepared"],
    "1f95b":[["\uD83E\uDD5B"],"Food & Drink",821,["glass_of_milk"],44,11,"3.0","drink"],
    "1f95c":[["\uD83E\uDD5C"],"Food & Drink",744,["peanuts"],44,12,"3.0","food-vegetable"],
    "1f95d":[["\uD83E\uDD5D"],"Food & Drink",728,["kiwifruit"],44,13,"3.0","food-fruit"],
    "1f95e":[["\uD83E\uDD5E"],"Food & Drink",756,["pancakes"],44,14,"3.0","food-prepared"],
    "1f95f":[["\uD83E\uDD5F"],"Food & Drink",798,["dumpling"],44,15,"5.0","food-asian"],
    "1f960":[["\uD83E\uDD60"],"Food & Drink",799,["fortune_cookie"],44,16,"5.0","food-asian"],
    "1f961":[["\uD83E\uDD61"],"Food & Drink",800,["takeout_box"],44,17,"5.0","food-asian"],
    "1f962":[["\uD83E\uDD62"],"Food & Drink",840,["chopsticks"],44,18,"5.0","dishware"],
    "1f963":[["\uD83E\uDD63"],"Food & Drink",778,["bowl_with_spoon"],44,19,"5.0","food-prepared"],
    "1f964":[["\uD83E\uDD64"],"Food & Drink",835,["cup_with_straw"],44,20,"5.0","drink"],
    "1f965":[["\uD83E\uDD65"],"Food & Drink",731,["coconut"],44,21,"5.0","food-fruit"],
    "1f966":[["\uD83E\uDD66"],"Food & Drink",741,["broccoli"],44,22,"5.0","food-vegetable"],
    "1f967":[["\uD83E\uDD67"],"Food & Drink",814,["pie"],44,23,"5.0","food-sweet"],
    "1f968":[["\uD83E\uDD68"],"Food & Drink",754,["pretzel"],44,24,"5.0","food-prepared"],
    "1f969":[["\uD83E\uDD69"],"Food & Drink",761,["cut_of_meat"],44,25,"5.0","food-prepared"],
    "1f96a":[["\uD83E\uDD6A"],"Food & Drink",767,["sandwich"],44,26,"5.0","food-prepared"],
    "1f96b":[["\uD83E\uDD6B"],"Food & Drink",783,["canned_food"],44,27,"5.0","food-prepared"],
    "1f96c":[["\uD83E\uDD6C"],"Food & Drink",740,["leafy_green"],44,28,"11.0","food-vegetable"],
    "1f96d":[["\uD83E\uDD6D"],"Food & Drink",720,["mango"],44,29,"11.0","food-fruit"],
    "1f96e":[["\uD83E\uDD6E"],"Food & Drink",796,["moon_cake"],44,30,"11.0","food-asian"],
    "1f96f":[["\uD83E\uDD6F"],"Food & Drink",755,["bagel"],44,31,"11.0","food-prepared"],
    "1f970":[["\uD83E\uDD70"],"Smileys & Emotion",15,["smiling_face_with_3_hearts"],44,32,"11.0","face-affection"],
    "1f971":[["\uD83E\uDD71"],"Smileys & Emotion",101,["yawning_face"],44,33,"12.0","face-concerned"],
    "1f972":[["\uD83E\uDD72"],"Smileys & Emotion",23,["smiling_face_with_tear"],44,34,"13.0","face-affection"],
    "1f973":[["\uD83E\uDD73"],"Smileys & Emotion",71,["partying_face"],44,35,"11.0","face-hat"],
    "1f974":[["\uD83E\uDD74"],"Smileys & Emotion",66,["woozy_face"],44,36,"11.0","face-unwell"],
    "1f975":[["\uD83E\uDD75"],"Smileys & Emotion",64,["hot_face"],44,37,"11.0","face-unwell"],
    "1f976":[["\uD83E\uDD76"],"Smileys & Emotion",65,["cold_face"],44,38,"11.0","face-unwell"],
    "1f977":[["\uD83E\uDD77"],"People & Body",345,["ninja"],44,39,"13.0","person-role"],
    "1f978":[["\uD83E\uDD78"],"Smileys & Emotion",72,["disguised_face"],44,45,"13.0","face-hat"],
    "1f979":[["\uD83E\uDD79"],"Smileys & Emotion",86,["face_holding_back_tears"],44,46,"14.0","face-concerned"],
    "1f97a":[["\uD83E\uDD7A"],"Smileys & Emotion",85,["pleading_face"],44,47,"11.0","face-concerned"],
    "1f97b":[["\uD83E\uDD7B"],"Objects",1164,["sari"],44,48,"12.0","clothing"],
    "1f97c":[["\uD83E\uDD7C"],"Objects",1153,["lab_coat"],44,49,"11.0","clothing"],
    "1f97d":[["\uD83E\uDD7D"],"Objects",1152,["goggles"],44,50,"11.0","clothing"],
    "1f97e":[["\uD83E\uDD7E"],"Objects",1179,["hiking_boot"],44,51,"11.0","clothing"],
    "1f97f":[["\uD83E\uDD7F"],"Objects",1180,["womans_flat_shoe"],44,52,"11.0","clothing"],
    "1f980":[["\uD83E\uDD80"],"Food & Drink",801,["crab"],44,53,"1.0","food-marine"],
    "1f981":[["\uD83E\uDD81"],"Animals & Nature",574,["lion_face"],44,54,"1.0","animal-mammal"],
    "1f982":[["\uD83E\uDD82"],"Animals & Nature",679,["scorpion"],44,55,"1.0","animal-bug"],
    "1f983":[["\uD83E\uDD83"],"Animals & Nature",625,["turkey"],44,56,"1.0","animal-bird"],
    "1f984":[["\uD83E\uDD84"],"Animals & Nature",582,["unicorn_face"],44,57,"1.0","animal-mammal"],
    "1f985":[["\uD83E\uDD85"],"Animals & Nature",634,["eagle"],44,58,"3.0","animal-bird"],
    "1f986":[["\uD83E\uDD86"],"Animals & Nature",635,["duck"],44,59,"3.0","animal-bird"],
    "1f987":[["\uD83E\uDD87"],"Animals & Nature",614,["bat"],44,60,"3.0","animal-mammal"],
    "1f988":[["\uD83E\uDD88"],"Animals & Nature",663,["shark"],44,61,"3.0","animal-marine"],
    "1f989":[["\uD83E\uDD89"],"Animals & Nature",637,["owl"],45,0,"3.0","animal-bird"],
    "1f98a":[["\uD83E\uDD8A"],"Animals & Nature",569,["fox_face"],45,1,"3.0","animal-mammal"],
    "1f98b":[["\uD83E\uDD8B"],"Animals & Nature",669,["butterfly"],45,2,"3.0","animal-bug"],
    "1f98c":[["\uD83E\uDD8C"],"Animals & Nature",584,["deer"],45,3,"3.0","animal-mammal"],
    "1f98d":[["\uD83E\uDD8D"],"Animals & Nature",561,["gorilla"],45,4,"3.0","animal-mammal"],
    "1f98e":[["\uD83E\uDD8E"],"Animals & Nature",650,["lizard"],45,5,"3.0","animal-reptile"],
    "1f98f":[["\uD83E\uDD8F"],"Animals & Nature",603,["rhinoceros"],45,6,"3.0","animal-mammal"],
    "1f990":[["\uD83E\uDD90"],"Food & Drink",803,["shrimp"],45,7,"3.0","food-marine"],
    "1f991":[["\uD83E\uDD91"],"Food & Drink",804,["squid"],45,8,"3.0","food-marine"],
    "1f992":[["\uD83E\uDD92"],"Animals & Nature",600,["giraffe_face"],45,9,"5.0","animal-mammal"],
    "1f993":[["\uD83E\uDD93"],"Animals & Nature",583,["zebra_face"],45,10,"5.0","animal-mammal"],
    "1f994":[["\uD83E\uDD94"],"Animals & Nature",613,["hedgehog"],45,11,"5.0","animal-mammal"],
    "1f995":[["\uD83E\uDD95"],"Animals & Nature",654,["sauropod"],45,12,"5.0","animal-reptile"],
    "1f996":[["\uD83E\uDD96"],"Animals & Nature",655,["t-rex"],45,13,"5.0","animal-reptile"],
    "1f997":[["\uD83E\uDD97"],"Animals & Nature",675,["cricket"],45,14,"5.0","animal-bug"],
    "1f998":[["\uD83E\uDD98"],"Animals & Nature",622,["kangaroo"],45,15,"11.0","animal-mammal"],
    "1f999":[["\uD83E\uDD99"],"Animals & Nature",599,["llama"],45,16,"11.0","animal-mammal"],
    "1f99a":[["\uD83E\uDD9A"],"Animals & Nature",641,["peacock"],45,17,"11.0","animal-bird"],
    "1f99b":[["\uD83E\uDD9B"],"Animals & Nature",604,["hippopotamus"],45,18,"11.0","animal-mammal"],
    "1f99c":[["\uD83E\uDD9C"],"Animals & Nature",642,["parrot"],45,19,"11.0","animal-bird"],
    "1f99d":[["\uD83E\uDD9D"],"Animals & Nature",570,["raccoon"],45,20,"11.0","animal-mammal"],
    "1f99e":[["\uD83E\uDD9E"],"Food & Drink",802,["lobster"],45,21,"11.0","food-marine"],
    "1f99f":[["\uD83E\uDD9F"],"Animals & Nature",680,["mosquito"],45,22,"11.0","animal-bug"],
    "1f9a0":[["\uD83E\uDDA0"],"Animals & Nature",683,["microbe"],45,23,"11.0","animal-bug"],
    "1f9a1":[["\uD83E\uDDA1"],"Animals & Nature",623,["badger"],45,24,"11.0","animal-mammal"],
    "1f9a2":[["\uD83E\uDDA2"],"Animals & Nature",636,["swan"],45,25,"11.0","animal-bird"],
    "1f9a3":[["\uD83E\uDDA3"],"Animals & Nature",602,["mammoth"],45,26,"13.0","animal-mammal"],
    "1f9a4":[["\uD83E\uDDA4"],"Animals & Nature",638,["dodo"],45,27,"13.0","animal-bird"],
    "1f9a5":[["\uD83E\uDDA5"],"Animals & Nature",619,["sloth"],45,28,"12.0","animal-mammal"],
    "1f9a6":[["\uD83E\uDDA6"],"Animals & Nature",620,["otter"],45,29,"12.0","animal-mammal"],
    "1f9a7":[["\uD83E\uDDA7"],"Animals & Nature",562,["orangutan"],45,30,"12.0","animal-mammal"],
    "1f9a8":[["\uD83E\uDDA8"],"Animals & Nature",621,["skunk"],45,31,"12.0","animal-mammal"],
    "1f9a9":[["\uD83E\uDDA9"],"Animals & Nature",640,["flamingo"],45,32,"12.0","animal-bird"],
    "1f9aa":[["\uD83E\uDDAA"],"Food & Drink",805,["oyster"],45,33,"12.0","food-marine"],
    "1f9ab":[["\uD83E\uDDAB"],"Animals & Nature",612,["beaver"],45,34,"13.0","animal-mammal"],
    "1f9ac":[["\uD83E\uDDAC"],"Animals & Nature",585,["bison"],45,35,"13.0","animal-mammal"],
    "1f9ad":[["\uD83E\uDDAD"],"Animals & Nature",659,["seal"],45,36,"13.0","animal-marine"],
    "1f9ae":[["\uD83E\uDDAE"],"Animals & Nature",565,["guide_dog"],45,37,"12.0","animal-mammal"],
    "1f9af":[["\uD83E\uDDAF"],"Objects",1356,["probing_cane"],45,38,"12.0","tool"],
    "1f9b4":[["\uD83E\uDDB4"],"People & Body",224,["bone"],45,39,"11.0","body-parts"],
    "1f9b5":[["\uD83E\uDDB5"],"People & Body",215,["leg"],45,40,"11.0","body-parts"],
    "1f9b6":[["\uD83E\uDDB6"],"People & Body",216,["foot"],45,46,"11.0","body-parts"],
    "1f9b7":[["\uD83E\uDDB7"],"People & Body",223,["tooth"],45,52,"11.0","body-parts"],
    "1f9b8-200d-2640-fe0f":[["\uD83E\uDDB8\u200D\u2640\uFE0F"],"People & Body",376,["female_superhero"],45,53,"11.0","person-fantasy"],
    "1f9b8-200d-2642-fe0f":[["\uD83E\uDDB8\u200D\u2642\uFE0F"],"People & Body",375,["male_superhero"],45,59,"11.0","person-fantasy"],
    "1f9b8":[["\uD83E\uDDB8"],"People & Body",374,["superhero"],46,3,"11.0","person-fantasy"],
    "1f9b9-200d-2640-fe0f":[["\uD83E\uDDB9\u200D\u2640\uFE0F"],"People & Body",379,["female_supervillain"],46,9,"11.0","person-fantasy"],
    "1f9b9-200d-2642-fe0f":[["\uD83E\uDDB9\u200D\u2642\uFE0F"],"People & Body",378,["male_supervillain"],46,15,"11.0","person-fantasy"],
    "1f9b9":[["\uD83E\uDDB9"],"People & Body",377,["supervillain"],46,21,"11.0","person-fantasy"],
    "1f9ba":[["\uD83E\uDDBA"],"Objects",1154,["safety_vest"],46,27,"12.0","clothing"],
    "1f9bb":[["\uD83E\uDDBB"],"People & Body",218,["ear_with_hearing_aid"],46,28,"12.0","body-parts"],
    "1f9bc":[["\uD83E\uDDBC"],"Travel & Places",946,["motorized_wheelchair"],46,34,"12.0","transport-ground"],
    "1f9bd":[["\uD83E\uDDBD"],"Travel & Places",945,["manual_wheelchair"],46,35,"12.0","transport-ground"],
    "1f9be":[["\uD83E\uDDBE"],"People & Body",213,["mechanical_arm"],46,36,"12.0","body-parts"],
    "1f9bf":[["\uD83E\uDDBF"],"People & Body",214,["mechanical_leg"],46,37,"12.0","body-parts"],
    "1f9c0":[["\uD83E\uDDC0"],"Food & Drink",758,["cheese_wedge"],46,38,"1.0","food-prepared"],
    "1f9c1":[["\uD83E\uDDC1"],"Food & Drink",813,["cupcake"],46,39,"11.0","food-sweet"],
    "1f9c2":[["\uD83E\uDDC2"],"Food & Drink",782,["salt"],46,40,"11.0","food-prepared"],
    "1f9c3":[["\uD83E\uDDC3"],"Food & Drink",837,["beverage_box"],46,41,"12.0","drink"],
    "1f9c4":[["\uD83E\uDDC4"],"Food & Drink",742,["garlic"],46,42,"12.0","food-vegetable"],
    "1f9c5":[["\uD83E\uDDC5"],"Food & Drink",743,["onion"],46,43,"12.0","food-vegetable"],
    "1f9c6":[["\uD83E\uDDC6"],"Food & Drink",772,["falafel"],46,44,"12.0","food-prepared"],
    "1f9c7":[["\uD83E\uDDC7"],"Food & Drink",757,["waffle"],46,45,"12.0","food-prepared"],
    "1f9c8":[["\uD83E\uDDC8"],"Food & Drink",781,["butter"],46,46,"12.0","food-prepared"],
    "1f9c9":[["\uD83E\uDDC9"],"Food & Drink",838,["mate_drink"],46,47,"12.0","drink"],
    "1f9ca":[["\uD83E\uDDCA"],"Food & Drink",839,["ice_cube"],46,48,"12.0","drink"],
    "1f9cb":[["\uD83E\uDDCB"],"Food & Drink",836,["bubble_tea"],46,49,"13.0","drink"],
    "1f9cc":[["\uD83E\uDDCC"],"People & Body",401,["troll"],46,50,"14.0","person-fantasy"],
    "1f9cd-200d-2640-fe0f":[["\uD83E\uDDCD\u200D\u2640\uFE0F"],"People & Body",416,["woman_standing"],46,51,"12.0","person-activity"],
    "1f9cd-200d-2642-fe0f":[["\uD83E\uDDCD\u200D\u2642\uFE0F"],"People & Body",415,["man_standing"],46,57,"12.0","person-activity"],
    "1f9cd":[["\uD83E\uDDCD"],"People & Body",414,["standing_person"],47,1,"12.0","person-activity"],
    "1f9ce-200d-2640-fe0f":[["\uD83E\uDDCE\u200D\u2640\uFE0F"],"People & Body",419,["woman_kneeling"],47,7,"12.0","person-activity"],
    "1f9ce-200d-2640-fe0f-200d-27a1-fe0f":[["\uD83E\uDDCE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"People & Body",421,["woman_kneeling_facing_right"],47,13,"15.1","person-activity"],
    "1f9ce-200d-2642-fe0f":[["\uD83E\uDDCE\u200D\u2642\uFE0F"],"People & Body",418,["man_kneeling"],47,19,"12.0","person-activity"],
    "1f9ce-200d-2642-fe0f-200d-27a1-fe0f":[["\uD83E\uDDCE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"People & Body",422,["man_kneeling_facing_right"],47,25,"15.1","person-activity"],
    "1f9ce-200d-27a1-fe0f":[["\uD83E\uDDCE\u200D\u27A1\uFE0F"],"People & Body",420,["person_kneeling_facing_right"],47,31,"15.1","person-activity"],
    "1f9ce":[["\uD83E\uDDCE"],"People & Body",417,["kneeling_person"],47,37,"12.0","person-activity"],
    "1f9cf-200d-2640-fe0f":[["\uD83E\uDDCF\u200D\u2640\uFE0F"],"People & Body",278,["deaf_woman"],47,43,"12.0","person-gesture"],
    "1f9cf-200d-2642-fe0f":[["\uD83E\uDDCF\u200D\u2642\uFE0F"],"People & Body",277,["deaf_man"],47,49,"12.0","person-gesture"],
    "1f9cf":[["\uD83E\uDDCF"],"People & Body",276,["deaf_person"],47,55,"12.0","person-gesture"],
    "1f9d0":[["\uD83E\uDDD0"],"Smileys & Emotion",75,["face_with_monocle"],47,61,"5.0","face-glasses"],
    "1f9d1-200d-1f33e":[["\uD83E\uDDD1\u200D\uD83C\uDF3E"],"People & Body",300,["farmer"],48,0,"12.1","person-role"],
    "1f9d1-200d-1f373":[["\uD83E\uDDD1\u200D\uD83C\uDF73"],"People & Body",303,["cook"],48,6,"12.1","person-role"],
    "1f9d1-200d-1f37c":[["\uD83E\uDDD1\u200D\uD83C\uDF7C"],"People & Body",369,["person_feeding_baby"],48,12,"13.0","person-role"],
    "1f9d1-200d-1f384":[["\uD83E\uDDD1\u200D\uD83C\uDF84"],"People & Body",373,["mx_claus"],48,18,"13.0","person-fantasy"],
    "1f9d1-200d-1f393":[["\uD83E\uDDD1\u200D\uD83C\uDF93"],"People & Body",291,["student"],48,24,"12.1","person-role"],
    "1f9d1-200d-1f3a4":[["\uD83E\uDDD1\u200D\uD83C\uDFA4"],"People & Body",321,["singer"],48,30,"12.1","person-role"],
    "1f9d1-200d-1f3a8":[["\uD83E\uDDD1\u200D\uD83C\uDFA8"],"People & Body",324,["artist"],48,36,"12.1","person-role"],
    "1f9d1-200d-1f3eb":[["\uD83E\uDDD1\u200D\uD83C\uDFEB"],"People & Body",294,["teacher"],48,42,"12.1","person-role"],
    "1f9d1-200d-1f3ed":[["\uD83E\uDDD1\u200D\uD83C\uDFED"],"People & Body",309,["factory_worker"],48,48,"12.1","person-role"],
    "1f9d1-200d-1f4bb":[["\uD83E\uDDD1\u200D\uD83D\uDCBB"],"People & Body",318,["technologist"],48,54,"12.1","person-role"],
    "1f9d1-200d-1f4bc":[["\uD83E\uDDD1\u200D\uD83D\uDCBC"],"People & Body",312,["office_worker"],48,60,"12.1","person-role"],
    "1f9d1-200d-1f527":[["\uD83E\uDDD1\u200D\uD83D\uDD27"],"People & Body",306,["mechanic"],49,4,"12.1","person-role"],
    "1f9d1-200d-1f52c":[["\uD83E\uDDD1\u200D\uD83D\uDD2C"],"People & Body",315,["scientist"],49,10,"12.1","person-role"],
    "1f9d1-200d-1f680":[["\uD83E\uDDD1\u200D\uD83D\uDE80"],"People & Body",330,["astronaut"],49,16,"12.1","person-role"],
    "1f9d1-200d-1f692":[["\uD83E\uDDD1\u200D\uD83D\uDE92"],"People & Body",333,["firefighter"],49,22,"12.1","person-role"],
    "1f9d1-200d-1f91d-200d-1f9d1":[["\uD83E\uDDD1\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1"],"People & Body",507,["people_holding_hands"],49,28,"12.0","family"],
    "1f9d1-200d-1f9af-200d-27a1-fe0f":[["\uD83E\uDDD1\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"People & Body",424,["person_with_white_cane_facing_right"],49,54,"15.1","person-activity"],
    "1f9d1-200d-1f9af":[["\uD83E\uDDD1\u200D\uD83E\uDDAF"],"People & Body",423,["person_with_probing_cane"],49,60,"12.1","person-activity"],
    "1f9d1-200d-1f9b0":[["\uD83E\uDDD1\u200D\uD83E\uDDB0"],"People & Body",246,["red_haired_person"],50,4,"12.1","person"],
    "1f9d1-200d-1f9b1":[["\uD83E\uDDD1\u200D\uD83E\uDDB1"],"People & Body",248,["curly_haired_person"],50,10,"12.1","person"],
    "1f9d1-200d-1f9b2":[["\uD83E\uDDD1\u200D\uD83E\uDDB2"],"People & Body",252,["bald_person"],50,16,"12.1","person"],
    "1f9d1-200d-1f9b3":[["\uD83E\uDDD1\u200D\uD83E\uDDB3"],"People & Body",250,["white_haired_person"],50,22,"12.1","person"],
    "1f9d1-200d-1f9bc-200d-27a1-fe0f":[["\uD83E\uDDD1\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"People & Body",430,["person_in_motorized_wheelchair_facing_right"],50,28,"15.1","person-activity"],
    "1f9d1-200d-1f9bc":[["\uD83E\uDDD1\u200D\uD83E\uDDBC"],"People & Body",429,["person_in_motorized_wheelchair"],50,34,"12.1","person-activity"],
    "1f9d1-200d-1f9bd-200d-27a1-fe0f":[["\uD83E\uDDD1\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"People & Body",436,["person_in_manual_wheelchair_facing_right"],50,40,"15.1","person-activity"],
    "1f9d1-200d-1f9bd":[["\uD83E\uDDD1\u200D\uD83E\uDDBD"],"People & Body",435,["person_in_manual_wheelchair"],50,46,"12.1","person-activity"],
    "1f9d1-200d-1f9d1-200d-1f9d2":[["\uD83E\uDDD1\u200D\uD83E\uDDD1\u200D\uD83E\uDDD2"],"People & Body",549,["family_adult_adult_child"],50,52,"15.1","person-symbol"],
    "1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2":[["\uD83E\uDDD1\u200D\uD83E\uDDD1\u200D\uD83E\uDDD2\u200D\uD83E\uDDD2"],"People & Body",550,["family_adult_adult_child_child"],50,53,"15.1","person-symbol"],
    "1f9d1-200d-1f9d2-200d-1f9d2":[["\uD83E\uDDD1\u200D\uD83E\uDDD2\u200D\uD83E\uDDD2"],"People & Body",552,["family_adult_child_child"],50,54,"15.1","person-symbol"],
    "1f9d1-200d-1f9d2":[["\uD83E\uDDD1\u200D\uD83E\uDDD2"],"People & Body",551,["family_adult_child"],50,55,"15.1","person-symbol"],
    "1f9d1-200d-2695-fe0f":[["\uD83E\uDDD1\u200D\u2695\uFE0F"],"People & Body",288,["health_worker"],50,56,"12.1","person-role"],
    "1f9d1-200d-2696-fe0f":[["\uD83E\uDDD1\u200D\u2696\uFE0F"],"People & Body",297,["judge"],51,0,"12.1","person-role"],
    "1f9d1-200d-2708-fe0f":[["\uD83E\uDDD1\u200D\u2708\uFE0F"],"People & Body",327,["pilot"],51,6,"12.1","person-role"],
    "1f9d1":[["\uD83E\uDDD1"],"People & Body",234,["adult"],51,12,"5.0","person"],
    "1f9d2":[["\uD83E\uDDD2"],"People & Body",231,["child"],51,18,"5.0","person"],
    "1f9d3":[["\uD83E\uDDD3"],"People & Body",255,["older_adult"],51,24,"5.0","person"],
    "1f9d4-200d-2640-fe0f":[["\uD83E\uDDD4\u200D\u2640\uFE0F"],"People & Body",239,["woman_with_beard"],51,30,"13.1","person"],
    "1f9d4-200d-2642-fe0f":[["\uD83E\uDDD4\u200D\u2642\uFE0F"],"People & Body",238,["man_with_beard"],51,36,"13.1","person"],
    "1f9d4":[["\uD83E\uDDD4"],"People & Body",237,["bearded_person"],51,42,"5.0","person"],
    "1f9d5":[["\uD83E\uDDD5"],"People & Body",356,["person_with_headscarf"],51,48,"5.0","person-role"],
    "1f9d6-200d-2640-fe0f":[["\uD83E\uDDD6\u200D\u2640\uFE0F"],"People & Body",455,["woman_in_steamy_room"],51,54,"5.0","person-activity"],
    "1f9d6-200d-2642-fe0f":[["\uD83E\uDDD6\u200D\u2642\uFE0F","\uD83E\uDDD6"],"People & Body",454,["man_in_steamy_room","person_in_steamy_room"],51,60,"5.0","person-activity"],
    "1f9d7-200d-2640-fe0f":[["\uD83E\uDDD7\u200D\u2640\uFE0F","\uD83E\uDDD7"],"People & Body",458,["woman_climbing","person_climbing"],52,10,"5.0","person-activity"],
    "1f9d7-200d-2642-fe0f":[["\uD83E\uDDD7\u200D\u2642\uFE0F"],"People & Body",457,["man_climbing"],52,16,"5.0","person-activity"],
    "1f9d8-200d-2640-fe0f":[["\uD83E\uDDD8\u200D\u2640\uFE0F","\uD83E\uDDD8"],"People & Body",504,["woman_in_lotus_position","person_in_lotus_position"],52,28,"5.0","person-resting"],
    "1f9d8-200d-2642-fe0f":[["\uD83E\uDDD8\u200D\u2642\uFE0F"],"People & Body",503,["man_in_lotus_position"],52,34,"5.0","person-resting"],
    "1f9d9-200d-2640-fe0f":[["\uD83E\uDDD9\u200D\u2640\uFE0F","\uD83E\uDDD9"],"People & Body",382,["female_mage","mage"],52,46,"5.0","person-fantasy"],
    "1f9d9-200d-2642-fe0f":[["\uD83E\uDDD9\u200D\u2642\uFE0F"],"People & Body",381,["male_mage"],52,52,"5.0","person-fantasy"],
    "1f9da-200d-2640-fe0f":[["\uD83E\uDDDA\u200D\u2640\uFE0F","\uD83E\uDDDA"],"People & Body",385,["female_fairy","fairy"],53,2,"5.0","person-fantasy"],
    "1f9da-200d-2642-fe0f":[["\uD83E\uDDDA\u200D\u2642\uFE0F"],"People & Body",384,["male_fairy"],53,8,"5.0","person-fantasy"],
    "1f9db-200d-2640-fe0f":[["\uD83E\uDDDB\u200D\u2640\uFE0F","\uD83E\uDDDB"],"People & Body",388,["female_vampire","vampire"],53,20,"5.0","person-fantasy"],
    "1f9db-200d-2642-fe0f":[["\uD83E\uDDDB\u200D\u2642\uFE0F"],"People & Body",387,["male_vampire"],53,26,"5.0","person-fantasy"],
    "1f9dc-200d-2640-fe0f":[["\uD83E\uDDDC\u200D\u2640\uFE0F"],"People & Body",391,["mermaid"],53,38,"5.0","person-fantasy"],
    "1f9dc-200d-2642-fe0f":[["\uD83E\uDDDC\u200D\u2642\uFE0F","\uD83E\uDDDC"],"People & Body",390,["merman","merperson"],53,44,"5.0","person-fantasy"],
    "1f9dd-200d-2640-fe0f":[["\uD83E\uDDDD\u200D\u2640\uFE0F"],"People & Body",394,["female_elf"],53,56,"5.0","person-fantasy"],
    "1f9dd-200d-2642-fe0f":[["\uD83E\uDDDD\u200D\u2642\uFE0F","\uD83E\uDDDD"],"People & Body",393,["male_elf","elf"],54,0,"5.0","person-fantasy"],
    "1f9de-200d-2640-fe0f":[["\uD83E\uDDDE\u200D\u2640\uFE0F"],"People & Body",397,["female_genie"],54,12,"5.0","person-fantasy"],
    "1f9de-200d-2642-fe0f":[["\uD83E\uDDDE\u200D\u2642\uFE0F","\uD83E\uDDDE"],"People & Body",396,["male_genie","genie"],54,13,"5.0","person-fantasy"],
    "1f9df-200d-2640-fe0f":[["\uD83E\uDDDF\u200D\u2640\uFE0F"],"People & Body",400,["female_zombie"],54,15,"5.0","person-fantasy"],
    "1f9df-200d-2642-fe0f":[["\uD83E\uDDDF\u200D\u2642\uFE0F","\uD83E\uDDDF"],"People & Body",399,["male_zombie","zombie"],54,16,"5.0","person-fantasy"],
    "1f9e0":[["\uD83E\uDDE0"],"People & Body",220,["brain"],54,18,"5.0","body-parts"],
    "1f9e1":[["\uD83E\uDDE1"],"Smileys & Emotion",145,["orange_heart"],54,19,"5.0","heart"],
    "1f9e2":[["\uD83E\uDDE2"],"Objects",1190,["billed_cap"],54,20,"5.0","clothing"],
    "1f9e3":[["\uD83E\uDDE3"],"Objects",1158,["scarf"],54,21,"5.0","clothing"],
    "1f9e4":[["\uD83E\uDDE4"],"Objects",1159,["gloves"],54,22,"5.0","clothing"],
    "1f9e5":[["\uD83E\uDDE5"],"Objects",1160,["coat"],54,23,"5.0","clothing"],
    "1f9e6":[["\uD83E\uDDE6"],"Objects",1161,["socks"],54,24,"5.0","clothing"],
    "1f9e7":[["\uD83E\uDDE7"],"Activities",1080,["red_envelope"],54,25,"11.0","event"],
    "1f9e8":[["\uD83E\uDDE8"],"Activities",1069,["firecracker"],54,26,"11.0","event"],
    "1f9e9":[["\uD83E\uDDE9"],"Activities",1130,["jigsaw"],54,27,"11.0","game"],
    "1f9ea":[["\uD83E\uDDEA"],"Objects",1365,["test_tube"],54,28,"11.0","science"],
    "1f9eb":[["\uD83E\uDDEB"],"Objects",1366,["petri_dish"],54,29,"11.0","science"],
    "1f9ec":[["\uD83E\uDDEC"],"Objects",1367,["dna"],54,30,"11.0","science"],
    "1f9ed":[["\uD83E\uDDED"],"Travel & Places",853,["compass"],54,31,"11.0","place-map"],
    "1f9ee":[["\uD83E\uDDEE"],"Objects",1245,["abacus"],54,32,"11.0","computer"],
    "1f9ef":[["\uD83E\uDDEF"],"Objects",1401,["fire_extinguisher"],54,33,"11.0","household"],
    "1f9f0":[["\uD83E\uDDF0"],"Objects",1361,["toolbox"],54,34,"11.0","tool"],
    "1f9f1":[["\uD83E\uDDF1"],"Travel & Places",866,["bricks"],54,35,"11.0","place-building"],
    "1f9f2":[["\uD83E\uDDF2"],"Objects",1362,["magnet"],54,36,"11.0","tool"],
    "1f9f3":[["\uD83E\uDDF3"],"Travel & Places",986,["luggage"],54,37,"11.0","hotel"],
    "1f9f4":[["\uD83E\uDDF4"],"Objects",1391,["lotion_bottle"],54,38,"11.0","household"],
    "1f9f5":[["\uD83E\uDDF5"],"Activities",1146,["thread"],54,39,"11.0","arts & crafts"],
    "1f9f6":[["\uD83E\uDDF6"],"Activities",1148,["yarn"],54,40,"11.0","arts & crafts"],
    "1f9f7":[["\uD83E\uDDF7"],"Objects",1392,["safety_pin"],54,41,"11.0","household"],
    "1f9f8":[["\uD83E\uDDF8"],"Activities",1131,["teddy_bear"],54,42,"11.0","game"],
    "1f9f9":[["\uD83E\uDDF9"],"Objects",1393,["broom"],54,43,"11.0","household"],
    "1f9fa":[["\uD83E\uDDFA"],"Objects",1394,["basket"],54,44,"11.0","household"],
    "1f9fb":[["\uD83E\uDDFB"],"Objects",1395,["roll_of_paper"],54,45,"11.0","household"],
    "1f9fc":[["\uD83E\uDDFC"],"Objects",1397,["soap"],54,46,"11.0","household"],
    "1f9fd":[["\uD83E\uDDFD"],"Objects",1400,["sponge"],54,47,"11.0","household"],
    "1f9fe":[["\uD83E\uDDFE"],"Objects",1287,["receipt"],54,48,"11.0","money"],
    "1f9ff":[["\uD83E\uDDFF"],"Objects",1407,["nazar_amulet"],54,49,"11.0","other-object"],
    "1fa70":[["\uD83E\uDE70"],"Objects",1183,["ballet_shoes"],54,50,"12.0","clothing"],
    "1fa71":[["\uD83E\uDE71"],"Objects",1165,["one-piece_swimsuit"],54,51,"12.0","clothing"],
    "1fa72":[["\uD83E\uDE72"],"Objects",1166,["briefs"],54,52,"12.0","clothing"],
    "1fa73":[["\uD83E\uDE73"],"Objects",1167,["shorts"],54,53,"12.0","clothing"],
    "1fa74":[["\uD83E\uDE74"],"Objects",1176,["thong_sandal"],54,54,"13.0","clothing"],
    "1fa75":[["\uD83E\uDE75"],"Smileys & Emotion",149,["light_blue_heart"],54,55,"15.0","heart"],
    "1fa76":[["\uD83E\uDE76"],"Smileys & Emotion",153,["grey_heart"],54,56,"15.0","heart"],
    "1fa77":[["\uD83E\uDE77"],"Smileys & Emotion",144,["pink_heart"],54,57,"15.0","heart"],
    "1fa78":[["\uD83E\uDE78"],"Objects",1372,["drop_of_blood"],54,58,"12.0","medical"],
    "1fa79":[["\uD83E\uDE79"],"Objects",1374,["adhesive_bandage"],54,59,"12.0","medical"],
    "1fa7a":[["\uD83E\uDE7A"],"Objects",1376,["stethoscope"],54,60,"12.0","medical"],
    "1fa7b":[["\uD83E\uDE7B"],"Objects",1377,["x-ray"],54,61,"14.0","medical"],
    "1fa7c":[["\uD83E\uDE7C"],"Objects",1375,["crutch"],55,0,"14.0","medical"],
    "1fa80":[["\uD83E\uDE80"],"Activities",1120,["yo-yo"],55,1,"12.0","game"],
    "1fa81":[["\uD83E\uDE81"],"Activities",1121,["kite"],55,2,"12.0","game"],
    "1fa82":[["\uD83E\uDE82"],"Travel & Places",976,["parachute"],55,3,"12.0","transport-air"],
    "1fa83":[["\uD83E\uDE83"],"Objects",1346,["boomerang"],55,4,"13.0","tool"],
    "1fa84":[["\uD83E\uDE84"],"Activities",1125,["magic_wand"],55,5,"13.0","game"],
    "1fa85":[["\uD83E\uDE85"],"Activities",1132,["pinata"],55,6,"13.0","game"],
    "1fa86":[["\uD83E\uDE86"],"Activities",1134,["nesting_dolls"],55,7,"13.0","game"],
    "1fa87":[["\uD83E\uDE87"],"Objects",1224,["maracas"],55,8,"15.0","musical-instrument"],
    "1fa88":[["\uD83E\uDE88"],"Objects",1225,["flute"],55,9,"15.0","musical-instrument"],
    "1fa90":[["\uD83E\uDE90"],"Travel & Places",1034,["ringed_planet"],55,10,"12.0","sky & weather"],
    "1fa91":[["\uD83E\uDE91"],"Objects",1384,["chair"],55,11,"12.0","household"],
    "1fa92":[["\uD83E\uDE92"],"Objects",1390,["razor"],55,12,"12.0","household"],
    "1fa93":[["\uD83E\uDE93"],"Objects",1339,["axe"],55,13,"12.0","tool"],
    "1fa94":[["\uD83E\uDE94"],"Objects",1261,["diya_lamp"],55,14,"12.0","light & video"],
    "1fa95":[["\uD83E\uDE95"],"Objects",1221,["banjo"],55,15,"12.0","musical-instrument"],
    "1fa96":[["\uD83E\uDE96"],"Objects",1191,["military_helmet"],55,16,"13.0","clothing"],
    "1fa97":[["\uD83E\uDE97"],"Objects",1216,["accordion"],55,17,"13.0","musical-instrument"],
    "1fa98":[["\uD83E\uDE98"],"Objects",1223,["long_drum"],55,18,"13.0","musical-instrument"],
    "1fa99":[["\uD83E\uDE99"],"Objects",1280,["coin"],55,19,"13.0","money"],
    "1fa9a":[["\uD83E\uDE9A"],"Objects",1349,["carpentry_saw"],55,20,"13.0","tool"],
    "1fa9b":[["\uD83E\uDE9B"],"Objects",1351,["screwdriver"],55,21,"13.0","tool"],
    "1fa9c":[["\uD83E\uDE9C"],"Objects",1363,["ladder"],55,22,"13.0","tool"],
    "1fa9d":[["\uD83E\uDE9D"],"Objects",1360,["hook"],55,23,"13.0","tool"],
    "1fa9e":[["\uD83E\uDE9E"],"Objects",1380,["mirror"],55,24,"13.0","household"],
    "1fa9f":[["\uD83E\uDE9F"],"Objects",1381,["window"],55,25,"13.0","household"],
    "1faa0":[["\uD83E\uDEA0"],"Objects",1386,["plunger"],55,26,"13.0","household"],
    "1faa1":[["\uD83E\uDEA1"],"Activities",1147,["sewing_needle"],55,27,"13.0","arts & crafts"],
    "1faa2":[["\uD83E\uDEA2"],"Activities",1149,["knot"],55,28,"13.0","arts & crafts"],
    "1faa3":[["\uD83E\uDEA3"],"Objects",1396,["bucket"],55,29,"13.0","household"],
    "1faa4":[["\uD83E\uDEA4"],"Objects",1389,["mouse_trap"],55,30,"13.0","household"],
    "1faa5":[["\uD83E\uDEA5"],"Objects",1399,["toothbrush"],55,31,"13.0","household"],
    "1faa6":[["\uD83E\uDEA6"],"Objects",1405,["headstone"],55,32,"13.0","other-object"],
    "1faa7":[["\uD83E\uDEA7"],"Objects",1410,["placard"],55,33,"13.0","other-object"],
    "1faa8":[["\uD83E\uDEA8"],"Travel & Places",867,["rock"],55,34,"13.0","place-building"],
    "1faa9":[["\uD83E\uDEA9"],"Activities",1133,["mirror_ball"],55,35,"14.0","game"],
    "1faaa":[["\uD83E\uDEAA"],"Objects",1411,["identification_card"],55,36,"14.0","other-object"],
    "1faab":[["\uD83E\uDEAB"],"Objects",1233,["low_battery"],55,37,"14.0","computer"],
    "1faac":[["\uD83E\uDEAC"],"Objects",1408,["hamsa"],55,38,"14.0","other-object"],
    "1faad":[["\uD83E\uDEAD"],"Objects",1170,["folding_hand_fan"],55,39,"15.0","clothing"],
    "1faae":[["\uD83E\uDEAE"],"Objects",1185,["hair_pick"],55,40,"15.0","clothing"],
    "1faaf":[["\uD83E\uDEAF"],"Symbols",1471,["khanda"],55,41,"15.0","religion"],
    "1fab0":[["\uD83E\uDEB0"],"Animals & Nature",681,["fly"],55,42,"13.0","animal-bug"],
    "1fab1":[["\uD83E\uDEB1"],"Animals & Nature",682,["worm"],55,43,"13.0","animal-bug"],
    "1fab2":[["\uD83E\uDEB2"],"Animals & Nature",673,["beetle"],55,44,"13.0","animal-bug"],
    "1fab3":[["\uD83E\uDEB3"],"Animals & Nature",676,["cockroach"],55,45,"13.0","animal-bug"],
    "1fab4":[["\uD83E\uDEB4"],"Animals & Nature",697,["potted_plant"],55,46,"13.0","plant-other"],
    "1fab5":[["\uD83E\uDEB5"],"Travel & Places",868,["wood"],55,47,"13.0","place-building"],
    "1fab6":[["\uD83E\uDEB6"],"Animals & Nature",639,["feather"],55,48,"13.0","animal-bird"],
    "1fab7":[["\uD83E\uDEB7"],"Animals & Nature",687,["lotus"],55,49,"14.0","plant-flower"],
    "1fab8":[["\uD83E\uDEB8"],"Animals & Nature",666,["coral"],55,50,"14.0","animal-marine"],
    "1fab9":[["\uD83E\uDEB9"],"Animals & Nature",709,["empty_nest"],55,51,"14.0","plant-other"],
    "1faba":[["\uD83E\uDEBA"],"Animals & Nature",710,["nest_with_eggs"],55,52,"14.0","plant-other"],
    "1fabb":[["\uD83E\uDEBB"],"Animals & Nature",695,["hyacinth"],55,53,"15.0","plant-flower"],
    "1fabc":[["\uD83E\uDEBC"],"Animals & Nature",667,["jellyfish"],55,54,"15.0","animal-marine"],
    "1fabd":[["\uD83E\uDEBD"],"Animals & Nature",643,["wing"],55,55,"15.0","animal-bird"],
    "1fabf":[["\uD83E\uDEBF"],"Animals & Nature",645,["goose"],55,56,"15.0","animal-bird"],
    "1fac0":[["\uD83E\uDEC0"],"People & Body",221,["anatomical_heart"],55,57,"13.0","body-parts"],
    "1fac1":[["\uD83E\uDEC1"],"People & Body",222,["lungs"],55,58,"13.0","body-parts"],
    "1fac2":[["\uD83E\uDEC2"],"People & Body",547,["people_hugging"],55,59,"13.0","person-symbol"],
    "1fac3":[["\uD83E\uDEC3"],"People & Body",364,["pregnant_man"],55,60,"14.0","person-role"],
    "1fac4":[["\uD83E\uDEC4"],"People & Body",365,["pregnant_person"],56,4,"14.0","person-role"],
    "1fac5":[["\uD83E\uDEC5"],"People & Body",349,["person_with_crown"],56,10,"14.0","person-role"],
    "1face":[["\uD83E\uDECE"],"Animals & Nature",579,["moose"],56,16,"15.0","animal-mammal"],
    "1facf":[["\uD83E\uDECF"],"Animals & Nature",580,["donkey"],56,17,"15.0","animal-mammal"],
    "1fad0":[["\uD83E\uDED0"],"Food & Drink",727,["blueberries"],56,18,"13.0","food-fruit"],
    "1fad1":[["\uD83E\uDED1"],"Food & Drink",738,["bell_pepper"],56,19,"13.0","food-vegetable"],
    "1fad2":[["\uD83E\uDED2"],"Food & Drink",730,["olive"],56,20,"13.0","food-fruit"],
    "1fad3":[["\uD83E\uDED3"],"Food & Drink",753,["flatbread"],56,21,"13.0","food-prepared"],
    "1fad4":[["\uD83E\uDED4"],"Food & Drink",770,["tamale"],56,22,"13.0","food-prepared"],
    "1fad5":[["\uD83E\uDED5"],"Food & Drink",777,["fondue"],56,23,"13.0","food-prepared"],
    "1fad6":[["\uD83E\uDED6"],"Food & Drink",823,["teapot"],56,24,"13.0","drink"],
    "1fad7":[["\uD83E\uDED7"],"Food & Drink",834,["pouring_liquid"],56,25,"14.0","drink"],
    "1fad8":[["\uD83E\uDED8"],"Food & Drink",745,["beans"],56,26,"14.0","food-vegetable"],
    "1fad9":[["\uD83E\uDED9"],"Food & Drink",845,["jar"],56,27,"14.0","dishware"],
    "1fada":[["\uD83E\uDEDA"],"Food & Drink",747,["ginger_root"],56,28,"15.0","food-vegetable"],
    "1fadb":[["\uD83E\uDEDB"],"Food & Drink",748,["pea_pod"],56,29,"15.0","food-vegetable"],
    "1fae0":[["\uD83E\uDEE0"],"Smileys & Emotion",11,["melting_face"],56,30,"14.0","face-smiling"],
    "1fae1":[["\uD83E\uDEE1"],"Smileys & Emotion",36,["saluting_face"],56,31,"14.0","face-hand"],
    "1fae2":[["\uD83E\uDEE2"],"Smileys & Emotion",32,["face_with_open_eyes_and_hand_over_mouth"],56,32,"14.0","face-hand"],
    "1fae3":[["\uD83E\uDEE3"],"Smileys & Emotion",33,["face_with_peeking_eye"],56,33,"14.0","face-hand"],
    "1fae4":[["\uD83E\uDEE4"],"Smileys & Emotion",77,["face_with_diagonal_mouth"],56,34,"14.0","face-concerned"],
    "1fae5":[["\uD83E\uDEE5"],"Smileys & Emotion",42,["dotted_line_face"],56,35,"14.0","face-neutral-skeptical"],
    "1fae6":[["\uD83E\uDEE6"],"People & Body",229,["biting_lip"],56,36,"14.0","body-parts"],
    "1fae7":[["\uD83E\uDEE7"],"Objects",1398,["bubbles"],56,37,"14.0","household"],
    "1fae8":[["\uD83E\uDEE8"],"Smileys & Emotion",50,["shaking_face"],56,38,"15.0","face-neutral-skeptical"],
    "1faf0":[["\uD83E\uDEF0"],"People & Body",185,["hand_with_index_finger_and_thumb_crossed"],56,39,"14.0","hand-fingers-partial"],
    "1faf1":[["\uD83E\uDEF1"],"People & Body",174,["rightwards_hand"],56,45,"14.0","hand-fingers-open"],
    "1faf2":[["\uD83E\uDEF2"],"People & Body",175,["leftwards_hand"],56,51,"14.0","hand-fingers-open"],
    "1faf3":[["\uD83E\uDEF3"],"People & Body",176,["palm_down_hand"],56,57,"14.0","hand-fingers-open"],
    "1faf4":[["\uD83E\uDEF4"],"People & Body",177,["palm_up_hand"],57,1,"14.0","hand-fingers-open"],
    "1faf5":[["\uD83E\uDEF5"],"People & Body",195,["index_pointing_at_the_viewer"],57,7,"14.0","hand-single-finger"],
    "1faf6":[["\uD83E\uDEF6"],"People & Body",204,["heart_hands"],57,13,"14.0","hands"],
    "1faf7":[["\uD83E\uDEF7"],"People & Body",178,["leftwards_pushing_hand"],57,19,"15.0","hand-fingers-open"],
    "1faf8":[["\uD83E\uDEF8"],"People & Body",179,["rightwards_pushing_hand"],57,25,"15.0","hand-fingers-open"],
    "203c-fe0f":[["\u203C\uFE0F"],"Symbols",1519,["bangbang"],57,31,"0.6","punctuation"],
    "2049-fe0f":[["\u2049\uFE0F"],"Symbols",1520,["interrobang"],57,32,"0.6","punctuation"],
    "2122-fe0f":[["\u2122\uFE0F"],"Symbols",1548,["tm"],57,33,"0.6","other-symbol"],
    "2139-fe0f":[["\u2139\uFE0F"],"Symbols",1573,["information_source"],57,34,"0.6","alphanum"],
    "2194-fe0f":[["\u2194\uFE0F"],"Symbols",1447,["left_right_arrow"],57,35,"0.6","arrow"],
    "2195-fe0f":[["\u2195\uFE0F"],"Symbols",1446,["arrow_up_down"],57,36,"0.6","arrow"],
    "2196-fe0f":[["\u2196\uFE0F"],"Symbols",1445,["arrow_upper_left"],57,37,"0.6","arrow"],
    "2197-fe0f":[["\u2197\uFE0F"],"Symbols",1439,["arrow_upper_right"],57,38,"0.6","arrow"],
    "2198-fe0f":[["\u2198\uFE0F"],"Symbols",1441,["arrow_lower_right"],57,39,"0.6","arrow"],
    "2199-fe0f":[["\u2199\uFE0F"],"Symbols",1443,["arrow_lower_left"],57,40,"0.6","arrow"],
    "21a9-fe0f":[["\u21A9\uFE0F"],"Symbols",1448,["leftwards_arrow_with_hook"],57,41,"0.6","arrow"],
    "21aa-fe0f":[["\u21AA\uFE0F"],"Symbols",1449,["arrow_right_hook"],57,42,"0.6","arrow"],
    "231a":[["\u231A"],"Travel & Places",989,["watch"],57,43,"0.6","time"],
    "231b":[["\u231B"],"Travel & Places",987,["hourglass"],57,44,"0.6","time"],
    "2328-fe0f":[["\u2328\uFE0F"],"Objects",1238,["keyboard"],57,45,"1.0","computer"],
    "23cf-fe0f":[["\u23CF\uFE0F"],"Symbols",1502,["eject"],57,46,"1.0","av-symbol"],
    "23e9":[["\u23E9"],"Symbols",1489,["fast_forward"],57,47,"0.6","av-symbol"],
    "23ea":[["\u23EA"],"Symbols",1493,["rewind"],57,48,"0.6","av-symbol"],
    "23eb":[["\u23EB"],"Symbols",1496,["arrow_double_up"],57,49,"0.6","av-symbol"],
    "23ec":[["\u23EC"],"Symbols",1498,["arrow_double_down"],57,50,"0.6","av-symbol"],
    "23ed-fe0f":[["\u23ED\uFE0F"],"Symbols",1490,["black_right_pointing_double_triangle_with_vertical_bar"],57,51,"0.7","av-symbol"],
    "23ee-fe0f":[["\u23EE\uFE0F"],"Symbols",1494,["black_left_pointing_double_triangle_with_vertical_bar"],57,52,"0.7","av-symbol"],
    "23ef-fe0f":[["\u23EF\uFE0F"],"Symbols",1491,["black_right_pointing_triangle_with_double_vertical_bar"],57,53,"1.0","av-symbol"],
    "23f0":[["\u23F0"],"Travel & Places",990,["alarm_clock"],57,54,"0.6","time"],
    "23f1-fe0f":[["\u23F1\uFE0F"],"Travel & Places",991,["stopwatch"],57,55,"1.0","time"],
    "23f2-fe0f":[["\u23F2\uFE0F"],"Travel & Places",992,["timer_clock"],57,56,"1.0","time"],
    "23f3":[["\u23F3"],"Travel & Places",988,["hourglass_flowing_sand"],57,57,"0.6","time"],
    "23f8-fe0f":[["\u23F8\uFE0F"],"Symbols",1499,["double_vertical_bar"],57,58,"0.7","av-symbol"],
    "23f9-fe0f":[["\u23F9\uFE0F"],"Symbols",1500,["black_square_for_stop"],57,59,"0.7","av-symbol"],
    "23fa-fe0f":[["\u23FA\uFE0F"],"Symbols",1501,["black_circle_for_record"],57,60,"0.7","av-symbol"],
    "24c2-fe0f":[["\u24C2\uFE0F"],"Symbols",1575,["m"],57,61,"0.6","alphanum"],
    "25aa-fe0f":[["\u25AA\uFE0F"],"Symbols",1623,["black_small_square"],58,0,"0.6","geometric"],
    "25ab-fe0f":[["\u25AB\uFE0F"],"Symbols",1624,["white_small_square"],58,1,"0.6","geometric"],
    "25b6-fe0f":[["\u25B6\uFE0F"],"Symbols",1488,["arrow_forward"],58,2,"0.6","av-symbol"],
    "25c0-fe0f":[["\u25C0\uFE0F"],"Symbols",1492,["arrow_backward"],58,3,"0.6","av-symbol"],
    "25fb-fe0f":[["\u25FB\uFE0F"],"Symbols",1620,["white_medium_square"],58,4,"0.6","geometric"],
    "25fc-fe0f":[["\u25FC\uFE0F"],"Symbols",1619,["black_medium_square"],58,5,"0.6","geometric"],
    "25fd":[["\u25FD"],"Symbols",1622,["white_medium_small_square"],58,6,"0.6","geometric"],
    "25fe":[["\u25FE"],"Symbols",1621,["black_medium_small_square"],58,7,"0.6","geometric"],
    "2600-fe0f":[["\u2600\uFE0F"],"Travel & Places",1031,["sunny"],58,8,"0.6","sky & weather"],
    "2601-fe0f":[["\u2601\uFE0F"],"Travel & Places",1039,["cloud"],58,9,"0.6","sky & weather"],
    "2602-fe0f":[["\u2602\uFE0F"],"Travel & Places",1054,["umbrella"],58,10,"0.7","sky & weather"],
    "2603-fe0f":[["\u2603\uFE0F"],"Travel & Places",1059,["snowman"],58,11,"0.7","sky & weather"],
    "2604-fe0f":[["\u2604\uFE0F"],"Travel & Places",1061,["comet"],58,12,"1.0","sky & weather"],
    "260e-fe0f":[["\u260E\uFE0F"],"Objects",1228,["phone","telephone"],58,13,"0.6","phone"],
    "2611-fe0f":[["\u2611\uFE0F"],"Symbols",1536,["ballot_box_with_check"],58,14,"0.6","other-symbol"],
    "2614":[["\u2614"],"Travel & Places",1055,["umbrella_with_rain_drops"],58,15,"0.6","sky & weather"],
    "2615":[["\u2615"],"Food & Drink",822,["coffee"],58,16,"0.6","drink"],
    "2618-fe0f":[["\u2618\uFE0F"],"Animals & Nature",704,["shamrock"],58,17,"1.0","plant-other"],
    "261d-fe0f":[["\u261D\uFE0F"],"People & Body",194,["point_up"],58,18,"0.6","hand-single-finger"],
    "2620-fe0f":[["\u2620\uFE0F"],"Smileys & Emotion",109,["skull_and_crossbones"],58,24,"1.0","face-negative"],
    "2622-fe0f":[["\u2622\uFE0F"],"Symbols",1436,["radioactive_sign"],58,25,"1.0","warning"],
    "2623-fe0f":[["\u2623\uFE0F"],"Symbols",1437,["biohazard_sign"],58,26,"1.0","warning"],
    "2626-fe0f":[["\u2626\uFE0F"],"Symbols",1466,["orthodox_cross"],58,27,"1.0","religion"],
    "262a-fe0f":[["\u262A\uFE0F"],"Symbols",1467,["star_and_crescent"],58,28,"0.7","religion"],
    "262e-fe0f":[["\u262E\uFE0F"],"Symbols",1468,["peace_symbol"],58,29,"1.0","religion"],
    "262f-fe0f":[["\u262F\uFE0F"],"Symbols",1464,["yin_yang"],58,30,"0.7","religion"],
    "2638-fe0f":[["\u2638\uFE0F"],"Symbols",1463,["wheel_of_dharma"],58,31,"0.7","religion"],
    "2639-fe0f":[["\u2639\uFE0F"],"Smileys & Emotion",80,["white_frowning_face"],58,32,"0.7","face-concerned"],
    "263a-fe0f":[["\u263A\uFE0F"],"Smileys & Emotion",20,["relaxed"],58,33,"0.6","face-affection"],
    "2640-fe0f":[["\u2640\uFE0F"],"Symbols",1510,["female_sign"],58,34,"4.0","gender"],
    "2642-fe0f":[["\u2642\uFE0F"],"Symbols",1511,["male_sign"],58,35,"4.0","gender"],
    "2648":[["\u2648"],"Symbols",1472,["aries"],58,36,"0.6","zodiac"],
    "2649":[["\u2649"],"Symbols",1473,["taurus"],58,37,"0.6","zodiac"],
    "264a":[["\u264A"],"Symbols",1474,["gemini"],58,38,"0.6","zodiac"],
    "264b":[["\u264B"],"Symbols",1475,["cancer"],58,39,"0.6","zodiac"],
    "264c":[["\u264C"],"Symbols",1476,["leo"],58,40,"0.6","zodiac"],
    "264d":[["\u264D"],"Symbols",1477,["virgo"],58,41,"0.6","zodiac"],
    "264e":[["\u264E"],"Symbols",1478,["libra"],58,42,"0.6","zodiac"],
    "264f":[["\u264F"],"Symbols",1479,["scorpius"],58,43,"0.6","zodiac"],
    "2650":[["\u2650"],"Symbols",1480,["sagittarius"],58,44,"0.6","zodiac"],
    "2651":[["\u2651"],"Symbols",1481,["capricorn"],58,45,"0.6","zodiac"],
    "2652":[["\u2652"],"Symbols",1482,["aquarius"],58,46,"0.6","zodiac"],
    "2653":[["\u2653"],"Symbols",1483,["pisces"],58,47,"0.6","zodiac"],
    "265f-fe0f":[["\u265F\uFE0F"],"Activities",1139,["chess_pawn"],58,48,"11.0","game"],
    "2660-fe0f":[["\u2660\uFE0F"],"Activities",1135,["spades"],58,49,"0.6","game"],
    "2663-fe0f":[["\u2663\uFE0F"],"Activities",1138,["clubs"],58,50,"0.6","game"],
    "2665-fe0f":[["\u2665\uFE0F"],"Activities",1136,["hearts"],58,51,"0.6","game"],
    "2666-fe0f":[["\u2666\uFE0F"],"Activities",1137,["diamonds"],58,52,"0.6","game"],
    "2668-fe0f":[["\u2668\uFE0F"],"Travel & Places",906,["hotsprings"],58,53,"0.6","place-other"],
    "267b-fe0f":[["\u267B\uFE0F"],"Symbols",1529,["recycle"],58,54,"0.6","other-symbol"],
    "267e-fe0f":[["\u267E\uFE0F"],"Symbols",1518,["infinity"],58,55,"11.0","math"],
    "267f":[["\u267F"],"Symbols",1415,["wheelchair"],58,56,"0.6","transport-sign"],
    "2692-fe0f":[["\u2692\uFE0F"],"Objects",1341,["hammer_and_pick"],58,57,"1.0","tool"],
    "2693":[["\u2693"],"Travel & Places",963,["anchor"],58,58,"0.6","transport-water"],
    "2694-fe0f":[["\u2694\uFE0F"],"Objects",1344,["crossed_swords"],58,59,"1.0","tool"],
    "2695-fe0f":[["\u2695\uFE0F"],"Symbols",1528,["medical_symbol","staff_of_aesculapius"],58,60,"4.0","other-symbol"],
    "2696-fe0f":[["\u2696\uFE0F"],"Objects",1355,["scales"],58,61,"1.0","tool"],
    "2697-fe0f":[["\u2697\uFE0F"],"Objects",1364,["alembic"],59,0,"1.0","science"],
    "2699-fe0f":[["\u2699\uFE0F"],"Objects",1353,["gear"],59,1,"1.0","tool"],
    "269b-fe0f":[["\u269B\uFE0F"],"Symbols",1460,["atom_symbol"],59,2,"1.0","religion"],
    "269c-fe0f":[["\u269C\uFE0F"],"Symbols",1530,["fleur_de_lis"],59,3,"1.0","other-symbol"],
    "26a0-fe0f":[["\u26A0\uFE0F"],"Symbols",1425,["warning"],59,4,"0.6","warning"],
    "26a1":[["\u26A1"],"Travel & Places",1057,["zap"],59,5,"0.6","sky & weather"],
    "26a7-fe0f":[["\u26A7\uFE0F"],"Symbols",1512,["transgender_symbol"],59,6,"13.0","gender"],
    "26aa":[["\u26AA"],"Symbols",1609,["white_circle"],59,7,"0.6","geometric"],
    "26ab":[["\u26AB"],"Symbols",1608,["black_circle"],59,8,"0.6","geometric"],
    "26b0-fe0f":[["\u26B0\uFE0F"],"Objects",1404,["coffin"],59,9,"1.0","other-object"],
    "26b1-fe0f":[["\u26B1\uFE0F"],"Objects",1406,["funeral_urn"],59,10,"1.0","other-object"],
    "26bd":[["\u26BD"],"Activities",1092,["soccer"],59,11,"0.6","sport"],
    "26be":[["\u26BE"],"Activities",1093,["baseball"],59,12,"0.6","sport"],
    "26c4":[["\u26C4"],"Travel & Places",1060,["snowman_without_snow"],59,13,"0.6","sky & weather"],
    "26c5":[["\u26C5"],"Travel & Places",1040,["partly_sunny"],59,14,"0.6","sky & weather"],
    "26c8-fe0f":[["\u26C8\uFE0F"],"Travel & Places",1041,["thunder_cloud_and_rain"],59,15,"0.7","sky & weather"],
    "26ce":[["\u26CE"],"Symbols",1484,["ophiuchus"],59,16,"0.6","zodiac"],
    "26cf-fe0f":[["\u26CF\uFE0F"],"Objects",1340,["pick"],59,17,"0.7","tool"],
    "26d1-fe0f":[["\u26D1\uFE0F"],"Objects",1192,["helmet_with_white_cross"],59,18,"0.7","clothing"],
    "26d3-fe0f-200d-1f4a5":[["\u26D3\uFE0F\u200D\uD83D\uDCA5"],"Objects",1358,["broken_chain"],59,19,"15.1","tool"],
    "26d3-fe0f":[["\u26D3\uFE0F"],"Objects",1359,["chains"],59,20,"0.7","tool"],
    "26d4":[["\u26D4"],"Symbols",1427,["no_entry"],59,21,"0.6","warning"],
    "26e9-fe0f":[["\u26E9\uFE0F"],"Travel & Places",894,["shinto_shrine"],59,22,"0.7","place-religious"],
    "26ea":[["\u26EA"],"Travel & Places",890,["church"],59,23,"0.6","place-religious"],
    "26f0-fe0f":[["\u26F0\uFE0F"],"Travel & Places",855,["mountain"],59,24,"0.7","place-geographic"],
    "26f1-fe0f":[["\u26F1\uFE0F"],"Travel & Places",1056,["umbrella_on_ground"],59,25,"0.7","sky & weather"],
    "26f2":[["\u26F2"],"Travel & Places",896,["fountain"],59,26,"0.6","place-other"],
    "26f3":[["\u26F3"],"Activities",1111,["golf"],59,27,"0.6","sport"],
    "26f4-fe0f":[["\u26F4\uFE0F"],"Travel & Places",969,["ferry"],59,28,"0.7","transport-water"],
    "26f5":[["\u26F5"],"Travel & Places",965,["boat","sailboat"],59,29,"0.6","transport-water"],
    "26f7-fe0f":[["\u26F7\uFE0F"],"People & Body",461,["skier"],59,30,"0.7","person-sport"],
    "26f8-fe0f":[["\u26F8\uFE0F"],"Activities",1112,["ice_skate"],59,31,"0.7","sport"],
    "26f9-fe0f-200d-2640-fe0f":[["\u26F9\uFE0F\u200D\u2640\uFE0F"],"People & Body",477,["woman-bouncing-ball"],59,32,"4.0","person-sport"],
    "26f9-fe0f-200d-2642-fe0f":[["\u26F9\uFE0F\u200D\u2642\uFE0F","\u26F9\uFE0F"],"People & Body",476,["man-bouncing-ball","person_with_ball"],59,38,"4.0","person-sport"],
    "26fa":[["\u26FA"],"Travel & Places",897,["tent"],59,50,"0.6","place-other"],
    "26fd":[["\u26FD"],"Travel & Places",956,["fuelpump"],59,51,"0.6","transport-ground"],
    "2702-fe0f":[["\u2702\uFE0F"],"Objects",1328,["scissors"],59,52,"0.6","office"],
    "2705":[["\u2705"],"Symbols",1535,["white_check_mark"],59,53,"0.6","other-symbol"],
    "2708-fe0f":[["\u2708\uFE0F"],"Travel & Places",972,["airplane"],59,54,"0.6","transport-air"],
    "2709-fe0f":[["\u2709\uFE0F"],"Objects",1289,["email","envelope"],59,55,"0.6","mail"],
    "270a":[["\u270A"],"People & Body",198,["fist"],59,56,"0.6","hand-fingers-closed"],
    "270b":[["\u270B"],"People & Body",172,["hand","raised_hand"],60,0,"0.6","hand-fingers-open"],
    "270c-fe0f":[["\u270C\uFE0F"],"People & Body",183,["v"],60,6,"0.6","hand-fingers-partial"],
    "270d-fe0f":[["\u270D\uFE0F"],"People & Body",209,["writing_hand"],60,12,"0.7","hand-prop"],
    "270f-fe0f":[["\u270F\uFE0F"],"Objects",1302,["pencil2"],60,18,"0.6","writing"],
    "2712-fe0f":[["\u2712\uFE0F"],"Objects",1303,["black_nib"],60,19,"0.6","writing"],
    "2714-fe0f":[["\u2714\uFE0F"],"Symbols",1537,["heavy_check_mark"],60,20,"0.6","other-symbol"],
    "2716-fe0f":[["\u2716\uFE0F"],"Symbols",1513,["heavy_multiplication_x"],60,21,"0.6","math"],
    "271d-fe0f":[["\u271D\uFE0F"],"Symbols",1465,["latin_cross"],60,22,"0.7","religion"],
    "2721-fe0f":[["\u2721\uFE0F"],"Symbols",1462,["star_of_david"],60,23,"0.7","religion"],
    "2728":[["\u2728"],"Activities",1070,["sparkles"],60,24,"0.6","event"],
    "2733-fe0f":[["\u2733\uFE0F"],"Symbols",1543,["eight_spoked_asterisk"],60,25,"0.6","other-symbol"],
    "2734-fe0f":[["\u2734\uFE0F"],"Symbols",1544,["eight_pointed_black_star"],60,26,"0.6","other-symbol"],
    "2744-fe0f":[["\u2744\uFE0F"],"Travel & Places",1058,["snowflake"],60,27,"0.6","sky & weather"],
    "2747-fe0f":[["\u2747\uFE0F"],"Symbols",1545,["sparkle"],60,28,"0.6","other-symbol"],
    "274c":[["\u274C"],"Symbols",1538,["x"],60,29,"0.6","other-symbol"],
    "274e":[["\u274E"],"Symbols",1539,["negative_squared_cross_mark"],60,30,"0.6","other-symbol"],
    "2753":[["\u2753"],"Symbols",1521,["question"],60,31,"0.6","punctuation"],
    "2754":[["\u2754"],"Symbols",1522,["grey_question"],60,32,"0.6","punctuation"],
    "2755":[["\u2755"],"Symbols",1523,["grey_exclamation"],60,33,"0.6","punctuation"],
    "2757":[["\u2757"],"Symbols",1524,["exclamation","heavy_exclamation_mark"],60,34,"0.6","punctuation"],
    "2763-fe0f":[["\u2763\uFE0F"],"Smileys & Emotion",139,["heavy_heart_exclamation_mark_ornament"],60,35,"1.0","heart"],
    "2764-fe0f-200d-1f525":[["\u2764\uFE0F\u200D\uD83D\uDD25"],"Smileys & Emotion",141,["heart_on_fire"],60,36,"13.1","heart"],
    "2764-fe0f-200d-1fa79":[["\u2764\uFE0F\u200D\uD83E\uDE79"],"Smileys & Emotion",142,["mending_heart"],60,37,"13.1","heart"],
    "2764-fe0f":[["\u2764\uFE0F"],"Smileys & Emotion",143,["heart"],60,38,"0.6","heart","<3"],
    "2795":[["\u2795"],"Symbols",1514,["heavy_plus_sign"],60,39,"0.6","math"],
    "2796":[["\u2796"],"Symbols",1515,["heavy_minus_sign"],60,40,"0.6","math"],
    "2797":[["\u2797"],"Symbols",1516,["heavy_division_sign"],60,41,"0.6","math"],
    "27a1-fe0f":[["\u27A1\uFE0F"],"Symbols",1440,["arrow_right"],60,42,"0.6","arrow"],
    "27b0":[["\u27B0"],"Symbols",1540,["curly_loop"],60,43,"0.6","other-symbol"],
    "27bf":[["\u27BF"],"Symbols",1541,["loop"],60,44,"1.0","other-symbol"],
    "2934-fe0f":[["\u2934\uFE0F"],"Symbols",1450,["arrow_heading_up"],60,45,"0.6","arrow"],
    "2935-fe0f":[["\u2935\uFE0F"],"Symbols",1451,["arrow_heading_down"],60,46,"0.6","arrow"],
    "2b05-fe0f":[["\u2B05\uFE0F"],"Symbols",1444,["arrow_left"],60,47,"0.6","arrow"],
    "2b06-fe0f":[["\u2B06\uFE0F"],"Symbols",1438,["arrow_up"],60,48,"0.6","arrow"],
    "2b07-fe0f":[["\u2B07\uFE0F"],"Symbols",1442,["arrow_down"],60,49,"0.6","arrow"],
    "2b1b":[["\u2B1B"],"Symbols",1617,["black_large_square"],60,50,"0.6","geometric"],
    "2b1c":[["\u2B1C"],"Symbols",1618,["white_large_square"],60,51,"0.6","geometric"],
    "2b50":[["\u2B50"],"Travel & Places",1035,["star"],60,52,"0.6","sky & weather"],
    "2b55":[["\u2B55"],"Symbols",1534,["o"],60,53,"0.6","other-symbol"],
    "3030-fe0f":[["\u3030\uFE0F"],"Symbols",1525,["wavy_dash"],60,54,"0.6","punctuation"],
    "303d-fe0f":[["\u303D\uFE0F"],"Symbols",1542,["part_alternation_mark"],60,55,"0.6","other-symbol"],
    "3297-fe0f":[["\u3297\uFE0F"],"Symbols",1597,["congratulations"],60,56,"0.6","alphanum"],
    "3299-fe0f":[["\u3299\uFE0F"],"Symbols",1598,["secret"],60,57,"0.6","alphanum"]
};
window.emoji.variations_data = {
    "1f385":{"1f3fb":["1f385-1f3fb",7,4,["\uD83C\uDF85\uD83C\uDFFB"],"1.0"],"1f3fc":["1f385-1f3fc",7,5,["\uD83C\uDF85\uD83C\uDFFC"],"1.0"],"1f3fd":["1f385-1f3fd",7,6,["\uD83C\uDF85\uD83C\uDFFD"],"1.0"],"1f3fe":["1f385-1f3fe",7,7,["\uD83C\uDF85\uD83C\uDFFE"],"1.0"],"1f3ff":["1f385-1f3ff",7,8,["\uD83C\uDF85\uD83C\uDFFF"],"1.0"]},
    "1f3c2":{"1f3fb":["1f3c2-1f3fb",8,3,["\uD83C\uDFC2\uD83C\uDFFB"],"1.0"],"1f3fc":["1f3c2-1f3fc",8,4,["\uD83C\uDFC2\uD83C\uDFFC"],"1.0"],"1f3fd":["1f3c2-1f3fd",8,5,["\uD83C\uDFC2\uD83C\uDFFD"],"1.0"],"1f3fe":["1f3c2-1f3fe",8,6,["\uD83C\uDFC2\uD83C\uDFFE"],"1.0"],"1f3ff":["1f3c2-1f3ff",8,7,["\uD83C\uDFC2\uD83C\uDFFF"],"1.0"]},
    "1f3c3-200d-2640-fe0f":{"1f3fb":["1f3c3-1f3fb-200d-2640-fe0f",8,9,["\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f3c3-1f3fc-200d-2640-fe0f",8,10,["\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f3c3-1f3fd-200d-2640-fe0f",8,11,["\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f3c3-1f3fe-200d-2640-fe0f",8,12,["\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f3c3-1f3ff-200d-2640-fe0f",8,13,["\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f3c3-200d-2640-fe0f-200d-27a1-fe0f":{"1f3fb":["1f3c3-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",8,15,["\uD83C\uDFC3\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f3c3-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",8,16,["\uD83C\uDFC3\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f3c3-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",8,17,["\uD83C\uDFC3\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f3c3-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",8,18,["\uD83C\uDFC3\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f3c3-1f3ff-200d-2640-fe0f-200d-27a1-fe0f",8,19,["\uD83C\uDFC3\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f3c3-200d-2642-fe0f":{"1f3fb":["1f3c3-1f3fb-200d-2642-fe0f",8,21,["\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f3c3-1f3fc-200d-2642-fe0f",8,22,["\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f3c3-1f3fd-200d-2642-fe0f",8,23,["\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f3c3-1f3fe-200d-2642-fe0f",8,24,["\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f3c3-1f3ff-200d-2642-fe0f",8,25,["\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f3c3-200d-2642-fe0f-200d-27a1-fe0f":{"1f3fb":["1f3c3-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",8,27,["\uD83C\uDFC3\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f3c3-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",8,28,["\uD83C\uDFC3\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f3c3-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",8,29,["\uD83C\uDFC3\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f3c3-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",8,30,["\uD83C\uDFC3\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f3c3-1f3ff-200d-2642-fe0f-200d-27a1-fe0f",8,31,["\uD83C\uDFC3\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f3c3-200d-27a1-fe0f":{"1f3fb":["1f3c3-1f3fb-200d-27a1-fe0f",8,33,["\uD83C\uDFC3\uD83C\uDFFB\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f3c3-1f3fc-200d-27a1-fe0f",8,34,["\uD83C\uDFC3\uD83C\uDFFC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f3c3-1f3fd-200d-27a1-fe0f",8,35,["\uD83C\uDFC3\uD83C\uDFFD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f3c3-1f3fe-200d-27a1-fe0f",8,36,["\uD83C\uDFC3\uD83C\uDFFE\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f3c3-1f3ff-200d-27a1-fe0f",8,37,["\uD83C\uDFC3\uD83C\uDFFF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f3c4-200d-2640-fe0f":{"1f3fb":["1f3c4-1f3fb-200d-2640-fe0f",8,45,["\uD83C\uDFC4\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f3c4-1f3fc-200d-2640-fe0f",8,46,["\uD83C\uDFC4\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f3c4-1f3fd-200d-2640-fe0f",8,47,["\uD83C\uDFC4\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f3c4-1f3fe-200d-2640-fe0f",8,48,["\uD83C\uDFC4\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f3c4-1f3ff-200d-2640-fe0f",8,49,["\uD83C\uDFC4\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f3c4-200d-2642-fe0f":{"1f3fb":["1f3c4-1f3fb-200d-2642-fe0f",8,51,["\uD83C\uDFC4\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f3c4-1f3fc-200d-2642-fe0f",8,52,["\uD83C\uDFC4\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f3c4-1f3fd-200d-2642-fe0f",8,53,["\uD83C\uDFC4\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f3c4-1f3fe-200d-2642-fe0f",8,54,["\uD83C\uDFC4\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f3c4-1f3ff-200d-2642-fe0f",8,55,["\uD83C\uDFC4\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f3c7":{"1f3fb":["1f3c7-1f3fb",9,3,["\uD83C\uDFC7\uD83C\uDFFB"],"1.0"],"1f3fc":["1f3c7-1f3fc",9,4,["\uD83C\uDFC7\uD83C\uDFFC"],"1.0"],"1f3fd":["1f3c7-1f3fd",9,5,["\uD83C\uDFC7\uD83C\uDFFD"],"1.0"],"1f3fe":["1f3c7-1f3fe",9,6,["\uD83C\uDFC7\uD83C\uDFFE"],"1.0"],"1f3ff":["1f3c7-1f3ff",9,7,["\uD83C\uDFC7\uD83C\uDFFF"],"1.0"]},
    "1f3ca-200d-2640-fe0f":{"1f3fb":["1f3ca-1f3fb-200d-2640-fe0f",9,11,["\uD83C\uDFCA\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f3ca-1f3fc-200d-2640-fe0f",9,12,["\uD83C\uDFCA\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f3ca-1f3fd-200d-2640-fe0f",9,13,["\uD83C\uDFCA\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f3ca-1f3fe-200d-2640-fe0f",9,14,["\uD83C\uDFCA\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f3ca-1f3ff-200d-2640-fe0f",9,15,["\uD83C\uDFCA\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f3ca-200d-2642-fe0f":{"1f3fb":["1f3ca-1f3fb-200d-2642-fe0f",9,17,["\uD83C\uDFCA\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f3ca-1f3fc-200d-2642-fe0f",9,18,["\uD83C\uDFCA\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f3ca-1f3fd-200d-2642-fe0f",9,19,["\uD83C\uDFCA\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f3ca-1f3fe-200d-2642-fe0f",9,20,["\uD83C\uDFCA\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f3ca-1f3ff-200d-2642-fe0f",9,21,["\uD83C\uDFCA\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f3cb-fe0f-200d-2640-fe0f":{"1f3fb":["1f3cb-1f3fb-200d-2640-fe0f",9,29,["\uD83C\uDFCB\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f3cb-1f3fc-200d-2640-fe0f",9,30,["\uD83C\uDFCB\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f3cb-1f3fd-200d-2640-fe0f",9,31,["\uD83C\uDFCB\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f3cb-1f3fe-200d-2640-fe0f",9,32,["\uD83C\uDFCB\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f3cb-1f3ff-200d-2640-fe0f",9,33,["\uD83C\uDFCB\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f3cb-fe0f-200d-2642-fe0f":{"1f3fb":["1f3cb-1f3fb-200d-2642-fe0f",9,35,["\uD83C\uDFCB\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f3cb-1f3fc-200d-2642-fe0f",9,36,["\uD83C\uDFCB\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f3cb-1f3fd-200d-2642-fe0f",9,37,["\uD83C\uDFCB\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f3cb-1f3fe-200d-2642-fe0f",9,38,["\uD83C\uDFCB\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f3cb-1f3ff-200d-2642-fe0f",9,39,["\uD83C\uDFCB\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f3cc-fe0f-200d-2640-fe0f":{"1f3fb":["1f3cc-1f3fb-200d-2640-fe0f",9,47,["\uD83C\uDFCC\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f3cc-1f3fc-200d-2640-fe0f",9,48,["\uD83C\uDFCC\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f3cc-1f3fd-200d-2640-fe0f",9,49,["\uD83C\uDFCC\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f3cc-1f3fe-200d-2640-fe0f",9,50,["\uD83C\uDFCC\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f3cc-1f3ff-200d-2640-fe0f",9,51,["\uD83C\uDFCC\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f3cc-fe0f-200d-2642-fe0f":{"1f3fb":["1f3cc-1f3fb-200d-2642-fe0f",9,53,["\uD83C\uDFCC\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f3cc-1f3fc-200d-2642-fe0f",9,54,["\uD83C\uDFCC\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f3cc-1f3fd-200d-2642-fe0f",9,55,["\uD83C\uDFCC\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f3cc-1f3fe-200d-2642-fe0f",9,56,["\uD83C\uDFCC\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f3cc-1f3ff-200d-2642-fe0f",9,57,["\uD83C\uDFCC\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f442":{"1f3fb":["1f442-1f3fb",12,5,["\uD83D\uDC42\uD83C\uDFFB"],"1.0"],"1f3fc":["1f442-1f3fc",12,6,["\uD83D\uDC42\uD83C\uDFFC"],"1.0"],"1f3fd":["1f442-1f3fd",12,7,["\uD83D\uDC42\uD83C\uDFFD"],"1.0"],"1f3fe":["1f442-1f3fe",12,8,["\uD83D\uDC42\uD83C\uDFFE"],"1.0"],"1f3ff":["1f442-1f3ff",12,9,["\uD83D\uDC42\uD83C\uDFFF"],"1.0"]},
    "1f443":{"1f3fb":["1f443-1f3fb",12,11,["\uD83D\uDC43\uD83C\uDFFB"],"1.0"],"1f3fc":["1f443-1f3fc",12,12,["\uD83D\uDC43\uD83C\uDFFC"],"1.0"],"1f3fd":["1f443-1f3fd",12,13,["\uD83D\uDC43\uD83C\uDFFD"],"1.0"],"1f3fe":["1f443-1f3fe",12,14,["\uD83D\uDC43\uD83C\uDFFE"],"1.0"],"1f3ff":["1f443-1f3ff",12,15,["\uD83D\uDC43\uD83C\uDFFF"],"1.0"]},
    "1f446":{"1f3fb":["1f446-1f3fb",12,19,["\uD83D\uDC46\uD83C\uDFFB"],"1.0"],"1f3fc":["1f446-1f3fc",12,20,["\uD83D\uDC46\uD83C\uDFFC"],"1.0"],"1f3fd":["1f446-1f3fd",12,21,["\uD83D\uDC46\uD83C\uDFFD"],"1.0"],"1f3fe":["1f446-1f3fe",12,22,["\uD83D\uDC46\uD83C\uDFFE"],"1.0"],"1f3ff":["1f446-1f3ff",12,23,["\uD83D\uDC46\uD83C\uDFFF"],"1.0"]},
    "1f447":{"1f3fb":["1f447-1f3fb",12,25,["\uD83D\uDC47\uD83C\uDFFB"],"1.0"],"1f3fc":["1f447-1f3fc",12,26,["\uD83D\uDC47\uD83C\uDFFC"],"1.0"],"1f3fd":["1f447-1f3fd",12,27,["\uD83D\uDC47\uD83C\uDFFD"],"1.0"],"1f3fe":["1f447-1f3fe",12,28,["\uD83D\uDC47\uD83C\uDFFE"],"1.0"],"1f3ff":["1f447-1f3ff",12,29,["\uD83D\uDC47\uD83C\uDFFF"],"1.0"]},
    "1f448":{"1f3fb":["1f448-1f3fb",12,31,["\uD83D\uDC48\uD83C\uDFFB"],"1.0"],"1f3fc":["1f448-1f3fc",12,32,["\uD83D\uDC48\uD83C\uDFFC"],"1.0"],"1f3fd":["1f448-1f3fd",12,33,["\uD83D\uDC48\uD83C\uDFFD"],"1.0"],"1f3fe":["1f448-1f3fe",12,34,["\uD83D\uDC48\uD83C\uDFFE"],"1.0"],"1f3ff":["1f448-1f3ff",12,35,["\uD83D\uDC48\uD83C\uDFFF"],"1.0"]},
    "1f449":{"1f3fb":["1f449-1f3fb",12,37,["\uD83D\uDC49\uD83C\uDFFB"],"1.0"],"1f3fc":["1f449-1f3fc",12,38,["\uD83D\uDC49\uD83C\uDFFC"],"1.0"],"1f3fd":["1f449-1f3fd",12,39,["\uD83D\uDC49\uD83C\uDFFD"],"1.0"],"1f3fe":["1f449-1f3fe",12,40,["\uD83D\uDC49\uD83C\uDFFE"],"1.0"],"1f3ff":["1f449-1f3ff",12,41,["\uD83D\uDC49\uD83C\uDFFF"],"1.0"]},
    "1f44a":{"1f3fb":["1f44a-1f3fb",12,43,["\uD83D\uDC4A\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44a-1f3fc",12,44,["\uD83D\uDC4A\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44a-1f3fd",12,45,["\uD83D\uDC4A\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44a-1f3fe",12,46,["\uD83D\uDC4A\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44a-1f3ff",12,47,["\uD83D\uDC4A\uD83C\uDFFF"],"1.0"]},
    "1f44b":{"1f3fb":["1f44b-1f3fb",12,49,["\uD83D\uDC4B\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44b-1f3fc",12,50,["\uD83D\uDC4B\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44b-1f3fd",12,51,["\uD83D\uDC4B\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44b-1f3fe",12,52,["\uD83D\uDC4B\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44b-1f3ff",12,53,["\uD83D\uDC4B\uD83C\uDFFF"],"1.0"]},
    "1f44c":{"1f3fb":["1f44c-1f3fb",12,55,["\uD83D\uDC4C\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44c-1f3fc",12,56,["\uD83D\uDC4C\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44c-1f3fd",12,57,["\uD83D\uDC4C\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44c-1f3fe",12,58,["\uD83D\uDC4C\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44c-1f3ff",12,59,["\uD83D\uDC4C\uD83C\uDFFF"],"1.0"]},
    "1f44d":{"1f3fb":["1f44d-1f3fb",12,61,["\uD83D\uDC4D\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44d-1f3fc",13,0,["\uD83D\uDC4D\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44d-1f3fd",13,1,["\uD83D\uDC4D\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44d-1f3fe",13,2,["\uD83D\uDC4D\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44d-1f3ff",13,3,["\uD83D\uDC4D\uD83C\uDFFF"],"1.0"]},
    "1f44e":{"1f3fb":["1f44e-1f3fb",13,5,["\uD83D\uDC4E\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44e-1f3fc",13,6,["\uD83D\uDC4E\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44e-1f3fd",13,7,["\uD83D\uDC4E\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44e-1f3fe",13,8,["\uD83D\uDC4E\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44e-1f3ff",13,9,["\uD83D\uDC4E\uD83C\uDFFF"],"1.0"]},
    "1f44f":{"1f3fb":["1f44f-1f3fb",13,11,["\uD83D\uDC4F\uD83C\uDFFB"],"1.0"],"1f3fc":["1f44f-1f3fc",13,12,["\uD83D\uDC4F\uD83C\uDFFC"],"1.0"],"1f3fd":["1f44f-1f3fd",13,13,["\uD83D\uDC4F\uD83C\uDFFD"],"1.0"],"1f3fe":["1f44f-1f3fe",13,14,["\uD83D\uDC4F\uD83C\uDFFE"],"1.0"],"1f3ff":["1f44f-1f3ff",13,15,["\uD83D\uDC4F\uD83C\uDFFF"],"1.0"]},
    "1f450":{"1f3fb":["1f450-1f3fb",13,17,["\uD83D\uDC50\uD83C\uDFFB"],"1.0"],"1f3fc":["1f450-1f3fc",13,18,["\uD83D\uDC50\uD83C\uDFFC"],"1.0"],"1f3fd":["1f450-1f3fd",13,19,["\uD83D\uDC50\uD83C\uDFFD"],"1.0"],"1f3fe":["1f450-1f3fe",13,20,["\uD83D\uDC50\uD83C\uDFFE"],"1.0"],"1f3ff":["1f450-1f3ff",13,21,["\uD83D\uDC50\uD83C\uDFFF"],"1.0"]},
    "1f466":{"1f3fb":["1f466-1f3fb",13,44,["\uD83D\uDC66\uD83C\uDFFB"],"1.0"],"1f3fc":["1f466-1f3fc",13,45,["\uD83D\uDC66\uD83C\uDFFC"],"1.0"],"1f3fd":["1f466-1f3fd",13,46,["\uD83D\uDC66\uD83C\uDFFD"],"1.0"],"1f3fe":["1f466-1f3fe",13,47,["\uD83D\uDC66\uD83C\uDFFE"],"1.0"],"1f3ff":["1f466-1f3ff",13,48,["\uD83D\uDC66\uD83C\uDFFF"],"1.0"]},
    "1f467":{"1f3fb":["1f467-1f3fb",13,50,["\uD83D\uDC67\uD83C\uDFFB"],"1.0"],"1f3fc":["1f467-1f3fc",13,51,["\uD83D\uDC67\uD83C\uDFFC"],"1.0"],"1f3fd":["1f467-1f3fd",13,52,["\uD83D\uDC67\uD83C\uDFFD"],"1.0"],"1f3fe":["1f467-1f3fe",13,53,["\uD83D\uDC67\uD83C\uDFFE"],"1.0"],"1f3ff":["1f467-1f3ff",13,54,["\uD83D\uDC67\uD83C\uDFFF"],"1.0"]},
    "1f468-200d-1f33e":{"1f3fb":["1f468-1f3fb-200d-1f33e",13,56,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF3E"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f33e",13,57,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF3E"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f33e",13,58,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF3E"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f33e",13,59,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF3E"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f33e",13,60,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF3E"],"4.0"]},
    "1f468-200d-1f373":{"1f3fb":["1f468-1f3fb-200d-1f373",14,0,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF73"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f373",14,1,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF73"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f373",14,2,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF73"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f373",14,3,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF73"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f373",14,4,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF73"],"4.0"]},
    "1f468-200d-1f37c":{"1f3fb":["1f468-1f3fb-200d-1f37c",14,6,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF7C"],"13.0"],"1f3fc":["1f468-1f3fc-200d-1f37c",14,7,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF7C"],"13.0"],"1f3fd":["1f468-1f3fd-200d-1f37c",14,8,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF7C"],"13.0"],"1f3fe":["1f468-1f3fe-200d-1f37c",14,9,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF7C"],"13.0"],"1f3ff":["1f468-1f3ff-200d-1f37c",14,10,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF7C"],"13.0"]},
    "1f468-200d-1f393":{"1f3fb":["1f468-1f3fb-200d-1f393",14,12,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDF93"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f393",14,13,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDF93"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f393",14,14,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDF93"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f393",14,15,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDF93"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f393",14,16,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDF93"],"4.0"]},
    "1f468-200d-1f3a4":{"1f3fb":["1f468-1f3fb-200d-1f3a4",14,18,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA4"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f3a4",14,19,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA4"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f3a4",14,20,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA4"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f3a4",14,21,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA4"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f3a4",14,22,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA4"],"4.0"]},
    "1f468-200d-1f3a8":{"1f3fb":["1f468-1f3fb-200d-1f3a8",14,24,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFA8"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f3a8",14,25,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFA8"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f3a8",14,26,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFA8"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f3a8",14,27,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFA8"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f3a8",14,28,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFA8"],"4.0"]},
    "1f468-200d-1f3eb":{"1f3fb":["1f468-1f3fb-200d-1f3eb",14,30,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFEB"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f3eb",14,31,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFEB"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f3eb",14,32,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFEB"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f3eb",14,33,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFEB"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f3eb",14,34,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFEB"],"4.0"]},
    "1f468-200d-1f3ed":{"1f3fb":["1f468-1f3fb-200d-1f3ed",14,36,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83C\uDFED"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f3ed",14,37,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83C\uDFED"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f3ed",14,38,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83C\uDFED"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f3ed",14,39,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83C\uDFED"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f3ed",14,40,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83C\uDFED"],"4.0"]},
    "1f468-200d-1f4bb":{"1f3fb":["1f468-1f3fb-200d-1f4bb",14,57,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBB"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f4bb",14,58,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBB"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f4bb",14,59,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBB"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f4bb",14,60,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBB"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f4bb",14,61,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBB"],"4.0"]},
    "1f468-200d-1f4bc":{"1f3fb":["1f468-1f3fb-200d-1f4bc",15,1,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDCBC"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f4bc",15,2,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDCBC"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f4bc",15,3,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDCBC"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f4bc",15,4,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDCBC"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f4bc",15,5,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDCBC"],"4.0"]},
    "1f468-200d-1f527":{"1f3fb":["1f468-1f3fb-200d-1f527",15,7,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD27"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f527",15,8,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD27"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f527",15,9,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD27"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f527",15,10,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD27"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f527",15,11,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD27"],"4.0"]},
    "1f468-200d-1f52c":{"1f3fb":["1f468-1f3fb-200d-1f52c",15,13,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDD2C"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f52c",15,14,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDD2C"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f52c",15,15,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDD2C"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f52c",15,16,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDD2C"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f52c",15,17,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDD2C"],"4.0"]},
    "1f468-200d-1f680":{"1f3fb":["1f468-1f3fb-200d-1f680",15,19,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE80"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f680",15,20,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE80"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f680",15,21,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE80"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f680",15,22,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE80"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f680",15,23,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE80"],"4.0"]},
    "1f468-200d-1f692":{"1f3fb":["1f468-1f3fb-200d-1f692",15,25,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83D\uDE92"],"4.0"],"1f3fc":["1f468-1f3fc-200d-1f692",15,26,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83D\uDE92"],"4.0"],"1f3fd":["1f468-1f3fd-200d-1f692",15,27,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83D\uDE92"],"4.0"],"1f3fe":["1f468-1f3fe-200d-1f692",15,28,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83D\uDE92"],"4.0"],"1f3ff":["1f468-1f3ff-200d-1f692",15,29,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83D\uDE92"],"4.0"]},
    "1f468-200d-1f9af-200d-27a1-fe0f":{"1f3fb":["1f468-1f3fb-200d-1f9af-200d-27a1-fe0f",15,31,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f468-1f3fc-200d-1f9af-200d-27a1-fe0f",15,32,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f468-1f3fd-200d-1f9af-200d-27a1-fe0f",15,33,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f468-1f3fe-200d-1f9af-200d-27a1-fe0f",15,34,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f468-1f3ff-200d-1f9af-200d-27a1-fe0f",15,35,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f468-200d-1f9af":{"1f3fb":["1f468-1f3fb-200d-1f9af",15,37,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDAF"],"12.0"],"1f3fc":["1f468-1f3fc-200d-1f9af",15,38,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDAF"],"12.0"],"1f3fd":["1f468-1f3fd-200d-1f9af",15,39,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDAF"],"12.0"],"1f3fe":["1f468-1f3fe-200d-1f9af",15,40,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDAF"],"12.0"],"1f3ff":["1f468-1f3ff-200d-1f9af",15,41,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDAF"],"12.0"]},
    "1f468-200d-1f9b0":{"1f3fb":["1f468-1f3fb-200d-1f9b0",15,43,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB0"],"11.0"],"1f3fc":["1f468-1f3fc-200d-1f9b0",15,44,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB0"],"11.0"],"1f3fd":["1f468-1f3fd-200d-1f9b0",15,45,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB0"],"11.0"],"1f3fe":["1f468-1f3fe-200d-1f9b0",15,46,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB0"],"11.0"],"1f3ff":["1f468-1f3ff-200d-1f9b0",15,47,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB0"],"11.0"]},
    "1f468-200d-1f9b1":{"1f3fb":["1f468-1f3fb-200d-1f9b1",15,49,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB1"],"11.0"],"1f3fc":["1f468-1f3fc-200d-1f9b1",15,50,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB1"],"11.0"],"1f3fd":["1f468-1f3fd-200d-1f9b1",15,51,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB1"],"11.0"],"1f3fe":["1f468-1f3fe-200d-1f9b1",15,52,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB1"],"11.0"],"1f3ff":["1f468-1f3ff-200d-1f9b1",15,53,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB1"],"11.0"]},
    "1f468-200d-1f9b2":{"1f3fb":["1f468-1f3fb-200d-1f9b2",15,55,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB2"],"11.0"],"1f3fc":["1f468-1f3fc-200d-1f9b2",15,56,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB2"],"11.0"],"1f3fd":["1f468-1f3fd-200d-1f9b2",15,57,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB2"],"11.0"],"1f3fe":["1f468-1f3fe-200d-1f9b2",15,58,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB2"],"11.0"],"1f3ff":["1f468-1f3ff-200d-1f9b2",15,59,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB2"],"11.0"]},
    "1f468-200d-1f9b3":{"1f3fb":["1f468-1f3fb-200d-1f9b3",15,61,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDB3"],"11.0"],"1f3fc":["1f468-1f3fc-200d-1f9b3",16,0,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDB3"],"11.0"],"1f3fd":["1f468-1f3fd-200d-1f9b3",16,1,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDB3"],"11.0"],"1f3fe":["1f468-1f3fe-200d-1f9b3",16,2,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDB3"],"11.0"],"1f3ff":["1f468-1f3ff-200d-1f9b3",16,3,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDB3"],"11.0"]},
    "1f468-200d-1f9bc-200d-27a1-fe0f":{"1f3fb":["1f468-1f3fb-200d-1f9bc-200d-27a1-fe0f",16,5,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f468-1f3fc-200d-1f9bc-200d-27a1-fe0f",16,6,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f468-1f3fd-200d-1f9bc-200d-27a1-fe0f",16,7,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f468-1f3fe-200d-1f9bc-200d-27a1-fe0f",16,8,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f468-1f3ff-200d-1f9bc-200d-27a1-fe0f",16,9,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"]},
    "1f468-200d-1f9bc":{"1f3fb":["1f468-1f3fb-200d-1f9bc",16,11,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBC"],"12.0"],"1f3fc":["1f468-1f3fc-200d-1f9bc",16,12,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBC"],"12.0"],"1f3fd":["1f468-1f3fd-200d-1f9bc",16,13,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBC"],"12.0"],"1f3fe":["1f468-1f3fe-200d-1f9bc",16,14,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBC"],"12.0"],"1f3ff":["1f468-1f3ff-200d-1f9bc",16,15,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBC"],"12.0"]},
    "1f468-200d-1f9bd-200d-27a1-fe0f":{"1f3fb":["1f468-1f3fb-200d-1f9bd-200d-27a1-fe0f",16,17,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f468-1f3fc-200d-1f9bd-200d-27a1-fe0f",16,18,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f468-1f3fd-200d-1f9bd-200d-27a1-fe0f",16,19,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f468-1f3fe-200d-1f9bd-200d-27a1-fe0f",16,20,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f468-1f3ff-200d-1f9bd-200d-27a1-fe0f",16,21,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"]},
    "1f468-200d-1f9bd":{"1f3fb":["1f468-1f3fb-200d-1f9bd",16,23,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDDBD"],"12.0"],"1f3fc":["1f468-1f3fc-200d-1f9bd",16,24,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDDBD"],"12.0"],"1f3fd":["1f468-1f3fd-200d-1f9bd",16,25,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDDBD"],"12.0"],"1f3fe":["1f468-1f3fe-200d-1f9bd",16,26,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDDBD"],"12.0"],"1f3ff":["1f468-1f3ff-200d-1f9bd",16,27,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDDBD"],"12.0"]},
    "1f468-200d-2695-fe0f":{"1f3fb":["1f468-1f3fb-200d-2695-fe0f",16,29,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2695\uFE0F"],"4.0"],"1f3fc":["1f468-1f3fc-200d-2695-fe0f",16,30,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2695\uFE0F"],"4.0"],"1f3fd":["1f468-1f3fd-200d-2695-fe0f",16,31,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2695\uFE0F"],"4.0"],"1f3fe":["1f468-1f3fe-200d-2695-fe0f",16,32,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2695\uFE0F"],"4.0"],"1f3ff":["1f468-1f3ff-200d-2695-fe0f",16,33,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2695\uFE0F"],"4.0"]},
    "1f468-200d-2696-fe0f":{"1f3fb":["1f468-1f3fb-200d-2696-fe0f",16,35,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2696\uFE0F"],"4.0"],"1f3fc":["1f468-1f3fc-200d-2696-fe0f",16,36,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2696\uFE0F"],"4.0"],"1f3fd":["1f468-1f3fd-200d-2696-fe0f",16,37,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2696\uFE0F"],"4.0"],"1f3fe":["1f468-1f3fe-200d-2696-fe0f",16,38,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2696\uFE0F"],"4.0"],"1f3ff":["1f468-1f3ff-200d-2696-fe0f",16,39,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2696\uFE0F"],"4.0"]},
    "1f468-200d-2708-fe0f":{"1f3fb":["1f468-1f3fb-200d-2708-fe0f",16,41,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2708\uFE0F"],"4.0"],"1f3fc":["1f468-1f3fc-200d-2708-fe0f",16,42,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2708\uFE0F"],"4.0"],"1f3fd":["1f468-1f3fd-200d-2708-fe0f",16,43,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2708\uFE0F"],"4.0"],"1f3fe":["1f468-1f3fe-200d-2708-fe0f",16,44,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2708\uFE0F"],"4.0"],"1f3ff":["1f468-1f3ff-200d-2708-fe0f",16,45,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2708\uFE0F"],"4.0"]},
    "1f468-200d-2764-fe0f-200d-1f468":{"1f3fb-1f3fb":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",16,47,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",16,48,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",16,49,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",16,50,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",16,51,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",16,52,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",16,53,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",16,54,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",16,55,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",16,56,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",16,57,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",16,58,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",16,59,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",16,60,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",16,61,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",17,0,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",17,1,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",17,2,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",17,3,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",17,4,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",17,5,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",17,6,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",17,7,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",17,8,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",17,9,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"]},
    "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468":{"1f3fb-1f3fb":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",17,11,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",17,12,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",17,13,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",17,14,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",17,15,["\uD83D\uDC68\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",17,16,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",17,17,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",17,18,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",17,19,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",17,20,["\uD83D\uDC68\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",17,21,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",17,22,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",17,23,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",17,24,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",17,25,["\uD83D\uDC68\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",17,26,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",17,27,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",17,28,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",17,29,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",17,30,["\uD83D\uDC68\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",17,31,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",17,32,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",17,33,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",17,34,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",17,35,["\uD83D\uDC68\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"]},
    "1f468":{"1f3fb":["1f468-1f3fb",17,37,["\uD83D\uDC68\uD83C\uDFFB"],"1.0"],"1f3fc":["1f468-1f3fc",17,38,["\uD83D\uDC68\uD83C\uDFFC"],"1.0"],"1f3fd":["1f468-1f3fd",17,39,["\uD83D\uDC68\uD83C\uDFFD"],"1.0"],"1f3fe":["1f468-1f3fe",17,40,["\uD83D\uDC68\uD83C\uDFFE"],"1.0"],"1f3ff":["1f468-1f3ff",17,41,["\uD83D\uDC68\uD83C\uDFFF"],"1.0"]},
    "1f469-200d-1f33e":{"1f3fb":["1f469-1f3fb-200d-1f33e",17,43,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF3E"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f33e",17,44,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF3E"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f33e",17,45,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF3E"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f33e",17,46,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF3E"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f33e",17,47,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF3E"],"4.0"]},
    "1f469-200d-1f373":{"1f3fb":["1f469-1f3fb-200d-1f373",17,49,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF73"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f373",17,50,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF73"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f373",17,51,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF73"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f373",17,52,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF73"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f373",17,53,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF73"],"4.0"]},
    "1f469-200d-1f37c":{"1f3fb":["1f469-1f3fb-200d-1f37c",17,55,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF7C"],"13.0"],"1f3fc":["1f469-1f3fc-200d-1f37c",17,56,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF7C"],"13.0"],"1f3fd":["1f469-1f3fd-200d-1f37c",17,57,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF7C"],"13.0"],"1f3fe":["1f469-1f3fe-200d-1f37c",17,58,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF7C"],"13.0"],"1f3ff":["1f469-1f3ff-200d-1f37c",17,59,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF7C"],"13.0"]},
    "1f469-200d-1f393":{"1f3fb":["1f469-1f3fb-200d-1f393",17,61,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDF93"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f393",18,0,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDF93"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f393",18,1,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDF93"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f393",18,2,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDF93"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f393",18,3,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDF93"],"4.0"]},
    "1f469-200d-1f3a4":{"1f3fb":["1f469-1f3fb-200d-1f3a4",18,5,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA4"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f3a4",18,6,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA4"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f3a4",18,7,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA4"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f3a4",18,8,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA4"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f3a4",18,9,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA4"],"4.0"]},
    "1f469-200d-1f3a8":{"1f3fb":["1f469-1f3fb-200d-1f3a8",18,11,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFA8"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f3a8",18,12,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFA8"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f3a8",18,13,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFA8"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f3a8",18,14,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFA8"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f3a8",18,15,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFA8"],"4.0"]},
    "1f469-200d-1f3eb":{"1f3fb":["1f469-1f3fb-200d-1f3eb",18,17,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFEB"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f3eb",18,18,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFEB"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f3eb",18,19,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFEB"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f3eb",18,20,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFEB"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f3eb",18,21,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFEB"],"4.0"]},
    "1f469-200d-1f3ed":{"1f3fb":["1f469-1f3fb-200d-1f3ed",18,23,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83C\uDFED"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f3ed",18,24,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83C\uDFED"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f3ed",18,25,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83C\uDFED"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f3ed",18,26,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83C\uDFED"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f3ed",18,27,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83C\uDFED"],"4.0"]},
    "1f469-200d-1f4bb":{"1f3fb":["1f469-1f3fb-200d-1f4bb",18,39,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBB"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f4bb",18,40,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBB"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f4bb",18,41,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBB"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f4bb",18,42,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBB"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f4bb",18,43,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBB"],"4.0"]},
    "1f469-200d-1f4bc":{"1f3fb":["1f469-1f3fb-200d-1f4bc",18,45,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDCBC"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f4bc",18,46,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDCBC"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f4bc",18,47,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDCBC"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f4bc",18,48,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDCBC"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f4bc",18,49,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDCBC"],"4.0"]},
    "1f469-200d-1f527":{"1f3fb":["1f469-1f3fb-200d-1f527",18,51,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD27"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f527",18,52,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD27"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f527",18,53,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD27"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f527",18,54,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD27"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f527",18,55,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD27"],"4.0"]},
    "1f469-200d-1f52c":{"1f3fb":["1f469-1f3fb-200d-1f52c",18,57,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDD2C"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f52c",18,58,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDD2C"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f52c",18,59,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDD2C"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f52c",18,60,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDD2C"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f52c",18,61,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDD2C"],"4.0"]},
    "1f469-200d-1f680":{"1f3fb":["1f469-1f3fb-200d-1f680",19,1,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE80"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f680",19,2,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE80"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f680",19,3,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE80"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f680",19,4,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE80"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f680",19,5,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE80"],"4.0"]},
    "1f469-200d-1f692":{"1f3fb":["1f469-1f3fb-200d-1f692",19,7,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83D\uDE92"],"4.0"],"1f3fc":["1f469-1f3fc-200d-1f692",19,8,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83D\uDE92"],"4.0"],"1f3fd":["1f469-1f3fd-200d-1f692",19,9,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83D\uDE92"],"4.0"],"1f3fe":["1f469-1f3fe-200d-1f692",19,10,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83D\uDE92"],"4.0"],"1f3ff":["1f469-1f3ff-200d-1f692",19,11,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83D\uDE92"],"4.0"]},
    "1f469-200d-1f9af-200d-27a1-fe0f":{"1f3fb":["1f469-1f3fb-200d-1f9af-200d-27a1-fe0f",19,13,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f469-1f3fc-200d-1f9af-200d-27a1-fe0f",19,14,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f469-1f3fd-200d-1f9af-200d-27a1-fe0f",19,15,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f469-1f3fe-200d-1f9af-200d-27a1-fe0f",19,16,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f469-1f3ff-200d-1f9af-200d-27a1-fe0f",19,17,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f469-200d-1f9af":{"1f3fb":["1f469-1f3fb-200d-1f9af",19,19,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDAF"],"12.0"],"1f3fc":["1f469-1f3fc-200d-1f9af",19,20,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDAF"],"12.0"],"1f3fd":["1f469-1f3fd-200d-1f9af",19,21,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDAF"],"12.0"],"1f3fe":["1f469-1f3fe-200d-1f9af",19,22,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDAF"],"12.0"],"1f3ff":["1f469-1f3ff-200d-1f9af",19,23,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDAF"],"12.0"]},
    "1f469-200d-1f9b0":{"1f3fb":["1f469-1f3fb-200d-1f9b0",19,25,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB0"],"11.0"],"1f3fc":["1f469-1f3fc-200d-1f9b0",19,26,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB0"],"11.0"],"1f3fd":["1f469-1f3fd-200d-1f9b0",19,27,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB0"],"11.0"],"1f3fe":["1f469-1f3fe-200d-1f9b0",19,28,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB0"],"11.0"],"1f3ff":["1f469-1f3ff-200d-1f9b0",19,29,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB0"],"11.0"]},
    "1f469-200d-1f9b1":{"1f3fb":["1f469-1f3fb-200d-1f9b1",19,31,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB1"],"11.0"],"1f3fc":["1f469-1f3fc-200d-1f9b1",19,32,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB1"],"11.0"],"1f3fd":["1f469-1f3fd-200d-1f9b1",19,33,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB1"],"11.0"],"1f3fe":["1f469-1f3fe-200d-1f9b1",19,34,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB1"],"11.0"],"1f3ff":["1f469-1f3ff-200d-1f9b1",19,35,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB1"],"11.0"]},
    "1f469-200d-1f9b2":{"1f3fb":["1f469-1f3fb-200d-1f9b2",19,37,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB2"],"11.0"],"1f3fc":["1f469-1f3fc-200d-1f9b2",19,38,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB2"],"11.0"],"1f3fd":["1f469-1f3fd-200d-1f9b2",19,39,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB2"],"11.0"],"1f3fe":["1f469-1f3fe-200d-1f9b2",19,40,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB2"],"11.0"],"1f3ff":["1f469-1f3ff-200d-1f9b2",19,41,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB2"],"11.0"]},
    "1f469-200d-1f9b3":{"1f3fb":["1f469-1f3fb-200d-1f9b3",19,43,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDB3"],"11.0"],"1f3fc":["1f469-1f3fc-200d-1f9b3",19,44,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDB3"],"11.0"],"1f3fd":["1f469-1f3fd-200d-1f9b3",19,45,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDB3"],"11.0"],"1f3fe":["1f469-1f3fe-200d-1f9b3",19,46,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDB3"],"11.0"],"1f3ff":["1f469-1f3ff-200d-1f9b3",19,47,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDB3"],"11.0"]},
    "1f469-200d-1f9bc-200d-27a1-fe0f":{"1f3fb":["1f469-1f3fb-200d-1f9bc-200d-27a1-fe0f",19,49,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f469-1f3fc-200d-1f9bc-200d-27a1-fe0f",19,50,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f469-1f3fd-200d-1f9bc-200d-27a1-fe0f",19,51,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f469-1f3fe-200d-1f9bc-200d-27a1-fe0f",19,52,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f469-1f3ff-200d-1f9bc-200d-27a1-fe0f",19,53,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"]},
    "1f469-200d-1f9bc":{"1f3fb":["1f469-1f3fb-200d-1f9bc",19,55,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBC"],"12.0"],"1f3fc":["1f469-1f3fc-200d-1f9bc",19,56,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBC"],"12.0"],"1f3fd":["1f469-1f3fd-200d-1f9bc",19,57,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBC"],"12.0"],"1f3fe":["1f469-1f3fe-200d-1f9bc",19,58,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBC"],"12.0"],"1f3ff":["1f469-1f3ff-200d-1f9bc",19,59,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBC"],"12.0"]},
    "1f469-200d-1f9bd-200d-27a1-fe0f":{"1f3fb":["1f469-1f3fb-200d-1f9bd-200d-27a1-fe0f",19,61,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f469-1f3fc-200d-1f9bd-200d-27a1-fe0f",20,0,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f469-1f3fd-200d-1f9bd-200d-27a1-fe0f",20,1,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f469-1f3fe-200d-1f9bd-200d-27a1-fe0f",20,2,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f469-1f3ff-200d-1f9bd-200d-27a1-fe0f",20,3,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"]},
    "1f469-200d-1f9bd":{"1f3fb":["1f469-1f3fb-200d-1f9bd",20,5,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDDBD"],"12.0"],"1f3fc":["1f469-1f3fc-200d-1f9bd",20,6,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDDBD"],"12.0"],"1f3fd":["1f469-1f3fd-200d-1f9bd",20,7,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDDBD"],"12.0"],"1f3fe":["1f469-1f3fe-200d-1f9bd",20,8,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDDBD"],"12.0"],"1f3ff":["1f469-1f3ff-200d-1f9bd",20,9,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDDBD"],"12.0"]},
    "1f469-200d-2695-fe0f":{"1f3fb":["1f469-1f3fb-200d-2695-fe0f",20,11,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2695\uFE0F"],"4.0"],"1f3fc":["1f469-1f3fc-200d-2695-fe0f",20,12,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2695\uFE0F"],"4.0"],"1f3fd":["1f469-1f3fd-200d-2695-fe0f",20,13,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2695\uFE0F"],"4.0"],"1f3fe":["1f469-1f3fe-200d-2695-fe0f",20,14,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2695\uFE0F"],"4.0"],"1f3ff":["1f469-1f3ff-200d-2695-fe0f",20,15,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2695\uFE0F"],"4.0"]},
    "1f469-200d-2696-fe0f":{"1f3fb":["1f469-1f3fb-200d-2696-fe0f",20,17,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2696\uFE0F"],"4.0"],"1f3fc":["1f469-1f3fc-200d-2696-fe0f",20,18,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2696\uFE0F"],"4.0"],"1f3fd":["1f469-1f3fd-200d-2696-fe0f",20,19,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2696\uFE0F"],"4.0"],"1f3fe":["1f469-1f3fe-200d-2696-fe0f",20,20,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2696\uFE0F"],"4.0"],"1f3ff":["1f469-1f3ff-200d-2696-fe0f",20,21,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2696\uFE0F"],"4.0"]},
    "1f469-200d-2708-fe0f":{"1f3fb":["1f469-1f3fb-200d-2708-fe0f",20,23,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2708\uFE0F"],"4.0"],"1f3fc":["1f469-1f3fc-200d-2708-fe0f",20,24,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2708\uFE0F"],"4.0"],"1f3fd":["1f469-1f3fd-200d-2708-fe0f",20,25,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2708\uFE0F"],"4.0"],"1f3fe":["1f469-1f3fe-200d-2708-fe0f",20,26,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2708\uFE0F"],"4.0"],"1f3ff":["1f469-1f3ff-200d-2708-fe0f",20,27,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2708\uFE0F"],"4.0"]},
    "1f469-200d-2764-fe0f-200d-1f468":{"1f3fb-1f3fb":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",20,29,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",20,30,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",20,31,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",20,32,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",20,33,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",20,34,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",20,35,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",20,36,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",20,37,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",20,38,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",20,39,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",20,40,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",20,41,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",20,42,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",20,43,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",20,44,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",20,45,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",20,46,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",20,47,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",20,48,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",20,49,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",20,50,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",20,51,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",20,52,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff",20,53,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"]},
    "1f469-200d-2764-fe0f-200d-1f469":{"1f3fb-1f3fb":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",20,55,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",20,56,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",20,57,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",20,58,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",20,59,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",20,60,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",20,61,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",21,0,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",21,1,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",21,2,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",21,3,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",21,4,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",21,5,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",21,6,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",21,7,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",21,8,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",21,9,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",21,10,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",21,11,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",21,12,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",21,13,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",21,14,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",21,15,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",21,16,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff",21,17,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"]},
    "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468":{"1f3fb-1f3fb":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",21,19,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",21,20,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",21,21,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",21,22,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",21,23,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",21,24,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",21,25,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",21,26,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",21,27,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",21,28,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",21,29,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",21,30,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",21,31,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",21,32,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",21,33,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",21,34,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",21,35,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",21,36,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",21,37,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",21,38,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",21,39,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",21,40,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",21,41,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",21,42,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",21,43,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68\uD83C\uDFFF"],"13.1"]},
    "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469":{"1f3fb-1f3fb":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",21,45,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fb-1f3fc":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",21,46,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",21,47,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",21,48,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",21,49,["\uD83D\uDC69\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",21,50,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fc":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",21,51,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fc-1f3fd":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",21,52,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",21,53,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",21,54,["\uD83D\uDC69\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",21,55,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",21,56,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fd":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",21,57,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fd-1f3fe":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",21,58,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",21,59,["\uD83D\uDC69\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",21,60,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",21,61,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",22,0,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3fe-1f3fe":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",22,1,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3fe-1f3ff":["1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",22,2,["\uD83D\uDC69\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",22,3,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",22,4,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",22,5,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",22,6,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFE"],"13.1"],"1f3ff-1f3ff":["1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",22,7,["\uD83D\uDC69\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69\uD83C\uDFFF"],"13.1"]},
    "1f469":{"1f3fb":["1f469-1f3fb",22,9,["\uD83D\uDC69\uD83C\uDFFB"],"1.0"],"1f3fc":["1f469-1f3fc",22,10,["\uD83D\uDC69\uD83C\uDFFC"],"1.0"],"1f3fd":["1f469-1f3fd",22,11,["\uD83D\uDC69\uD83C\uDFFD"],"1.0"],"1f3fe":["1f469-1f3fe",22,12,["\uD83D\uDC69\uD83C\uDFFE"],"1.0"],"1f3ff":["1f469-1f3ff",22,13,["\uD83D\uDC69\uD83C\uDFFF"],"1.0"]},
    "1f46b":{"1f3fb":["1f46b-1f3fb",22,16,["\uD83D\uDC6B\uD83C\uDFFB"],"12.0"],"1f3fc":["1f46b-1f3fc",22,17,["\uD83D\uDC6B\uD83C\uDFFC"],"12.0"],"1f3fd":["1f46b-1f3fd",22,18,["\uD83D\uDC6B\uD83C\uDFFD"],"12.0"],"1f3fe":["1f46b-1f3fe",22,19,["\uD83D\uDC6B\uD83C\uDFFE"],"12.0"],"1f3ff":["1f46b-1f3ff",22,20,["\uD83D\uDC6B\uD83C\uDFFF"],"12.0"],"1f3fb-1f3fc":["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",22,21,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3fb-1f3fd":["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",22,22,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3fb-1f3fe":["1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",22,23,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.0"],"1f3fb-1f3ff":["1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",22,24,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.0"],"1f3fc-1f3fb":["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",22,25,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fc-1f3fd":["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",22,26,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3fc-1f3fe":["1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",22,27,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.0"],"1f3fc-1f3ff":["1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",22,28,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.0"],"1f3fd-1f3fb":["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",22,29,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fd-1f3fc":["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",22,30,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3fd-1f3fe":["1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",22,31,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.0"],"1f3fd-1f3ff":["1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",22,32,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.0"],"1f3fe-1f3fb":["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",22,33,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fe-1f3fc":["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",22,34,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3fe-1f3fd":["1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",22,35,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3fe-1f3ff":["1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",22,36,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.0"],"1f3ff-1f3fb":["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",22,37,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3ff-1f3fc":["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",22,38,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3ff-1f3fd":["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",22,39,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3ff-1f3fe":["1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe",22,40,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.0"]},
    "1f46c":{"1f3fb":["1f46c-1f3fb",22,42,["\uD83D\uDC6C\uD83C\uDFFB"],"12.0"],"1f3fc":["1f46c-1f3fc",22,43,["\uD83D\uDC6C\uD83C\uDFFC"],"12.0"],"1f3fd":["1f46c-1f3fd",22,44,["\uD83D\uDC6C\uD83C\uDFFD"],"12.0"],"1f3fe":["1f46c-1f3fe",22,45,["\uD83D\uDC6C\uD83C\uDFFE"],"12.0"],"1f3ff":["1f46c-1f3ff",22,46,["\uD83D\uDC6C\uD83C\uDFFF"],"12.0"],"1f3fb-1f3fc":["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",22,47,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.1"],"1f3fb-1f3fd":["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",22,48,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.1"],"1f3fb-1f3fe":["1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",22,49,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.1"],"1f3fb-1f3ff":["1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",22,50,["\uD83D\uDC68\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.1"],"1f3fc-1f3fb":["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",22,51,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fc-1f3fd":["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",22,52,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.1"],"1f3fc-1f3fe":["1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",22,53,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.1"],"1f3fc-1f3ff":["1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",22,54,["\uD83D\uDC68\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.1"],"1f3fd-1f3fb":["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",22,55,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fd-1f3fc":["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",22,56,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3fd-1f3fe":["1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",22,57,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.1"],"1f3fd-1f3ff":["1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",22,58,["\uD83D\uDC68\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.1"],"1f3fe-1f3fb":["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",22,59,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3fe-1f3fc":["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",22,60,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3fe-1f3fd":["1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",22,61,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3fe-1f3ff":["1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",23,0,["\uD83D\uDC68\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFF"],"12.1"],"1f3ff-1f3fb":["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",23,1,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFB"],"12.0"],"1f3ff-1f3fc":["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",23,2,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFC"],"12.0"],"1f3ff-1f3fd":["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",23,3,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFD"],"12.0"],"1f3ff-1f3fe":["1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe",23,4,["\uD83D\uDC68\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC68\uD83C\uDFFE"],"12.0"]},
    "1f46d":{"1f3fb":["1f46d-1f3fb",23,6,["\uD83D\uDC6D\uD83C\uDFFB"],"12.0"],"1f3fc":["1f46d-1f3fc",23,7,["\uD83D\uDC6D\uD83C\uDFFC"],"12.0"],"1f3fd":["1f46d-1f3fd",23,8,["\uD83D\uDC6D\uD83C\uDFFD"],"12.0"],"1f3fe":["1f46d-1f3fe",23,9,["\uD83D\uDC6D\uD83C\uDFFE"],"12.0"],"1f3ff":["1f46d-1f3ff",23,10,["\uD83D\uDC6D\uD83C\uDFFF"],"12.0"],"1f3fb-1f3fc":["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",23,11,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC"],"12.1"],"1f3fb-1f3fd":["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",23,12,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD"],"12.1"],"1f3fb-1f3fe":["1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",23,13,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE"],"12.1"],"1f3fb-1f3ff":["1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",23,14,["\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF"],"12.1"],"1f3fc-1f3fb":["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",23,15,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB"],"12.0"],"1f3fc-1f3fd":["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",23,16,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD"],"12.1"],"1f3fc-1f3fe":["1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",23,17,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE"],"12.1"],"1f3fc-1f3ff":["1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",23,18,["\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF"],"12.1"],"1f3fd-1f3fb":["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",23,19,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB"],"12.0"],"1f3fd-1f3fc":["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",23,20,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC"],"12.0"],"1f3fd-1f3fe":["1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",23,21,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE"],"12.1"],"1f3fd-1f3ff":["1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",23,22,["\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF"],"12.1"],"1f3fe-1f3fb":["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",23,23,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB"],"12.0"],"1f3fe-1f3fc":["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",23,24,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC"],"12.0"],"1f3fe-1f3fd":["1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",23,25,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD"],"12.0"],"1f3fe-1f3ff":["1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",23,26,["\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFF"],"12.1"],"1f3ff-1f3fb":["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",23,27,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFB"],"12.0"],"1f3ff-1f3fc":["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",23,28,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFC"],"12.0"],"1f3ff-1f3fd":["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",23,29,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFD"],"12.0"],"1f3ff-1f3fe":["1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe",23,30,["\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83D\uDC69\uD83C\uDFFE"],"12.0"]},
    "1f46e-200d-2640-fe0f":{"1f3fb":["1f46e-1f3fb-200d-2640-fe0f",23,32,["\uD83D\uDC6E\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f46e-1f3fc-200d-2640-fe0f",23,33,["\uD83D\uDC6E\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f46e-1f3fd-200d-2640-fe0f",23,34,["\uD83D\uDC6E\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f46e-1f3fe-200d-2640-fe0f",23,35,["\uD83D\uDC6E\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f46e-1f3ff-200d-2640-fe0f",23,36,["\uD83D\uDC6E\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f46e-200d-2642-fe0f":{"1f3fb":["1f46e-1f3fb-200d-2642-fe0f",23,38,["\uD83D\uDC6E\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f46e-1f3fc-200d-2642-fe0f",23,39,["\uD83D\uDC6E\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f46e-1f3fd-200d-2642-fe0f",23,40,["\uD83D\uDC6E\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f46e-1f3fe-200d-2642-fe0f",23,41,["\uD83D\uDC6E\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f46e-1f3ff-200d-2642-fe0f",23,42,["\uD83D\uDC6E\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f470-200d-2640-fe0f":{"1f3fb":["1f470-1f3fb-200d-2640-fe0f",23,53,["\uD83D\uDC70\uD83C\uDFFB\u200D\u2640\uFE0F"],"13.0"],"1f3fc":["1f470-1f3fc-200d-2640-fe0f",23,54,["\uD83D\uDC70\uD83C\uDFFC\u200D\u2640\uFE0F"],"13.0"],"1f3fd":["1f470-1f3fd-200d-2640-fe0f",23,55,["\uD83D\uDC70\uD83C\uDFFD\u200D\u2640\uFE0F"],"13.0"],"1f3fe":["1f470-1f3fe-200d-2640-fe0f",23,56,["\uD83D\uDC70\uD83C\uDFFE\u200D\u2640\uFE0F"],"13.0"],"1f3ff":["1f470-1f3ff-200d-2640-fe0f",23,57,["\uD83D\uDC70\uD83C\uDFFF\u200D\u2640\uFE0F"],"13.0"]},
    "1f470-200d-2642-fe0f":{"1f3fb":["1f470-1f3fb-200d-2642-fe0f",23,59,["\uD83D\uDC70\uD83C\uDFFB\u200D\u2642\uFE0F"],"13.0"],"1f3fc":["1f470-1f3fc-200d-2642-fe0f",23,60,["\uD83D\uDC70\uD83C\uDFFC\u200D\u2642\uFE0F"],"13.0"],"1f3fd":["1f470-1f3fd-200d-2642-fe0f",23,61,["\uD83D\uDC70\uD83C\uDFFD\u200D\u2642\uFE0F"],"13.0"],"1f3fe":["1f470-1f3fe-200d-2642-fe0f",24,0,["\uD83D\uDC70\uD83C\uDFFE\u200D\u2642\uFE0F"],"13.0"],"1f3ff":["1f470-1f3ff-200d-2642-fe0f",24,1,["\uD83D\uDC70\uD83C\uDFFF\u200D\u2642\uFE0F"],"13.0"]},
    "1f470":{"1f3fb":["1f470-1f3fb",24,3,["\uD83D\uDC70\uD83C\uDFFB"],"1.0"],"1f3fc":["1f470-1f3fc",24,4,["\uD83D\uDC70\uD83C\uDFFC"],"1.0"],"1f3fd":["1f470-1f3fd",24,5,["\uD83D\uDC70\uD83C\uDFFD"],"1.0"],"1f3fe":["1f470-1f3fe",24,6,["\uD83D\uDC70\uD83C\uDFFE"],"1.0"],"1f3ff":["1f470-1f3ff",24,7,["\uD83D\uDC70\uD83C\uDFFF"],"1.0"]},
    "1f471-200d-2640-fe0f":{"1f3fb":["1f471-1f3fb-200d-2640-fe0f",24,9,["\uD83D\uDC71\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f471-1f3fc-200d-2640-fe0f",24,10,["\uD83D\uDC71\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f471-1f3fd-200d-2640-fe0f",24,11,["\uD83D\uDC71\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f471-1f3fe-200d-2640-fe0f",24,12,["\uD83D\uDC71\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f471-1f3ff-200d-2640-fe0f",24,13,["\uD83D\uDC71\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f471-200d-2642-fe0f":{"1f3fb":["1f471-1f3fb-200d-2642-fe0f",24,15,["\uD83D\uDC71\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f471-1f3fc-200d-2642-fe0f",24,16,["\uD83D\uDC71\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f471-1f3fd-200d-2642-fe0f",24,17,["\uD83D\uDC71\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f471-1f3fe-200d-2642-fe0f",24,18,["\uD83D\uDC71\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f471-1f3ff-200d-2642-fe0f",24,19,["\uD83D\uDC71\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f472":{"1f3fb":["1f472-1f3fb",24,27,["\uD83D\uDC72\uD83C\uDFFB"],"1.0"],"1f3fc":["1f472-1f3fc",24,28,["\uD83D\uDC72\uD83C\uDFFC"],"1.0"],"1f3fd":["1f472-1f3fd",24,29,["\uD83D\uDC72\uD83C\uDFFD"],"1.0"],"1f3fe":["1f472-1f3fe",24,30,["\uD83D\uDC72\uD83C\uDFFE"],"1.0"],"1f3ff":["1f472-1f3ff",24,31,["\uD83D\uDC72\uD83C\uDFFF"],"1.0"]},
    "1f473-200d-2640-fe0f":{"1f3fb":["1f473-1f3fb-200d-2640-fe0f",24,33,["\uD83D\uDC73\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f473-1f3fc-200d-2640-fe0f",24,34,["\uD83D\uDC73\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f473-1f3fd-200d-2640-fe0f",24,35,["\uD83D\uDC73\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f473-1f3fe-200d-2640-fe0f",24,36,["\uD83D\uDC73\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f473-1f3ff-200d-2640-fe0f",24,37,["\uD83D\uDC73\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f473-200d-2642-fe0f":{"1f3fb":["1f473-1f3fb-200d-2642-fe0f",24,39,["\uD83D\uDC73\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f473-1f3fc-200d-2642-fe0f",24,40,["\uD83D\uDC73\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f473-1f3fd-200d-2642-fe0f",24,41,["\uD83D\uDC73\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f473-1f3fe-200d-2642-fe0f",24,42,["\uD83D\uDC73\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f473-1f3ff-200d-2642-fe0f",24,43,["\uD83D\uDC73\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f474":{"1f3fb":["1f474-1f3fb",24,51,["\uD83D\uDC74\uD83C\uDFFB"],"1.0"],"1f3fc":["1f474-1f3fc",24,52,["\uD83D\uDC74\uD83C\uDFFC"],"1.0"],"1f3fd":["1f474-1f3fd",24,53,["\uD83D\uDC74\uD83C\uDFFD"],"1.0"],"1f3fe":["1f474-1f3fe",24,54,["\uD83D\uDC74\uD83C\uDFFE"],"1.0"],"1f3ff":["1f474-1f3ff",24,55,["\uD83D\uDC74\uD83C\uDFFF"],"1.0"]},
    "1f475":{"1f3fb":["1f475-1f3fb",24,57,["\uD83D\uDC75\uD83C\uDFFB"],"1.0"],"1f3fc":["1f475-1f3fc",24,58,["\uD83D\uDC75\uD83C\uDFFC"],"1.0"],"1f3fd":["1f475-1f3fd",24,59,["\uD83D\uDC75\uD83C\uDFFD"],"1.0"],"1f3fe":["1f475-1f3fe",24,60,["\uD83D\uDC75\uD83C\uDFFE"],"1.0"],"1f3ff":["1f475-1f3ff",24,61,["\uD83D\uDC75\uD83C\uDFFF"],"1.0"]},
    "1f476":{"1f3fb":["1f476-1f3fb",25,1,["\uD83D\uDC76\uD83C\uDFFB"],"1.0"],"1f3fc":["1f476-1f3fc",25,2,["\uD83D\uDC76\uD83C\uDFFC"],"1.0"],"1f3fd":["1f476-1f3fd",25,3,["\uD83D\uDC76\uD83C\uDFFD"],"1.0"],"1f3fe":["1f476-1f3fe",25,4,["\uD83D\uDC76\uD83C\uDFFE"],"1.0"],"1f3ff":["1f476-1f3ff",25,5,["\uD83D\uDC76\uD83C\uDFFF"],"1.0"]},
    "1f477-200d-2640-fe0f":{"1f3fb":["1f477-1f3fb-200d-2640-fe0f",25,7,["\uD83D\uDC77\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f477-1f3fc-200d-2640-fe0f",25,8,["\uD83D\uDC77\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f477-1f3fd-200d-2640-fe0f",25,9,["\uD83D\uDC77\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f477-1f3fe-200d-2640-fe0f",25,10,["\uD83D\uDC77\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f477-1f3ff-200d-2640-fe0f",25,11,["\uD83D\uDC77\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f477-200d-2642-fe0f":{"1f3fb":["1f477-1f3fb-200d-2642-fe0f",25,13,["\uD83D\uDC77\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f477-1f3fc-200d-2642-fe0f",25,14,["\uD83D\uDC77\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f477-1f3fd-200d-2642-fe0f",25,15,["\uD83D\uDC77\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f477-1f3fe-200d-2642-fe0f",25,16,["\uD83D\uDC77\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f477-1f3ff-200d-2642-fe0f",25,17,["\uD83D\uDC77\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f478":{"1f3fb":["1f478-1f3fb",25,25,["\uD83D\uDC78\uD83C\uDFFB"],"1.0"],"1f3fc":["1f478-1f3fc",25,26,["\uD83D\uDC78\uD83C\uDFFC"],"1.0"],"1f3fd":["1f478-1f3fd",25,27,["\uD83D\uDC78\uD83C\uDFFD"],"1.0"],"1f3fe":["1f478-1f3fe",25,28,["\uD83D\uDC78\uD83C\uDFFE"],"1.0"],"1f3ff":["1f478-1f3ff",25,29,["\uD83D\uDC78\uD83C\uDFFF"],"1.0"]},
    "1f47c":{"1f3fb":["1f47c-1f3fb",25,34,["\uD83D\uDC7C\uD83C\uDFFB"],"1.0"],"1f3fc":["1f47c-1f3fc",25,35,["\uD83D\uDC7C\uD83C\uDFFC"],"1.0"],"1f3fd":["1f47c-1f3fd",25,36,["\uD83D\uDC7C\uD83C\uDFFD"],"1.0"],"1f3fe":["1f47c-1f3fe",25,37,["\uD83D\uDC7C\uD83C\uDFFE"],"1.0"],"1f3ff":["1f47c-1f3ff",25,38,["\uD83D\uDC7C\uD83C\uDFFF"],"1.0"]},
    "1f481-200d-2640-fe0f":{"1f3fb":["1f481-1f3fb-200d-2640-fe0f",25,44,["\uD83D\uDC81\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f481-1f3fc-200d-2640-fe0f",25,45,["\uD83D\uDC81\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f481-1f3fd-200d-2640-fe0f",25,46,["\uD83D\uDC81\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f481-1f3fe-200d-2640-fe0f",25,47,["\uD83D\uDC81\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f481-1f3ff-200d-2640-fe0f",25,48,["\uD83D\uDC81\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f481-200d-2642-fe0f":{"1f3fb":["1f481-1f3fb-200d-2642-fe0f",25,50,["\uD83D\uDC81\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f481-1f3fc-200d-2642-fe0f",25,51,["\uD83D\uDC81\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f481-1f3fd-200d-2642-fe0f",25,52,["\uD83D\uDC81\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f481-1f3fe-200d-2642-fe0f",25,53,["\uD83D\uDC81\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f481-1f3ff-200d-2642-fe0f",25,54,["\uD83D\uDC81\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f482-200d-2640-fe0f":{"1f3fb":["1f482-1f3fb-200d-2640-fe0f",26,0,["\uD83D\uDC82\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f482-1f3fc-200d-2640-fe0f",26,1,["\uD83D\uDC82\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f482-1f3fd-200d-2640-fe0f",26,2,["\uD83D\uDC82\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f482-1f3fe-200d-2640-fe0f",26,3,["\uD83D\uDC82\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f482-1f3ff-200d-2640-fe0f",26,4,["\uD83D\uDC82\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f482-200d-2642-fe0f":{"1f3fb":["1f482-1f3fb-200d-2642-fe0f",26,6,["\uD83D\uDC82\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f482-1f3fc-200d-2642-fe0f",26,7,["\uD83D\uDC82\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f482-1f3fd-200d-2642-fe0f",26,8,["\uD83D\uDC82\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f482-1f3fe-200d-2642-fe0f",26,9,["\uD83D\uDC82\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f482-1f3ff-200d-2642-fe0f",26,10,["\uD83D\uDC82\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f483":{"1f3fb":["1f483-1f3fb",26,18,["\uD83D\uDC83\uD83C\uDFFB"],"1.0"],"1f3fc":["1f483-1f3fc",26,19,["\uD83D\uDC83\uD83C\uDFFC"],"1.0"],"1f3fd":["1f483-1f3fd",26,20,["\uD83D\uDC83\uD83C\uDFFD"],"1.0"],"1f3fe":["1f483-1f3fe",26,21,["\uD83D\uDC83\uD83C\uDFFE"],"1.0"],"1f3ff":["1f483-1f3ff",26,22,["\uD83D\uDC83\uD83C\uDFFF"],"1.0"]},
    "1f485":{"1f3fb":["1f485-1f3fb",26,25,["\uD83D\uDC85\uD83C\uDFFB"],"1.0"],"1f3fc":["1f485-1f3fc",26,26,["\uD83D\uDC85\uD83C\uDFFC"],"1.0"],"1f3fd":["1f485-1f3fd",26,27,["\uD83D\uDC85\uD83C\uDFFD"],"1.0"],"1f3fe":["1f485-1f3fe",26,28,["\uD83D\uDC85\uD83C\uDFFE"],"1.0"],"1f3ff":["1f485-1f3ff",26,29,["\uD83D\uDC85\uD83C\uDFFF"],"1.0"]},
    "1f486-200d-2640-fe0f":{"1f3fb":["1f486-1f3fb-200d-2640-fe0f",26,31,["\uD83D\uDC86\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f486-1f3fc-200d-2640-fe0f",26,32,["\uD83D\uDC86\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f486-1f3fd-200d-2640-fe0f",26,33,["\uD83D\uDC86\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f486-1f3fe-200d-2640-fe0f",26,34,["\uD83D\uDC86\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f486-1f3ff-200d-2640-fe0f",26,35,["\uD83D\uDC86\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f486-200d-2642-fe0f":{"1f3fb":["1f486-1f3fb-200d-2642-fe0f",26,37,["\uD83D\uDC86\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f486-1f3fc-200d-2642-fe0f",26,38,["\uD83D\uDC86\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f486-1f3fd-200d-2642-fe0f",26,39,["\uD83D\uDC86\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f486-1f3fe-200d-2642-fe0f",26,40,["\uD83D\uDC86\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f486-1f3ff-200d-2642-fe0f",26,41,["\uD83D\uDC86\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f487-200d-2640-fe0f":{"1f3fb":["1f487-1f3fb-200d-2640-fe0f",26,49,["\uD83D\uDC87\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f487-1f3fc-200d-2640-fe0f",26,50,["\uD83D\uDC87\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f487-1f3fd-200d-2640-fe0f",26,51,["\uD83D\uDC87\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f487-1f3fe-200d-2640-fe0f",26,52,["\uD83D\uDC87\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f487-1f3ff-200d-2640-fe0f",26,53,["\uD83D\uDC87\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f487-200d-2642-fe0f":{"1f3fb":["1f487-1f3fb-200d-2642-fe0f",26,55,["\uD83D\uDC87\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f487-1f3fc-200d-2642-fe0f",26,56,["\uD83D\uDC87\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f487-1f3fd-200d-2642-fe0f",26,57,["\uD83D\uDC87\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f487-1f3fe-200d-2642-fe0f",26,58,["\uD83D\uDC87\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f487-1f3ff-200d-2642-fe0f",26,59,["\uD83D\uDC87\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f48f":{"1f3fb":["1f48f-1f3fb",27,12,["\uD83D\uDC8F\uD83C\uDFFB"],"13.1"],"1f3fc":["1f48f-1f3fc",27,13,["\uD83D\uDC8F\uD83C\uDFFC"],"13.1"],"1f3fd":["1f48f-1f3fd",27,14,["\uD83D\uDC8F\uD83C\uDFFD"],"13.1"],"1f3fe":["1f48f-1f3fe",27,15,["\uD83D\uDC8F\uD83C\uDFFE"],"13.1"],"1f3ff":["1f48f-1f3ff",27,16,["\uD83D\uDC8F\uD83C\uDFFF"],"13.1"],"1f3fb-1f3fc":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",27,17,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",27,18,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",27,19,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",27,20,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",27,21,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fd":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",27,22,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",27,23,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",27,24,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",27,25,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",27,26,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fe":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",27,27,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",27,28,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",27,29,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",27,30,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",27,31,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fe-1f3ff":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",27,32,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",27,33,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",27,34,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",27,35,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",27,36,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"]},
    "1f491":{"1f3fb":["1f491-1f3fb",27,39,["\uD83D\uDC91\uD83C\uDFFB"],"13.1"],"1f3fc":["1f491-1f3fc",27,40,["\uD83D\uDC91\uD83C\uDFFC"],"13.1"],"1f3fd":["1f491-1f3fd",27,41,["\uD83D\uDC91\uD83C\uDFFD"],"13.1"],"1f3fe":["1f491-1f3fe",27,42,["\uD83D\uDC91\uD83C\uDFFE"],"13.1"],"1f3ff":["1f491-1f3ff",27,43,["\uD83D\uDC91\uD83C\uDFFF"],"13.1"],"1f3fb-1f3fc":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",27,44,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fb-1f3fd":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",27,45,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fb-1f3fe":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",27,46,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fb-1f3ff":["1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",27,47,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fc-1f3fb":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",27,48,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fc-1f3fd":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",27,49,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fc-1f3fe":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",27,50,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fc-1f3ff":["1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",27,51,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fd-1f3fb":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",27,52,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fd-1f3fc":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",27,53,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fd-1f3fe":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",27,54,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"],"1f3fd-1f3ff":["1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",27,55,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3fe-1f3fb":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",27,56,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3fe-1f3fc":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",27,57,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3fe-1f3fd":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",27,58,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3fe-1f3ff":["1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",27,59,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFF"],"13.1"],"1f3ff-1f3fb":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",27,60,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFB"],"13.1"],"1f3ff-1f3fc":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",27,61,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFC"],"13.1"],"1f3ff-1f3fd":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",28,0,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFD"],"13.1"],"1f3ff-1f3fe":["1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe",28,1,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D\uD83E\uDDD1\uD83C\uDFFE"],"13.1"]},
    "1f4aa":{"1f3fb":["1f4aa-1f3fb",28,27,["\uD83D\uDCAA\uD83C\uDFFB"],"1.0"],"1f3fc":["1f4aa-1f3fc",28,28,["\uD83D\uDCAA\uD83C\uDFFC"],"1.0"],"1f3fd":["1f4aa-1f3fd",28,29,["\uD83D\uDCAA\uD83C\uDFFD"],"1.0"],"1f3fe":["1f4aa-1f3fe",28,30,["\uD83D\uDCAA\uD83C\uDFFE"],"1.0"],"1f3ff":["1f4aa-1f3ff",28,31,["\uD83D\uDCAA\uD83C\uDFFF"],"1.0"]},
    "1f574-fe0f":{"1f3fb":["1f574-1f3fb",31,26,["\uD83D\uDD74\uD83C\uDFFB"],"4.0"],"1f3fc":["1f574-1f3fc",31,27,["\uD83D\uDD74\uD83C\uDFFC"],"4.0"],"1f3fd":["1f574-1f3fd",31,28,["\uD83D\uDD74\uD83C\uDFFD"],"4.0"],"1f3fe":["1f574-1f3fe",31,29,["\uD83D\uDD74\uD83C\uDFFE"],"4.0"],"1f3ff":["1f574-1f3ff",31,30,["\uD83D\uDD74\uD83C\uDFFF"],"4.0"]},
    "1f575-fe0f-200d-2640-fe0f":{"1f3fb":["1f575-1f3fb-200d-2640-fe0f",31,32,["\uD83D\uDD75\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f575-1f3fc-200d-2640-fe0f",31,33,["\uD83D\uDD75\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f575-1f3fd-200d-2640-fe0f",31,34,["\uD83D\uDD75\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f575-1f3fe-200d-2640-fe0f",31,35,["\uD83D\uDD75\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f575-1f3ff-200d-2640-fe0f",31,36,["\uD83D\uDD75\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f575-fe0f-200d-2642-fe0f":{"1f3fb":["1f575-1f3fb-200d-2642-fe0f",31,38,["\uD83D\uDD75\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f575-1f3fc-200d-2642-fe0f",31,39,["\uD83D\uDD75\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f575-1f3fd-200d-2642-fe0f",31,40,["\uD83D\uDD75\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f575-1f3fe-200d-2642-fe0f",31,41,["\uD83D\uDD75\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f575-1f3ff-200d-2642-fe0f",31,42,["\uD83D\uDD75\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f57a":{"1f3fb":["1f57a-1f3fb",31,54,["\uD83D\uDD7A\uD83C\uDFFB"],"3.0"],"1f3fc":["1f57a-1f3fc",31,55,["\uD83D\uDD7A\uD83C\uDFFC"],"3.0"],"1f3fd":["1f57a-1f3fd",31,56,["\uD83D\uDD7A\uD83C\uDFFD"],"3.0"],"1f3fe":["1f57a-1f3fe",31,57,["\uD83D\uDD7A\uD83C\uDFFE"],"3.0"],"1f3ff":["1f57a-1f3ff",31,58,["\uD83D\uDD7A\uD83C\uDFFF"],"3.0"]},
    "1f590-fe0f":{"1f3fb":["1f590-1f3fb",32,3,["\uD83D\uDD90\uD83C\uDFFB"],"1.0"],"1f3fc":["1f590-1f3fc",32,4,["\uD83D\uDD90\uD83C\uDFFC"],"1.0"],"1f3fd":["1f590-1f3fd",32,5,["\uD83D\uDD90\uD83C\uDFFD"],"1.0"],"1f3fe":["1f590-1f3fe",32,6,["\uD83D\uDD90\uD83C\uDFFE"],"1.0"],"1f3ff":["1f590-1f3ff",32,7,["\uD83D\uDD90\uD83C\uDFFF"],"1.0"]},
    "1f595":{"1f3fb":["1f595-1f3fb",32,9,["\uD83D\uDD95\uD83C\uDFFB"],"1.0"],"1f3fc":["1f595-1f3fc",32,10,["\uD83D\uDD95\uD83C\uDFFC"],"1.0"],"1f3fd":["1f595-1f3fd",32,11,["\uD83D\uDD95\uD83C\uDFFD"],"1.0"],"1f3fe":["1f595-1f3fe",32,12,["\uD83D\uDD95\uD83C\uDFFE"],"1.0"],"1f3ff":["1f595-1f3ff",32,13,["\uD83D\uDD95\uD83C\uDFFF"],"1.0"]},
    "1f596":{"1f3fb":["1f596-1f3fb",32,15,["\uD83D\uDD96\uD83C\uDFFB"],"1.0"],"1f3fc":["1f596-1f3fc",32,16,["\uD83D\uDD96\uD83C\uDFFC"],"1.0"],"1f3fd":["1f596-1f3fd",32,17,["\uD83D\uDD96\uD83C\uDFFD"],"1.0"],"1f3fe":["1f596-1f3fe",32,18,["\uD83D\uDD96\uD83C\uDFFE"],"1.0"],"1f3ff":["1f596-1f3ff",32,19,["\uD83D\uDD96\uD83C\uDFFF"],"1.0"]},
    "1f645-200d-2640-fe0f":{"1f3fb":["1f645-1f3fb-200d-2640-fe0f",33,59,["\uD83D\uDE45\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f645-1f3fc-200d-2640-fe0f",33,60,["\uD83D\uDE45\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f645-1f3fd-200d-2640-fe0f",33,61,["\uD83D\uDE45\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f645-1f3fe-200d-2640-fe0f",34,0,["\uD83D\uDE45\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f645-1f3ff-200d-2640-fe0f",34,1,["\uD83D\uDE45\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f645-200d-2642-fe0f":{"1f3fb":["1f645-1f3fb-200d-2642-fe0f",34,3,["\uD83D\uDE45\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f645-1f3fc-200d-2642-fe0f",34,4,["\uD83D\uDE45\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f645-1f3fd-200d-2642-fe0f",34,5,["\uD83D\uDE45\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f645-1f3fe-200d-2642-fe0f",34,6,["\uD83D\uDE45\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f645-1f3ff-200d-2642-fe0f",34,7,["\uD83D\uDE45\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f646-200d-2640-fe0f":{"1f3fb":["1f646-1f3fb-200d-2640-fe0f",34,15,["\uD83D\uDE46\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f646-1f3fc-200d-2640-fe0f",34,16,["\uD83D\uDE46\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f646-1f3fd-200d-2640-fe0f",34,17,["\uD83D\uDE46\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f646-1f3fe-200d-2640-fe0f",34,18,["\uD83D\uDE46\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f646-1f3ff-200d-2640-fe0f",34,19,["\uD83D\uDE46\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f646-200d-2642-fe0f":{"1f3fb":["1f646-1f3fb-200d-2642-fe0f",34,21,["\uD83D\uDE46\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f646-1f3fc-200d-2642-fe0f",34,22,["\uD83D\uDE46\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f646-1f3fd-200d-2642-fe0f",34,23,["\uD83D\uDE46\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f646-1f3fe-200d-2642-fe0f",34,24,["\uD83D\uDE46\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f646-1f3ff-200d-2642-fe0f",34,25,["\uD83D\uDE46\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f647-200d-2640-fe0f":{"1f3fb":["1f647-1f3fb-200d-2640-fe0f",34,33,["\uD83D\uDE47\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f647-1f3fc-200d-2640-fe0f",34,34,["\uD83D\uDE47\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f647-1f3fd-200d-2640-fe0f",34,35,["\uD83D\uDE47\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f647-1f3fe-200d-2640-fe0f",34,36,["\uD83D\uDE47\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f647-1f3ff-200d-2640-fe0f",34,37,["\uD83D\uDE47\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f647-200d-2642-fe0f":{"1f3fb":["1f647-1f3fb-200d-2642-fe0f",34,39,["\uD83D\uDE47\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f647-1f3fc-200d-2642-fe0f",34,40,["\uD83D\uDE47\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f647-1f3fd-200d-2642-fe0f",34,41,["\uD83D\uDE47\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f647-1f3fe-200d-2642-fe0f",34,42,["\uD83D\uDE47\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f647-1f3ff-200d-2642-fe0f",34,43,["\uD83D\uDE47\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f647":{"1f3fb":["1f647-1f3fb",34,45,["\uD83D\uDE47\uD83C\uDFFB"],"1.0"],"1f3fc":["1f647-1f3fc",34,46,["\uD83D\uDE47\uD83C\uDFFC"],"1.0"],"1f3fd":["1f647-1f3fd",34,47,["\uD83D\uDE47\uD83C\uDFFD"],"1.0"],"1f3fe":["1f647-1f3fe",34,48,["\uD83D\uDE47\uD83C\uDFFE"],"1.0"],"1f3ff":["1f647-1f3ff",34,49,["\uD83D\uDE47\uD83C\uDFFF"],"1.0"]},
    "1f64b-200d-2640-fe0f":{"1f3fb":["1f64b-1f3fb-200d-2640-fe0f",34,54,["\uD83D\uDE4B\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f64b-1f3fc-200d-2640-fe0f",34,55,["\uD83D\uDE4B\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f64b-1f3fd-200d-2640-fe0f",34,56,["\uD83D\uDE4B\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f64b-1f3fe-200d-2640-fe0f",34,57,["\uD83D\uDE4B\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f64b-1f3ff-200d-2640-fe0f",34,58,["\uD83D\uDE4B\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f64b-200d-2642-fe0f":{"1f3fb":["1f64b-1f3fb-200d-2642-fe0f",34,60,["\uD83D\uDE4B\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f64b-1f3fc-200d-2642-fe0f",34,61,["\uD83D\uDE4B\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f64b-1f3fd-200d-2642-fe0f",35,0,["\uD83D\uDE4B\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f64b-1f3fe-200d-2642-fe0f",35,1,["\uD83D\uDE4B\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f64b-1f3ff-200d-2642-fe0f",35,2,["\uD83D\uDE4B\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f64c":{"1f3fb":["1f64c-1f3fb",35,10,["\uD83D\uDE4C\uD83C\uDFFB"],"1.0"],"1f3fc":["1f64c-1f3fc",35,11,["\uD83D\uDE4C\uD83C\uDFFC"],"1.0"],"1f3fd":["1f64c-1f3fd",35,12,["\uD83D\uDE4C\uD83C\uDFFD"],"1.0"],"1f3fe":["1f64c-1f3fe",35,13,["\uD83D\uDE4C\uD83C\uDFFE"],"1.0"],"1f3ff":["1f64c-1f3ff",35,14,["\uD83D\uDE4C\uD83C\uDFFF"],"1.0"]},
    "1f64d-200d-2640-fe0f":{"1f3fb":["1f64d-1f3fb-200d-2640-fe0f",35,16,["\uD83D\uDE4D\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f64d-1f3fc-200d-2640-fe0f",35,17,["\uD83D\uDE4D\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f64d-1f3fd-200d-2640-fe0f",35,18,["\uD83D\uDE4D\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f64d-1f3fe-200d-2640-fe0f",35,19,["\uD83D\uDE4D\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f64d-1f3ff-200d-2640-fe0f",35,20,["\uD83D\uDE4D\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f64d-200d-2642-fe0f":{"1f3fb":["1f64d-1f3fb-200d-2642-fe0f",35,22,["\uD83D\uDE4D\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f64d-1f3fc-200d-2642-fe0f",35,23,["\uD83D\uDE4D\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f64d-1f3fd-200d-2642-fe0f",35,24,["\uD83D\uDE4D\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f64d-1f3fe-200d-2642-fe0f",35,25,["\uD83D\uDE4D\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f64d-1f3ff-200d-2642-fe0f",35,26,["\uD83D\uDE4D\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f64e-200d-2640-fe0f":{"1f3fb":["1f64e-1f3fb-200d-2640-fe0f",35,34,["\uD83D\uDE4E\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f64e-1f3fc-200d-2640-fe0f",35,35,["\uD83D\uDE4E\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f64e-1f3fd-200d-2640-fe0f",35,36,["\uD83D\uDE4E\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f64e-1f3fe-200d-2640-fe0f",35,37,["\uD83D\uDE4E\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f64e-1f3ff-200d-2640-fe0f",35,38,["\uD83D\uDE4E\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f64e-200d-2642-fe0f":{"1f3fb":["1f64e-1f3fb-200d-2642-fe0f",35,40,["\uD83D\uDE4E\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f64e-1f3fc-200d-2642-fe0f",35,41,["\uD83D\uDE4E\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f64e-1f3fd-200d-2642-fe0f",35,42,["\uD83D\uDE4E\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f64e-1f3fe-200d-2642-fe0f",35,43,["\uD83D\uDE4E\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f64e-1f3ff-200d-2642-fe0f",35,44,["\uD83D\uDE4E\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f64f":{"1f3fb":["1f64f-1f3fb",35,52,["\uD83D\uDE4F\uD83C\uDFFB"],"1.0"],"1f3fc":["1f64f-1f3fc",35,53,["\uD83D\uDE4F\uD83C\uDFFC"],"1.0"],"1f3fd":["1f64f-1f3fd",35,54,["\uD83D\uDE4F\uD83C\uDFFD"],"1.0"],"1f3fe":["1f64f-1f3fe",35,55,["\uD83D\uDE4F\uD83C\uDFFE"],"1.0"],"1f3ff":["1f64f-1f3ff",35,56,["\uD83D\uDE4F\uD83C\uDFFF"],"1.0"]},
    "1f6a3-200d-2640-fe0f":{"1f3fb":["1f6a3-1f3fb-200d-2640-fe0f",36,31,["\uD83D\uDEA3\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f6a3-1f3fc-200d-2640-fe0f",36,32,["\uD83D\uDEA3\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f6a3-1f3fd-200d-2640-fe0f",36,33,["\uD83D\uDEA3\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f6a3-1f3fe-200d-2640-fe0f",36,34,["\uD83D\uDEA3\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f6a3-1f3ff-200d-2640-fe0f",36,35,["\uD83D\uDEA3\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f6a3-200d-2642-fe0f":{"1f3fb":["1f6a3-1f3fb-200d-2642-fe0f",36,37,["\uD83D\uDEA3\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f6a3-1f3fc-200d-2642-fe0f",36,38,["\uD83D\uDEA3\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f6a3-1f3fd-200d-2642-fe0f",36,39,["\uD83D\uDEA3\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f6a3-1f3fe-200d-2642-fe0f",36,40,["\uD83D\uDEA3\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f6a3-1f3ff-200d-2642-fe0f",36,41,["\uD83D\uDEA3\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f6b4-200d-2640-fe0f":{"1f3fb":["1f6b4-1f3fb-200d-2640-fe0f",37,3,["\uD83D\uDEB4\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f6b4-1f3fc-200d-2640-fe0f",37,4,["\uD83D\uDEB4\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f6b4-1f3fd-200d-2640-fe0f",37,5,["\uD83D\uDEB4\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f6b4-1f3fe-200d-2640-fe0f",37,6,["\uD83D\uDEB4\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f6b4-1f3ff-200d-2640-fe0f",37,7,["\uD83D\uDEB4\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f6b4-200d-2642-fe0f":{"1f3fb":["1f6b4-1f3fb-200d-2642-fe0f",37,9,["\uD83D\uDEB4\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f6b4-1f3fc-200d-2642-fe0f",37,10,["\uD83D\uDEB4\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f6b4-1f3fd-200d-2642-fe0f",37,11,["\uD83D\uDEB4\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f6b4-1f3fe-200d-2642-fe0f",37,12,["\uD83D\uDEB4\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f6b4-1f3ff-200d-2642-fe0f",37,13,["\uD83D\uDEB4\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f6b5-200d-2640-fe0f":{"1f3fb":["1f6b5-1f3fb-200d-2640-fe0f",37,21,["\uD83D\uDEB5\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f6b5-1f3fc-200d-2640-fe0f",37,22,["\uD83D\uDEB5\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f6b5-1f3fd-200d-2640-fe0f",37,23,["\uD83D\uDEB5\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f6b5-1f3fe-200d-2640-fe0f",37,24,["\uD83D\uDEB5\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f6b5-1f3ff-200d-2640-fe0f",37,25,["\uD83D\uDEB5\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f6b5-200d-2642-fe0f":{"1f3fb":["1f6b5-1f3fb-200d-2642-fe0f",37,27,["\uD83D\uDEB5\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f6b5-1f3fc-200d-2642-fe0f",37,28,["\uD83D\uDEB5\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f6b5-1f3fd-200d-2642-fe0f",37,29,["\uD83D\uDEB5\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f6b5-1f3fe-200d-2642-fe0f",37,30,["\uD83D\uDEB5\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f6b5-1f3ff-200d-2642-fe0f",37,31,["\uD83D\uDEB5\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f6b6-200d-2640-fe0f":{"1f3fb":["1f6b6-1f3fb-200d-2640-fe0f",37,39,["\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f6b6-1f3fc-200d-2640-fe0f",37,40,["\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f6b6-1f3fd-200d-2640-fe0f",37,41,["\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f6b6-1f3fe-200d-2640-fe0f",37,42,["\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f6b6-1f3ff-200d-2640-fe0f",37,43,["\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f6b6-200d-2640-fe0f-200d-27a1-fe0f":{"1f3fb":["1f6b6-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",37,45,["\uD83D\uDEB6\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f6b6-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",37,46,["\uD83D\uDEB6\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f6b6-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",37,47,["\uD83D\uDEB6\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f6b6-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",37,48,["\uD83D\uDEB6\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f6b6-1f3ff-200d-2640-fe0f-200d-27a1-fe0f",37,49,["\uD83D\uDEB6\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f6b6-200d-2642-fe0f":{"1f3fb":["1f6b6-1f3fb-200d-2642-fe0f",37,51,["\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f6b6-1f3fc-200d-2642-fe0f",37,52,["\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f6b6-1f3fd-200d-2642-fe0f",37,53,["\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f6b6-1f3fe-200d-2642-fe0f",37,54,["\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f6b6-1f3ff-200d-2642-fe0f",37,55,["\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f6b6-200d-2642-fe0f-200d-27a1-fe0f":{"1f3fb":["1f6b6-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",37,57,["\uD83D\uDEB6\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f6b6-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",37,58,["\uD83D\uDEB6\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f6b6-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",37,59,["\uD83D\uDEB6\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f6b6-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",37,60,["\uD83D\uDEB6\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f6b6-1f3ff-200d-2642-fe0f-200d-27a1-fe0f",37,61,["\uD83D\uDEB6\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f6b6-200d-27a1-fe0f":{"1f3fb":["1f6b6-1f3fb-200d-27a1-fe0f",38,1,["\uD83D\uDEB6\uD83C\uDFFB\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f6b6-1f3fc-200d-27a1-fe0f",38,2,["\uD83D\uDEB6\uD83C\uDFFC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f6b6-1f3fd-200d-27a1-fe0f",38,3,["\uD83D\uDEB6\uD83C\uDFFD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f6b6-1f3fe-200d-27a1-fe0f",38,4,["\uD83D\uDEB6\uD83C\uDFFE\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f6b6-1f3ff-200d-27a1-fe0f",38,5,["\uD83D\uDEB6\uD83C\uDFFF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f6c0":{"1f3fb":["1f6c0-1f3fb",38,22,["\uD83D\uDEC0\uD83C\uDFFB"],"1.0"],"1f3fc":["1f6c0-1f3fc",38,23,["\uD83D\uDEC0\uD83C\uDFFC"],"1.0"],"1f3fd":["1f6c0-1f3fd",38,24,["\uD83D\uDEC0\uD83C\uDFFD"],"1.0"],"1f3fe":["1f6c0-1f3fe",38,25,["\uD83D\uDEC0\uD83C\uDFFE"],"1.0"],"1f3ff":["1f6c0-1f3ff",38,26,["\uD83D\uDEC0\uD83C\uDFFF"],"1.0"]},
    "1f6cc":{"1f3fb":["1f6cc-1f3fb",38,34,["\uD83D\uDECC\uD83C\uDFFB"],"4.0"],"1f3fc":["1f6cc-1f3fc",38,35,["\uD83D\uDECC\uD83C\uDFFC"],"4.0"],"1f3fd":["1f6cc-1f3fd",38,36,["\uD83D\uDECC\uD83C\uDFFD"],"4.0"],"1f3fe":["1f6cc-1f3fe",38,37,["\uD83D\uDECC\uD83C\uDFFE"],"4.0"],"1f3ff":["1f6cc-1f3ff",38,38,["\uD83D\uDECC\uD83C\uDFFF"],"4.0"]},
    "1f90c":{"1f3fb":["1f90c-1f3fb",39,24,["\uD83E\uDD0C\uD83C\uDFFB"],"13.0"],"1f3fc":["1f90c-1f3fc",39,25,["\uD83E\uDD0C\uD83C\uDFFC"],"13.0"],"1f3fd":["1f90c-1f3fd",39,26,["\uD83E\uDD0C\uD83C\uDFFD"],"13.0"],"1f3fe":["1f90c-1f3fe",39,27,["\uD83E\uDD0C\uD83C\uDFFE"],"13.0"],"1f3ff":["1f90c-1f3ff",39,28,["\uD83E\uDD0C\uD83C\uDFFF"],"13.0"]},
    "1f90f":{"1f3fb":["1f90f-1f3fb",39,32,["\uD83E\uDD0F\uD83C\uDFFB"],"12.0"],"1f3fc":["1f90f-1f3fc",39,33,["\uD83E\uDD0F\uD83C\uDFFC"],"12.0"],"1f3fd":["1f90f-1f3fd",39,34,["\uD83E\uDD0F\uD83C\uDFFD"],"12.0"],"1f3fe":["1f90f-1f3fe",39,35,["\uD83E\uDD0F\uD83C\uDFFE"],"12.0"],"1f3ff":["1f90f-1f3ff",39,36,["\uD83E\uDD0F\uD83C\uDFFF"],"12.0"]},
    "1f918":{"1f3fb":["1f918-1f3fb",39,46,["\uD83E\uDD18\uD83C\uDFFB"],"1.0"],"1f3fc":["1f918-1f3fc",39,47,["\uD83E\uDD18\uD83C\uDFFC"],"1.0"],"1f3fd":["1f918-1f3fd",39,48,["\uD83E\uDD18\uD83C\uDFFD"],"1.0"],"1f3fe":["1f918-1f3fe",39,49,["\uD83E\uDD18\uD83C\uDFFE"],"1.0"],"1f3ff":["1f918-1f3ff",39,50,["\uD83E\uDD18\uD83C\uDFFF"],"1.0"]},
    "1f919":{"1f3fb":["1f919-1f3fb",39,52,["\uD83E\uDD19\uD83C\uDFFB"],"3.0"],"1f3fc":["1f919-1f3fc",39,53,["\uD83E\uDD19\uD83C\uDFFC"],"3.0"],"1f3fd":["1f919-1f3fd",39,54,["\uD83E\uDD19\uD83C\uDFFD"],"3.0"],"1f3fe":["1f919-1f3fe",39,55,["\uD83E\uDD19\uD83C\uDFFE"],"3.0"],"1f3ff":["1f919-1f3ff",39,56,["\uD83E\uDD19\uD83C\uDFFF"],"3.0"]},
    "1f91a":{"1f3fb":["1f91a-1f3fb",39,58,["\uD83E\uDD1A\uD83C\uDFFB"],"3.0"],"1f3fc":["1f91a-1f3fc",39,59,["\uD83E\uDD1A\uD83C\uDFFC"],"3.0"],"1f3fd":["1f91a-1f3fd",39,60,["\uD83E\uDD1A\uD83C\uDFFD"],"3.0"],"1f3fe":["1f91a-1f3fe",39,61,["\uD83E\uDD1A\uD83C\uDFFE"],"3.0"],"1f3ff":["1f91a-1f3ff",40,0,["\uD83E\uDD1A\uD83C\uDFFF"],"3.0"]},
    "1f91b":{"1f3fb":["1f91b-1f3fb",40,2,["\uD83E\uDD1B\uD83C\uDFFB"],"3.0"],"1f3fc":["1f91b-1f3fc",40,3,["\uD83E\uDD1B\uD83C\uDFFC"],"3.0"],"1f3fd":["1f91b-1f3fd",40,4,["\uD83E\uDD1B\uD83C\uDFFD"],"3.0"],"1f3fe":["1f91b-1f3fe",40,5,["\uD83E\uDD1B\uD83C\uDFFE"],"3.0"],"1f3ff":["1f91b-1f3ff",40,6,["\uD83E\uDD1B\uD83C\uDFFF"],"3.0"]},
    "1f91c":{"1f3fb":["1f91c-1f3fb",40,8,["\uD83E\uDD1C\uD83C\uDFFB"],"3.0"],"1f3fc":["1f91c-1f3fc",40,9,["\uD83E\uDD1C\uD83C\uDFFC"],"3.0"],"1f3fd":["1f91c-1f3fd",40,10,["\uD83E\uDD1C\uD83C\uDFFD"],"3.0"],"1f3fe":["1f91c-1f3fe",40,11,["\uD83E\uDD1C\uD83C\uDFFE"],"3.0"],"1f3ff":["1f91c-1f3ff",40,12,["\uD83E\uDD1C\uD83C\uDFFF"],"3.0"]},
    "1f91d":{"1f3fb":["1f91d-1f3fb",40,14,["\uD83E\uDD1D\uD83C\uDFFB"],"14.0"],"1f3fc":["1f91d-1f3fc",40,15,["\uD83E\uDD1D\uD83C\uDFFC"],"14.0"],"1f3fd":["1f91d-1f3fd",40,16,["\uD83E\uDD1D\uD83C\uDFFD"],"14.0"],"1f3fe":["1f91d-1f3fe",40,17,["\uD83E\uDD1D\uD83C\uDFFE"],"14.0"],"1f3ff":["1f91d-1f3ff",40,18,["\uD83E\uDD1D\uD83C\uDFFF"],"14.0"],"1f3fb-1f3fc":["1faf1-1f3fb-200d-1faf2-1f3fc",40,19,["\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFC"],"14.0"],"1f3fb-1f3fd":["1faf1-1f3fb-200d-1faf2-1f3fd",40,20,["\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFD"],"14.0"],"1f3fb-1f3fe":["1faf1-1f3fb-200d-1faf2-1f3fe",40,21,["\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFE"],"14.0"],"1f3fb-1f3ff":["1faf1-1f3fb-200d-1faf2-1f3ff",40,22,["\uD83E\uDEF1\uD83C\uDFFB\u200D\uD83E\uDEF2\uD83C\uDFFF"],"14.0"],"1f3fc-1f3fb":["1faf1-1f3fc-200d-1faf2-1f3fb",40,23,["\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFB"],"14.0"],"1f3fc-1f3fd":["1faf1-1f3fc-200d-1faf2-1f3fd",40,24,["\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFD"],"14.0"],"1f3fc-1f3fe":["1faf1-1f3fc-200d-1faf2-1f3fe",40,25,["\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFE"],"14.0"],"1f3fc-1f3ff":["1faf1-1f3fc-200d-1faf2-1f3ff",40,26,["\uD83E\uDEF1\uD83C\uDFFC\u200D\uD83E\uDEF2\uD83C\uDFFF"],"14.0"],"1f3fd-1f3fb":["1faf1-1f3fd-200d-1faf2-1f3fb",40,27,["\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFB"],"14.0"],"1f3fd-1f3fc":["1faf1-1f3fd-200d-1faf2-1f3fc",40,28,["\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFC"],"14.0"],"1f3fd-1f3fe":["1faf1-1f3fd-200d-1faf2-1f3fe",40,29,["\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFE"],"14.0"],"1f3fd-1f3ff":["1faf1-1f3fd-200d-1faf2-1f3ff",40,30,["\uD83E\uDEF1\uD83C\uDFFD\u200D\uD83E\uDEF2\uD83C\uDFFF"],"14.0"],"1f3fe-1f3fb":["1faf1-1f3fe-200d-1faf2-1f3fb",40,31,["\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFB"],"14.0"],"1f3fe-1f3fc":["1faf1-1f3fe-200d-1faf2-1f3fc",40,32,["\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFC"],"14.0"],"1f3fe-1f3fd":["1faf1-1f3fe-200d-1faf2-1f3fd",40,33,["\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFD"],"14.0"],"1f3fe-1f3ff":["1faf1-1f3fe-200d-1faf2-1f3ff",40,34,["\uD83E\uDEF1\uD83C\uDFFE\u200D\uD83E\uDEF2\uD83C\uDFFF"],"14.0"],"1f3ff-1f3fb":["1faf1-1f3ff-200d-1faf2-1f3fb",40,35,["\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFB"],"14.0"],"1f3ff-1f3fc":["1faf1-1f3ff-200d-1faf2-1f3fc",40,36,["\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFC"],"14.0"],"1f3ff-1f3fd":["1faf1-1f3ff-200d-1faf2-1f3fd",40,37,["\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFD"],"14.0"],"1f3ff-1f3fe":["1faf1-1f3ff-200d-1faf2-1f3fe",40,38,["\uD83E\uDEF1\uD83C\uDFFF\u200D\uD83E\uDEF2\uD83C\uDFFE"],"14.0"]},
    "1f91e":{"1f3fb":["1f91e-1f3fb",40,40,["\uD83E\uDD1E\uD83C\uDFFB"],"3.0"],"1f3fc":["1f91e-1f3fc",40,41,["\uD83E\uDD1E\uD83C\uDFFC"],"3.0"],"1f3fd":["1f91e-1f3fd",40,42,["\uD83E\uDD1E\uD83C\uDFFD"],"3.0"],"1f3fe":["1f91e-1f3fe",40,43,["\uD83E\uDD1E\uD83C\uDFFE"],"3.0"],"1f3ff":["1f91e-1f3ff",40,44,["\uD83E\uDD1E\uD83C\uDFFF"],"3.0"]},
    "1f91f":{"1f3fb":["1f91f-1f3fb",40,46,["\uD83E\uDD1F\uD83C\uDFFB"],"5.0"],"1f3fc":["1f91f-1f3fc",40,47,["\uD83E\uDD1F\uD83C\uDFFC"],"5.0"],"1f3fd":["1f91f-1f3fd",40,48,["\uD83E\uDD1F\uD83C\uDFFD"],"5.0"],"1f3fe":["1f91f-1f3fe",40,49,["\uD83E\uDD1F\uD83C\uDFFE"],"5.0"],"1f3ff":["1f91f-1f3ff",40,50,["\uD83E\uDD1F\uD83C\uDFFF"],"5.0"]},
    "1f926-200d-2640-fe0f":{"1f3fb":["1f926-1f3fb-200d-2640-fe0f",40,58,["\uD83E\uDD26\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f926-1f3fc-200d-2640-fe0f",40,59,["\uD83E\uDD26\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f926-1f3fd-200d-2640-fe0f",40,60,["\uD83E\uDD26\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f926-1f3fe-200d-2640-fe0f",40,61,["\uD83E\uDD26\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f926-1f3ff-200d-2640-fe0f",41,0,["\uD83E\uDD26\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f926-200d-2642-fe0f":{"1f3fb":["1f926-1f3fb-200d-2642-fe0f",41,2,["\uD83E\uDD26\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f926-1f3fc-200d-2642-fe0f",41,3,["\uD83E\uDD26\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f926-1f3fd-200d-2642-fe0f",41,4,["\uD83E\uDD26\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f926-1f3fe-200d-2642-fe0f",41,5,["\uD83E\uDD26\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f926-1f3ff-200d-2642-fe0f",41,6,["\uD83E\uDD26\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f926":{"1f3fb":["1f926-1f3fb",41,8,["\uD83E\uDD26\uD83C\uDFFB"],"3.0"],"1f3fc":["1f926-1f3fc",41,9,["\uD83E\uDD26\uD83C\uDFFC"],"3.0"],"1f3fd":["1f926-1f3fd",41,10,["\uD83E\uDD26\uD83C\uDFFD"],"3.0"],"1f3fe":["1f926-1f3fe",41,11,["\uD83E\uDD26\uD83C\uDFFE"],"3.0"],"1f3ff":["1f926-1f3ff",41,12,["\uD83E\uDD26\uD83C\uDFFF"],"3.0"]},
    "1f930":{"1f3fb":["1f930-1f3fb",41,23,["\uD83E\uDD30\uD83C\uDFFB"],"3.0"],"1f3fc":["1f930-1f3fc",41,24,["\uD83E\uDD30\uD83C\uDFFC"],"3.0"],"1f3fd":["1f930-1f3fd",41,25,["\uD83E\uDD30\uD83C\uDFFD"],"3.0"],"1f3fe":["1f930-1f3fe",41,26,["\uD83E\uDD30\uD83C\uDFFE"],"3.0"],"1f3ff":["1f930-1f3ff",41,27,["\uD83E\uDD30\uD83C\uDFFF"],"3.0"]},
    "1f931":{"1f3fb":["1f931-1f3fb",41,29,["\uD83E\uDD31\uD83C\uDFFB"],"5.0"],"1f3fc":["1f931-1f3fc",41,30,["\uD83E\uDD31\uD83C\uDFFC"],"5.0"],"1f3fd":["1f931-1f3fd",41,31,["\uD83E\uDD31\uD83C\uDFFD"],"5.0"],"1f3fe":["1f931-1f3fe",41,32,["\uD83E\uDD31\uD83C\uDFFE"],"5.0"],"1f3ff":["1f931-1f3ff",41,33,["\uD83E\uDD31\uD83C\uDFFF"],"5.0"]},
    "1f932":{"1f3fb":["1f932-1f3fb",41,35,["\uD83E\uDD32\uD83C\uDFFB"],"5.0"],"1f3fc":["1f932-1f3fc",41,36,["\uD83E\uDD32\uD83C\uDFFC"],"5.0"],"1f3fd":["1f932-1f3fd",41,37,["\uD83E\uDD32\uD83C\uDFFD"],"5.0"],"1f3fe":["1f932-1f3fe",41,38,["\uD83E\uDD32\uD83C\uDFFE"],"5.0"],"1f3ff":["1f932-1f3ff",41,39,["\uD83E\uDD32\uD83C\uDFFF"],"5.0"]},
    "1f933":{"1f3fb":["1f933-1f3fb",41,41,["\uD83E\uDD33\uD83C\uDFFB"],"3.0"],"1f3fc":["1f933-1f3fc",41,42,["\uD83E\uDD33\uD83C\uDFFC"],"3.0"],"1f3fd":["1f933-1f3fd",41,43,["\uD83E\uDD33\uD83C\uDFFD"],"3.0"],"1f3fe":["1f933-1f3fe",41,44,["\uD83E\uDD33\uD83C\uDFFE"],"3.0"],"1f3ff":["1f933-1f3ff",41,45,["\uD83E\uDD33\uD83C\uDFFF"],"3.0"]},
    "1f934":{"1f3fb":["1f934-1f3fb",41,47,["\uD83E\uDD34\uD83C\uDFFB"],"3.0"],"1f3fc":["1f934-1f3fc",41,48,["\uD83E\uDD34\uD83C\uDFFC"],"3.0"],"1f3fd":["1f934-1f3fd",41,49,["\uD83E\uDD34\uD83C\uDFFD"],"3.0"],"1f3fe":["1f934-1f3fe",41,50,["\uD83E\uDD34\uD83C\uDFFE"],"3.0"],"1f3ff":["1f934-1f3ff",41,51,["\uD83E\uDD34\uD83C\uDFFF"],"3.0"]},
    "1f935-200d-2640-fe0f":{"1f3fb":["1f935-1f3fb-200d-2640-fe0f",41,53,["\uD83E\uDD35\uD83C\uDFFB\u200D\u2640\uFE0F"],"13.0"],"1f3fc":["1f935-1f3fc-200d-2640-fe0f",41,54,["\uD83E\uDD35\uD83C\uDFFC\u200D\u2640\uFE0F"],"13.0"],"1f3fd":["1f935-1f3fd-200d-2640-fe0f",41,55,["\uD83E\uDD35\uD83C\uDFFD\u200D\u2640\uFE0F"],"13.0"],"1f3fe":["1f935-1f3fe-200d-2640-fe0f",41,56,["\uD83E\uDD35\uD83C\uDFFE\u200D\u2640\uFE0F"],"13.0"],"1f3ff":["1f935-1f3ff-200d-2640-fe0f",41,57,["\uD83E\uDD35\uD83C\uDFFF\u200D\u2640\uFE0F"],"13.0"]},
    "1f935-200d-2642-fe0f":{"1f3fb":["1f935-1f3fb-200d-2642-fe0f",41,59,["\uD83E\uDD35\uD83C\uDFFB\u200D\u2642\uFE0F"],"13.0"],"1f3fc":["1f935-1f3fc-200d-2642-fe0f",41,60,["\uD83E\uDD35\uD83C\uDFFC\u200D\u2642\uFE0F"],"13.0"],"1f3fd":["1f935-1f3fd-200d-2642-fe0f",41,61,["\uD83E\uDD35\uD83C\uDFFD\u200D\u2642\uFE0F"],"13.0"],"1f3fe":["1f935-1f3fe-200d-2642-fe0f",42,0,["\uD83E\uDD35\uD83C\uDFFE\u200D\u2642\uFE0F"],"13.0"],"1f3ff":["1f935-1f3ff-200d-2642-fe0f",42,1,["\uD83E\uDD35\uD83C\uDFFF\u200D\u2642\uFE0F"],"13.0"]},
    "1f935":{"1f3fb":["1f935-1f3fb",42,3,["\uD83E\uDD35\uD83C\uDFFB"],"3.0"],"1f3fc":["1f935-1f3fc",42,4,["\uD83E\uDD35\uD83C\uDFFC"],"3.0"],"1f3fd":["1f935-1f3fd",42,5,["\uD83E\uDD35\uD83C\uDFFD"],"3.0"],"1f3fe":["1f935-1f3fe",42,6,["\uD83E\uDD35\uD83C\uDFFE"],"3.0"],"1f3ff":["1f935-1f3ff",42,7,["\uD83E\uDD35\uD83C\uDFFF"],"3.0"]},
    "1f936":{"1f3fb":["1f936-1f3fb",42,9,["\uD83E\uDD36\uD83C\uDFFB"],"3.0"],"1f3fc":["1f936-1f3fc",42,10,["\uD83E\uDD36\uD83C\uDFFC"],"3.0"],"1f3fd":["1f936-1f3fd",42,11,["\uD83E\uDD36\uD83C\uDFFD"],"3.0"],"1f3fe":["1f936-1f3fe",42,12,["\uD83E\uDD36\uD83C\uDFFE"],"3.0"],"1f3ff":["1f936-1f3ff",42,13,["\uD83E\uDD36\uD83C\uDFFF"],"3.0"]},
    "1f937-200d-2640-fe0f":{"1f3fb":["1f937-1f3fb-200d-2640-fe0f",42,15,["\uD83E\uDD37\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f937-1f3fc-200d-2640-fe0f",42,16,["\uD83E\uDD37\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f937-1f3fd-200d-2640-fe0f",42,17,["\uD83E\uDD37\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f937-1f3fe-200d-2640-fe0f",42,18,["\uD83E\uDD37\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f937-1f3ff-200d-2640-fe0f",42,19,["\uD83E\uDD37\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f937-200d-2642-fe0f":{"1f3fb":["1f937-1f3fb-200d-2642-fe0f",42,21,["\uD83E\uDD37\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f937-1f3fc-200d-2642-fe0f",42,22,["\uD83E\uDD37\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f937-1f3fd-200d-2642-fe0f",42,23,["\uD83E\uDD37\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f937-1f3fe-200d-2642-fe0f",42,24,["\uD83E\uDD37\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f937-1f3ff-200d-2642-fe0f",42,25,["\uD83E\uDD37\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f937":{"1f3fb":["1f937-1f3fb",42,27,["\uD83E\uDD37\uD83C\uDFFB"],"3.0"],"1f3fc":["1f937-1f3fc",42,28,["\uD83E\uDD37\uD83C\uDFFC"],"3.0"],"1f3fd":["1f937-1f3fd",42,29,["\uD83E\uDD37\uD83C\uDFFD"],"3.0"],"1f3fe":["1f937-1f3fe",42,30,["\uD83E\uDD37\uD83C\uDFFE"],"3.0"],"1f3ff":["1f937-1f3ff",42,31,["\uD83E\uDD37\uD83C\uDFFF"],"3.0"]},
    "1f938-200d-2640-fe0f":{"1f3fb":["1f938-1f3fb-200d-2640-fe0f",42,33,["\uD83E\uDD38\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f938-1f3fc-200d-2640-fe0f",42,34,["\uD83E\uDD38\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f938-1f3fd-200d-2640-fe0f",42,35,["\uD83E\uDD38\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f938-1f3fe-200d-2640-fe0f",42,36,["\uD83E\uDD38\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f938-1f3ff-200d-2640-fe0f",42,37,["\uD83E\uDD38\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f938-200d-2642-fe0f":{"1f3fb":["1f938-1f3fb-200d-2642-fe0f",42,39,["\uD83E\uDD38\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f938-1f3fc-200d-2642-fe0f",42,40,["\uD83E\uDD38\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f938-1f3fd-200d-2642-fe0f",42,41,["\uD83E\uDD38\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f938-1f3fe-200d-2642-fe0f",42,42,["\uD83E\uDD38\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f938-1f3ff-200d-2642-fe0f",42,43,["\uD83E\uDD38\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f938":{"1f3fb":["1f938-1f3fb",42,45,["\uD83E\uDD38\uD83C\uDFFB"],"3.0"],"1f3fc":["1f938-1f3fc",42,46,["\uD83E\uDD38\uD83C\uDFFC"],"3.0"],"1f3fd":["1f938-1f3fd",42,47,["\uD83E\uDD38\uD83C\uDFFD"],"3.0"],"1f3fe":["1f938-1f3fe",42,48,["\uD83E\uDD38\uD83C\uDFFE"],"3.0"],"1f3ff":["1f938-1f3ff",42,49,["\uD83E\uDD38\uD83C\uDFFF"],"3.0"]},
    "1f939-200d-2640-fe0f":{"1f3fb":["1f939-1f3fb-200d-2640-fe0f",42,51,["\uD83E\uDD39\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f939-1f3fc-200d-2640-fe0f",42,52,["\uD83E\uDD39\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f939-1f3fd-200d-2640-fe0f",42,53,["\uD83E\uDD39\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f939-1f3fe-200d-2640-fe0f",42,54,["\uD83E\uDD39\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f939-1f3ff-200d-2640-fe0f",42,55,["\uD83E\uDD39\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f939-200d-2642-fe0f":{"1f3fb":["1f939-1f3fb-200d-2642-fe0f",42,57,["\uD83E\uDD39\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f939-1f3fc-200d-2642-fe0f",42,58,["\uD83E\uDD39\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f939-1f3fd-200d-2642-fe0f",42,59,["\uD83E\uDD39\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f939-1f3fe-200d-2642-fe0f",42,60,["\uD83E\uDD39\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f939-1f3ff-200d-2642-fe0f",42,61,["\uD83E\uDD39\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f939":{"1f3fb":["1f939-1f3fb",43,1,["\uD83E\uDD39\uD83C\uDFFB"],"3.0"],"1f3fc":["1f939-1f3fc",43,2,["\uD83E\uDD39\uD83C\uDFFC"],"3.0"],"1f3fd":["1f939-1f3fd",43,3,["\uD83E\uDD39\uD83C\uDFFD"],"3.0"],"1f3fe":["1f939-1f3fe",43,4,["\uD83E\uDD39\uD83C\uDFFE"],"3.0"],"1f3ff":["1f939-1f3ff",43,5,["\uD83E\uDD39\uD83C\uDFFF"],"3.0"]},
    "1f93d-200d-2640-fe0f":{"1f3fb":["1f93d-1f3fb-200d-2640-fe0f",43,11,["\uD83E\uDD3D\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f93d-1f3fc-200d-2640-fe0f",43,12,["\uD83E\uDD3D\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f93d-1f3fd-200d-2640-fe0f",43,13,["\uD83E\uDD3D\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f93d-1f3fe-200d-2640-fe0f",43,14,["\uD83E\uDD3D\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f93d-1f3ff-200d-2640-fe0f",43,15,["\uD83E\uDD3D\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f93d-200d-2642-fe0f":{"1f3fb":["1f93d-1f3fb-200d-2642-fe0f",43,17,["\uD83E\uDD3D\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f93d-1f3fc-200d-2642-fe0f",43,18,["\uD83E\uDD3D\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f93d-1f3fd-200d-2642-fe0f",43,19,["\uD83E\uDD3D\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f93d-1f3fe-200d-2642-fe0f",43,20,["\uD83E\uDD3D\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f93d-1f3ff-200d-2642-fe0f",43,21,["\uD83E\uDD3D\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f93d":{"1f3fb":["1f93d-1f3fb",43,23,["\uD83E\uDD3D\uD83C\uDFFB"],"3.0"],"1f3fc":["1f93d-1f3fc",43,24,["\uD83E\uDD3D\uD83C\uDFFC"],"3.0"],"1f3fd":["1f93d-1f3fd",43,25,["\uD83E\uDD3D\uD83C\uDFFD"],"3.0"],"1f3fe":["1f93d-1f3fe",43,26,["\uD83E\uDD3D\uD83C\uDFFE"],"3.0"],"1f3ff":["1f93d-1f3ff",43,27,["\uD83E\uDD3D\uD83C\uDFFF"],"3.0"]},
    "1f93e-200d-2640-fe0f":{"1f3fb":["1f93e-1f3fb-200d-2640-fe0f",43,29,["\uD83E\uDD3E\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["1f93e-1f3fc-200d-2640-fe0f",43,30,["\uD83E\uDD3E\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["1f93e-1f3fd-200d-2640-fe0f",43,31,["\uD83E\uDD3E\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["1f93e-1f3fe-200d-2640-fe0f",43,32,["\uD83E\uDD3E\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["1f93e-1f3ff-200d-2640-fe0f",43,33,["\uD83E\uDD3E\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "1f93e-200d-2642-fe0f":{"1f3fb":["1f93e-1f3fb-200d-2642-fe0f",43,35,["\uD83E\uDD3E\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["1f93e-1f3fc-200d-2642-fe0f",43,36,["\uD83E\uDD3E\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["1f93e-1f3fd-200d-2642-fe0f",43,37,["\uD83E\uDD3E\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["1f93e-1f3fe-200d-2642-fe0f",43,38,["\uD83E\uDD3E\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["1f93e-1f3ff-200d-2642-fe0f",43,39,["\uD83E\uDD3E\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "1f93e":{"1f3fb":["1f93e-1f3fb",43,41,["\uD83E\uDD3E\uD83C\uDFFB"],"3.0"],"1f3fc":["1f93e-1f3fc",43,42,["\uD83E\uDD3E\uD83C\uDFFC"],"3.0"],"1f3fd":["1f93e-1f3fd",43,43,["\uD83E\uDD3E\uD83C\uDFFD"],"3.0"],"1f3fe":["1f93e-1f3fe",43,44,["\uD83E\uDD3E\uD83C\uDFFE"],"3.0"],"1f3ff":["1f93e-1f3ff",43,45,["\uD83E\uDD3E\uD83C\uDFFF"],"3.0"]},
    "1f977":{"1f3fb":["1f977-1f3fb",44,40,["\uD83E\uDD77\uD83C\uDFFB"],"13.0"],"1f3fc":["1f977-1f3fc",44,41,["\uD83E\uDD77\uD83C\uDFFC"],"13.0"],"1f3fd":["1f977-1f3fd",44,42,["\uD83E\uDD77\uD83C\uDFFD"],"13.0"],"1f3fe":["1f977-1f3fe",44,43,["\uD83E\uDD77\uD83C\uDFFE"],"13.0"],"1f3ff":["1f977-1f3ff",44,44,["\uD83E\uDD77\uD83C\uDFFF"],"13.0"]},
    "1f9b5":{"1f3fb":["1f9b5-1f3fb",45,41,["\uD83E\uDDB5\uD83C\uDFFB"],"11.0"],"1f3fc":["1f9b5-1f3fc",45,42,["\uD83E\uDDB5\uD83C\uDFFC"],"11.0"],"1f3fd":["1f9b5-1f3fd",45,43,["\uD83E\uDDB5\uD83C\uDFFD"],"11.0"],"1f3fe":["1f9b5-1f3fe",45,44,["\uD83E\uDDB5\uD83C\uDFFE"],"11.0"],"1f3ff":["1f9b5-1f3ff",45,45,["\uD83E\uDDB5\uD83C\uDFFF"],"11.0"]},
    "1f9b6":{"1f3fb":["1f9b6-1f3fb",45,47,["\uD83E\uDDB6\uD83C\uDFFB"],"11.0"],"1f3fc":["1f9b6-1f3fc",45,48,["\uD83E\uDDB6\uD83C\uDFFC"],"11.0"],"1f3fd":["1f9b6-1f3fd",45,49,["\uD83E\uDDB6\uD83C\uDFFD"],"11.0"],"1f3fe":["1f9b6-1f3fe",45,50,["\uD83E\uDDB6\uD83C\uDFFE"],"11.0"],"1f3ff":["1f9b6-1f3ff",45,51,["\uD83E\uDDB6\uD83C\uDFFF"],"11.0"]},
    "1f9b8-200d-2640-fe0f":{"1f3fb":["1f9b8-1f3fb-200d-2640-fe0f",45,54,["\uD83E\uDDB8\uD83C\uDFFB\u200D\u2640\uFE0F"],"11.0"],"1f3fc":["1f9b8-1f3fc-200d-2640-fe0f",45,55,["\uD83E\uDDB8\uD83C\uDFFC\u200D\u2640\uFE0F"],"11.0"],"1f3fd":["1f9b8-1f3fd-200d-2640-fe0f",45,56,["\uD83E\uDDB8\uD83C\uDFFD\u200D\u2640\uFE0F"],"11.0"],"1f3fe":["1f9b8-1f3fe-200d-2640-fe0f",45,57,["\uD83E\uDDB8\uD83C\uDFFE\u200D\u2640\uFE0F"],"11.0"],"1f3ff":["1f9b8-1f3ff-200d-2640-fe0f",45,58,["\uD83E\uDDB8\uD83C\uDFFF\u200D\u2640\uFE0F"],"11.0"]},
    "1f9b8-200d-2642-fe0f":{"1f3fb":["1f9b8-1f3fb-200d-2642-fe0f",45,60,["\uD83E\uDDB8\uD83C\uDFFB\u200D\u2642\uFE0F"],"11.0"],"1f3fc":["1f9b8-1f3fc-200d-2642-fe0f",45,61,["\uD83E\uDDB8\uD83C\uDFFC\u200D\u2642\uFE0F"],"11.0"],"1f3fd":["1f9b8-1f3fd-200d-2642-fe0f",46,0,["\uD83E\uDDB8\uD83C\uDFFD\u200D\u2642\uFE0F"],"11.0"],"1f3fe":["1f9b8-1f3fe-200d-2642-fe0f",46,1,["\uD83E\uDDB8\uD83C\uDFFE\u200D\u2642\uFE0F"],"11.0"],"1f3ff":["1f9b8-1f3ff-200d-2642-fe0f",46,2,["\uD83E\uDDB8\uD83C\uDFFF\u200D\u2642\uFE0F"],"11.0"]},
    "1f9b8":{"1f3fb":["1f9b8-1f3fb",46,4,["\uD83E\uDDB8\uD83C\uDFFB"],"11.0"],"1f3fc":["1f9b8-1f3fc",46,5,["\uD83E\uDDB8\uD83C\uDFFC"],"11.0"],"1f3fd":["1f9b8-1f3fd",46,6,["\uD83E\uDDB8\uD83C\uDFFD"],"11.0"],"1f3fe":["1f9b8-1f3fe",46,7,["\uD83E\uDDB8\uD83C\uDFFE"],"11.0"],"1f3ff":["1f9b8-1f3ff",46,8,["\uD83E\uDDB8\uD83C\uDFFF"],"11.0"]},
    "1f9b9-200d-2640-fe0f":{"1f3fb":["1f9b9-1f3fb-200d-2640-fe0f",46,10,["\uD83E\uDDB9\uD83C\uDFFB\u200D\u2640\uFE0F"],"11.0"],"1f3fc":["1f9b9-1f3fc-200d-2640-fe0f",46,11,["\uD83E\uDDB9\uD83C\uDFFC\u200D\u2640\uFE0F"],"11.0"],"1f3fd":["1f9b9-1f3fd-200d-2640-fe0f",46,12,["\uD83E\uDDB9\uD83C\uDFFD\u200D\u2640\uFE0F"],"11.0"],"1f3fe":["1f9b9-1f3fe-200d-2640-fe0f",46,13,["\uD83E\uDDB9\uD83C\uDFFE\u200D\u2640\uFE0F"],"11.0"],"1f3ff":["1f9b9-1f3ff-200d-2640-fe0f",46,14,["\uD83E\uDDB9\uD83C\uDFFF\u200D\u2640\uFE0F"],"11.0"]},
    "1f9b9-200d-2642-fe0f":{"1f3fb":["1f9b9-1f3fb-200d-2642-fe0f",46,16,["\uD83E\uDDB9\uD83C\uDFFB\u200D\u2642\uFE0F"],"11.0"],"1f3fc":["1f9b9-1f3fc-200d-2642-fe0f",46,17,["\uD83E\uDDB9\uD83C\uDFFC\u200D\u2642\uFE0F"],"11.0"],"1f3fd":["1f9b9-1f3fd-200d-2642-fe0f",46,18,["\uD83E\uDDB9\uD83C\uDFFD\u200D\u2642\uFE0F"],"11.0"],"1f3fe":["1f9b9-1f3fe-200d-2642-fe0f",46,19,["\uD83E\uDDB9\uD83C\uDFFE\u200D\u2642\uFE0F"],"11.0"],"1f3ff":["1f9b9-1f3ff-200d-2642-fe0f",46,20,["\uD83E\uDDB9\uD83C\uDFFF\u200D\u2642\uFE0F"],"11.0"]},
    "1f9b9":{"1f3fb":["1f9b9-1f3fb",46,22,["\uD83E\uDDB9\uD83C\uDFFB"],"11.0"],"1f3fc":["1f9b9-1f3fc",46,23,["\uD83E\uDDB9\uD83C\uDFFC"],"11.0"],"1f3fd":["1f9b9-1f3fd",46,24,["\uD83E\uDDB9\uD83C\uDFFD"],"11.0"],"1f3fe":["1f9b9-1f3fe",46,25,["\uD83E\uDDB9\uD83C\uDFFE"],"11.0"],"1f3ff":["1f9b9-1f3ff",46,26,["\uD83E\uDDB9\uD83C\uDFFF"],"11.0"]},
    "1f9bb":{"1f3fb":["1f9bb-1f3fb",46,29,["\uD83E\uDDBB\uD83C\uDFFB"],"12.0"],"1f3fc":["1f9bb-1f3fc",46,30,["\uD83E\uDDBB\uD83C\uDFFC"],"12.0"],"1f3fd":["1f9bb-1f3fd",46,31,["\uD83E\uDDBB\uD83C\uDFFD"],"12.0"],"1f3fe":["1f9bb-1f3fe",46,32,["\uD83E\uDDBB\uD83C\uDFFE"],"12.0"],"1f3ff":["1f9bb-1f3ff",46,33,["\uD83E\uDDBB\uD83C\uDFFF"],"12.0"]},
    "1f9cd-200d-2640-fe0f":{"1f3fb":["1f9cd-1f3fb-200d-2640-fe0f",46,52,["\uD83E\uDDCD\uD83C\uDFFB\u200D\u2640\uFE0F"],"12.0"],"1f3fc":["1f9cd-1f3fc-200d-2640-fe0f",46,53,["\uD83E\uDDCD\uD83C\uDFFC\u200D\u2640\uFE0F"],"12.0"],"1f3fd":["1f9cd-1f3fd-200d-2640-fe0f",46,54,["\uD83E\uDDCD\uD83C\uDFFD\u200D\u2640\uFE0F"],"12.0"],"1f3fe":["1f9cd-1f3fe-200d-2640-fe0f",46,55,["\uD83E\uDDCD\uD83C\uDFFE\u200D\u2640\uFE0F"],"12.0"],"1f3ff":["1f9cd-1f3ff-200d-2640-fe0f",46,56,["\uD83E\uDDCD\uD83C\uDFFF\u200D\u2640\uFE0F"],"12.0"]},
    "1f9cd-200d-2642-fe0f":{"1f3fb":["1f9cd-1f3fb-200d-2642-fe0f",46,58,["\uD83E\uDDCD\uD83C\uDFFB\u200D\u2642\uFE0F"],"12.0"],"1f3fc":["1f9cd-1f3fc-200d-2642-fe0f",46,59,["\uD83E\uDDCD\uD83C\uDFFC\u200D\u2642\uFE0F"],"12.0"],"1f3fd":["1f9cd-1f3fd-200d-2642-fe0f",46,60,["\uD83E\uDDCD\uD83C\uDFFD\u200D\u2642\uFE0F"],"12.0"],"1f3fe":["1f9cd-1f3fe-200d-2642-fe0f",46,61,["\uD83E\uDDCD\uD83C\uDFFE\u200D\u2642\uFE0F"],"12.0"],"1f3ff":["1f9cd-1f3ff-200d-2642-fe0f",47,0,["\uD83E\uDDCD\uD83C\uDFFF\u200D\u2642\uFE0F"],"12.0"]},
    "1f9cd":{"1f3fb":["1f9cd-1f3fb",47,2,["\uD83E\uDDCD\uD83C\uDFFB"],"12.0"],"1f3fc":["1f9cd-1f3fc",47,3,["\uD83E\uDDCD\uD83C\uDFFC"],"12.0"],"1f3fd":["1f9cd-1f3fd",47,4,["\uD83E\uDDCD\uD83C\uDFFD"],"12.0"],"1f3fe":["1f9cd-1f3fe",47,5,["\uD83E\uDDCD\uD83C\uDFFE"],"12.0"],"1f3ff":["1f9cd-1f3ff",47,6,["\uD83E\uDDCD\uD83C\uDFFF"],"12.0"]},
    "1f9ce-200d-2640-fe0f":{"1f3fb":["1f9ce-1f3fb-200d-2640-fe0f",47,8,["\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\uFE0F"],"12.0"],"1f3fc":["1f9ce-1f3fc-200d-2640-fe0f",47,9,["\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\uFE0F"],"12.0"],"1f3fd":["1f9ce-1f3fd-200d-2640-fe0f",47,10,["\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\uFE0F"],"12.0"],"1f3fe":["1f9ce-1f3fe-200d-2640-fe0f",47,11,["\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\uFE0F"],"12.0"],"1f3ff":["1f9ce-1f3ff-200d-2640-fe0f",47,12,["\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\uFE0F"],"12.0"]},
    "1f9ce-200d-2640-fe0f-200d-27a1-fe0f":{"1f3fb":["1f9ce-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",47,14,["\uD83E\uDDCE\uD83C\uDFFB\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9ce-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",47,15,["\uD83E\uDDCE\uD83C\uDFFC\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9ce-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",47,16,["\uD83E\uDDCE\uD83C\uDFFD\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9ce-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",47,17,["\uD83E\uDDCE\uD83C\uDFFE\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9ce-1f3ff-200d-2640-fe0f-200d-27a1-fe0f",47,18,["\uD83E\uDDCE\uD83C\uDFFF\u200D\u2640\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9ce-200d-2642-fe0f":{"1f3fb":["1f9ce-1f3fb-200d-2642-fe0f",47,20,["\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\uFE0F"],"12.0"],"1f3fc":["1f9ce-1f3fc-200d-2642-fe0f",47,21,["\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\uFE0F"],"12.0"],"1f3fd":["1f9ce-1f3fd-200d-2642-fe0f",47,22,["\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\uFE0F"],"12.0"],"1f3fe":["1f9ce-1f3fe-200d-2642-fe0f",47,23,["\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\uFE0F"],"12.0"],"1f3ff":["1f9ce-1f3ff-200d-2642-fe0f",47,24,["\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\uFE0F"],"12.0"]},
    "1f9ce-200d-2642-fe0f-200d-27a1-fe0f":{"1f3fb":["1f9ce-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",47,26,["\uD83E\uDDCE\uD83C\uDFFB\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9ce-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",47,27,["\uD83E\uDDCE\uD83C\uDFFC\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9ce-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",47,28,["\uD83E\uDDCE\uD83C\uDFFD\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9ce-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",47,29,["\uD83E\uDDCE\uD83C\uDFFE\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9ce-1f3ff-200d-2642-fe0f-200d-27a1-fe0f",47,30,["\uD83E\uDDCE\uD83C\uDFFF\u200D\u2642\uFE0F\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9ce-200d-27a1-fe0f":{"1f3fb":["1f9ce-1f3fb-200d-27a1-fe0f",47,32,["\uD83E\uDDCE\uD83C\uDFFB\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9ce-1f3fc-200d-27a1-fe0f",47,33,["\uD83E\uDDCE\uD83C\uDFFC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9ce-1f3fd-200d-27a1-fe0f",47,34,["\uD83E\uDDCE\uD83C\uDFFD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9ce-1f3fe-200d-27a1-fe0f",47,35,["\uD83E\uDDCE\uD83C\uDFFE\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9ce-1f3ff-200d-27a1-fe0f",47,36,["\uD83E\uDDCE\uD83C\uDFFF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9ce":{"1f3fb":["1f9ce-1f3fb",47,38,["\uD83E\uDDCE\uD83C\uDFFB"],"12.0"],"1f3fc":["1f9ce-1f3fc",47,39,["\uD83E\uDDCE\uD83C\uDFFC"],"12.0"],"1f3fd":["1f9ce-1f3fd",47,40,["\uD83E\uDDCE\uD83C\uDFFD"],"12.0"],"1f3fe":["1f9ce-1f3fe",47,41,["\uD83E\uDDCE\uD83C\uDFFE"],"12.0"],"1f3ff":["1f9ce-1f3ff",47,42,["\uD83E\uDDCE\uD83C\uDFFF"],"12.0"]},
    "1f9cf-200d-2640-fe0f":{"1f3fb":["1f9cf-1f3fb-200d-2640-fe0f",47,44,["\uD83E\uDDCF\uD83C\uDFFB\u200D\u2640\uFE0F"],"12.0"],"1f3fc":["1f9cf-1f3fc-200d-2640-fe0f",47,45,["\uD83E\uDDCF\uD83C\uDFFC\u200D\u2640\uFE0F"],"12.0"],"1f3fd":["1f9cf-1f3fd-200d-2640-fe0f",47,46,["\uD83E\uDDCF\uD83C\uDFFD\u200D\u2640\uFE0F"],"12.0"],"1f3fe":["1f9cf-1f3fe-200d-2640-fe0f",47,47,["\uD83E\uDDCF\uD83C\uDFFE\u200D\u2640\uFE0F"],"12.0"],"1f3ff":["1f9cf-1f3ff-200d-2640-fe0f",47,48,["\uD83E\uDDCF\uD83C\uDFFF\u200D\u2640\uFE0F"],"12.0"]},
    "1f9cf-200d-2642-fe0f":{"1f3fb":["1f9cf-1f3fb-200d-2642-fe0f",47,50,["\uD83E\uDDCF\uD83C\uDFFB\u200D\u2642\uFE0F"],"12.0"],"1f3fc":["1f9cf-1f3fc-200d-2642-fe0f",47,51,["\uD83E\uDDCF\uD83C\uDFFC\u200D\u2642\uFE0F"],"12.0"],"1f3fd":["1f9cf-1f3fd-200d-2642-fe0f",47,52,["\uD83E\uDDCF\uD83C\uDFFD\u200D\u2642\uFE0F"],"12.0"],"1f3fe":["1f9cf-1f3fe-200d-2642-fe0f",47,53,["\uD83E\uDDCF\uD83C\uDFFE\u200D\u2642\uFE0F"],"12.0"],"1f3ff":["1f9cf-1f3ff-200d-2642-fe0f",47,54,["\uD83E\uDDCF\uD83C\uDFFF\u200D\u2642\uFE0F"],"12.0"]},
    "1f9cf":{"1f3fb":["1f9cf-1f3fb",47,56,["\uD83E\uDDCF\uD83C\uDFFB"],"12.0"],"1f3fc":["1f9cf-1f3fc",47,57,["\uD83E\uDDCF\uD83C\uDFFC"],"12.0"],"1f3fd":["1f9cf-1f3fd",47,58,["\uD83E\uDDCF\uD83C\uDFFD"],"12.0"],"1f3fe":["1f9cf-1f3fe",47,59,["\uD83E\uDDCF\uD83C\uDFFE"],"12.0"],"1f3ff":["1f9cf-1f3ff",47,60,["\uD83E\uDDCF\uD83C\uDFFF"],"12.0"]},
    "1f9d1-200d-1f33e":{"1f3fb":["1f9d1-1f3fb-200d-1f33e",48,1,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF3E"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f33e",48,2,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF3E"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f33e",48,3,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF3E"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f33e",48,4,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF3E"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f33e",48,5,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF3E"],"12.1"]},
    "1f9d1-200d-1f373":{"1f3fb":["1f9d1-1f3fb-200d-1f373",48,7,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF73"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f373",48,8,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF73"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f373",48,9,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF73"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f373",48,10,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF73"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f373",48,11,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF73"],"12.1"]},
    "1f9d1-200d-1f37c":{"1f3fb":["1f9d1-1f3fb-200d-1f37c",48,13,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF7C"],"13.0"],"1f3fc":["1f9d1-1f3fc-200d-1f37c",48,14,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF7C"],"13.0"],"1f3fd":["1f9d1-1f3fd-200d-1f37c",48,15,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF7C"],"13.0"],"1f3fe":["1f9d1-1f3fe-200d-1f37c",48,16,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF7C"],"13.0"],"1f3ff":["1f9d1-1f3ff-200d-1f37c",48,17,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF7C"],"13.0"]},
    "1f9d1-200d-1f384":{"1f3fb":["1f9d1-1f3fb-200d-1f384",48,19,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF84"],"13.0"],"1f3fc":["1f9d1-1f3fc-200d-1f384",48,20,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF84"],"13.0"],"1f3fd":["1f9d1-1f3fd-200d-1f384",48,21,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF84"],"13.0"],"1f3fe":["1f9d1-1f3fe-200d-1f384",48,22,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF84"],"13.0"],"1f3ff":["1f9d1-1f3ff-200d-1f384",48,23,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF84"],"13.0"]},
    "1f9d1-200d-1f393":{"1f3fb":["1f9d1-1f3fb-200d-1f393",48,25,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDF93"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f393",48,26,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDF93"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f393",48,27,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDF93"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f393",48,28,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDF93"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f393",48,29,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDF93"],"12.1"]},
    "1f9d1-200d-1f3a4":{"1f3fb":["1f9d1-1f3fb-200d-1f3a4",48,31,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFA4"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f3a4",48,32,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFA4"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f3a4",48,33,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFA4"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f3a4",48,34,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFA4"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f3a4",48,35,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFA4"],"12.1"]},
    "1f9d1-200d-1f3a8":{"1f3fb":["1f9d1-1f3fb-200d-1f3a8",48,37,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFA8"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f3a8",48,38,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFA8"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f3a8",48,39,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFA8"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f3a8",48,40,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFA8"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f3a8",48,41,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFA8"],"12.1"]},
    "1f9d1-200d-1f3eb":{"1f3fb":["1f9d1-1f3fb-200d-1f3eb",48,43,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFEB"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f3eb",48,44,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFEB"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f3eb",48,45,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFEB"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f3eb",48,46,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFEB"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f3eb",48,47,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFEB"],"12.1"]},
    "1f9d1-200d-1f3ed":{"1f3fb":["1f9d1-1f3fb-200d-1f3ed",48,49,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83C\uDFED"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f3ed",48,50,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83C\uDFED"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f3ed",48,51,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83C\uDFED"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f3ed",48,52,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83C\uDFED"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f3ed",48,53,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83C\uDFED"],"12.1"]},
    "1f9d1-200d-1f4bb":{"1f3fb":["1f9d1-1f3fb-200d-1f4bb",48,55,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDCBB"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f4bb",48,56,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDCBB"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f4bb",48,57,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDCBB"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f4bb",48,58,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDCBB"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f4bb",48,59,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDCBB"],"12.1"]},
    "1f9d1-200d-1f4bc":{"1f3fb":["1f9d1-1f3fb-200d-1f4bc",48,61,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDCBC"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f4bc",49,0,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDCBC"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f4bc",49,1,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDCBC"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f4bc",49,2,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDCBC"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f4bc",49,3,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDCBC"],"12.1"]},
    "1f9d1-200d-1f527":{"1f3fb":["1f9d1-1f3fb-200d-1f527",49,5,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDD27"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f527",49,6,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDD27"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f527",49,7,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDD27"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f527",49,8,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDD27"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f527",49,9,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDD27"],"12.1"]},
    "1f9d1-200d-1f52c":{"1f3fb":["1f9d1-1f3fb-200d-1f52c",49,11,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDD2C"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f52c",49,12,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDD2C"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f52c",49,13,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDD2C"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f52c",49,14,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDD2C"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f52c",49,15,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDD2C"],"12.1"]},
    "1f9d1-200d-1f680":{"1f3fb":["1f9d1-1f3fb-200d-1f680",49,17,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDE80"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f680",49,18,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDE80"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f680",49,19,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDE80"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f680",49,20,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDE80"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f680",49,21,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDE80"],"12.1"]},
    "1f9d1-200d-1f692":{"1f3fb":["1f9d1-1f3fb-200d-1f692",49,23,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83D\uDE92"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f692",49,24,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83D\uDE92"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f692",49,25,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83D\uDE92"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f692",49,26,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83D\uDE92"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f692",49,27,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83D\uDE92"],"12.1"]},
    "1f9d1-200d-1f91d-200d-1f9d1":{"1f3fb-1f3fb":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",49,29,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"],"12.0"],"1f3fb-1f3fc":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",49,30,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"],"12.1"],"1f3fb-1f3fd":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",49,31,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"],"12.1"],"1f3fb-1f3fe":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",49,32,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"],"12.1"],"1f3fb-1f3ff":["1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",49,33,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"],"12.1"],"1f3fc-1f3fb":["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",49,34,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"],"12.0"],"1f3fc-1f3fc":["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",49,35,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"],"12.0"],"1f3fc-1f3fd":["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",49,36,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"],"12.1"],"1f3fc-1f3fe":["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",49,37,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"],"12.1"],"1f3fc-1f3ff":["1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",49,38,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"],"12.1"],"1f3fd-1f3fb":["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",49,39,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"],"12.0"],"1f3fd-1f3fc":["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",49,40,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"],"12.0"],"1f3fd-1f3fd":["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",49,41,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"],"12.0"],"1f3fd-1f3fe":["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",49,42,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"],"12.1"],"1f3fd-1f3ff":["1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",49,43,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"],"12.1"],"1f3fe-1f3fb":["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",49,44,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"],"12.0"],"1f3fe-1f3fc":["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",49,45,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"],"12.0"],"1f3fe-1f3fd":["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",49,46,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"],"12.0"],"1f3fe-1f3fe":["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",49,47,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"],"12.0"],"1f3fe-1f3ff":["1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",49,48,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"],"12.1"],"1f3ff-1f3fb":["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",49,49,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFB"],"12.0"],"1f3ff-1f3fc":["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",49,50,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFC"],"12.0"],"1f3ff-1f3fd":["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",49,51,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFD"],"12.0"],"1f3ff-1f3fe":["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",49,52,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFE"],"12.0"],"1f3ff-1f3ff":["1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",49,53,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1\uD83C\uDFFF"],"12.0"]},
    "1f9d1-200d-1f9af-200d-27a1-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-1f9af-200d-27a1-fe0f",49,55,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9af-200d-27a1-fe0f",49,56,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9af-200d-27a1-fe0f",49,57,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9af-200d-27a1-fe0f",49,58,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9af-200d-27a1-fe0f",49,59,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDAF\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9d1-200d-1f9af":{"1f3fb":["1f9d1-1f3fb-200d-1f9af",49,61,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDAF"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9af",50,0,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDAF"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9af",50,1,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDAF"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9af",50,2,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDAF"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9af",50,3,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDAF"],"12.1"]},
    "1f9d1-200d-1f9b0":{"1f3fb":["1f9d1-1f3fb-200d-1f9b0",50,5,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB0"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9b0",50,6,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB0"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9b0",50,7,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB0"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9b0",50,8,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB0"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9b0",50,9,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB0"],"12.1"]},
    "1f9d1-200d-1f9b1":{"1f3fb":["1f9d1-1f3fb-200d-1f9b1",50,11,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB1"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9b1",50,12,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB1"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9b1",50,13,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB1"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9b1",50,14,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB1"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9b1",50,15,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB1"],"12.1"]},
    "1f9d1-200d-1f9b2":{"1f3fb":["1f9d1-1f3fb-200d-1f9b2",50,17,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB2"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9b2",50,18,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB2"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9b2",50,19,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB2"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9b2",50,20,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB2"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9b2",50,21,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB2"],"12.1"]},
    "1f9d1-200d-1f9b3":{"1f3fb":["1f9d1-1f3fb-200d-1f9b3",50,23,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDB3"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9b3",50,24,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDB3"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9b3",50,25,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDB3"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9b3",50,26,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDB3"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9b3",50,27,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDB3"],"12.1"]},
    "1f9d1-200d-1f9bc-200d-27a1-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-1f9bc-200d-27a1-fe0f",50,29,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9bc-200d-27a1-fe0f",50,30,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9bc-200d-27a1-fe0f",50,31,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9bc-200d-27a1-fe0f",50,32,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9bc-200d-27a1-fe0f",50,33,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBC\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9d1-200d-1f9bc":{"1f3fb":["1f9d1-1f3fb-200d-1f9bc",50,35,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBC"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9bc",50,36,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBC"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9bc",50,37,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBC"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9bc",50,38,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBC"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9bc",50,39,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBC"],"12.1"]},
    "1f9d1-200d-1f9bd-200d-27a1-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-1f9bd-200d-27a1-fe0f",50,41,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9bd-200d-27a1-fe0f",50,42,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9bd-200d-27a1-fe0f",50,43,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9bd-200d-27a1-fe0f",50,44,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9bd-200d-27a1-fe0f",50,45,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBD\u200D\u27A1\uFE0F"],"15.1"]},
    "1f9d1-200d-1f9bd":{"1f3fb":["1f9d1-1f3fb-200d-1f9bd",50,47,["\uD83E\uDDD1\uD83C\uDFFB\u200D\uD83E\uDDBD"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-1f9bd",50,48,["\uD83E\uDDD1\uD83C\uDFFC\u200D\uD83E\uDDBD"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-1f9bd",50,49,["\uD83E\uDDD1\uD83C\uDFFD\u200D\uD83E\uDDBD"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-1f9bd",50,50,["\uD83E\uDDD1\uD83C\uDFFE\u200D\uD83E\uDDBD"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-1f9bd",50,51,["\uD83E\uDDD1\uD83C\uDFFF\u200D\uD83E\uDDBD"],"12.1"]},
    "1f9d1-200d-2695-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-2695-fe0f",50,57,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2695\uFE0F"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-2695-fe0f",50,58,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2695\uFE0F"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-2695-fe0f",50,59,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2695\uFE0F"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-2695-fe0f",50,60,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2695\uFE0F"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-2695-fe0f",50,61,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2695\uFE0F"],"12.1"]},
    "1f9d1-200d-2696-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-2696-fe0f",51,1,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2696\uFE0F"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-2696-fe0f",51,2,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2696\uFE0F"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-2696-fe0f",51,3,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2696\uFE0F"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-2696-fe0f",51,4,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2696\uFE0F"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-2696-fe0f",51,5,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2696\uFE0F"],"12.1"]},
    "1f9d1-200d-2708-fe0f":{"1f3fb":["1f9d1-1f3fb-200d-2708-fe0f",51,7,["\uD83E\uDDD1\uD83C\uDFFB\u200D\u2708\uFE0F"],"12.1"],"1f3fc":["1f9d1-1f3fc-200d-2708-fe0f",51,8,["\uD83E\uDDD1\uD83C\uDFFC\u200D\u2708\uFE0F"],"12.1"],"1f3fd":["1f9d1-1f3fd-200d-2708-fe0f",51,9,["\uD83E\uDDD1\uD83C\uDFFD\u200D\u2708\uFE0F"],"12.1"],"1f3fe":["1f9d1-1f3fe-200d-2708-fe0f",51,10,["\uD83E\uDDD1\uD83C\uDFFE\u200D\u2708\uFE0F"],"12.1"],"1f3ff":["1f9d1-1f3ff-200d-2708-fe0f",51,11,["\uD83E\uDDD1\uD83C\uDFFF\u200D\u2708\uFE0F"],"12.1"]},
    "1f9d1":{"1f3fb":["1f9d1-1f3fb",51,13,["\uD83E\uDDD1\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d1-1f3fc",51,14,["\uD83E\uDDD1\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d1-1f3fd",51,15,["\uD83E\uDDD1\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d1-1f3fe",51,16,["\uD83E\uDDD1\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d1-1f3ff",51,17,["\uD83E\uDDD1\uD83C\uDFFF"],"5.0"]},
    "1f9d2":{"1f3fb":["1f9d2-1f3fb",51,19,["\uD83E\uDDD2\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d2-1f3fc",51,20,["\uD83E\uDDD2\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d2-1f3fd",51,21,["\uD83E\uDDD2\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d2-1f3fe",51,22,["\uD83E\uDDD2\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d2-1f3ff",51,23,["\uD83E\uDDD2\uD83C\uDFFF"],"5.0"]},
    "1f9d3":{"1f3fb":["1f9d3-1f3fb",51,25,["\uD83E\uDDD3\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d3-1f3fc",51,26,["\uD83E\uDDD3\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d3-1f3fd",51,27,["\uD83E\uDDD3\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d3-1f3fe",51,28,["\uD83E\uDDD3\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d3-1f3ff",51,29,["\uD83E\uDDD3\uD83C\uDFFF"],"5.0"]},
    "1f9d4-200d-2640-fe0f":{"1f3fb":["1f9d4-1f3fb-200d-2640-fe0f",51,31,["\uD83E\uDDD4\uD83C\uDFFB\u200D\u2640\uFE0F"],"13.1"],"1f3fc":["1f9d4-1f3fc-200d-2640-fe0f",51,32,["\uD83E\uDDD4\uD83C\uDFFC\u200D\u2640\uFE0F"],"13.1"],"1f3fd":["1f9d4-1f3fd-200d-2640-fe0f",51,33,["\uD83E\uDDD4\uD83C\uDFFD\u200D\u2640\uFE0F"],"13.1"],"1f3fe":["1f9d4-1f3fe-200d-2640-fe0f",51,34,["\uD83E\uDDD4\uD83C\uDFFE\u200D\u2640\uFE0F"],"13.1"],"1f3ff":["1f9d4-1f3ff-200d-2640-fe0f",51,35,["\uD83E\uDDD4\uD83C\uDFFF\u200D\u2640\uFE0F"],"13.1"]},
    "1f9d4-200d-2642-fe0f":{"1f3fb":["1f9d4-1f3fb-200d-2642-fe0f",51,37,["\uD83E\uDDD4\uD83C\uDFFB\u200D\u2642\uFE0F"],"13.1"],"1f3fc":["1f9d4-1f3fc-200d-2642-fe0f",51,38,["\uD83E\uDDD4\uD83C\uDFFC\u200D\u2642\uFE0F"],"13.1"],"1f3fd":["1f9d4-1f3fd-200d-2642-fe0f",51,39,["\uD83E\uDDD4\uD83C\uDFFD\u200D\u2642\uFE0F"],"13.1"],"1f3fe":["1f9d4-1f3fe-200d-2642-fe0f",51,40,["\uD83E\uDDD4\uD83C\uDFFE\u200D\u2642\uFE0F"],"13.1"],"1f3ff":["1f9d4-1f3ff-200d-2642-fe0f",51,41,["\uD83E\uDDD4\uD83C\uDFFF\u200D\u2642\uFE0F"],"13.1"]},
    "1f9d4":{"1f3fb":["1f9d4-1f3fb",51,43,["\uD83E\uDDD4\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d4-1f3fc",51,44,["\uD83E\uDDD4\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d4-1f3fd",51,45,["\uD83E\uDDD4\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d4-1f3fe",51,46,["\uD83E\uDDD4\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d4-1f3ff",51,47,["\uD83E\uDDD4\uD83C\uDFFF"],"5.0"]},
    "1f9d5":{"1f3fb":["1f9d5-1f3fb",51,49,["\uD83E\uDDD5\uD83C\uDFFB"],"5.0"],"1f3fc":["1f9d5-1f3fc",51,50,["\uD83E\uDDD5\uD83C\uDFFC"],"5.0"],"1f3fd":["1f9d5-1f3fd",51,51,["\uD83E\uDDD5\uD83C\uDFFD"],"5.0"],"1f3fe":["1f9d5-1f3fe",51,52,["\uD83E\uDDD5\uD83C\uDFFE"],"5.0"],"1f3ff":["1f9d5-1f3ff",51,53,["\uD83E\uDDD5\uD83C\uDFFF"],"5.0"]},
    "1f9d6-200d-2640-fe0f":{"1f3fb":["1f9d6-1f3fb-200d-2640-fe0f",51,55,["\uD83E\uDDD6\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9d6-1f3fc-200d-2640-fe0f",51,56,["\uD83E\uDDD6\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9d6-1f3fd-200d-2640-fe0f",51,57,["\uD83E\uDDD6\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9d6-1f3fe-200d-2640-fe0f",51,58,["\uD83E\uDDD6\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9d6-1f3ff-200d-2640-fe0f",51,59,["\uD83E\uDDD6\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9d6-200d-2642-fe0f":{"1f3fb":["1f9d6-1f3fb-200d-2642-fe0f",51,61,["\uD83E\uDDD6\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9d6-1f3fc-200d-2642-fe0f",52,0,["\uD83E\uDDD6\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9d6-1f3fd-200d-2642-fe0f",52,1,["\uD83E\uDDD6\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9d6-1f3fe-200d-2642-fe0f",52,2,["\uD83E\uDDD6\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9d6-1f3ff-200d-2642-fe0f",52,3,["\uD83E\uDDD6\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9d7-200d-2640-fe0f":{"1f3fb":["1f9d7-1f3fb-200d-2640-fe0f",52,11,["\uD83E\uDDD7\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9d7-1f3fc-200d-2640-fe0f",52,12,["\uD83E\uDDD7\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9d7-1f3fd-200d-2640-fe0f",52,13,["\uD83E\uDDD7\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9d7-1f3fe-200d-2640-fe0f",52,14,["\uD83E\uDDD7\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9d7-1f3ff-200d-2640-fe0f",52,15,["\uD83E\uDDD7\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9d7-200d-2642-fe0f":{"1f3fb":["1f9d7-1f3fb-200d-2642-fe0f",52,17,["\uD83E\uDDD7\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9d7-1f3fc-200d-2642-fe0f",52,18,["\uD83E\uDDD7\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9d7-1f3fd-200d-2642-fe0f",52,19,["\uD83E\uDDD7\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9d7-1f3fe-200d-2642-fe0f",52,20,["\uD83E\uDDD7\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9d7-1f3ff-200d-2642-fe0f",52,21,["\uD83E\uDDD7\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9d8-200d-2640-fe0f":{"1f3fb":["1f9d8-1f3fb-200d-2640-fe0f",52,29,["\uD83E\uDDD8\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9d8-1f3fc-200d-2640-fe0f",52,30,["\uD83E\uDDD8\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9d8-1f3fd-200d-2640-fe0f",52,31,["\uD83E\uDDD8\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9d8-1f3fe-200d-2640-fe0f",52,32,["\uD83E\uDDD8\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9d8-1f3ff-200d-2640-fe0f",52,33,["\uD83E\uDDD8\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9d8-200d-2642-fe0f":{"1f3fb":["1f9d8-1f3fb-200d-2642-fe0f",52,35,["\uD83E\uDDD8\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9d8-1f3fc-200d-2642-fe0f",52,36,["\uD83E\uDDD8\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9d8-1f3fd-200d-2642-fe0f",52,37,["\uD83E\uDDD8\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9d8-1f3fe-200d-2642-fe0f",52,38,["\uD83E\uDDD8\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9d8-1f3ff-200d-2642-fe0f",52,39,["\uD83E\uDDD8\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9d9-200d-2640-fe0f":{"1f3fb":["1f9d9-1f3fb-200d-2640-fe0f",52,47,["\uD83E\uDDD9\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9d9-1f3fc-200d-2640-fe0f",52,48,["\uD83E\uDDD9\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9d9-1f3fd-200d-2640-fe0f",52,49,["\uD83E\uDDD9\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9d9-1f3fe-200d-2640-fe0f",52,50,["\uD83E\uDDD9\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9d9-1f3ff-200d-2640-fe0f",52,51,["\uD83E\uDDD9\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9d9-200d-2642-fe0f":{"1f3fb":["1f9d9-1f3fb-200d-2642-fe0f",52,53,["\uD83E\uDDD9\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9d9-1f3fc-200d-2642-fe0f",52,54,["\uD83E\uDDD9\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9d9-1f3fd-200d-2642-fe0f",52,55,["\uD83E\uDDD9\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9d9-1f3fe-200d-2642-fe0f",52,56,["\uD83E\uDDD9\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9d9-1f3ff-200d-2642-fe0f",52,57,["\uD83E\uDDD9\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9da-200d-2640-fe0f":{"1f3fb":["1f9da-1f3fb-200d-2640-fe0f",53,3,["\uD83E\uDDDA\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9da-1f3fc-200d-2640-fe0f",53,4,["\uD83E\uDDDA\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9da-1f3fd-200d-2640-fe0f",53,5,["\uD83E\uDDDA\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9da-1f3fe-200d-2640-fe0f",53,6,["\uD83E\uDDDA\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9da-1f3ff-200d-2640-fe0f",53,7,["\uD83E\uDDDA\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9da-200d-2642-fe0f":{"1f3fb":["1f9da-1f3fb-200d-2642-fe0f",53,9,["\uD83E\uDDDA\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9da-1f3fc-200d-2642-fe0f",53,10,["\uD83E\uDDDA\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9da-1f3fd-200d-2642-fe0f",53,11,["\uD83E\uDDDA\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9da-1f3fe-200d-2642-fe0f",53,12,["\uD83E\uDDDA\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9da-1f3ff-200d-2642-fe0f",53,13,["\uD83E\uDDDA\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9db-200d-2640-fe0f":{"1f3fb":["1f9db-1f3fb-200d-2640-fe0f",53,21,["\uD83E\uDDDB\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9db-1f3fc-200d-2640-fe0f",53,22,["\uD83E\uDDDB\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9db-1f3fd-200d-2640-fe0f",53,23,["\uD83E\uDDDB\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9db-1f3fe-200d-2640-fe0f",53,24,["\uD83E\uDDDB\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9db-1f3ff-200d-2640-fe0f",53,25,["\uD83E\uDDDB\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9db-200d-2642-fe0f":{"1f3fb":["1f9db-1f3fb-200d-2642-fe0f",53,27,["\uD83E\uDDDB\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9db-1f3fc-200d-2642-fe0f",53,28,["\uD83E\uDDDB\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9db-1f3fd-200d-2642-fe0f",53,29,["\uD83E\uDDDB\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9db-1f3fe-200d-2642-fe0f",53,30,["\uD83E\uDDDB\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9db-1f3ff-200d-2642-fe0f",53,31,["\uD83E\uDDDB\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9dc-200d-2640-fe0f":{"1f3fb":["1f9dc-1f3fb-200d-2640-fe0f",53,39,["\uD83E\uDDDC\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9dc-1f3fc-200d-2640-fe0f",53,40,["\uD83E\uDDDC\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9dc-1f3fd-200d-2640-fe0f",53,41,["\uD83E\uDDDC\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9dc-1f3fe-200d-2640-fe0f",53,42,["\uD83E\uDDDC\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9dc-1f3ff-200d-2640-fe0f",53,43,["\uD83E\uDDDC\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9dc-200d-2642-fe0f":{"1f3fb":["1f9dc-1f3fb-200d-2642-fe0f",53,45,["\uD83E\uDDDC\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9dc-1f3fc-200d-2642-fe0f",53,46,["\uD83E\uDDDC\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9dc-1f3fd-200d-2642-fe0f",53,47,["\uD83E\uDDDC\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9dc-1f3fe-200d-2642-fe0f",53,48,["\uD83E\uDDDC\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9dc-1f3ff-200d-2642-fe0f",53,49,["\uD83E\uDDDC\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1f9dd-200d-2640-fe0f":{"1f3fb":["1f9dd-1f3fb-200d-2640-fe0f",53,57,["\uD83E\uDDDD\uD83C\uDFFB\u200D\u2640\uFE0F"],"5.0"],"1f3fc":["1f9dd-1f3fc-200d-2640-fe0f",53,58,["\uD83E\uDDDD\uD83C\uDFFC\u200D\u2640\uFE0F"],"5.0"],"1f3fd":["1f9dd-1f3fd-200d-2640-fe0f",53,59,["\uD83E\uDDDD\uD83C\uDFFD\u200D\u2640\uFE0F"],"5.0"],"1f3fe":["1f9dd-1f3fe-200d-2640-fe0f",53,60,["\uD83E\uDDDD\uD83C\uDFFE\u200D\u2640\uFE0F"],"5.0"],"1f3ff":["1f9dd-1f3ff-200d-2640-fe0f",53,61,["\uD83E\uDDDD\uD83C\uDFFF\u200D\u2640\uFE0F"],"5.0"]},
    "1f9dd-200d-2642-fe0f":{"1f3fb":["1f9dd-1f3fb-200d-2642-fe0f",54,1,["\uD83E\uDDDD\uD83C\uDFFB\u200D\u2642\uFE0F"],"5.0"],"1f3fc":["1f9dd-1f3fc-200d-2642-fe0f",54,2,["\uD83E\uDDDD\uD83C\uDFFC\u200D\u2642\uFE0F"],"5.0"],"1f3fd":["1f9dd-1f3fd-200d-2642-fe0f",54,3,["\uD83E\uDDDD\uD83C\uDFFD\u200D\u2642\uFE0F"],"5.0"],"1f3fe":["1f9dd-1f3fe-200d-2642-fe0f",54,4,["\uD83E\uDDDD\uD83C\uDFFE\u200D\u2642\uFE0F"],"5.0"],"1f3ff":["1f9dd-1f3ff-200d-2642-fe0f",54,5,["\uD83E\uDDDD\uD83C\uDFFF\u200D\u2642\uFE0F"],"5.0"]},
    "1fac3":{"1f3fb":["1fac3-1f3fb",55,61,["\uD83E\uDEC3\uD83C\uDFFB"],"14.0"],"1f3fc":["1fac3-1f3fc",56,0,["\uD83E\uDEC3\uD83C\uDFFC"],"14.0"],"1f3fd":["1fac3-1f3fd",56,1,["\uD83E\uDEC3\uD83C\uDFFD"],"14.0"],"1f3fe":["1fac3-1f3fe",56,2,["\uD83E\uDEC3\uD83C\uDFFE"],"14.0"],"1f3ff":["1fac3-1f3ff",56,3,["\uD83E\uDEC3\uD83C\uDFFF"],"14.0"]},
    "1fac4":{"1f3fb":["1fac4-1f3fb",56,5,["\uD83E\uDEC4\uD83C\uDFFB"],"14.0"],"1f3fc":["1fac4-1f3fc",56,6,["\uD83E\uDEC4\uD83C\uDFFC"],"14.0"],"1f3fd":["1fac4-1f3fd",56,7,["\uD83E\uDEC4\uD83C\uDFFD"],"14.0"],"1f3fe":["1fac4-1f3fe",56,8,["\uD83E\uDEC4\uD83C\uDFFE"],"14.0"],"1f3ff":["1fac4-1f3ff",56,9,["\uD83E\uDEC4\uD83C\uDFFF"],"14.0"]},
    "1fac5":{"1f3fb":["1fac5-1f3fb",56,11,["\uD83E\uDEC5\uD83C\uDFFB"],"14.0"],"1f3fc":["1fac5-1f3fc",56,12,["\uD83E\uDEC5\uD83C\uDFFC"],"14.0"],"1f3fd":["1fac5-1f3fd",56,13,["\uD83E\uDEC5\uD83C\uDFFD"],"14.0"],"1f3fe":["1fac5-1f3fe",56,14,["\uD83E\uDEC5\uD83C\uDFFE"],"14.0"],"1f3ff":["1fac5-1f3ff",56,15,["\uD83E\uDEC5\uD83C\uDFFF"],"14.0"]},
    "1faf0":{"1f3fb":["1faf0-1f3fb",56,40,["\uD83E\uDEF0\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf0-1f3fc",56,41,["\uD83E\uDEF0\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf0-1f3fd",56,42,["\uD83E\uDEF0\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf0-1f3fe",56,43,["\uD83E\uDEF0\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf0-1f3ff",56,44,["\uD83E\uDEF0\uD83C\uDFFF"],"14.0"]},
    "1faf1":{"1f3fb":["1faf1-1f3fb",56,46,["\uD83E\uDEF1\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf1-1f3fc",56,47,["\uD83E\uDEF1\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf1-1f3fd",56,48,["\uD83E\uDEF1\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf1-1f3fe",56,49,["\uD83E\uDEF1\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf1-1f3ff",56,50,["\uD83E\uDEF1\uD83C\uDFFF"],"14.0"]},
    "1faf2":{"1f3fb":["1faf2-1f3fb",56,52,["\uD83E\uDEF2\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf2-1f3fc",56,53,["\uD83E\uDEF2\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf2-1f3fd",56,54,["\uD83E\uDEF2\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf2-1f3fe",56,55,["\uD83E\uDEF2\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf2-1f3ff",56,56,["\uD83E\uDEF2\uD83C\uDFFF"],"14.0"]},
    "1faf3":{"1f3fb":["1faf3-1f3fb",56,58,["\uD83E\uDEF3\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf3-1f3fc",56,59,["\uD83E\uDEF3\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf3-1f3fd",56,60,["\uD83E\uDEF3\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf3-1f3fe",56,61,["\uD83E\uDEF3\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf3-1f3ff",57,0,["\uD83E\uDEF3\uD83C\uDFFF"],"14.0"]},
    "1faf4":{"1f3fb":["1faf4-1f3fb",57,2,["\uD83E\uDEF4\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf4-1f3fc",57,3,["\uD83E\uDEF4\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf4-1f3fd",57,4,["\uD83E\uDEF4\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf4-1f3fe",57,5,["\uD83E\uDEF4\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf4-1f3ff",57,6,["\uD83E\uDEF4\uD83C\uDFFF"],"14.0"]},
    "1faf5":{"1f3fb":["1faf5-1f3fb",57,8,["\uD83E\uDEF5\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf5-1f3fc",57,9,["\uD83E\uDEF5\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf5-1f3fd",57,10,["\uD83E\uDEF5\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf5-1f3fe",57,11,["\uD83E\uDEF5\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf5-1f3ff",57,12,["\uD83E\uDEF5\uD83C\uDFFF"],"14.0"]},
    "1faf6":{"1f3fb":["1faf6-1f3fb",57,14,["\uD83E\uDEF6\uD83C\uDFFB"],"14.0"],"1f3fc":["1faf6-1f3fc",57,15,["\uD83E\uDEF6\uD83C\uDFFC"],"14.0"],"1f3fd":["1faf6-1f3fd",57,16,["\uD83E\uDEF6\uD83C\uDFFD"],"14.0"],"1f3fe":["1faf6-1f3fe",57,17,["\uD83E\uDEF6\uD83C\uDFFE"],"14.0"],"1f3ff":["1faf6-1f3ff",57,18,["\uD83E\uDEF6\uD83C\uDFFF"],"14.0"]},
    "1faf7":{"1f3fb":["1faf7-1f3fb",57,20,["\uD83E\uDEF7\uD83C\uDFFB"],"15.0"],"1f3fc":["1faf7-1f3fc",57,21,["\uD83E\uDEF7\uD83C\uDFFC"],"15.0"],"1f3fd":["1faf7-1f3fd",57,22,["\uD83E\uDEF7\uD83C\uDFFD"],"15.0"],"1f3fe":["1faf7-1f3fe",57,23,["\uD83E\uDEF7\uD83C\uDFFE"],"15.0"],"1f3ff":["1faf7-1f3ff",57,24,["\uD83E\uDEF7\uD83C\uDFFF"],"15.0"]},
    "1faf8":{"1f3fb":["1faf8-1f3fb",57,26,["\uD83E\uDEF8\uD83C\uDFFB"],"15.0"],"1f3fc":["1faf8-1f3fc",57,27,["\uD83E\uDEF8\uD83C\uDFFC"],"15.0"],"1f3fd":["1faf8-1f3fd",57,28,["\uD83E\uDEF8\uD83C\uDFFD"],"15.0"],"1f3fe":["1faf8-1f3fe",57,29,["\uD83E\uDEF8\uD83C\uDFFE"],"15.0"],"1f3ff":["1faf8-1f3ff",57,30,["\uD83E\uDEF8\uD83C\uDFFF"],"15.0"]},
    "261d-fe0f":{"1f3fb":["261d-1f3fb",58,19,["\u261D\uD83C\uDFFB"],"1.0"],"1f3fc":["261d-1f3fc",58,20,["\u261D\uD83C\uDFFC"],"1.0"],"1f3fd":["261d-1f3fd",58,21,["\u261D\uD83C\uDFFD"],"1.0"],"1f3fe":["261d-1f3fe",58,22,["\u261D\uD83C\uDFFE"],"1.0"],"1f3ff":["261d-1f3ff",58,23,["\u261D\uD83C\uDFFF"],"1.0"]},
    "26f9-fe0f-200d-2640-fe0f":{"1f3fb":["26f9-1f3fb-200d-2640-fe0f",59,33,["\u26F9\uD83C\uDFFB\u200D\u2640\uFE0F"],"4.0"],"1f3fc":["26f9-1f3fc-200d-2640-fe0f",59,34,["\u26F9\uD83C\uDFFC\u200D\u2640\uFE0F"],"4.0"],"1f3fd":["26f9-1f3fd-200d-2640-fe0f",59,35,["\u26F9\uD83C\uDFFD\u200D\u2640\uFE0F"],"4.0"],"1f3fe":["26f9-1f3fe-200d-2640-fe0f",59,36,["\u26F9\uD83C\uDFFE\u200D\u2640\uFE0F"],"4.0"],"1f3ff":["26f9-1f3ff-200d-2640-fe0f",59,37,["\u26F9\uD83C\uDFFF\u200D\u2640\uFE0F"],"4.0"]},
    "26f9-fe0f-200d-2642-fe0f":{"1f3fb":["26f9-1f3fb-200d-2642-fe0f",59,39,["\u26F9\uD83C\uDFFB\u200D\u2642\uFE0F"],"4.0"],"1f3fc":["26f9-1f3fc-200d-2642-fe0f",59,40,["\u26F9\uD83C\uDFFC\u200D\u2642\uFE0F"],"4.0"],"1f3fd":["26f9-1f3fd-200d-2642-fe0f",59,41,["\u26F9\uD83C\uDFFD\u200D\u2642\uFE0F"],"4.0"],"1f3fe":["26f9-1f3fe-200d-2642-fe0f",59,42,["\u26F9\uD83C\uDFFE\u200D\u2642\uFE0F"],"4.0"],"1f3ff":["26f9-1f3ff-200d-2642-fe0f",59,43,["\u26F9\uD83C\uDFFF\u200D\u2642\uFE0F"],"4.0"]},
    "270a":{"1f3fb":["270a-1f3fb",59,57,["\u270A\uD83C\uDFFB"],"1.0"],"1f3fc":["270a-1f3fc",59,58,["\u270A\uD83C\uDFFC"],"1.0"],"1f3fd":["270a-1f3fd",59,59,["\u270A\uD83C\uDFFD"],"1.0"],"1f3fe":["270a-1f3fe",59,60,["\u270A\uD83C\uDFFE"],"1.0"],"1f3ff":["270a-1f3ff",59,61,["\u270A\uD83C\uDFFF"],"1.0"]},
    "270b":{"1f3fb":["270b-1f3fb",60,1,["\u270B\uD83C\uDFFB"],"1.0"],"1f3fc":["270b-1f3fc",60,2,["\u270B\uD83C\uDFFC"],"1.0"],"1f3fd":["270b-1f3fd",60,3,["\u270B\uD83C\uDFFD"],"1.0"],"1f3fe":["270b-1f3fe",60,4,["\u270B\uD83C\uDFFE"],"1.0"],"1f3ff":["270b-1f3ff",60,5,["\u270B\uD83C\uDFFF"],"1.0"]},
    "270c-fe0f":{"1f3fb":["270c-1f3fb",60,7,["\u270C\uD83C\uDFFB"],"1.0"],"1f3fc":["270c-1f3fc",60,8,["\u270C\uD83C\uDFFC"],"1.0"],"1f3fd":["270c-1f3fd",60,9,["\u270C\uD83C\uDFFD"],"1.0"],"1f3fe":["270c-1f3fe",60,10,["\u270C\uD83C\uDFFE"],"1.0"],"1f3ff":["270c-1f3ff",60,11,["\u270C\uD83C\uDFFF"],"1.0"]},
    "270d-fe0f":{"1f3fb":["270d-1f3fb",60,13,["\u270D\uD83C\uDFFB"],"1.0"],"1f3fc":["270d-1f3fc",60,14,["\u270D\uD83C\uDFFC"],"1.0"],"1f3fd":["270d-1f3fd",60,15,["\u270D\uD83C\uDFFD"],"1.0"],"1f3fe":["270d-1f3fe",60,16,["\u270D\uD83C\uDFFE"],"1.0"],"1f3ff":["270d-1f3ff",60,17,["\u270D\uD83C\uDFFF"],"1.0"]}
};

/***/ }),

/***/ "nEsx":
/***/ (function(module, exports) {

(function () {

function emoji () {}
// settings
emoji.img_path = 'emoji/';
emoji.img_suffix = '';
emoji.colon_aliases = {};
emoji.text_maps = {};
emoji.unified_blacklist = {};
emoji.non_native = {};

emoji.use_css_imgs = false;
emoji.colons_mode = false;
emoji.text_mode = false;
emoji.include_title = false;
emoji.allow_native = true;
emoji.use_sheet = false;
emoji.with_emocodes = true;

emoji.inits = {};
emoji.map = {};
emoji.categories = [
    "Smileys & Emotion",
    "People & Body",
    "Animals & Nature",
    "Food & Drink",
    "Travel & Places",
    "Activities",
    "Objects",
    "Symbols",
    "Flags"
];

emoji.re = {
    colons: /(:[^\s:]+:)(:skin-tone-[2-6]:)?/,
    strip_colons: /^:(:?[^:]+)(::skin-tone-[2-6])?:$/i,
    strip_colons_only: /^:(.+):$/i,
    multi_skin: /(\w+)-(\w+)/,
    ipv6_hex: /^[a-f0-9]+$/,
    ipv6_mask_pre: /([:*?]|(\b[a-f0-9:*?]+))$/,
    ipv6_mask_post: /^([:*?]|([a-f0-9:*?]+\b))/,
    ua_cr_os: /CrOS/i,
    ua_mac_os: /Mac OS X 1[01][_.][0-9]/i,
    ua_mac_os_hs: /Mac OS X 10[_.]13/i,
    ua_mac_os_mojave: /Mac OS X 10[_.]14/i,
    ua_mac_os_catalina: /Mac OS X 10[_.]15/i,
    ua_windows_10: /Windows NT 10\.\d/i
};

emoji.strip_colons = function (colon){
    return colon.replace(emoji.re.strip_colons, "$1");
};
emoji.strip_colons_only = function (colon){
    return colon.replace(emoji.re.strip_colons_only, "$1");
};
emoji.replace_colons = function(str, force_unified, skin_tone, options) {
    options = options || {};
    emoji.init_colons();
    var match = str.match(emoji.re.colons);
    if (!match) {
        return str;
    }
    var matchPart = match[0];
    var colon = match[1];
    var skin_colon = match[2];
    var idx = emoji.strip_colons(colon);
    var first = str.slice(0, match.index);
    var rest = str.slice(match.index+matchPart.length);
    var val = emoji.map.colons[idx];
    if (skin_colon) {
        var skin_idx = emoji.strip_colons(skin_colon);
        var skin_val = emoji.map.colons[skin_idx];
        if (skin_val) {
            skin_tone = emoji.data[skin_val][0][0];
        }
    }
    var replaced = ':' + idx;
    var colon_rest = ':' + rest;
    var was_replaced = false;

    if (
        // Filter out ipv6 hex masks
        // 1000:1000:100:1000:0
        // *:100:1000:0
        // ?:100:1000:0
        emoji.re.ipv6_hex.test(idx) && (
            (
                first &&
                first != ':' &&
                !/\s$/.test(first) && (
                    emoji.re.ipv6_mask_pre.test(first) ||
                    emoji.re.ipv6_mask_post.test(rest)
                )
            ) || (
                options.prev && (
                    emoji.re.ipv6_mask_pre.test(options.prev)
                )
            )
        )
    ) {
        rest = colon_rest;
    } else if (
        // Filter out Perl modules
        // Dpkg::package::package::package::package
        (!options.prev_replaced && /:$/.test(first))
    ) {
        rest = colon_rest;
    } else {
        if (val) {
            var titleText = idx;
            if (emoji.colon_aliases[val]) {
                var aliasIdx = _.indexOf(emoji.colon_aliases[val], idx);
                if (aliasIdx !== -1) {
                    var smileyAliasIdx = _.indexOf(emoji.colon_aliases[val], ':' + idx);
                    if (smileyAliasIdx !== -1) {
                        aliasIdx = smileyAliasIdx;
                    }
                    titleText = emoji.colon_aliases[val][aliasIdx];
                }
            }
            replaced = emoji.replacement(val, colon, titleText, colon, force_unified, skin_tone);
            was_replaced = true;
        } else if (idx in emoji.text_maps) {
            replaced = emoji.text_maps[idx];
        } else {
            rest = colon_rest;
        }
    }
    return first + replaced + emoji.replace_colons(rest, force_unified, undefined, {
        prev_replaced: was_replaced,
        prev: (options.prev || '') + first + replaced
    });
};
emoji.idx_to_title = function (idx) {
    if (emoji.data[idx]) return emoji.data[idx][3][0];
};
emoji.match_unified = function (str) {
    emoji.init_unified();
    return str.match(emoji.rx_unified);
};
emoji.unified_to_text = function (str) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var m = match[1];
        var rest = match[3] + str.slice(match.index+match[0].length);
        var val = emoji.map.unified[m];
        var val_var = emoji.map.unified_vars[m];
        var replaced = m;
        if (val) {
            replaced = emoji.data[val][3][0];
            var skin_idx = emoji.skin_tone_to_idx(match[2]);
            if (skin_idx) {
                replaced += '::' + emoji.data[skin_idx][3][0];
            }
        } else if (val_var) {
            replaced = emoji.data[val_var[0]][3][0];
            replaced += '::' + emoji.data[val_var[1]][3][0];
        }
        return first + replaced + emoji.unified_to_text(rest);
    } else {
        return str;
    }
};
emoji.strip_unified = function (str, single) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var rest = match[3] + str.slice(match.index+match[0].length);
        if (single) {
            return first + rest;
        } else {
            return first + emoji.strip_unified(rest);
        }
    } else {
        return str;
    }
};
emoji.replace_unified = function (str) {
    var match = emoji.match_unified(str);
    if (match) {
        var first = str.slice(0, match.index);
        var m = match[1];
        var rest = match[3] + str.slice(match.index+match[0].length);
        var val = emoji.map.unified[m];
        var val_var = emoji.map.unified_vars[m];
        var replaced = m;
        if (val) {
            replaced = emoji.replacement(val, m, emoji.idx_to_title(val), undefined, undefined, match[2]);
        } else if (val_var) {
            var skin_tone_idx = val_var[1];
            var skin_tone_data = emoji.data[skin_tone_idx];
            var skin_tone;
            if (skin_tone_data) {
                skin_tone = skin_tone_data[0][0];
            }
            replaced = emoji.replacement(val_var[0], m, emoji.idx_to_title(val_var[0]), undefined, undefined, skin_tone, skin_tone_idx);
        }
        return first + replaced + emoji.replace_unified(rest);
    } else {
        return str;
    }
};
emoji.make_attrs = function (attrs, extraClass) {
    if (attrs.classNames) {
        attrs.classNames = attrs.classNames.concat(extraClass);
        if (attrs.classNames.length) {
            attrs['class'] = attrs.classNames.join(' ');
        }
        delete attrs.classNames;
    }
    var parts = [];
    for (var attr in attrs) {
        if (attrs[attr] != null) {
            parts.push(attr + '="' + attrs[attr] + '"');
        }
    }
    return parts.length ? ' ' + parts.join(' ') : '';
};
emoji.wrap_span = function (val, attrs, extraClass) {
    extraClass = extraClass || [];
    return '<span'+emoji.make_attrs(attrs, extraClass)+'>' + val + '</span>';
};

emoji.skin_tone_to_idx = function (skin_tone) {
    return emoji.map.skin_tone_to_idx[skin_tone];
};
emoji.idx_to_colon = function (idx, skin_tone) {
    var out = ':'+emoji.data[idx][3][0]+':';
    var skin_idx = emoji.skin_tone_to_idx(skin_tone);
    if (skin_idx) {
        if (emoji.variations_data[idx] && emoji.variations_data[idx][skin_idx]) {
            out += ':'+emoji.data[skin_idx][3][0]+':';
        }
    }
    return out;
};

function get_version (idx) {
    return emoji.data[idx][6];
}
function get_variation_version (idx, skin_idx) {
    if (!skin_idx) {
        return get_version(idx);
    }
    if (!emoji.variations_data[idx]) {
        return;
    }
    return emoji.variations_data[idx][skin_idx][4];
}

emoji.check_allow_native = function (idx, skin_idx) {
    if (emoji.non_native[idx]) {
        return false;
    }
    if (
        emoji.allow_native &&
        emoji.replace_mode == 'unified' &&
        emoji.data[idx][0][0]
    ) {
        // Emoji 5.0 / Unicode 10.0 is ready from High Sierra and Windows 10 onwards
        if (
            get_variation_version(idx, skin_idx) === '5.0' &&
            !emoji.is_mac_os_hs() &&
            !emoji.is_mac_os_mojave() &&
            !emoji.is_mac_os_catalina() &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_10() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 11 is ready from Mojave and Windows 10 onwards
        if (
            get_variation_version(idx, skin_idx) === '11.0' &&
            !emoji.is_mac_os_mojave() &&
            !emoji.is_mac_os_catalina() &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_10() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 12.0 is ready from Catalina and Windows 10 onwards
        if (
            get_variation_version(idx, skin_idx) === '12.0' &&
            !emoji.is_mac_os_catalina() &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_10() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 12.1 is ready from Catalina and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '12.1' &&
            !emoji.is_mac_os_catalina() &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 13.0 is ready from Big Sur and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '13.0' &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 13.1 is ready from Big Sur and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '13.1' &&
            !emoji.is_mac_os_bigsur() &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 14.0 is ready from Monterey and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '14.0' &&
            !emoji.is_mac_os_monterey() &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 15.0 is ready from Ventura and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '15.0' &&
            !emoji.is_mac_os_ventura() &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }
        // Emoji 15.1 is ready from Sonoma and Windows 11 onwards
        if (
            get_variation_version(idx, skin_idx) === '15.1' &&
            !emoji.is_mac_os_sonoma() &&
            !emoji.is_windows_11()
        ) {
            return false;
        }

        if (emoji.is_windows_10() || emoji.is_windows_11()) {
            // Windows doesn't support country flags
            if (
                emoji.data[idx][7] === 'country-flag' ||
                emoji.data[idx][7] === 'subdivision-flag'
            ) {
                return false;
            }
        }

        switch (idx) {
        // Mojave only
        case '1f1fa-1f1f3': // flag-un
            return emoji.is_mac_os_mojave() ||
                   emoji.is_mac_os_catalina() ||
                   emoji.is_mac_os_bigsur() ||
                   emoji.is_mac_os_monterey() ||
                   emoji.is_mac_os_ventura();
        // Windows only
        case '2695-fe0f': // medical_symbol
        case '2640-fe0f': // female_sign
        case '2642-fe0f': // male_sign
            return emoji.is_windows_10() ||
                   emoji.is_windows_11();
        }

        return true;
    }
    return false;
};
emoji.replacement = function(idx, actual, titleText, colon, force_unified, skin_tone, skin_idx) {
    skin_tone = skin_tone || '';
    skin_idx = skin_idx || emoji.skin_tone_to_idx(skin_tone);
    var full_idx = idx;
    var variation_data;
    if (skin_idx) {
        variation_data = emoji.variations_data[idx] && emoji.variations_data[idx][skin_idx];
        if (variation_data) {
            full_idx = variation_data[0];
        } else {
            skin_idx = '';
            skin_tone = '';
        }
    }

    if (force_unified) {
        if (variation_data) {
            return variation_data[3][0];
        } else {
            return emoji.data[idx][0][0] + skin_tone;
        }
    }
    if (emoji.colons_mode) {
        var out = ':'+emoji.data[idx][3][0]+':';
        if (skin_idx) {
            out += ':'+emoji.data[skin_idx][3][0]+':';
        }
        return out;
    }
    if (emoji.text_mode) {
        var text_name = ':' + titleText + ':';
        return text_name;
    }
    emoji.init_env();
    var attrs = {classNames: []};
    if (emoji.include_title) {
        attrs.title = titleText;
    }
    var extraClass = [];
    var emoCode = '';
    if (emoji.with_emocodes && colon) {
        emoCode = emoji.wrap_span(colon, {
            classNames: ['emocode']
        });
        extraClass.push('emoconverted');
    }

    if (emoji.check_allow_native(idx, skin_idx)) {
        extraClass.push('emojinative');
        if (emoji.is_windows_10()) {
            extraClass.push('emojinative--win');
        }
        if (emoji.is_cr_os_native()) {
            extraClass.push('emojinative--cros');
        }
        if (emoji.is_mac_os_native()) {
            extraClass.push('emojinative--mac');
        }
        var native;
        if (variation_data) {
            native = variation_data[3][0];
        } else {
            native = emoji.data[idx][0][0] + skin_tone;
        }

        return emoji.wrap_span(native, attrs, extraClass) + emoCode;
    }
    attrs.classNames.push('emoji');
    var img = emoji.img_path+idx+'.png' + emoji.img_suffix;
    if (emoji.supports_css) {
        var px = emoji.data[idx][4];
        var py = emoji.data[idx][5];
        if (variation_data) {
            px = variation_data[1];
            py = variation_data[2];
            img = emoji.img_path+full_idx+'.png' + emoji.img_suffix;
        }
        if (emoji.use_sheet && px != null && py != null) {
            var mul = 100 / (emoji.sheet_size - 1);
            attrs.style = 'background-position:'+(mul*px)+'% '+(mul*py)+'%;';
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        } else if (emoji.use_css_imgs){
            attrs.classNames.push('emoji-'+full_idx);
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        } else {
            attrs.classNames.push('emoji-sizer');
            attrs.style = 'background-image:url('+img+')';
            return emoji.wrap_span(actual, attrs, extraClass) + emoCode;
        }
    }
    attrs.src = img;
    return '<img' + emoji.make_attrs(attrs) + '>' + emoCode;
};
emoji.init_colons = function(){
    if (emoji.inits.colons) return;
    emoji.inits.colons = 1;
    emoji.map.colons = {};
    var names;
    for (var i in emoji.data){
        names = emoji.data[i][3];
        if (emoji.colon_aliases[i]) {
            names = names.concat(emoji.colon_aliases[i]);
        }
        for (var j=0; j<names.length; j++){
            emoji.map.colons[names[j].toLowerCase()] = i;
        }
    }
};
emoji.init_unified = function(){
    if (emoji.inits.unified) return;
    emoji.inits.unified = 1;

    var a = [];
    emoji.map.unified = {};
    emoji.map.unified_vars = {};
    emoji.map.category = {};
    emoji.map.skin_tone_to_idx = {};

    for (var i in emoji.data){
        if (!emoji.map.category[emoji.data[i][1]]) {
            emoji.map.category[emoji.data[i][1]] = [];
        }
        emoji.map.category[emoji.data[i][1]].push({key: i, item: emoji.data[i]});
        if (emoji.data[i][1] === 'Component' && emoji.data[i][7] === 'skin-tone') {
            emoji.map.skin_tone_to_idx[emoji.data[i][0][0]] = i;
        }

        var eCodes = emoji.data[i][0];
        for (var j = 0; j < eCodes.length; j++) {
            if (!emoji.unified_blacklist[eCodes[j]]) {
                a.push(eCodes[j].replace('*', '\\*'));
                emoji.map.unified[eCodes[j]] = i;
            }
        }
    }
    for (var vi in emoji.variations_data){
        var toAdd = [];
        var eVars = emoji.variations_data[vi];
        for (var vk in eVars) {
            var vCodes = eVars[vk][3];
            var multi_tone = vk.match(emoji.re.multi_skin);
            if (multi_tone && multi_tone[1] == multi_tone[2] && !emoji.variations_data[multi_tone[1]]) {
                toAdd.push([multi_tone[1], eVars[vk]]);
            }
            for (var vj = 0; vj < vCodes.length; vj++) {
                a.push(vCodes[vj].replace('*', '\\*'));
                emoji.map.unified_vars[vCodes[vj]] = [vi, vk];
            }
        }
        // Add simple form same skin tone variations when missing (e.g. people_holding_hands)
        if (toAdd.length) {
            for (var addI = 0; addI < toAdd.length; addI++) {
                eVars[toAdd[addI][0]] = toAdd[addI][1];
            }
        }
    }

    for (var cat in emoji.map.category) {
        emoji.map.category[cat].sort(function (a, b) {
            return a.item[2] - b.item[2];
        });
    }

    // Sort by length so that combined sequences match first
    a.sort(function (a, b) {
        return b.length - a.length;
    });
    // Escape code points, they get corrupted by uglify otherwise
    emoji.rx_unified = new RegExp('('+a.join('|')+')(\\uD83C[\\uDFFB-\\uDFFF])?([^\\ufe0e]|$)');
};
emoji.init_env = function(){
    if (emoji.inits.env) return;
    emoji.inits.env = 1;
    emoji.replace_mode = 'img';
    emoji.supports_css = false;
    if (window.getComputedStyle){
        var st = window.getComputedStyle(document.body);
        if (st['background-size'] || st['backgroundSize']){
            emoji.supports_css = true;
        }
    }
    if (emoji.supports_css) {
        emoji.replace_mode = 'css';
    }
    if (emoji.is_mac_os_native() || emoji.is_windows_10() || emoji.is_windows_11() || emoji.is_cr_os_native()) {
        emoji.replace_mode = 'unified';
    }
};

var _is_cr_os_native = null;
emoji.is_cr_os_native = function () {
    if (_is_cr_os_native === null) {
        _is_cr_os_native = emoji.re.ua_cr_os.test(navigator.userAgent);
    }
    return _is_cr_os_native;
};

var _is_mac_os_native = null;
emoji.is_mac_os_native = function () {
    if (_is_mac_os_native === null) {
        _is_mac_os_native = emoji.re.ua_mac_os.test(navigator.userAgent);
    }
    return _is_mac_os_native;
};

var _is_mac_os_hs = null;
emoji.is_mac_os_hs = function () {
    if (_is_mac_os_hs === null) {
        _is_mac_os_hs = emoji.re.ua_mac_os_hs.test(navigator.userAgent);
    }
    return _is_mac_os_hs;
};

var _is_mac_os_mojave = null;
emoji.is_mac_os_mojave = function () {
    if (_is_mac_os_mojave === null) {
        _is_mac_os_mojave = emoji.re.ua_mac_os_mojave.test(navigator.userAgent);
    }
    return _is_mac_os_mojave;
};

var _is_mac_os_catalina = null;
emoji.is_mac_os_catalina = function () {
    if (_is_mac_os_catalina === null) {
        _is_mac_os_catalina = emoji.re.ua_mac_os_catalina.test(navigator.userAgent);
    }
    return _is_mac_os_catalina;
};

function platform_test (platform, versions) {
    if ('userAgentData' in navigator) {
        return navigator.userAgentData.getHighEntropyValues(["platformVersion"]).then(function (ua) {
            if (ua.platform === platform) {
                return _.any(versions, function (version) {
                    return ua.platformVersion.indexOf(version) === 0;
                });
            }
            return false;
        });
    }
}

var _is_mac_os_bigsur = null;
emoji.is_mac_os_bigsur = function () {
    if (_is_mac_os_bigsur === null) {
        _is_mac_os_bigsur = false; // Fallback
        var prom = platform_test('macOS', ['11.']);
        if (prom) {
            prom.then(function (ret) {
                _is_mac_os_bigsur = ret;
            });
        }
    }
    return _is_mac_os_bigsur;
};

var _is_mac_os_monterey = null;
emoji.is_mac_os_monterey = function () {
    if (_is_mac_os_monterey === null) {
        _is_mac_os_monterey = false; // Fallback
        var prom = platform_test('macOS', ['12.']);
        if (prom) {
            prom.then(function (ret) {
                _is_mac_os_monterey = ret;
            });
        }
    }
    return _is_mac_os_monterey;
};

var _is_mac_os_ventura = null;
emoji.is_mac_os_ventura = function () {
    if (_is_mac_os_ventura === null) {
        _is_mac_os_ventura = false; // Fallback
        var prom = platform_test('macOS', ['13.']);
        if (prom) {
            prom.then(function (ret) {
                _is_mac_os_ventura = ret;
            });
        }
    }
    return _is_mac_os_ventura;
};

var _is_mac_os_sonoma = null;
emoji.is_mac_os_sonoma = function () {
    if (_is_mac_os_sonoma === null) {
        _is_mac_os_sonoma = false; // Fallback
        var prom = platform_test('macOS', ['14.']);
        if (prom) {
            prom.then(function (ret) {
                _is_mac_os_sonoma = ret;
            });
        }
    }
    return _is_mac_os_sonoma;
};

var _is_windows_10 = null;
emoji.is_windows_10 = function () {
    if (emoji.is_windows_11()) {
        return false;
    }
    if (_is_windows_10 === null) {
        _is_windows_10 = emoji.re.ua_windows_10.test(navigator.userAgent);
    }
    return _is_windows_10;
};

var _is_windows_11 = null;
emoji.is_windows_11 = function () {
    if (_is_windows_11 === null) {
        _is_windows_11 = false; // Fallback
        var prom = platform_test('Windows', ['13.', '14.', '15.']);
        if (prom) {
            prom.then(function (ret) {
                _is_windows_11 = ret;
            });
        }
    }
    return _is_windows_11;
};

// Prefetch promise based uas
emoji.is_mac_os_bigsur();
emoji.is_mac_os_monterey();
emoji.is_mac_os_ventura();
emoji.is_mac_os_sonoma();
emoji.is_windows_11();

window.emoji = emoji;

})();

/***/ }),

/***/ "qXSf":
/***/ (function(module, exports) {

/*!
 * JavaScript Debug - v0.4 - 6/22/2010
 * http://benalman.com/projects/javascript-debug-console-log/
 * 
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 * 
 * With lots of help from Paul Irish!
 * http://paulirish.com/
 */

// Script: JavaScript Debug: A simple wrapper for console.log
//
// *Version: 0.4, Last Updated: 6/22/2010*
// 
// Tested with Internet Explorer 6-8, Firefox 3-3.6, Safari 3-4, Chrome 3-5, Opera 9.6-10.5
// 
// Home       - http://benalman.com/projects/javascript-debug-console-log/
// GitHub     - http://github.com/cowboy/javascript-debug/
// Source     - http://github.com/cowboy/javascript-debug/raw/master/ba-debug.js
// (Minified) - http://github.com/cowboy/javascript-debug/raw/master/ba-debug.min.js (1.1kb)
// 
// About: License
// 
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
// 
// About: Support and Testing
// 
// Information about what browsers this code has been tested in.
// 
// Browsers Tested - Internet Explorer 6-8, Firefox 3-3.6, Safari 3-4, Chrome
// 3-5, Opera 9.6-10.5
// 
// About: Examples
// 
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
// 
// Examples - http://benalman.com/code/projects/javascript-debug/examples/debug/
// 
// About: Revision History
// 
// 0.4 - (6/22/2010) Added missing passthrough methods: exception,
//       groupCollapsed, table
// 0.3 - (6/8/2009) Initial release
// 
// Topic: Pass-through console methods
// 
// assert, clear, count, dir, dirxml, exception, group, groupCollapsed,
// groupEnd, profile, profileEnd, table, time, timeEnd, trace
// 
// These console methods are passed through (but only if both the console and
// the method exists), so use them without fear of reprisal. Note that these
// methods will not be passed through if the logging level is set to 0 via
// <debug.setLevel>.

window.irccloud_debug = (function(){
  var window = this,
    
    // Some convenient shortcuts.
    aps = Array.prototype.slice,
    con = window.console,
    
    // Public object to be returned.
    that = {},
    
    callback_func,
    callback_force,
    
    // Default logging level, show everything.
    log_level = 9,
    
    // Logging methods, in "priority order". Not all console implementations
    // will utilize these
    log_methods = [ 'error', 'warn', 'info', 'debug', 'log' ],
    
    // Pass these methods through to the console if they exist, otherwise just
    // fail gracefully. These methods are provided for convenience.
    pass_methods = 'assert clear count dir dirxml exception group groupCollapsed groupEnd profile profileEnd table time timeEnd trace timeStamp'.split(' '),
    idx = pass_methods.length,
    
    // Logs are stored here so that they can be recalled as necessary.
    logs = [];
  
  while ( --idx >= 0 ) {
    (function( method ){
      
      // Generate pass-through methods. These methods will be called, if they
      // exist, as long as the logging level is non-zero.
      that[ method ] = function() {
        if (log_level !== 0 && con && con[ method ]) {
            doPass(method, aps.call( arguments ));
        }
      };
      
    })( pass_methods[idx] );
  }
  
  idx = log_methods.length;
  while ( --idx >= 0 ) {
    (function( idx, level ){
      
      // Method: debug.log
      // 
      // Call the console.log method if available. Adds an entry into the logs
      // array for a callback specified via <debug.setCallback>.
      // 
      // Usage:
      // 
      //  debug.log( object [, object, ...] );                               - -
      // 
      // Arguments:
      // 
      //  object - (Object) Any valid JavaScript object.
      
      // Method: debug.debug
      // 
      // Call the console.debug method if available, otherwise call console.log.
      // Adds an entry into the logs array for a callback specified via
      // <debug.setCallback>.
      // 
      // Usage:
      // 
      //  debug.debug( object [, object, ...] );                             - -
      // 
      // Arguments:
      // 
      //  object - (Object) Any valid JavaScript object.
      
      // Method: debug.info
      // 
      // Call the console.info method if available, otherwise call console.log.
      // Adds an entry into the logs array for a callback specified via
      // <debug.setCallback>.
      // 
      // Usage:
      // 
      //  debug.info( object [, object, ...] );                              - -
      // 
      // Arguments:
      // 
      //  object - (Object) Any valid JavaScript object.
      
      // Method: debug.warn
      // 
      // Call the console.warn method if available, otherwise call console.log.
      // Adds an entry into the logs array for a callback specified via
      // <debug.setCallback>.
      // 
      // Usage:
      // 
      //  debug.warn( object [, object, ...] );                              - -
      // 
      // Arguments:
      // 
      //  object - (Object) Any valid JavaScript object.
      
      // Method: debug.error
      // 
      // Call the console.error method if available, otherwise call console.log.
      // Adds an entry into the logs array for a callback specified via
      // <debug.setCallback>.
      // 
      // Usage:
      // 
      //  debug.error( object [, object, ...] );                             - -
      // 
      // Arguments:
      // 
      //  object - (Object) Any valid JavaScript object.
      
      that[ level ] = function() {
        var args = aps.call( arguments );
        args.unshift('['+(new Date()).toString('HH:mm:ss')+']');
        var log_arr = [ idx ].concat( args );
        
        if (window.FEATURES && window.FEATURES.log_limit && logs.length > window.FEATURES.log_limit) {
          logs.shift();
        }
        logs.push( log_arr );
        exec_callback( log_arr );
        
        if ( !con || !is_level( idx ) ) { return; }
                
        doLog(level, args);
      };
      
    })( idx, log_methods[idx] );
  }
  
  function doPass(method, args) {
    con[ method ].apply( con, args );
  }
  function doLog(level, args) {
    (con.firebug || con.trace) ? con[ level ].apply( con, args )
      : con[ level ] ? con[ level ]( args )
      : con.log( args );
  }

  // Execute the callback function if set.
  function exec_callback( args ) {
    if ( callback_func && (callback_force || !con || !con.log) ) {
      callback_func.apply( window, args );
    }
  }
  
  // Method: debug.setLevel
  // 
  // Set a minimum or maximum logging level for the console. Doesn't affect
  // the <debug.setCallback> callback function, but if set to 0 to disable
  // logging, <Pass-through console methods> will be disabled as well.
  // 
  // Usage:
  // 
  //  debug.setLevel( [ level ] )                                            - -
  // 
  // Arguments:
  // 
  //  level - (Number) If 0, disables logging. If negative, shows N lowest
  //    priority levels of log messages. If positive, shows N highest priority
  //    levels of log messages.
  //
  // Priority levels:
  // 
  //   log (1) < debug (2) < info (3) < warn (4) < error (5)
  
  that.setLevel = function( level ) {
    log_level = typeof level === 'number' ? level : 9;
  };
  
  // Determine if the level is visible given the current log_level.
  function is_level( level ) {
    return log_level > 0
      ? log_level > level
      : log_methods.length + log_level <= level;
  }
  
  // Method: debug.setCallback
  // 
  // Set a callback to be used if logging isn't possible due to console.log
  // not existing. If unlogged logs exist when callback is set, they will all
  // be logged immediately unless a limit is specified.
  // 
  // Usage:
  // 
  //  debug.setCallback( callback [, force ] [, limit ] )
  // 
  // Arguments:
  // 
  //  callback - (Function) The aforementioned callback function. The first
  //    argument is the logging level, and all subsequent arguments are those
  //    passed to the initial debug logging method.
  //  force - (Boolean) If false, log to console.log if available, otherwise
  //    callback. If true, log to both console.log and callback.
  //  limit - (Number) If specified, number of lines to limit initial scrollback
  //    to.
  
  that.setCallback = function() {
    var args = aps.call( arguments ),
      max = logs.length,
      i = max;
    
    callback_func = args.shift() || null;
    callback_force = typeof args[0] === 'boolean' ? args.shift() : false;
    
    i -= typeof args[0] === 'number' ? args.shift() : max;
    i = Math.max(0, i);
    
    while ( i < max ) {
      exec_callback( logs[i++] );
    }
  };
  
  that.getLogger = function (force) {
    return function( idx ) {
      if (!force && !is_level(idx)) {
        return;
      }
      var level = log_methods[idx];
      var args = Array.prototype.slice.call( arguments, 1 );
      console[ level ].apply( console, args );
    };
  };
  
  that.getLogs = function () {
    return logs;
  };
  
  that.initFirebugLite = function () {
    if (!window.Firebug || !window.fbScript) {
      // from firebug lite bookmarklet
      fbScript = document.createElement('script');
      fbScript.setAttribute( 'src', 'https://getfirebug.com/firebug-lite.js#startOpened,overrideConsole=false' );
      document.body.appendChild( fbScript );
    }
    if (!window.Firebug) {
      setTimeout( arguments.callee );
      return;
    }
    
    debug.setCallback(debug.getLogger(), true);
  };
  
  
  return that;
})();
window.debug = window.irccloud_debug;


/***/ }),

/***/ "rO4t":
/***/ (function(module, exports) {

/**
 * Timeago is a jQuery plugin that makes it easy to support automatically
 * updating fuzzy timestamps (e.g. "4 minutes ago" or "about 1 day ago").
 *
 * @name timeago
 * @version 1.5.2
 * @requires jQuery v1.2.3+
 * @author Ryan McGeary
 * @license MIT License - http://www.opensource.org/licenses/mit-license.php
 *
 * For usage and examples, visit:
 * http://timeago.yarp.com/
 *
 * Copyright (c) 2008-2015, Ryan McGeary (ryan -[at]- mcgeary [*dot*] org)
 */

(function (factory) {
  // Browser globals
  factory(jQuery);
}(function ($) {
  $.timeago = function(timestamp, strings) {
    if (timestamp instanceof Date) {
      return inWords(timestamp, strings);
    } else if (typeof timestamp === "string") {
      return inWords($.timeago.parse(timestamp), strings);
    } else if (typeof timestamp === "number") {
      return inWords(new Date(timestamp), strings);
    } else {
      return inWords($.timeago.datetime(timestamp), strings);
    }
  };
  var $t = $.timeago;

  $.extend($.timeago, {
    settings: {
      refreshMillis: 60000,
      allowPast: true,
      allowFuture: false,
      localeTitle: false,
      cutoff: 0,
      autoDispose: true,
      strings: {
        prefixAgo: null,
        prefixFromNow: null,
        suffixAgo: "ago",
        suffixFromNow: "from now",
        inPast: 'any moment now',
        seconds: "less than a minute",
        minute: "about a minute",
        minutes: "%d minutes",
        hour: "about an hour",
        hours: "about %d hours",
        day: "a day",
        days: "%d days",
        month: "about a month",
        months: "%d months",
        year: "about a year",
        years: "%d years",
        wordSeparator: " ",
        numbers: []
      }
    },

    inWords: function(distanceMillis, strings) {
      if (!this.settings.allowPast && ! this.settings.allowFuture) {
          throw 'timeago allowPast and allowFuture settings can not both be set to false.';
      }

      var $l = strings || this.settings.strings;
      var prefix = $l.prefixAgo;
      var suffix = $l.suffixAgo;
      if (this.settings.allowFuture) {
        if (distanceMillis < 0) {
          prefix = $l.prefixFromNow;
          suffix = $l.suffixFromNow;
        }
      }

      if (!this.settings.allowPast && distanceMillis >= 0) {
        return this.settings.strings.inPast;
      }

      var seconds = Math.abs(distanceMillis) / 1000;
      var minutes = seconds / 60;
      var hours = minutes / 60;
      var days = hours / 24;
      var years = days / 365;

      function substitute(stringOrFunction, number) {
        var string = $.isFunction(stringOrFunction) ? stringOrFunction(number, distanceMillis) : stringOrFunction;
        var value = ($l.numbers && $l.numbers[number]) || number;
        return string.replace(/%d/i, value);
      }

      var words = seconds < 45 && substitute($l.seconds, Math.round(seconds)) ||
        seconds < 90 && substitute($l.minute, 1) ||
        minutes < 45 && substitute($l.minutes, Math.round(minutes)) ||
        minutes < 90 && substitute($l.hour, 1) ||
        hours < 24 && substitute($l.hours, Math.round(hours)) ||
        hours < 42 && substitute($l.day, 1) ||
        days < 30 && substitute($l.days, Math.round(days)) ||
        days < 45 && substitute($l.month, 1) ||
        days < 365 && substitute($l.months, Math.round(days / 30)) ||
        years < 1.5 && substitute($l.year, 1) ||
        substitute($l.years, Math.round(years));

      var separator = $l.wordSeparator || "";
      if ($l.wordSeparator === undefined) { separator = " "; }
      return $.trim([prefix, words, suffix].join(separator));
    },

    parse: function(iso8601) {
      var s = $.trim(iso8601);
      s = s.replace(/\.\d+/,""); // remove milliseconds
      s = s.replace(/-/,"/").replace(/-/,"/");
      s = s.replace(/T/," ").replace(/Z/," UTC");
      s = s.replace(/([\+\-]\d\d)\:?(\d\d)/," $1$2"); // -04:00 -> -0400
      s = s.replace(/([\+\-]\d\d)$/," $100"); // +09 -> +0900
      return new Date(s);
    },
    datetime: function(elem) {
      var iso8601 = $t.isTime(elem) ? $(elem).attr("datetime") : $(elem).attr("title");
      return $t.parse(iso8601);
    },
    isTime: function(elem) {
      // jQuery's `is()` doesn't play well with HTML5 in IE
      return $(elem).get(0).tagName.toLowerCase() === "time"; // $(elem).is("time");
    }
  });

  // functions that can be called via $(el).timeago('action')
  // init is default when no action is given
  // functions are called with context of a single element
  var functions = {
    init: function(strings) {
      var refresh_el = $.proxy(refresh, this, strings);
      refresh_el();
      var $s = $t.settings;
      if ($s.refreshMillis > 0) {
        this._timeagoInterval = setInterval(refresh_el, $s.refreshMillis);
      }
    },
    update: function(timestamp) {
      var date = (timestamp instanceof Date) ? timestamp : $t.parse(timestamp);
      $(this).data('timeago', { datetime: date });
      if ($t.settings.localeTitle) $(this).attr("title", date.toLocaleString());
      refresh.apply(this);
    },
    updateFromDOM: function() {
      $(this).data('timeago', { datetime: $t.parse( $t.isTime(this) ? $(this).attr("datetime") : $(this).attr("title") ) });
      refresh.apply(this);
    },
    dispose: function () {
      $(this).removeData('timeago');
      if (this._timeagoInterval) {
        window.clearInterval(this._timeagoInterval);
        this._timeagoInterval = null;
      }
    }
  };

  $.fn.timeago = function(action, options) {
    var fn = action ? functions[action] : functions.init;
    if (!fn) {
      throw new Error("Unknown function name '"+ action +"' for timeago");
    }
    // each over objects here and call the requested function
    this.each(function() {
      fn.call(this, options);
    });
    return this;
  };

  function refresh(strings) {
    var $s = $t.settings;

    //check if it's still visible
    if ($s.autoDispose && !$.contains(document.documentElement,this)) {
      //stop if it has been removed
      $(this).timeago("dispose");
      return this;
    }

    var data = prepareData(this);

    if (!isNaN(data.datetime)) {
      if ( $s.cutoff == 0 || Math.abs(distance(data.datetime)) < $s.cutoff) {
        $(this).text(inWords(data.datetime, strings));
      }
    }
    return this;
  }

  function prepareData(element) {
    element = $(element);
    if (!element.data("timeago")) {
      element.data("timeago", { datetime: $t.datetime(element) });
      var text = $.trim(element.text());
      if ($t.settings.localeTitle) {
        element.attr("title", element.data('timeago').datetime.toLocaleString());
      } else if (text.length > 0 && !($t.isTime(element) && element.attr("title"))) {
        element.attr("title", text);
      }
    }
    return element.data("timeago");
  }

  function inWords(date, strings) {
    return $t.inWords(distance(date), strings);
  }

  function distance(date) {
    return (new Date().getTime() - date.getTime());
  }

  // fix for IE6 suckage
  document.createElement("abbr");
  document.createElement("time");
}));

/***/ })

},["FbJA"]);


// WEBPACK FOOTER //
// libs-b8cdc548.js